/* ─────────────────────────────────────────────────────────────────────────────
   SCHUTZ: Endlosschleifen-Bremse für Produkt-.js-Abrufe (429-Schleife).
   Eine externe App (z.B. Abo-/Tracking-Skript) kann window.fetch kapern und die
   Produkt-.js dieser Seite in einer Schleife abrufen, bis Shopify mit 429 sperrt.
   Diese Bremse fängt wiederholte fehlgeschlagene Abrufe DERSELBEN URL ab und gibt
   eine harmlose leere Antwort zurück, statt die Schleife weiterzutreiben.
   Eigene fetches des Konfigurators (cart/add.js, cart/update.js, Webhook) sind NIE
   betroffen — gebremst wird nur, was wiederholt 429/HTML statt JSON liefert.
   ──────────────────────────────────────────────────────────────────────────── */
(function(){
  try{
    if(window.__bioFetchGuard) return;       // nur einmal installieren
    var _origFetch = window.fetch;
    if(typeof _origFetch !== 'function') return;
    var fails = {};                            // URL → Anzahl Fehlversuche
    var blocked = {};                          // URL → gesperrt (Schleife erkannt)
    var THRESHOLD = 3;                          // ab so vielen Fehlversuchen bremsen
    function keyOf(input){
      try{ return (typeof input==='string') ? input : (input && input.url) || ''; }
      catch(e){ return ''; }
    }
    function isProductJs(url){
      // Nur Shopify-Produkt-.js-Endpunkte dieser Seite betreffen
      return /\/products\/[^?]*\.js(\?|$)/.test(url);
    }
    window.fetch = function(input, init){
      var url = keyOf(input);
      if(url && isProductJs(url) && blocked[url]){
        // Schleife bereits erkannt → harmlose leere JSON-Antwort, kein echter Request
        return Promise.resolve(new Response('null', {
          status: 200, headers: {'Content-Type':'application/json'}
        }));
      }
      return _origFetch.apply(this, arguments).then(function(res){
        if(url && isProductJs(url) && res && res.status === 429){
          fails[url] = (fails[url]||0) + 1;
          if(fails[url] >= THRESHOLD){ blocked[url] = true; }
        }
        return res;
      }).catch(function(err){
        if(url && isProductJs(url)){
          fails[url] = (fails[url]||0) + 1;
          if(fails[url] >= THRESHOLD){ blocked[url] = true; }
        }
        throw err;
      });
    };
    window.__bioFetchGuard = true;
  }catch(e){ /* Schutz darf die Seite nie blockieren */ }
})();

/* ─────────────────────────────────────────────────────────────────────────────
   SCHUTZ: Veralteten Sitzungszustand aus früheren Code-Versionen bereinigen.
   Wenn im localStorage ein Zustand von einer älteren Version liegt (z.B. ein
   Bluttest-Zustand, den es so nicht mehr gibt), kann das Wiederherstellen die
   Seite leer rendern. Diese Versionssperre räumt einmalig den flüchtigen
   Sitzungszustand, sobald die Code-Version wechselt. Admin-Preise bleiben.
   ──────────────────────────────────────────────────────────────────────────── */
(function(){
  try{
    var CODE_VERSION = '2026-10-30-warenkorb-fix';
    var stored = null;
    try{ stored = localStorage.getItem('biotiva_codeversion'); }catch(e){ return; }
    if(stored !== CODE_VERSION){
      // Nur den flüchtigen Sitzungszustand entfernen (nicht die Admin-Rohwaren).
      try{ localStorage.removeItem('biotiva_state'); }catch(e){}
      try{ localStorage.setItem('biotiva_codeversion', CODE_VERSION); }catch(e){}
    }
  }catch(e){ /* darf die Seite nie blockieren */ }
})();

// ── Versionsanzeige: Konsole immer, mit ?v=1 auch als Leiste auf der Seite ──
window.PURAVEDA_VERSION='2026-08-25-warum';
(function(){try{var s=document.createElement('style');s.textContent='.b-why{margin-top:16px;border-top:1px solid rgba(30,51,24,.10);padding-top:12px}.b-why>summary{cursor:pointer;list-style:none;text-align:center;font-size:12px;font-style:italic;font-weight:600;color:#818c77;user-select:none;outline:none}.b-why>summary::-webkit-details-marker{display:none}.b-why>summary::after{content:\" \\25BE\";font-style:normal;font-size:10px;color:#727c6a}.b-why[open]>summary::after{content:\" \\25B4\"}.b-why-body{margin:9px auto 0;max-width:94%;text-align:center;font-size:12px;line-height:1.6;color:#818c77}';(document.head||document.documentElement).appendChild(s);}catch(e){}})();
try{ console.log('%cPuraveda Konfigurator '+window.PURAVEDA_VERSION,'color:#7a1f2b;font-weight:bold;font-size:13px'); }catch(e){}
(function(){
  try{
    if(new URLSearchParams(location.search).get('v')!=='1') return;
    var show=function(){
      if(!document.body) return;
      var b=document.createElement('div');
      b.textContent='Puraveda '+window.PURAVEDA_VERSION;
      b.style.cssText='position:fixed;bottom:0;left:0;z-index:99999;background:#7a1f2b;color:#fff;font:12px/1 monospace;padding:4px 9px;opacity:.9;border-top-right-radius:6px';
      document.body.appendChild(b);
    };
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',show);
    else show();
  }catch(e){}
})();






































































var LOGO='https://www.biotiva.de/cdn/shop/files/Biotiva_Logo_RGB_V2_f1ffc201-87f3-4590-9fcb-771ce0b260fc.png';
// Bluttest-Upload zum Launch ausgeblendet. Zum Reaktivieren: auf true setzen.
var BLUTTEST_AKTIV = false;

// ── INGREDIENT DATABASE ────────────────────────────────────────────────────────
// dose = empfohlener Ausgangswert (60% NRV als Basis)
// maxSafe = BfR/EFSA Höchstmenge für NEM (harter Stopper, User kann nicht darüber)
// softMax = empfohlene Tageshöchstmenge (Score-Ausgabe wird hier gekappt, User kann bis maxSafe)
// noUpperLimit = true → EFSA/BfR kein UL definiert, Warnung erst bei sehr hohen Werten
// ── NÄHRSTOFFE (vollständige Liste mit Health Claims) ────────────────────────
// ── NÄHRSTOFF-DATENBANK (Vitamin_ID.csv → vollständige Einträge) ────────────
// Jeder Eintrag: id, name, type='nutrient', nrv, unit, maxSafe, softMax,
//   claim (EU 432/2012), goals[], se_weights (Scoring-Regeln)
// Pflanzliche Quellen werden als separate DB-Einträge geführt (type='plant')
// mit std (Standardisierungsgrad) und ref_nutrient (zeigt auf Nährstoff-ID)

var NUTRIENTS = [

  {id:'vit_a',       quelle:'Retinylacetat', std:0.0975, name:'Vitamin A',           nrv:0.8,   unit:'mg', softMax:0.2,  maxSafe:3, pk:1538.46,
   warnung:'In der Schwangerschaft bitte nur nach ärztlicher Rücksprache einnehmen.',
   claim:'Vitamin A trägt zur Erhaltung normaler Sehkraft und zur normalen Funktion des Immunsystems bei.',
   goals:['Haut','Immunsystem','Augen'],
   se:{sun:{'kaum':1.2,'zwischen':0.6}, diet:{'vegan':1.5,'vegetarisch':0.8}, goals:{'Haut':1.5,'Immunsystem':1.0}}},

  {id:'vit_b1',      std:0.89, name:'Thiamin (Vitamin B1)',    nrv:1.1,   unit:'mg', softMax:null, maxSafe:null, noUpperLimit:true, pk:112.36,
   claim:'Thiamin trägt zu einem normalen Energiestoffwechsel und zur normalen Herzfunktion bei.',
   goals:['Energie','Konzentration'],
   se:{alc:{'>=7':1.5,'>=4':0.8}, stress:{'>=4':0.8}, goals:{'Energie':1.2,'Konzentration':0.8}}},

  {id:'vit_b2',      name:'Riboflavin (Vitamin B2)', nrv:1.4,   unit:'mg', softMax:null, maxSafe:null, noUpperLimit:true, pk:500,
   claim:'Riboflavin trägt zur Verringerung von Müdigkeit und Erschöpfung und zum Schutz der Zellen vor oxidativem Stress bei.',
   goals:['Energie','Haut','Augen'],
   se:{sport:{'>=3':0.8}, goals:{'Energie':1.2,'Haut':0.8}}},

  {id:'vit_b3',      name:'Niacin (Vitamin B3)',     nrv:16,    unit:'mg', softMax:160,   maxSafe:900, pk:100,
   warnung:'Schwangere sollten auf die Einnahme dieses Produkts verzichten.', warnungAb:16.001,
   claim:'Niacin trägt zu einem normalen Energiestoffwechsel und zur normalen Funktion des Nervensystems bei.',
   goals:['Energie','Haut','Konzentration'],
   se:{alc:{'>=4':0.8}, goals:{'Energie':1.0,'Haut':1.5,'Konzentration':0.8}}},

  {id:'vit_b5',      std:0.92, name:'Pantothensäure (B5)',     nrv:6,     unit:'mg', softMax:null, maxSafe:null, noUpperLimit:true, pk:54.35,
   claim:'Pantothensäure trägt zu einem normalen Energiestoffwechsel und zur normalen Synthese von Steroidhormonen bei.',
   goals:['Energie','Stress'],
   se:{stress:{'>=3':0.8}, goals:{'Energie':1.0,'Stress':1.2}}},

  {id:'vit_b6',      std:0.8, name:'Vitamin B6',              nrv:1.4,   unit:'mg', softMax:0.9,  maxSafe:12, pk:60,
   claim:'Vitamin B6 trägt zur normalen Funktion des Nervensystems und zur Regulierung der Hormontätigkeit bei.',
   goals:['Konzentration','Stress','Energie'],
   se:{stress:{'>=4':1.0}, alc:{'>=7':1.2}, goals:{'Konzentration':1.2,'Stress':1.0,'Energie':0.8}}},

  {id:'vit_b12',     quelle:'Chlorella', name:'Bio Vitamin B12',             nrv:2.5,   base_dose:250, unit:'µg',softMax:500,  maxSafe:null, noUpperLimit:true, pk:140000,
   claim:'Vitamin B12 trägt zur Verringerung von Müdigkeit und Erschöpfung und zur normalen Funktion des Nervensystems bei.',
   goals:['Energie','Konzentration'],
   base_score:3.0,
   mandatory_conditions:[{signal:'diet',condition:'vegan',weight:9,grade:'A',source:'EFSA NDA 2015'},
                          {signal:'diet',condition:'vegetarisch',weight:6,grade:'A',source:'Pawlak 2013'}],
   se:{diet:{'vegan':9,'vegetarisch':6}, goals:{'Energie':1.2,'Konzentration':0.8}},
   std:0.002},

  // std ohne quelle: 99 % Gehalt zaehlt fuer die Einwaage, taugt aber nicht als
  // Beispielsatz („0 mg Biotin stecken in 0 mg D-Biotin") — siehe quellenBeispiel().
  {id:'biotin',      std:0.99, name:'Biotin (Vitamin B7)',      nrv:50,  unit:'µg', softMax:null, maxSafe:null, noUpperLimit:true, pk:303.03,
   warnung:'Wenn Du Dich einem Labortest unterziehen musst, informiere bitte Deine Ärztin, Deinen Arzt oder das Laborpersonal darüber, dass Du Biotin einnimmst.',
   claim:'Biotin trägt zur Erhaltung normaler Haare, Haut und Schleimhäute bei.',
   goals:['Haare','Haut'],
   se:{goals:{'Haare':2.5,'Haut':1.5}}},

  {id:'folat',       quelle:'Calcium-L-Methylfolat', std:0.9, name:'Folat (Vitamin B9)',       nrv:200,   unit:'µg', softMax:200,  maxSafe:1000, pk:144.44,
   claim:'Folat trägt zur normalen Bildung von Blut und zur normalen Funktion des Immunsystems bei.',
   goals:['Energie'],
   mandatory_conditions:[{signal:'sex',condition:'weiblich',weight:2.0,grade:'A',source:'BfR 013/2014'},
                          {signal:'sex',condition:'schwanger',weight:5.0,grade:'A',source:'WHO 2006'}],
   se:{sex:{'weiblich':2.0,'schwanger':5.0}, goals:{'Energie':0.8}}},

  {id:'vit_c',       quelle:'Acerola', std:0.17, name:'Bio Vitamin C',               nrv:80,    unit:'mg', softMax:250, maxSafe:null, pk:588,
   claim:'Vitamin C trägt zur normalen Kollagenbildung für die Funktion von Haut, Knochen und Knorpeln bei.',
   goals:['Immunsystem','Haut','Energie'],
   se:{smoke:{'ja':2.5,'selten':1.2}, sun:{'kaum':0.5}, veg:{'<=2':1.2}, goals:{'Immunsystem':1.5,'Haut':1.2,'Energie':0.8,'Longevity':1.2}}},

  {id:'vit_d',       quelle:'Flechten-Extrakt', std:0.0025, name:'Vitamin D3 aus Flechten',               nrv:5, base_dose:25, unit:'µg', softMax:25, maxSafe:100, pk:600000,
   claim:'Vitamin D trägt zur normalen Funktion des Immunsystems und zur Erhaltung normaler Knochen und Zähne bei.',
   goals:['Immunsystem','Knochen'],
   mandatory_conditions:[{signal:'diet',condition:'vegan',weight:3.0,grade:'B',source:'Crowe 2011 EPIC-Oxford'}],
   base_score:1.5,
   se:{sun:{'kaum':3.5,'zwischen':2.0}, age:{'>50':2.5,'>35':1.2}, bmi:{'adipositas':2.5,'übergewicht':1.0},
       lacto:{'ja':0.8}, diet:{'vegan':3.0}, goals:{'Immunsystem':1.5,'Knochen':1.2,'Longevity':1.3}}},

  {id:'vit_e',       quelle:'D-alpha-Tocopherol', std:0.5, name:'Vitamin E',               nrv:12,    unit:'mg', softMax:30,   maxSafe:300, pk:1753,
   claim:'Vitamin E trägt zum Schutz der Zellen vor oxidativem Stress bei.',
   goals:['Sport','Immunsystem'],
   se:{smoke:{'ja':1.5,'selten':0.7}, goals:{'Sport':1.2,'Immunsystem':0.8,'Longevity':2.0}}},

  {id:'vit_k',       std:0.013, name:'Vitamin K2',              nrv:75, unit:'µg', softMax:75,maxSafe:null, pk:23076.92,
   warnung:'Wenn Du gerinnungshemmende Medikamente einnimmst, hole bitte vor der Einnahme ärztlichen Rat ein.',
   claim:'Vitamin K trägt zur normalen Blutgerinnung und zur Erhaltung normaler Knochen bei.',
   goals:['Knochen'],
   se:{age:{'>45':2.0,'>35':0.5}, lacto:{'ja':0.5}, goals:{'Knochen':2.5,'Longevity':1.0}}},

  {id:'calcium',     quelle:'Calciumcitrat', std:0.21, name:'Calcium',                 nrv:800,   base_dose:250, unit:'mg', softMax:500,  maxSafe:2500, pk:40,
   warnung:'Bitte verzichte auf den Verzehr eines weiteren calciumhaltigen Nahrungsergänzungsmittels.', warnungAb:250,
   claim:'Calcium wird für die Erhaltung normaler Knochen und Zähne sowie die normale Muskelfunktion benötigt.',
   goals:['Knochen'],
   se:{lacto:{'ja':2.0}, age:{'>50':1.5}, goals:{'Knochen':2.0}}},

  // Chrom-Gehalt 12 % am 26.10.2026 bestaetigt. Preis unveraendert: pk 833,33
  // entspricht 100 EUR/kg Pulver (833,33 x 0,12).
  {id:'chrom',       quelle:'Chrompicolinat', std:0.12, name:'Chrom',                   nrv:0.04,  unit:'mg', softMax:0.06, maxSafe:null, pk:833.33,
   claim:'Chrom trägt zur Aufrechterhaltung eines normalen Blutzuckerspiegels bei.',
   goals:['Energie'],
   se:{bmi:{'übergewicht':1.0,'adipositas':1.5}, goals:{'Energie':0.8}}},

  {id:'eisen',       quelle:'Eisenbisglycinat', std:0.16, name:'Eisen',                   nrv:14,    unit:'mg', softMax:6,   maxSafe:45, pk:250,
   warnung:'Männer, Frauen nach den Wechseljahren und Schwangere sollten Eisen nur nach ärztlicher Rücksprache einnehmen.',
   claim:'Eisen trägt zur Verringerung von Müdigkeit und Erschöpfung und zur normalen Bildung roter Blutkörperchen bei.',
   goals:['Energie'],
   mandatory_conditions:[{signal:'diet',condition:'vegan',weight:3.0,grade:'A',source:'EFSA NDA 2017'},
                          {signal:'diet',condition:'vegetarisch',weight:2.0,grade:'A',source:'EFSA NDA 2017'}],
   se:{diet:{'vegan':3.0,'vegetarisch':2.0}, sex:{'weiblich':1.5}, goals:{'Energie':1.5}}},

  {id:'jod',         quelle:'Kelp-Alge', std:0.05, name:'Bio Jod',                     nrv:0.15,  unit:'mg', softMax:0.1,  maxSafe:0.6, pk:600,
   claim:'Jod trägt zur normalen Funktion der Schilddrüse und zum normalen Energiestoffwechsel bei.',
   goals:['Energie','Konzentration'],
   se:{diet:{'vegan':2.0,'vegetarisch':1.0}, fish:{'<=1':1.2}, goals:{'Energie':0.8,'Konzentration':0.8}}},

  {id:'kalium',      quelle:'Kaliumcitrat', std:0.36, name:'Kalium',                  nrv:2000,  base_dose:300, unit:'mg', softMax:500, maxSafe:null, noUpperLimit:true, pk:48,
   claim:'Kalium trägt zur normalen Muskelfunktion und zur Aufrechterhaltung eines normalen Blutdrucks bei.',
   goals:['Sport','Herz'],
   se:{sport:{'>=4':1.5,'>=2':0.8}, goals:{'Sport':1.2,'Herz':1.5}}},

  {id:'kupfer',      quelle:'Kupfergluconat', std:0.14, name:'Kupfer',                  nrv:1,     unit:'mg', softMax:1,  maxSafe:5, pk:1428.57,
   warnung:'Nicht für Kinder und Jugendliche geeignet.',
   claim:'Kupfer trägt zur normalen Funktion des Nervensystems und des Immunsystems bei.',
   goals:['Immunsystem','Haare'],
   se:{goals:{'Immunsystem':0.8,'Haare':1.0}}},

  {id:'magnesium',   quelle:'Magnesiumbisglycinat', std:0.12, name:'Magnesium',               nrv:375,   unit:'mg', softMax:250,  maxSafe:250, pk:300,
   warnung:'Wir empfehlen, diese Menge auf zwei oder mehr Portionen über den Tag zu verteilen.', warnungAb:250,
   claim:'Magnesium trägt zur Verringerung von Müdigkeit und Erschöpfung, zur normalen Muskelfunktion und zur Erhaltung normaler Knochen bei.',
   goals:['Sport','Schlaf','Stress','Knochen'],
   se:{sport:{'>=3':2.0,'>=2':1.0}, stress:{'>=4':1.8,'>=3':1.0}, sleep:{'<6':1.5},
       goals:{'Sport':1.5,'Schlaf':2.0,'Stress':1.5,'Knochen':0.8,'Longevity':1.2}}},

  {id:'mangan',      quelle:'Mangangluconat', std:0.12, name:'Mangan',                  nrv:2,     unit:'mg', softMax:0.5,  maxSafe:8, pk:1250,
   claim:'Mangan trägt zur Erhaltung normaler Knochen und zum normalen Energiestoffwechsel bei.',
   goals:['Knochen'],
   se:{goals:{'Knochen':1.0}}},

  {id:'selen',       quelle:'Selen-Hefe', std:0.002, name:'Selen',                   nrv:55, unit:'µg', softMax:40,maxSafe:255, pk:50000,
   claim:'Selen trägt zum Schutz der Zellen vor oxidativem Stress und zur normalen Funktion des Immunsystems bei.',
   goals:['Immunsystem','Haare'],
   se:{smoke:{'ja':1.5,'selten':0.7}, goals:{'Immunsystem':1.2,'Haare':1.8,'Longevity':1.8}}},

  {id:'zink',        quelle:'Guavenblatt', std:0.04, name:'Bio Zink',                    nrv:10,    unit:'mg', softMax:6.5,  maxSafe:25, pk:5000,
   claim:'Zink trägt zur Erhaltung normaler Haare, Haut und Nägel sowie zur normalen Funktion des Immunsystems bei.',
   goals:['Immunsystem','Haut','Haare','Augen'],
   se:{diet:{'vegan':1.5,'vegetarisch':0.8}, goals:{'Immunsystem':1.5,'Haut':1.5,'Haare':1.5}}},

  {id:'omega3',       quelle:'DHA-Algenölpulver', std:0.17, name:'Omega-3 DHA (aus Algenöl)', nrv:null, base_dose:250, unit:'mg', softMax:500, maxSafe:1000, pk:588, step:50, claimMin:250,
   claim:'DHA trägt zur Erhaltung einer normalen Gehirnfunktion bei. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 250 mg DHA ein.',
   // Pflicht-Allergen laut Spezifikation: Milcheiweiß (8,5 % im Pulver).
   // Die Zutat ist vegetarisch zertifiziert, aber NICHT vegan.
   warnung:'Enthält Milch (Milcheiweiß aus dem Trägerstoff des Algenölpulvers). Rezepturen mit dieser Zutat sind vegetarisch, aber nicht vegan.',
   goals:['Herz','Konzentration','Augen'],
   se:{goals:{'Herz':2.0,'Konzentration':1.5,'Augen':1.5}}},

  {id:'cholin',       quelle:'Cholinbitartrat', std:0.41, name:'Cholin',                 nrv:null,  base_dose:400,  unit:'mg', softMax:550.0,  maxSafe:3500.0, pk:150,
   claim:'Cholin trägt zur normalen Leberfunktion und zum normalen Fettstoffwechsel bei.',
   goals:['Konzentration','Leber'],
   se:{alc:{'>=4':1.5}, goals:{'Konzentration':1.2,'Leber':1.5}}},

  {id:'glucomannan',  quelle:'Konjakwurzel', name:'Bio Glucomannan',            nrv:null,  base_dose:3,  unit:'g',  softMax:4, maxSafe:4, std:0.95, pk:80, claimMin:3,
   claim:'Glucomannan trägt im Rahmen einer kalorienarmen Ernährung zu Gewichtsverlust bei (Wirkung ab 3 g täglich in 3 Portionen à 1 g, jeweils mit 1–2 Gläsern Wasser vor den Mahlzeiten).',
   goals:['Herz','Darm','Gewicht'],
   se:{bmi:{'übergewicht':1.5,'adipositas':2.5}, goals:{'Herz':1.2,'Darm':1.8}}},

  {id:'guarkernmehl', name:'Bio Guarkernmehl',           nrv:null,  base_dose:1,  unit:'g',  softMax:null, maxSafe:null, noUpperLimit:true, pk:20, claimMin:10,
   // VO (EU) 432/2012 verlangt zur Guarkernmehl-Angabe zwingend den Hinweis auf
   // die Tagesdosis von 10 g — wie bei DHA/250 mg. Fehlte bis 27.10.2026.
   claim:'Guarkernmehl trägt zur Aufrechterhaltung eines normalen Cholesterinspiegels im Blut bei. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 10 g Guarkernmehl ein.',
   goals:['Herz','Darm'],
   se:{bmi:{'übergewicht':1.2,'adipositas':2.0}, goals:{'Herz':1.0,'Darm':1.5}}},

  {id:'Q10',          name:'Coenzym Q10',                nrv:null,  base_dose:50,  unit:'mg', softMax:100,  maxSafe:100, pk:500,
   goals:['Longevity','Energie','Immunsystem'],
   se:{age:{'>=50':1.5,'>=40':1.2}, goals:{'Longevity':1.8,'Energie':1.3,'Immunsystem':1.0}}},

  {id:'Kollagen',     name:'Kollagen Peptide',           nrv:null,  base_dose:2,   unit:'g',  softMax:10,   maxSafe:null, noUpperLimit:true, pk:70,
   goals:['Longevity','Haut','Energie'],
   se:{age:{'>=50':1.5,'>=40':1.2}, goals:{'Longevity':1.5,'Haut':2.0,'Energie':0.8}}},

  {id:'resveratol',   quelle:'Riesenknöterich', name:'Resveratrol (aus Jap. Staudenknöterich)',  nrv:null,  base_dose:50,  unit:'mg', softMax:150,  maxSafe:150, std:0.1, pk:1200,
   goals:['Longevity','Leber','Herz'],
   se:{age:{'>=50':1.8,'>=40':1.3}, goals:{'Longevity':2.0,'Leber':1.2,'Herz':1.5}}},

  {id:'alpha_liponsaeure', name:'Alpha-Liponsäure', nrv:null, base_dose:300, unit:'mg', softMax:600, maxSafe:600, pk:380,
   goals:['Longevity','Energie','Haut'],
   se:{age:{'>=50':1.5,'>=40':1.0}, smoke:{'ja':1.0,'selten':0.5}, goals:{'Longevity':2.0,'Energie':1.2,'Haut':1.0}}},

  ];

// ── PFLANZLICHE QUELLEN (Rohstoffe mit Standardisierungsgrad) ────────────────
// ── PFLANZLICHE QUELLEN (type='plant') ──────────────────────────────────────
// Jede Quelle hat:
//   ref_nutrients: [{nutrient_id, std (Anteil 0-1)}]  ← mehrere Nährstoffe möglich
//   Die Dose bezieht sich auf das PULVER (nicht den Nährstoff)
//   Nährstoff-Menge = powder_dose × std
// Botanical-Quellen bleiben separat als type='bot'

// PLANT_SOURCES — Pflanzen- und Algenpulver. Zaehlen seit 2026-09-14-typen als
// Botanicals (type 'bot') und werden in der Oberflaeche auch dort gefuehrt. Das
// eigene Array bleibt nur wegen des abweichenden Aufbaupfads in buildDB
// bestehen: Eintraege koennen ueber ref_nutrients Grenzwerte von einem
// Leitnaehrstoff erben. Aktuell nutzt das keiner der fuenf Eintraege.
var PLANT_SOURCES = [

  {id:'chlorella',     name:'Bio Chlorella',
   type:'bot', pk:36,
   dose:500,   unit:'mg', step:50,
   desc:'',
   scope:'Darm | Entgiftung | vegane Ernährung'},

  {id:'spirulina',     name:'Bio Spirulina',
   type:'bot', pk:27,
   dose:500,   unit:'mg', step:50,
   desc:'',
   scope:'Energie | Vitalität | vegane Ernährung'},


  {id:'brennnessel',   name:'Bio Brennnessel',
   type:'bot', pk:48,
   dose:500,   unit:'mg', step:50,
   desc:'',
   scope:'Energie | Knochen | vegane Ernährung'},


  {id:'gerstengras',   name:'Bio Gerstengras',
   type:'bot', pk:60,
   dose:500,   unit:'mg', step:50,
   desc:'',
   scope:'Darm | Entgiftung | Energie'},

  {id:'weizengras',    name:'Bio Weizengras',
   type:'bot', pk:60,
   dose:500,   unit:'mg', step:50,
   desc:'',
   scope:'Darm | Immunsystem | Entgiftung'},

  ];

// ── BOTANICALS (unverändert) ──────────────────────────────────────────────────
var BOTANICALS = [
  {id:'ashwagandha', name:'Bio Ashwagandha',         type:'bot',dose:300, unit:'mg',step:50, pk:60, nrv:null,softMax:600,  maxSafe:600,
   desc:'',scope:'Stress | Schlaf | Sport',
   claim:''},
  {id:'reishi',      name:'Bio Reishi Vitalpilz',    type:'bot',dose:300, unit:'mg',step:50, pk:180, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'',scope:'Immunsystem | Stress | Schlaf',
   claim:''},
  {id:'hericium',    name:'Bio Hericium',            type:'bot',dose:300, unit:'mg',step:50, pk:180, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Igelstachelbart-Pilz (Hericium erinaceus).',scope:'Konzentration | Nervensystem',
   claim:''},
  {id:'kurkuma',     name:'Bio Kurkuma',             type:'bot',dose:300, unit:'mg',step:50, pk:60, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Kurkuma mit natürlichem Curcumin.',scope:'Gelenke | Darm | Entzündung',
   claim:''},
  {id:'ginseng',     name:'Bio Ginseng',             type:'bot',dose:100, unit:'mg',step:25, pk:300, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Koreanischer Ginseng (Panax ginseng).',scope:'Energie | Konzentration | Immunsystem',
   claim:''},
  {id:'matcha',      name:'Bio Matcha / Grüner Tee', type:'bot',dose:200, unit:'mg',step:25, pk:240, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Matcha mit L-Theanin.',scope:'Konzentration | Energie',
   claim:''},
  {id:'moringa_bot', name:'Bio Moringa',   type:'bot',dose:300,unit:'mg',step:100,pk:90, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Moringa oleifera.',scope:'Energie | Immunsystem',
   claim:''},
  {id:'rote_beete',  name:'Bio Rote Beete',          type:'bot',dose:300,unit:'mg',step:100,pk:90, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'',scope:'Sport | Ausdauer | Energie',
   claim:''},
  {id:'maca',        name:'Bio Maca Pulver',         type:'bot',dose:300,unit:'mg',step:100,pk:120, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'Maca aus den Anden.',scope:'Energie | Libido | Sport',
   claim:''},
  {id:'baldrian',    name:'Bio Baldrian',    type:'bot',dose:400, unit:'mg',step:50, pk:150, nrv:null,softMax:600,  maxSafe:600,
   desc:'',scope:'Schlaf | Entspannung',
   claim:''},
  {id:'cordyceps',   name:'Bio Cordyceps',      type:'bot',dose:300, unit:'mg',step:50, pk:210, nrv:null,softMax:null, maxSafe:null, noUpperLimit:true,
   desc:'',scope:'Sport | Ausdauer | Energie',
   claim:''},

  {id:'schwarzpfeffer',quelle:'Bio Schwarzer Pfefferpulver', std:0.05, name:'Bio Schwarzer Pfeffer (Piperin)',type:'bot',dose:5,unit:'mg',step:1,pk:600,nrv:null,softMax:20,maxSafe:20,
   desc:'Schwarzer Pfeffer mit Piperin.',scope:'Bioverfügbarkeit',
   claim:''},
  {id:'lucuma', name:'Bio Lucuma', type:'bot', dose:300, unit:'mg', step:50, pk:60, nrv:null, softMax:1000, maxSafe:null, noUpperLimit:true,
   desc:'Lucuma aus Peru. Natürlicher Aromageber.',
   scope:'Energie | Antioxidantien | Vitalität',
   claim:''},
  {id:'chaga', name:'Bio Chaga', type:'bot', dose:300, unit:'mg', step:50, pk:30, nrv:null, softMax:1000, maxSafe:null, noUpperLimit:true,
   desc:'Chaga (Inonotus obliquus) mit Beta-Glucanen.',
   scope:'Immunsystem | Antioxidantien | Longevity',
   claim:''},
  {id:'ingwer', name:'Bio Ingwer', type:'bot', dose:300, unit:'mg', step:50, pk:10, nrv:null, softMax:2000, maxSafe:null, noUpperLimit:true,
   desc:'Ingwer (Zingiber officinale) mit Gingerolen.',
   scope:'Darm | Verdauung | Entzündung | Immunsystem',
   claim:''},
  {id:'spermidin', name:'Bio Spermidin (Weizenkeimpulver)', type:'bot', dose:750, unit:'mg', step:150, pk:10, nrv:null, softMax:1250, maxSafe:null, noUpperLimit:true,
   desc:'Spermidin aus Bio-Weizenkeimen (0,4 % Spermidin). Enthält glutenhaltiges Weizen.',
   scope:'Longevity | Zellschutz | Autophagie',
   claim:''},

  // ── NEU (Juli 2026) ────────────────────────────────────────────────────────
  // pk-Werte sind SCHAETZUNGEN und muessen gegen die realen Einkaufspreise
  // (EUR/kg) geprueft werden, bevor die Zutaten live gehen.
  {id:'teufelskralle', name:'Bio Teufelskralle', type:'bot', dose:400, unit:'mg', step:50, pk:100, nrv:null, softMax:1200, maxSafe:1200,
   desc:'Teufelskralle (Harpagophytum procumbens) mit Harpagosiden.',
   scope:'Gelenke | Bewegung | Entzündung',
   goals:['Knochen'],
   claim:''},
  {id:'knoblauch', name:'Bio Knoblauchpulver', type:'bot', dose:600, unit:'mg', step:100, pk:40, nrv:null, softMax:1500, maxSafe:null, noUpperLimit:true,
   desc:'Knoblauchpulver (Allium sativum) mit Allicin-Vorstufen.',
   scope:'Herz | Gefäße | Immunsystem',
   goals:['Herz','Immunsystem'],
   claim:''},
  {id:'mct', name:'Bio MCT Pulver', type:'bot', dose:3, unit:'g', step:0.5, pk:50, nrv:null, softMax:5, maxSafe:null, noUpperLimit:true,
   desc:'MCT-Pulver aus Bio-Kokosöl auf Akazienfaser-Träger (ca. 70 % MCT, C8/C10).',
   scope:'Energie | Konzentration | Sport',
   goals:['Energie','Konzentration'],
   claim:''},
  {id:'opc', quelle:'Traubenkernextrakt', std:0.4, name:'OPC Traubenkernextrakt', type:'bot', dose:150, unit:'mg', step:25, pk:450, nrv:null, softMax:300, maxSafe:300,
   desc:'Traubenkernextrakt mit oligomeren Proanthocyanidinen (OPC). Polyphenol-Komplex.',
   scope:'Antioxidantien | Gefäße | Haut',
   goals:['Herz','Haut'],
   claim:''},
  {id:'msm', name:'MSM (Methylsulfonylmethan)', type:'nutrient', dose:1, unit:'g', step:0.25, pk:30, nrv:null, softMax:3, maxSafe:3,
   desc:'Methylsulfonylmethan – organische Schwefelverbindung.',
   scope:'Gelenke | Haut | Bindegewebe',
   goals:['Knochen','Haut'],
   claim:''},
  {id:'irish_moss', name:'Bio Irish Moss', type:'bot', dose:250, unit:'mg', step:50, pk:90, nrv:null, softMax:500, maxSafe:500,
   desc:'Irish Moss / Knorpeltang (Chondrus crispus) – Meeresalge. ACHTUNG: natürlich jodhaltig.',
   scope:'Darm | Haut | Mineralstoffe',
   goals:['Darm','Haut'],
   claim:''},
  {id:'triphala', name:'Bio Triphala', type:'bot', dose:500, unit:'mg', step:100, pk:40, nrv:null, softMax:2000, maxSafe:null, noUpperLimit:true,
   desc:'Triphala – ayurvedische Mischung aus Amalaki, Bibhitaki und Haritaki.',
   scope:'Darm | Verdauung | Entgiftung',
   goals:['Darm','Leber'],
   claim:''},
  {id:'kreatin', quelle:'Kreatin-Monohydrat', std:0.88, name:'Kreatin Monohydrat', type:'nutrient', dose:3, unit:'g', step:0.5, pk:20, nrv:null, softMax:5, maxSafe:5, claimMin:3,
   desc:'Kreatin-Monohydrat. Zugelassener EU Health Claim ab 3 g Tagesdosis.',
   scope:'Sport | Kraft | Energie',
   goals:['Sport','Energie'],
   claim:'Kreatin erhöht die körperliche Leistung bei Schnellkrafttraining im Rahmen kurzzeitiger intensiver körperlicher Betätigung.'},

  // ── Neu 10/2026 ────────────────────────────────────────────────────────
  {id:'hagebutte', name:'Bio Hagebuttenpulver', type:'bot', dose:500, unit:'mg', step:100, pk:10, nrv:null, softMax:1000, maxSafe:null, noUpperLimit:true,
   desc:'Hagebuttenpulver (Rosa canina) aus der ganzen Frucht, mit Polyphenolen und Galaktolipiden.',
   scope:'Gelenke | Antioxidantien | Haut',
   goals:['Knochen','Haut','Immunsystem'],
   claim:''},
  // Glycin: Aminosaeure, kein zugelassener Health Claim. 3 g sind viel Masse —
  // deshalb im Expertenmodus voreingestellt aus.
  {id:'glycin', name:'L-Glycin', type:'nutrient', dose:3, unit:'g', step:0.5, pk:15, nrv:null, softMax:5, maxSafe:null, noUpperLimit:true,
   desc:'L-Glycin – kleinste Aminosäure.',
   scope:'Schlaf | Bindegewebe | Regeneration',
   goals:['Schlaf','Haut','Longevity'],
   claim:''},
  // NAC: in Deutschland ist Acetylcystein als Arzneimittel zugelassen (600 mg).
  // Bis die Abgrenzung geklaert ist, bleibt die Zutat gesperrt.
  {id:'nac', name:'N-Acetyl-L-Cystein (NAC)', type:'nutrient', dose:600, unit:'mg', step:100, pk:65, nrv:null, softMax:600, maxSafe:600,
   desc:'N-Acetyl-L-Cystein – acetylierte Form der Aminosäure Cystein.',
   scope:'Leber | Antioxidantien | Atemwege',
   goals:['Leber','Longevity'],
   claim:''},

  // ── Erweiterung 27.10.2026 ───────────────────────────────────────────────
  // 25 Zutaten aus dem Biotiva-Bestand. desc traegt nur Zusammensetzung und
  // Herkunft — keine gesundheitsbezogenen Aussagen (Regel vom 27.10.2026).
  // Nicht alle sind freigeschaltet, siehe UNAVAILABLE_IDS.
  {id:'akazienfaser', name:'Bio Akazienfaser', type:'bot', dose:5, unit:'g', step:1, pk:12, nrv:null, softMax:10, maxSafe:null,
   desc:'Akazienfaser (Acacia senegal), lösliche Ballaststoffe aus dem Gummi des Akazienbaums.',
   scope:'Darm | Ballaststoff',
   goals:['Darm'],
   claim:''},
  {id:'zimt', name:'Bio Zimt', type:'bot', dose:500, unit:'mg', step:100, pk:18, nrv:null, softMax:1000, maxSafe:null,
   desc:'Zimtrinde, gemahlen. Enthält Cumarin — Sorte und Gehalt sind zu belegen.',
   scope:'Stoffwechsel',
   goals:['Energie'],
   claim:''},
  {id:'loewenzahn', name:'Bio Löwenzahnwurzel', type:'bot', dose:500, unit:'mg', step:100, pk:25, nrv:null, softMax:1500, maxSafe:null,
   desc:'Löwenzahnwurzel (Taraxacum officinale), gemahlen, mit Bitterstoffen und Inulin.',
   scope:'Leber | Verdauung',
   goals:['Leber','Darm'],
   claim:''},
  {id:'brahmi', name:'Bio Brahmi', type:'bot', dose:300, unit:'mg', step:50, pk:12, nrv:null, softMax:600, maxSafe:null,
   desc:'Brahmi (Bacopa monnieri), Blattpulver mit Bacosiden.',
   scope:'Nervensystem | Konzentration',
   goals:['Konzentration'],
   claim:''},
  {id:'bockshornklee', name:'Bio Bockshornkleesamen', type:'bot', dose:500, unit:'mg', step:100, pk:12, nrv:null, softMax:1500, maxSafe:null,
   desc:'Bockshornkleesamen (Trigonella foenum-graecum), gemahlen.',
   scope:'Stoffwechsel | Ayurveda',
   goals:['Energie'],
   claim:''},
  {id:'mate', name:'Bio Mateblätter', type:'bot', dose:500, unit:'mg', step:100, pk:20, nrv:null, softMax:1500, maxSafe:2000,
   desc:'Mateblätter (Ilex paraguariensis), gemahlen. Natürlich koffeinhaltig.',
   scope:'Energie | Koffein',
   goals:['Energie','Konzentration'],
   claim:''},
  {id:'melisse', name:'Bio Melissenblätter', type:'bot', dose:400, unit:'mg', step:100, pk:30, nrv:null, softMax:1000, maxSafe:null,
   desc:'Melissenblätter (Melissa officinalis), gemahlen.',
   scope:'Entspannung | Schlaf',
   goals:['Schlaf','Stress'],
   claim:''},
  {id:'silberohr', name:'Bio Silberohr', type:'bot', dose:300, unit:'mg', step:50, pk:50, nrv:null, softMax:600, maxSafe:null,
   desc:'Silberohr (Tremella fuciformis), Pilzpulver mit Polysacchariden.',
   scope:'Haut | Vitalpilz',
   goals:['Haut'],
   claim:''},
  {id:'schafgarbe', name:'Bio Schafgarbe', type:'bot', dose:300, unit:'mg', step:50, pk:25, nrv:null, softMax:900, maxSafe:null,
   desc:'Schafgarbenkraut (Achillea millefolium), gemahlen.',
   scope:'Verdauung',
   goals:['Darm'],
   claim:''},
  {id:'agar', name:'Bio Agar Agar', type:'bot', dose:500, unit:'mg', step:100, pk:15, nrv:null, softMax:2000, maxSafe:null,
   desc:'Agar-Agar (E 406) aus Rotalgen. Geliermittel, quillt mit Wasser.',
   scope:'Ballaststoff',
   goals:['Darm'],
   claim:''},
  {id:'baobab', name:'Bio Baobab', type:'bot', dose:500, unit:'mg', step:100, pk:20, nrv:null, softMax:2000, maxSafe:null,
   desc:'Baobab-Fruchtpulver (Adansonia digitata).',
   scope:'Frucht | Ballaststoff',
   goals:['Darm'],
   claim:''},
  {id:'guarana', name:'Bio Guarana', type:'bot', dose:300, unit:'mg', step:50, pk:40, nrv:null, softMax:1000, maxSafe:1500,
   desc:'Guaranasamen (Paullinia cupana), gemahlen. Natürlich koffeinhaltig (ca. 4 %).',
   scope:'Energie | Koffein',
   goals:['Energie','Konzentration','Sport'],
   claim:''},
  {id:'oregano', name:'Bio Oreganum', type:'bot', dose:200, unit:'mg', step:50, pk:25, nrv:null, softMax:600, maxSafe:null,
   desc:'Oreganokraut (Origanum vulgare), gemahlen.',
   scope:'Küche | Kraut',
   goals:['Immunsystem'],
   claim:''},
  {id:'flohsamen', name:'Bio Flohsamenschalen', type:'bot', dose:5, unit:'g', step:1, pk:25, nrv:null, softMax:10, maxSafe:null,
   desc:'Flohsamenschalen (Plantago ovata), gemahlen. Quellende Ballaststoffe — immer mit reichlich Flüssigkeit einnehmen.',
   scope:'Darm | Ballaststoff',
   goals:['Darm','Gewicht'],
   claim:''},
  {id:'schachtelhalm', name:'Bio Schachtelhalmkraut', type:'bot', dose:400, unit:'mg', step:100, pk:25, nrv:null, softMax:1200, maxSafe:null,
   desc:'Schachtelhalmkraut (Equisetum arvense), gemahlen, mit natürlicher Kieselsäure.',
   scope:'Haut | Haare | Nägel',
   goals:['Haare','Haut'],
   claim:''},
  {id:'tulsi', name:'Bio Tulsi', type:'bot', dose:300, unit:'mg', step:50, pk:20, nrv:null, softMax:900, maxSafe:null,
   desc:'Tulsikraut (Ocimum tenuiflorum), gemahlen.',
   scope:'Ayurveda | Entspannung',
   goals:['Stress'],
   claim:''},
  {id:'zistrose', name:'Bio Zistrosenkraut', type:'bot', dose:300, unit:'mg', step:50, pk:30, nrv:null, softMax:900, maxSafe:null,
   desc:'Zistrosenkraut (Cistus incanus), gemahlen, mit Polyphenolen.',
   scope:'Polyphenole',
   goals:['Immunsystem'],
   claim:''},
  {id:'shatavari', name:'Bio Shatavari', type:'bot', dose:500, unit:'mg', step:100, pk:20, nrv:null, softMax:1500, maxSafe:null,
   desc:'Shatavari-Wurzel (Asparagus racemosus), gemahlen.',
   scope:'Ayurveda',
   goals:['Stress'],
   claim:''},
  {id:'artischocke', name:'Bio Artischockenextrakt', type:'bot', dose:300, unit:'mg', step:50, pk:50, nrv:null, softMax:600, maxSafe:null,
   desc:'Artischockenblatt-Extrakt (Cynara scolymus) mit Cynarin.',
   scope:'Leber | Verdauung',
   goals:['Leber','Darm'],
   claim:''},
  {id:'granatapfel', name:'Bio Granatapfelextrakt', type:'bot', dose:300, unit:'mg', step:50, pk:50, nrv:null, softMax:600, maxSafe:null,
   desc:'Granatapfel-Extrakt (Punica granatum) mit Punicalaginen.',
   scope:'Polyphenole | Herz',
   goals:['Herz','Longevity'],
   claim:''},
  {id:'garcinia', name:'Bio Garcinia Cambogiaextrakt', type:'bot', dose:500, unit:'mg', step:100, pk:70, nrv:null, softMax:1000, maxSafe:1000,
   desc:'Garcinia-cambogia-Extrakt mit Hydroxyzitronensäure (HCA).',
   scope:'Stoffwechsel',
   goals:['Gewicht'],
   claim:''},
  {id:'agaricus', name:'Bio Agaricus Pilz', type:'bot', dose:300, unit:'mg', step:50, pk:50, nrv:null, softMax:900, maxSafe:null,
   desc:'Agaricus blazei murill, Pilzpulver mit Beta-Glucanen.',
   scope:'Vitalpilz',
   goals:['Immunsystem'],
   claim:''},
  {id:'wermut', name:'Bio Wermut', type:'bot', dose:200, unit:'mg', step:50, pk:30, nrv:null, softMax:400, maxSafe:400,
   desc:'Wermutkraut (Artemisia absinthium), gemahlen. Enthält Thujon.',
   scope:'Bitterstoffe',
   goals:['Darm'],
   claim:''},
  {id:'amla', name:'Bio Amla', type:'bot', dose:500, unit:'mg', step:100, pk:15, nrv:null, softMax:1500, maxSafe:null,
   desc:'Amla-Fruchtpulver (Phyllanthus emblica), mit natürlichem Vitamin C.',
   scope:'Frucht | Ayurveda',
   goals:['Immunsystem'],
   claim:''},
];

// ── VOLLSTÄNDIGE EU HEALTH CLAIMS (VO 432/2012 + 983/2009) ──────────────────────
// Pro Nährstoff: Liste aller zugelassenen Claims. Jeder Claim:
//   t = exakte zugelassene Formulierung (DE)
//   g = zugeordnetes Ziel-Tag (für Relevanz-Match) oder null
// Reihenfolge = feste Priorität (Tie-Breaker), wichtigste zuerst.
var CLAIMS_ALL = {
 vit_a: [
   {t:'Vitamin A trägt zu einem normalen Eisenstoffwechsel bei.', g:'Energie'},
   {t:'Vitamin A trägt zur Erhaltung normaler Schleimhäute bei.', g:'Immunsystem'},
   {t:'Vitamin A trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Vitamin A trägt zur Erhaltung normaler Sehkraft bei.', g:'Augen'},
   {t:'Vitamin A trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Vitamin A hat eine Funktion bei der Zellspezialisierung.', g:null}
 ],
 vit_b1: [
   {t:'Thiamin trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Thiamin trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Thiamin trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Thiamin trägt zu einer normalen Herzfunktion bei.', g:'Herz'}
 ],
 vit_b2: [
   {t:'Riboflavin trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Riboflavin trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Riboflavin trägt zur Erhaltung normaler Schleimhäute bei.', g:'Immunsystem'},
   {t:'Riboflavin trägt zur Erhaltung normaler roter Blutkörperchen bei.', g:null},
   {t:'Riboflavin trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Riboflavin trägt zur Erhaltung normaler Sehkraft bei.', g:'Augen'},
   {t:'Riboflavin trägt zu einem normalen Eisenstoffwechsel bei.', g:null},
   {t:'Riboflavin trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null},
   {t:'Riboflavin trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'}
 ],
 vit_b3: [
   {t:'Niacin trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Niacin trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Niacin trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Niacin trägt zur Erhaltung normaler Schleimhäute bei.', g:'Immunsystem'},
   {t:'Niacin trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Niacin trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'}
 ],
 vit_b5: [
   {t:'Pantothensäure trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Pantothensäure trägt zu einer normalen geistigen Leistungsfähigkeit bei.', g:'Konzentration'},
   {t:'Pantothensäure trägt zur normalen Synthese und zum normalen Stoffwechsel von Steroidhormonen, Vitamin D und einigen Neurotransmittern bei.', g:'Stress'},
   {t:'Pantothensäure trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'}
 ],
 vit_b6: [
   {t:'Vitamin B6 trägt zu einem normalen Eiweiß- und Glykogenstoffwechsel bei.', g:'Sport'},
   {t:'Vitamin B6 trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Vitamin B6 trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Vitamin B6 trägt zur Regulierung der Hormontätigkeit bei.', g:null},
   {t:'Vitamin B6 trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Vitamin B6 trägt zur normalen Bildung roter Blutkörperchen bei.', g:null},
   {t:'Vitamin B6 trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Vitamin B6 trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Vitamin B6 trägt zu einem normalen Homocystein-Stoffwechsel bei.', g:'Herz'},
   {t:'Vitamin B6 trägt zu einer normalen Cystein-Synthese bei.', g:null}
 ],
 vit_b12: [
   {t:'Vitamin B12 trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Vitamin B12 trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Vitamin B12 trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Vitamin B12 trägt zur normalen Bildung roter Blutkörperchen bei.', g:null},
   {t:'Vitamin B12 trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Vitamin B12 trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Vitamin B12 hat eine Funktion bei der Zellteilung.', g:null},
   {t:'Vitamin B12 trägt zu einem normalen Homocystein-Stoffwechsel bei.', g:'Herz'}
 ],
 biotin: [
   {t:'Biotin trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Biotin trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Biotin trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Biotin trägt zur Erhaltung normaler Haare bei.', g:'Haare'},
   {t:'Biotin trägt zur Erhaltung normaler Schleimhäute bei.', g:'Immunsystem'},
   {t:'Biotin trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Biotin trägt zu einem normalen Stoffwechsel von Makronährstoffen bei.', g:'Energie'}
 ],
 folat: [
   {t:'Folat trägt zum Wachstum des mütterlichen Gewebes während der Schwangerschaft bei.', g:null},
   {t:'Folat trägt zur normalen Aminosäuresynthese bei.', g:null},
   {t:'Folat trägt zur normalen Blutbildung bei.', g:null},
   {t:'Folat trägt zu einem normalen Homocystein-Stoffwechsel bei.', g:'Herz'},
   {t:'Folat trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Folat trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Folat trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Folat hat eine Funktion bei der Zellteilung.', g:null}
 ],
 vit_c: [
   {t:'Vitamin C trägt dazu bei, die normale Funktion des Immunsystems während und nach intensiver körperlicher Betätigung aufrechtzuerhalten.', g:'Sport'},
   {t:'Vitamin C trägt zu einer normalen Kollagenbildung für eine normale Funktion der Haut bei.', g:'Haut'},
   {t:'Vitamin C trägt zu einer normalen Kollagenbildung für eine normale Funktion der Knochen bei.', g:'Knochen'},
   {t:'Vitamin C trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Vitamin C trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Vitamin C trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Vitamin C trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null},
   {t:'Vitamin C trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Vitamin C erhöht die Eisenaufnahme.', g:null}
 ],
 vit_d: [
   {t:'Vitamin D trägt zu einer normalen Aufnahme und Verwertung von Calcium und Phosphor bei.', g:'Knochen'},
   {t:'Vitamin D trägt zu einem normalen Calciumspiegel im Blut bei.', g:null},
   {t:'Vitamin D trägt zur Erhaltung normaler Knochen bei.', g:'Knochen'},
   {t:'Vitamin D trägt zur Erhaltung einer normalen Muskelfunktion bei.', g:'Sport'},
   {t:'Vitamin D trägt zur Erhaltung normaler Zähne bei.', g:null},
   {t:'Vitamin D trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Vitamin D hat eine Funktion bei der Zellteilung.', g:null}
 ],
 vit_e: [
   {t:'Vitamin E trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null}
 ],
 vit_k: [
   {t:'Vitamin K trägt zu einer normalen Blutgerinnung bei.', g:null},
   {t:'Vitamin K trägt zur Erhaltung normaler Knochen bei.', g:'Knochen'}
 ],
 calcium: [
   {t:'Calcium trägt zu einer normalen Blutgerinnung bei.', g:null},
   {t:'Calcium trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Calcium trägt zu einer normalen Muskelfunktion bei.', g:'Sport'},
   {t:'Calcium trägt zu einer normalen Signalübertragung zwischen den Nervenzellen bei.', g:'Konzentration'},
   {t:'Calcium trägt zu einer normalen Funktion von Verdauungsenzymen bei.', g:'Darm'},
   {t:'Calcium hat eine Funktion bei der Zellteilung und -spezialisierung.', g:null},
   {t:'Calcium wird für die Erhaltung normaler Knochen benötigt.', g:'Knochen'},
   {t:'Calcium wird für die Erhaltung normaler Zähne benötigt.', g:null}
 ],
 chrom: [
   {t:'Chrom trägt zu einem normalen Stoffwechsel von Makronährstoffen bei.', g:'Energie'},
   {t:'Chrom trägt zur Aufrechterhaltung eines normalen Blutzuckerspiegels bei.', g:null}
 ],
 eisen: [
   {t:'Eisen trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Eisen trägt zu einer normalen Bildung roter Blutkörperchen und von Hämoglobin bei.', g:null},
   {t:'Eisen trägt zu einem normalen Sauerstofftransport im Körper bei.', g:'Sport'},
   {t:'Eisen trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Eisen trägt zu einer normalen kognitiven Funktion bei.', g:'Konzentration'},
   {t:'Eisen trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Eisen hat eine Funktion bei der Zellteilung.', g:null}
 ],
 jod: [
   {t:'Jod trägt zu einer normalen kognitiven Funktion bei.', g:'Konzentration'},
   {t:'Jod trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Jod trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Jod trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Jod trägt zu einer normalen Produktion von Schilddrüsenhormonen und zu einer normalen Schilddrüsenfunktion bei.', g:null}
 ],
 kalium: [
   {t:'Kalium trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Kalium trägt zu einer normalen Muskelfunktion bei.', g:'Sport'},
   {t:'Kalium trägt zur Aufrechterhaltung eines normalen Blutdrucks bei.', g:'Herz'}
 ],
 kupfer: [
   {t:'Kupfer trägt zur Erhaltung von normalem Bindegewebe bei.', g:'Haut'},
   {t:'Kupfer trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Kupfer trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Kupfer trägt zu einer normalen Haarpigmentierung bei.', g:'Haare'},
   {t:'Kupfer trägt zu einem normalen Eisentransport im Körper bei.', g:null},
   {t:'Kupfer trägt zu einer normalen Hautpigmentierung bei.', g:'Haut'},
   {t:'Kupfer trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Kupfer trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null}
 ],
 magnesium: [
   {t:'Magnesium trägt zur Verringerung von Müdigkeit und Erschöpfung bei.', g:'Energie'},
   {t:'Magnesium trägt zum Elektrolytgleichgewicht bei.', g:null},
   {t:'Magnesium trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Magnesium trägt zu einer normalen Funktion des Nervensystems bei.', g:'Konzentration'},
   {t:'Magnesium trägt zu einer normalen Muskelfunktion bei.', g:'Sport'},
   {t:'Magnesium trägt zu einer normalen Eiweißsynthese bei.', g:'Sport'},
   {t:'Magnesium trägt zu einer normalen psychischen Funktion bei.', g:'Stress'},
   {t:'Magnesium trägt zur Erhaltung normaler Knochen bei.', g:'Knochen'},
   {t:'Magnesium trägt zur Erhaltung normaler Zähne bei.', g:null},
   {t:'Magnesium hat eine Funktion bei der Zellteilung.', g:null}
 ],
 mangan: [
   {t:'Mangan trägt zu einem normalen Energiestoffwechsel bei.', g:'Energie'},
   {t:'Mangan trägt zur Erhaltung normaler Knochen bei.', g:'Knochen'},
   {t:'Mangan trägt zu einer normalen Bildung von Bindegewebe bei.', g:'Haut'},
   {t:'Mangan trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null}
 ],
 selen: [
   {t:'Selen trägt zu einer normalen Spermabildung bei.', g:null},
   {t:'Selen trägt zur Erhaltung normaler Haare bei.', g:'Haare'},
   {t:'Selen trägt zur Erhaltung normaler Nägel bei.', g:null},
   {t:'Selen trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Selen trägt zu einer normalen Schilddrüsenfunktion bei.', g:null},
   {t:'Selen trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null}
 ],
 zink: [
   {t:'Zink trägt zu einem normalen Säure-Basen-Stoffwechsel bei.', g:null},
   {t:'Zink trägt zu einem normalen Kohlenhydratstoffwechsel bei.', g:'Energie'},
   {t:'Zink trägt zu einer normalen kognitiven Funktion bei.', g:'Konzentration'},
   {t:'Zink trägt zu einer normalen DNA-Synthese bei.', g:null},
   {t:'Zink trägt zu einer normalen Fruchtbarkeit und einer normalen Reproduktion bei.', g:null},
   {t:'Zink trägt zu einem normalen Stoffwechsel von Makronährstoffen bei.', g:'Energie'},
   {t:'Zink trägt zu einem normalen Fettsäurestoffwechsel bei.', g:null},
   {t:'Zink trägt zu einem normalen Vitamin-A-Stoffwechsel bei.', g:null},
   {t:'Zink trägt zu einer normalen Eiweißsynthese bei.', g:'Sport'},
   {t:'Zink trägt zur Erhaltung normaler Knochen bei.', g:'Knochen'},
   {t:'Zink trägt zur Erhaltung normaler Haare bei.', g:'Haare'},
   {t:'Zink trägt zur Erhaltung normaler Nägel bei.', g:null},
   {t:'Zink trägt zur Erhaltung normaler Haut bei.', g:'Haut'},
   {t:'Zink trägt zur Erhaltung eines normalen Testosteronspiegels im Blut bei.', g:null},
   {t:'Zink trägt zur Erhaltung normaler Sehkraft bei.', g:'Augen'},
   {t:'Zink trägt zu einer normalen Funktion des Immunsystems bei.', g:'Immunsystem'},
   {t:'Zink trägt dazu bei, die Zellen vor oxidativem Stress zu schützen.', g:null},
   {t:'Zink hat eine Funktion bei der Zellteilung.', g:null}
 ],
 omega3: [
   {t:'DHA trägt zur Erhaltung einer normalen Gehirnfunktion bei. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 250 mg DHA ein.', g:'Konzentration'},
   {t:'DHA trägt zur Erhaltung normaler Sehkraft bei. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 250 mg DHA ein.', g:'Augen'},
   {t:'EPA und DHA tragen zu einer normalen Herzfunktion bei. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 250 mg EPA und DHA ein.', g:'Herz'}
   // Bewusst NICHT aufgenommen:
   //  - Triglyceridspiegel: braucht 2 g DHA/Tag, unser maxSafe liegt bei 1 g.
   //  - Blutdruck: braucht 3 g EPA+DHA/Tag, erst recht unerreichbar.
   //  - Die beiden Schwangerschafts-Angaben (Entwicklung von Gehirn und Augen
   //    beim Foetus und gestillten Saeugling, 200 mg DHA zusaetzlich) sind
   //    Artikel-14-Angaben aus einer anderen Verordnung, mit eigenen
   //    Bedingungen und Pflichthinweisen. Erst nach juristischer Pruefung.
   // Hinweis zur Herzfunktion-Angabe: sie lautet auf EPA UND DHA. Unser
   // Rohstoff enthaelt nur DHA. Die Schwelle von 250 mg bezieht sich auf die
   // Summe beider, DHA allein zaehlt darauf ein — das ist die uebliche
   // Auslegung, aber keine ausdrueckliche Klarstellung der Kommission.
 ],
 cholin: [
   {t:'Cholin trägt zu einem normalen Homocystein-Stoffwechsel bei.', g:'Herz'},
   {t:'Cholin trägt zu einem normalen Fettstoffwechsel bei.', g:null},
   {t:'Cholin trägt zur Erhaltung einer normalen Leberfunktion bei.', g:'Leber'}
 ],
 glucomannan: [
   // Health Claims deaktiviert: Gewichtsabnahme erfordert 3 g/Tag (3×1 g), Cholesterin
   // erfordert 4 g als Einzelportion – wegen Quell-/Erstickungsrisiko nicht vertretbar.
 ],
 guarkernmehl: [
   {t:'Guarkernmehl trägt zur Aufrechterhaltung eines normalen Cholesterinspiegels im Blut bei.', g:'Herz'}
 ]
};

// ── CLAIM-AUSWAHL-LOGIK ─────────────────────────────────────────────────────────
// Liefert für einen Nährstoff die N relevantesten Claims.
// Reihenfolge: erst Claims, deren Ziel-Tag in den aktiven Nutzer-Zielen liegt
// (in Reihenfolge der Nutzer-Ziele), dann Auffüllen nach fester DB-Reihenfolge.
function getTopClaims(id, n){
  var list = CLAIMS_ALL[id];
  if(!list || !list.length) return [];
  n = n || 3;
  var userGoals = (S.ans && S.ans.goals) ? S.ans.goals : [];
  var picked = [], used = {};
  // 1) Ziel-Match in Reihenfolge der Nutzer-Ziele
  userGoals.forEach(function(goal){
    list.forEach(function(c, idx){
      if(picked.length>=n) return;
      if(used[idx]) return;
      if(c.g === goal){ picked.push(c.t); used[idx]=true; }
    });
  });
  // 2) Auffüllen nach fester DB-Reihenfolge (Tie-Breaker)
  list.forEach(function(c, idx){
    if(picked.length>=n) return;
    if(used[idx]) return;
    picked.push(c.t); used[idx]=true;
  });
  return picked.slice(0,n);
}
// Alle Claims eines Nährstoffs als Volltext (für das EU-Health-Claims-Feld)
function getAllClaims(id){
  var list = CLAIMS_ALL[id];
  if(!list || !list.length) return [];
  return list.map(function(c){return c.t;});
}

// ── Wirksame Menge fuer einen Health Claim ────────────────────────────────
// Ein Claim darf nur stehen, wenn der Naehrstoff in wirksamer Menge enthalten
// ist: 15 % NRV je Tagesportion (VO 1169/2011 Anh. XIII), bei Zutaten ohne
// NRV die in der Zulassung genannte Mindestmenge (Glucomannan 3 g,
// Guarkernmehl 10 g, Kreatin 3 g). Botanicals tragen nie einen Claim.
// Diese Pruefung stand bis 10/2026 dreimal im Code (Bestellung, Etikett,
// Beipackzettel) und fehlte in den beiden Bildschirmausgaben. Jetzt eine
// Funktion, die alle fuenf Stellen benutzen.
function claimErlaubt(it){
  if(!it) return false;
  if(it.type==='bot' || it.type==='plant') return false;
  var amt = S.amt[it.id] || 0;
  if(amt <= 0) return false;
  if(it.nrv && (amt/it.nrv)*100 < 15) return false;
  if(it.claimMin && amt < it.claimMin) return false;
  return true;
}

// Kleinste Dosis, bei der der Claim noch steht — Untergrenze fuer jede
// Kuerzung. null = die Zutat traegt ohnehin keinen Claim.
function claimUntergrenze(it){
  if(!it || it.type==='bot' || it.type==='plant') return null;
  var g = 0;
  if(it.nrv)      g = Math.max(g, it.nrv*0.15);
  if(it.claimMin) g = Math.max(g, it.claimMin);
  return g > 0 ? g : null;
}

// Rendert die Claims-Box für eine Rezeptur-Karte.
// Botanicals (type 'bot') und Pflanzenpulver (type 'plant') zeigen NIE einen Health Claim.
// Nährstoffe zeigen die 3 relevantesten EU-Claims (Ziel-Match + feste Reihenfolge).
function renderClaims(it){
  // Bis 10/2026 pruefte diese Karte nur claimMin, nicht die 15 % NRV. Calcium
  // bei 100 mg (13 % NRV) zeigte hier seinen Claim, waehrend Bestellung und
  // Etikett ihn richtigerweise weglassen.
  if(!claimErlaubt(it)) return '';
  var cl = getTopClaims(it.id, 3);
  if(!cl.length){
    // Fallback: bestehender Einzel-Claim, falls für die ID keine Liste existiert
    return it.claim ? '<div class="b-claim">'+it.claim+'</div>' : '';
  }
  var inner = cl.map(function(t){return '<div style="margin-bottom:3px">'+t+'</div>';}).join('');
  return '<div class="b-claim">'+inner+'</div>';
}

// ── UNIFIED DB für Abwärtskompatibilität ─────────────────────────────────────
// Baut eine einheitliche DB aus NUTRIENTS, PLANT_SOURCES und BOTANICALS
// Nutzt ref_nutrients um Nährstoff-Werte in Pflanzliche Quellen einzutragen
// Waechter: buildDB() baut Naehrstoffe Feld fuer Feld neu auf. Jedes Feld, das
// dabei vergessen wird, verschwindet still zur Laufzeit — genau so verloren
// Omega-3, Glucomannan und Guarkernmehl ihre claimMin und trugen ihren Health
// Claim auch weit unter der noetigen Menge. Diese Pruefung vergleicht nach dem
// Aufbau die Rohdaten mit der fertigen DB und meldet, was fehlt.
function _pruefeDbFelder(db){
  var pflicht = ['claimMin','nrv','softMax','maxSafe','std','pk'];
  var fehlend = [];
  NUTRIENTS.forEach(function(n){
    var x = db.find(function(y){ return y.id===n.id; });
    if(!x) return;
    pflicht.forEach(function(f){
      if(n[f] !== undefined && n[f] !== null && x[f] === undefined)
        fehlend.push(n.id + '.' + f);
    });
  });
  if(fehlend.length && typeof console!=='undefined' && console.warn)
    console.warn('[Puraveda] buildDB() verliert Felder aus NUTRIENTS: '
      + fehlend.join(', ') + '. Ohne sie greifen Claim-Schranken und '
      + 'Sicherheits-Hoechstmengen zur Laufzeit nicht.');
  return fehlend;
}

function buildDB(){

  function isActive(id, type){
    if(type==='nutrient') return true;
    if(!window._activeIds) return true;
    return window._activeIds.indexOf(id)>=0;
  }

  var db = [];
  

  NUTRIENTS.forEach(function(n){
    if(!isActive(n.id,'nutrient'))return;
    db.push({
      id: n.id, name: n.name, type:'nutrient',
      nutrient: n.name,
      dose: n.base_dose || n.nrv || 0,
      unit: n.unit,
      step: (function(d,u){
        var raw=Math.max(d*0.05,0.001);
        // Round to sensible minimum by unit
        if(u==='µg') raw=Math.max(raw,0.25);
        else if(u==='mg') raw=Math.max(raw,0.01);
        else if(u==='g')  raw=Math.max(raw,0.05);
        return parseFloat(raw.toFixed(4));
      })(n.base_dose||n.nrv||n.dose||0, n.unit||'mg'),
      pk: n.pk || 0,
      nrv: n.nrv,
      softMax: n.softMax,
      maxSafe: n.maxSafe,
      noUpperLimit: n.noUpperLimit || false,
      base_score: n.base_score || 0,
      scope: (n.goals||[]).join(' | '),
      desc: n.claim || '',
      claim: n.claim || '',
      // claimMin MUSS mitwandern. Fehlte es hier, verloren Omega-3,
      // Glucomannan und Guarkernmehl zur Laufzeit ihre Claim-Untergrenze:
      // claimErlaubt() prueft it.claimMin, und bei nrv:null fiel damit jede
      // Schranke weg — der Claim stand dann auch bei 1 g statt 10 g auf
      // Etikett und Beipackzettel. Kreatin war nicht betroffen, weil
      // BOTANICALS unveraendert durchgereicht werden.
      claimMin: n.claimMin,
      goals: n.goals || [],
      se_def: n.se || {},
      mandatory_conditions: n.mandatory_conditions || [],
      std: (n.std!==undefined && n.std!==null) ? n.std : 1,
      powderDose: n.powderDose, powderUnit: n.powderUnit,
    });
  });
  

  PLANT_SOURCES.forEach(function(p){
    if(!isActive(p.id,'bot'))return;
  
    var primaryNut = p.ref_nutrients && p.ref_nutrients[0];
    var nutObj = primaryNut ? NUTRIENTS.find(function(n){return n.id===primaryNut.id;}) : null;
    db.push({
      id: p.id, name: p.name, type:'bot',
      nutrient: nutObj ? nutObj.name : null,
      base_score: nutObj ? (nutObj.base_score||0) : 0,
      dose: p.dose,
      unit: p.unit,
      step: p.step,
      pk: p.pk,
      nrv: nutObj ? nutObj.nrv : null,
      softMax: nutObj ? nutObj.softMax : null,
      maxSafe: nutObj ? nutObj.maxSafe : null,
      noUpperLimit: nutObj ? (nutObj.noUpperLimit||false) : false,
      scope: p.scope || '',
      desc: p.desc || '',
      claim: (nutObj ? nutObj.claim : '') || '',
      goals: nutObj ? (nutObj.goals||[]) : [],
      ref_nutrients: p.ref_nutrients || [],
      std: primaryNut ? primaryNut.std : 1,
      se_def: nutObj ? (nutObj.se||{}) : {},
      mandatory_conditions: nutObj ? (nutObj.mandatory_conditions||[]) : [],
    });
  });
  

  BOTANICALS.forEach(function(b){
    if(!isActive(b.id,'bot'))return;
    db.push(b);
  });
  

  _pruefeDbFelder(db);
  return db;
}

var DB = buildDB();

// ═══════════════════════════════════════════════════════════════════════════
// SHOPIFY INTEGRATION + AGB + EMAIL
// ═══════════════════════════════════════════════════════════════════════════

// ── Konfiguration ──────────────────────────────────────────────────────────
var SHOPIFY_DOMAIN   = 'biotiva.de';         
var SHOPIFY_PRODUCT_ID = ''; // Shopify Produkt-ID (im Shopify Admin eintragen)
var SHOPIFY_VARIANT_ID = '53150276550923';       // (Alt-Guard für Produkt A, bleibt)

// ── Produkt A: 3×30-Abo (Seal, 3 Zyklen, endet automatisch) ──
var SEAL_SELLING_PLAN_ID = 8685093131;           // Seal Plan, auf max 3 Zyklen konfiguriert
var SEAL_ABO_DISCOUNT = 0;                        // Abo künftig OHNE Rabatt (Rabatt liegt beim 90-Tage-Kauf)

// ── Produkt B: 90-Tage-Einmalkauf ──
var PRODUCT_B_90_ID   = 10992788373771;           // Shopify Product-ID (nur Info/Debug)
var NINETY_DISCOUNT   = 0.08;                     // 8 % Rabatt auf 3× Monatspreis

// Kaufart: '90' = Einmalkauf 90 Tage | 'abo3' = 3×30 Abo
var PURCHASE_TYPE = '90';                         // Default: 90-Tage (mit Rabatt = attraktiver)
// Vom Kunden gewählte Darreichungsform: 'powder' = Pulver (Standard), 'capsule' = Kapseln
var DELIVERY_FORM = 'powder';
// Zweite, unabhängige Wahl für die Abend-Routine. Gramm-Zutaten (Kreatin,
// Guarkernmehl, MCT …) bleiben auch dann Pulver, wenn hier 'capsule' steht —
// sie passen physikalisch nicht in eine 450-mg-Kapsel.
var DELIVERY_FORM_EVENING = 'powder';
// Freigabeschalter fuer die Abend-Kapsel-Option. MUSS false bleiben, solange die
// AV App keinen zweiten Kapsel-Fuell-Lauf beherrscht (eigenes Rueckenetikett,
// Verzehrempfehlung, Tuetengroesse, 300 Kapselhuellen in der Ruestliste). Bei
// false verhaelt sich der Konfigurator exakt wie vorher: Abend immer Pulver.
var EVENING_CAPSULE_ENABLED = true;
// Einzige Stelle, die entscheidet, ob der Abend als Kapsel laeuft.
function eveningIsCapsule(){
  return EVENING_CAPSULE_ENABLED && DELIVERY_FORM_EVENING==='capsule';
}
// Tüten-Bilder für Morgen-/Abend-Routine. Leer lassen = Emoji-Platzhalter.
// Später hier die gehosteten Bild-URLs eintragen (z. B. Shopify-CDN).
var IMG_POUCH_MORNING = '';   // z. B. 'https://www.biotiva.de/cdn/shop/files/morgen.png'
var IMG_POUCH_EVENING = '';   // z. B. 'https://www.biotiva.de/cdn/shop/files/abend.png'
// Gebündelten Health-Claims-Sammelkasten auf der Ergebnisseite anzeigen?
// false = ausgeblendet (Claims stehen ohnehin unter jeder Zutat). true = Kasten zeigen.
var SHOW_CLAIMS_SUMMARY_BOX = false;
// Google Apps Script URL — nach Deployment hier eintragen:
window.GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwbiRXXEWfVpslTw_W4NzudbKwNAUtDFNNCuNt41WrLrTtEtFXa6-bKsQYObuhhwlIS/exec'; // Shopify Varianten-ID
// Ziel fuer den Rezeptur-Versand an den Kunden. Standard ist dasselbe Apps
// Script wie oben. Soll stattdessen Zapier versenden, hier die URL des
// "Catch Hook" eintragen — der Payload enthaelt fertige Felder betreff, text
// und empfaenger, die sich direkt auf eine Mail-Aktion mappen lassen.
// Der Bestellweg (Shopify -> Zapier-Liste) bleibt davon unberuehrt.
window.PURAVEDA_MAIL_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/4797622/4dgljl1/';
// Mitgesendetes Kennwort. Der Zap prueft es in einem Filter-Schritt und bricht
// ab, wenn es fehlt. Das haelt Bots ab, die die Adresse im Quelltext finden —
// gegen jemanden, der gezielt hinschaut, schuetzt es nicht, denn es steht
// zwangslaeufig mit in dieser Datei. Bei Missbrauch hier und im Zap aendern.
window.PURAVEDA_MAIL_TOKEN = 'pv-8f3c1a29';
var INTERNAL_EMAIL   = 'germekoliver@gmail.com';
var EMAILJS_SERVICE  = ''; 
var EMAILJS_TEMPLATE = ''; 
var EMAILJS_KEY      = ''; 

// ── AGB-Zustimmung Status ──────────────────────────────────────────────────
var agbAccepted = false;
var sgbAccepted = false;

function toggleAgb(cb){
  agbAccepted = cb.checked;
  updateCartBtn();
}

function updateCartBtn(){
  var btn = document.getElementById('b-cart-btn-main');
  if(btn){
    var ok = agbAccepted && sgbAccepted;
    btn.style.opacity = ok ? '1' : '0.5';
    btn.style.cursor  = ok ? 'pointer' : 'not-allowed';
  }
}
function toggleSgb(cb){
  sgbAccepted = cb.checked;
  updateCartBtn();
}

// ── State speichern für Zurück-Button ──────────────────────────────────────
function saveStateForReturn(){
  try {
    var state = {
      ans:  S.ans,
      amt:  S.amt,
      sc:   S.sc,
      step: 'r',
      ts:   Date.now()
    };
    localStorage.setItem('biotiva_state', JSON.stringify(state));
  } catch(e){}
}

function restoreState(){
  try {
    var raw = localStorage.getItem('biotiva_state');
    if(!raw) return false;
    var state = JSON.parse(raw);
    if(!state || typeof state!=='object') return false;
    if(Date.now() - (state.ts||0) > 3600000) return false; // 1h timeout
    // Nur wiederherstellen, wenn der Zustand plausibel ist (sonst sauberer Start).
    if(!state.ans || !state.amt || !state.sc) return false;
    S.ans  = state.ans;
    S.amt  = state.amt;
    S.sc   = state.sc;
    S.step = 'r';
    // Booster-Dosen neu setzen. Der gespeicherte Stand kann aus einer Zeit
    // stammen, in der eine Zutat noch keine feste Dosis hatte — Guarkernmehl
    // kam so mit 1 g statt 10 g zurueck, und der Claim-Pruefung fehlte die
    // Grundlage. Die feste Dosis gilt immer, auch fuer alte Staende.
    if(typeof boosterDosisAnwenden==='function') boosterDosisAnwenden();
    agbAccepted = false;
    try { render(); }
    catch(eR){
      // Wiederherstellung führte zu Render-Fehler → alten Zustand verwerfen, sauber starten.
      try { localStorage.removeItem('biotiva_state'); } catch(eX){}
      S.step='start'; S.ans={}; S.sc={}; S.amt={}; S.mode=null;
      render();
    }
    return true;
  } catch(e){
    try { localStorage.removeItem('biotiva_state'); } catch(eX){}
    return false;
  }
}

// ── Shopify: Artikel in den Warenkorb ──────────────────────────────────────
function addToShopifyCart(){


  var rname = S.ans.rezepturname || 'Meine Biotiva Rezeptur';
  // Bestellt wird exakt das, was auch produziert und berechnet wird —
  // dieselbe Menge wie auf der Ergebnisseite und im Live-Preis.
  var activeItems = billableItems();

  // ── Strukturierte Line Item Properties für Zapier → Google Sheets ──────────
  var properties = {};

  // ── Kunden-Properties (sichtbar im Cart) ───────────────────────────────
  properties['Rezepttitel']           = rname || 'Meine Rezeptur';
  properties['Ziele']                 = (S.ans.goals || []).join(' | ');
  // properties['Kaufart'] wird weiter unten je nach '90' / 'abo3' gesetzt (Add-to-Cart-Block)
  // _prod MUSS vor der Darreichungszeile stehen: sie liest _prod.days fuer die
  // Beutelzahl. Stand die Deklaration weiter unten, war _prod durch var-Hoisting
  // hier undefined und addToShopifyCart brach ab, sobald die Rezeptur einen
  // Booster enthielt — also praktisch immer. Gefunden 30.10.2026.
  var _prod = getProductionData();
  var _dfE = getCapsuleDistribution();
  var _eveCaps = (eveningIsCapsule() && _dfE.hasEveningCaps);
  properties['Darreichungsform']      = 'Morgens: ' + ((DELIVERY_FORM==='capsule') ? 'Kapseln' : 'Pulver')
                                      + ' · Abends: ' + (_eveCaps ? ('Kapseln' + (_dfE.eveningPowder.length ? ' + Pulver' : '')) : 'Pulver')
                                      + ' (zur Mahlzeit)'
                                      + (boosterContainers().length ? ' + ' + boosterBeutelAnzahl(_prod.days) + ' Booster-Beutel (separat)' : '');

  // Jede Zutat einzeln: nur Name + Menge + Einheit
  activeItems.forEach(function(it){
    var menge = parseFloat(fa(S.amt[it.id], it.unit));
    // Name mehrfach absichern: names[] → it.name → id. So entsteht NIE ein leerer
    // Feldname (sonst überschreiben sich namenlose Zutaten gegenseitig im Payload
    // und die Produktion erhält nur Mengen ohne Zutat).
    var zutatName = (names[it.id] && String(names[it.id]).trim())
                 || (it.name && String(it.name).trim())
                 || it.id;
    properties[zutatName] = menge + ' ' + it.unit + '/Tag';
  });

  // ── Health Claims (sichtbar im Cart) — nur bei wirksamer Menge (>=15% NRV) ─
  // Jeder Claim als eigene Property => in jedem Theme als eigene Zeile sichtbar
  var _hcList = activeItems.map(function(it){
    var c = (claims[it.id]!==undefined ? claims[it.id] : it.claim) || '';
    c = c.trim();
    if(!c) return '';
    if(!claimErlaubt(it)) return '';
    return c;
  }).filter(function(x){return x;});
  // ── Alle Claims in EINER Property (Shopify-Property-Limit-sicher) ─────────
  if(_hcList.length){
    properties['Gesundheitshinweise'] = _hcList.join('  |  ');
  }

  // ── Hinweise zu Lieferung und Anwendung (bedingt, eine Property) ──────────
  var _dnotes = getDeliveryNotes();
  if(_dnotes.length){
    properties['Hinweise zu Lieferung und Anwendung'] = _dnotes.join('  |  ');
  }

  // ── Ärztlicher Rücksprache-Hinweis dokumentieren (rechtliche Absicherung) ──
  // Hält in den Bestelldaten fest, dass der Kunde einen relevanten Gesundheits-
  // zustand angegeben hat UND den Hinweis zur ärztlichen Rücksprache erhalten hat.
  var _gesArr = S.ans.gesundheit || [];
  var _docNeeded = _gesArr.some(function(g){
    return g.indexOf('schwanger')>=0 || g.indexOf('stille')>=0 ||
           g.indexOf('Medikamente')>=0 || g.indexOf('Erkrankung')>=0;
  });
  if(_docNeeded){
    properties['Ärztlicher Hinweis'] = 'Angezeigt & bestätigt: Bei Schwangerschaft, Stillzeit, Medikamenteneinnahme oder diagnostizierten Krankheiten vor Einnahme ärztliche Rücksprache empfohlen. Kundenangabe: ' + _gesArr.filter(function(g){return g.indexOf('Keine')<0;}).join(', ');
  }

  // ── Interne Properties (für Zapier/Google Sheets) ────────────────────
  properties['_Anzahl_Zutaten']       = activeItems.length + ' Zutaten';

  // ── Beutel-Aufteilung: Morning / Evening Formula (Produktion + intern) ────
  var _antP = getAntagonismResults();
  var _nmP = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?it.name:id; };
  if(_antP.split){
    properties['_Beutel_Anzahl']      = '2';
    properties['_Morning_Formula']    = _antP.morning.map(_nmP).join(', ');
    properties['_Evening_Formula']    = _antP.evening.map(_nmP).join(', ');
    properties['_Trennung_Grund']     = 'Eisen >= 5 mg (Resorptions-Konkurrenz mit Mg/Zn/Ca)';
    properties['_Antagonismen']       = _antP.triggered.map(function(a){return a.label;}).join(' | ');
  } else {
    properties['_Beutel_Anzahl']      = '1';
  }

  // ── Morgen-Routine als Kapseln: Produktionsdaten (Produktion + intern) ────
  if(DELIVERY_FORM==='capsule'){
    var _capD = getCapsuleDistribution();
    var _nmC = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?it.name:id; };
    if(_capD.hasMorning){
      properties['_Morgen_Kapseln']       = 'Ja';
      properties['_Kapseln_pro_Tag']      = String(_capD.capsulesPerDay);
      properties['_Kapseln_pro_Charge']   = String(_capD.morgenCapsTotal)+' Kapseln Bedarf, '
                                          + _capD.morgenRuns+' Füll-Lauf'+(_capD.morgenRuns>1?'läufe':'')
                                          + ' à '+_capD.capsulesPerRun;
      properties['_Kapsel_Inhalt']        = _capD.morning.map(_nmC).join(', ');
      properties['_Akazien_Auffuellung_mg_Tag'] = String(Math.round(_capD.acaciaFillMg));
      properties['_Kapselaufschlag_EUR_Tag']    = getCapsuleSurchargeDay().toFixed(2).replace('.',',');
    }
    if(_capD.hasEvening) properties['_Haupt_Pulver'] = _capD.evening.map(_nmC).join(', ');
  }

  // ── Abend-Routine als Kapseln: eigener Füll-Lauf, eigene Produktionsdaten ──
  if(eveningIsCapsule()){
    var _capE = getCapsuleDistribution();
    var _nmE = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?it.name:id; };
    if(_capE.hasEveningCaps){
      properties['_Abend_Kapseln']        = 'Ja';
      properties['_Abend_Kapseln_pro_Tag']= String(_capE.eveningCapsulesPerDay);
      properties['_Abend_Kapsel_Inhalt']  = _capE.eveningCaps.map(_nmE).join(', ');
      properties['_Abend_Akazien_Auffuellung_mg_Tag'] = String(Math.round(_capE.eveningAcaciaMg));
      if(_capE.eveningPowder.length)
        properties['_Abend_Pulver_Rest']  = _capE.eveningPowder.map(_nmE).join(', ');
    }
  }

  // ── Produktionsdaten (Einwaage für die Laufzeit, inkl. Extrakt-Umrechnung) ──
  properties['_Prod_Laufzeit_Tage'] = String(_prod.days);
  if(_prod.split){
    properties['_Prod_Morning'] = _prod.morning.join('  |  ');
    properties['_Prod_Evening'] = _prod.evening.join('  |  ');
  } else {
    properties['_Prod_Mischung'] = _prod.single.join('  |  ');
  }

  // ── SICHTBARE Zutatenlisten für Zapier → Google Sheets ─────────────────────
  // Feste Feldnamen (ohne "_"), damit Zapier sie zuverlässig als Spalten mappen kann.
  // Format je Zutat: "Name: Menge Einheit/Tag" — getrennt nach Morgen-/Abend-Routine.
  // Die Zutat-Properties oben (properties[zutatName]) haben WECHSELNDE Feldnamen und
  // sind für Zapier-Spalten ungeeignet — diese Felder hier sind der verlässliche Weg.
  (function(){
    var _res = getAntagonismResults();
    function _linesFor(ids){
      return ids.map(function(id){
        var it = DB.find(function(x){ return x.id===id; });
        if(!it) return null;
        var nm = (names[it.id] && String(names[it.id]).trim()) || it.name || it.id;
        return nm + ': ' + fa(S.amt[it.id], it.unit) + ' ' + it.unit + '/Tag';
      }).filter(Boolean);
    }
    if(_res.split){
      properties['Zutaten_Morgen'] = _linesFor(_res.morning).join('  |  ');
      properties['Zutaten_Abend']  = _linesFor(_res.evening).join('  |  ');
    } else {
      // Keine Trennung nötig → alles in einer Routine (Morgen), Abend bleibt leer.
      // Konjak bleibt auch hier draußen — es ist immer eine separate Beilage.
      properties['Zutaten_Morgen'] = _linesFor(withoutKonjak(activeItems.map(function(it){return it.id;}))).join('  |  ');
      properties['Zutaten_Abend']  = '—';
    }
    // Booster als eigene, verlaessliche Zapier-Spalten. Je Behaelter eine Zeile,
    // damit die Produktion ohne Interpretation weiss, was abzufuellen ist.
    var _bcP = boosterContainers();
    if(_bcP.length){
      // Physische Beutel, nicht Behaelter: Guarkernmehl braucht 3 x 300 g.
      // Die AV App liest "Beutel n von m" aus der Notiz und muss dieselbe
      // Gesamtzahl sehen, sonst stimmen Etiketten und Umkarton nicht.
      var _tageP = parseInt(properties['_Prod_Laufzeit_Tage']||'90',10);
      properties['Booster_Anzahl_Beutel'] = String(boosterBeutelAnzahl(_tageP));
      properties['Booster_Anzahl_Behaelter'] = String(_bcP.length);
      _bcP.forEach(function(c,i){
        var _bez = (c.art==='mix') ? 'Booster-Pulver' : (names[c.ids[0]]||c.ids[0]);
        var _inh = c.ids.map(function(id){
          var it=DB.find(function(x){return x.id===id;});
          return (names[id]||id)+' '+fa(S.amt[id],it?it.unit:'mg')+' '+(it?it.unit:'mg')+'/Tag';
        }).join(', ');
        var _z = _bez+': '+_inh
          + ' | Rohware '+Math.round(c.rohMgTag)+' mg/Tag'
          + ' | '+(c.form==='capsule' ? c.kapselnTag+' Kapseln/Tag' : 'Pulver')
          + (c.loeffelG ? ' | '+c.loeffelG+'-g-Loeffel' : '')
          + (c.loeffelKalibrieren ? ' | LOEFFEL KALIBRIEREN (einen gestrichenen Loeffel wiegen, Wert aufs Etikett)' : '');
        properties['Booster_'+(i+1)] = _z;
      });
      // Glucomannan behaelt seine gesetzlich vorgeschriebene Einnahmeangabe.
      if(konjakActive())
        properties['Konjak_Komponente'] = 'Bio Glucomannan: '+fa(S.amt['glucomannan'],'g')+' g/Tag – separater Beutel mit 1-g-Dosierlöffel ('+fa(S.amt['glucomannan']*30,'g')+' g je 30 Tage). Einnahme: 3×1 g mit Wasser vor den Mahlzeiten.';
    }
    // Gesamtliste als Rückfall/Kontrolle (inkl. Konjak – Vollständigkeit)
    properties['Zutaten_Gesamt'] = _linesFor(activeItems.map(function(it){return it.id;})).join('  |  ');

    // Fertig formatierter Rezepturtext — eine Quelle für Notiz und E-Mail.
    properties['Rezeptur_Text'] = rezepturText();
  })();

    var totalG30 = activeItems.reduce(function(acc,it){return acc+toMg(S.amt[it.id],it.unit);},0)/1000*30;
  var totalCost30 = activeItems.reduce(function(acc,it){return acc+pd(it);},0)*30;

  var totalG  = totalG30;
  var totalPr = totalCost30;

  saveStateForReturn();

  // ── Preis, Variante & Kaufart-Metadaten je nach Wahl bestimmen ──
  var _monthPrice = (S.tPrD||0)*30 + getCapsuleSurchargeMonth();
  var _variantId, _sellingPlan = null;

  if(PURCHASE_TYPE === '90'){
    // Produkt B: Einmalkauf 90 Tage
    _variantId = getVariantId90(get90DayPrice());
    if(!_variantId){
      toast('Diese 90-Tage-Rezeptur liegt bei € '+get90DayPrice().toFixed(2).replace('.',',')+' und überschreitet den bestellbaren Höchstpreis. Bitte reduziere Menge/Zutaten – oder kontaktiere uns direkt.');
      return;
    }
    properties['_Prod_Laufzeit_Tage'] = '90';
    properties['Kaufart'] = 'Einmalkauf 90 Tage';
  } else {
    // Produkt A: 3×30-Abo (Seal, 3 Zyklen)
    _variantId = getVariantId(_monthPrice);       // bestehende Monatspreis-Map
    _sellingPlan = SEAL_SELLING_PLAN_ID;
    if(!_variantId){
      toast('Diese Rezeptur liegt bei € '+_monthPrice.toFixed(2).replace('.',',')+'/Monat und überschreitet den Höchstpreis von € '+VARIANT_PRICE_MAX+'. Bitte reduziere Menge/Zutaten – oder kontaktiere uns direkt.');
      return;
    }
    properties['_Prod_Laufzeit_Tage'] = '90';     // Gesamtproduktion 90 Tage (3×30 in einem Batch)
    properties['Kaufart'] = '3×30 Tage Abo (endet automatisch)';
  }

  if(SHOPIFY_VARIANT_ID){
    fetch('https://'+window.location.hostname+'/cart/clear.js', {method:'POST'})
    .then(function(){
      return fetch('https://'+window.location.hostname+'/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: (function(){
        var _item = { id: _variantId, quantity: 1, properties: properties };
        if(_sellingPlan){ _item.selling_plan = _sellingPlan; }
        return JSON.stringify({ items:[_item] });
      })()
    })
    .then(function(r){
      // Antwort defensiv verarbeiten: Shopify liefert bei Fehlern oder in
      // Nicht-Shopify-Umgebungen teils HTML statt JSON. Erst als Text lesen,
      // dann sicher zu JSON parsen — sonst klare, verständliche Fehlermeldung.
      return r.text().then(function(txt){
        var data;
        try { data = JSON.parse(txt); }
        catch(e){
          // Kein JSON. Der haeufigste Fall ist NICHT ein Shopify-Fehler, sondern
          // die Cloudflare-Verifizierungsseite ("Managed Challenge"): sie schiebt
          // sich vor /cart/add.js, wenn in kurzer Folge viele gleichartige POSTs
          // von derselben IP kommen — z.B. beim Testen. Erkannt am 27.10.2026.
          // Die alte Sammelmeldung schickte die Fehlersuche zur Variante und zur
          // Nutzlast, die beide in Ordnung waren. Darum hier getrennt melden.
          if(/_cf_chl_opt|cdn-cgi\/challenge-platform|challenge-error-text/.test(txt)){
            console.warn('[Puraveda] Cloudflare-Challenge statt Warenkorb-Antwort. '
              + 'Erste 200 Zeichen: ' + txt.slice(0,200));
            throw new Error('Der Shop führt gerade eine Sicherheitsprüfung Deiner Verbindung durch. '
              + 'Bitte lade die Seite neu, warte kurz, bis die Prüfung durchgelaufen ist, '
              + 'und klicke dann erneut auf "In den Warenkorb".');
          }
          console.warn('[Puraveda] Warenkorb-Antwort war kein JSON. Status ' + r.status
            + ', Content-Type ' + (r.headers.get('content-type')||'—')
            + ', erste 200 Zeichen: ' + txt.slice(0,200));
          throw new Error('Der Warenkorb konnte nicht erreicht werden. Bitte lade die Seite neu und versuche es erneut. (Antwort war kein gültiges JSON, Status '+r.status+')');
        }
        if(!r.ok){ throw new Error(data && data.description ? data.description : ('Warenkorb-Fehler '+r.status)); }
        return data;
      });
    })
    .then(function(){
      // Bestellnotiz für Zapier: Shopify liefert Line-Item-Properties an Zapier nur
      // als zwei Sammel-Listen (Key/Value) — Einzelfelder wie 'Zutaten_Morgen' sind
      // dort NICHT wählbar. Die Bestellnotiz dagegen kommt als EIN sauberes Feld
      // ("Notizen") an. Deshalb steht hier die vollständige Produktionsinfo.
      var _capNote = '';
      if(DELIVERY_FORM==='capsule'){
        var _cd = getCapsuleDistribution();
        if(_cd.hasMorning){
          var _g=function(mg){ return mg>=1000 ? (mg/1000).toFixed(2).replace('.',',')+' g'
                                               : Math.round(mg)+' mg'; };
          _capNote = 'Morgen-Routine als KAPSELN: JA\n'
            + 'Kapseln pro Tag: ' + _cd.capsulesPerDay + '\n'
            + 'Produktionslauf: ' + _cd.capsulesPerRun + ' Kapseln à ' + KAPSEL_FUELLGEWICHT_MG + ' mg\n'
            + 'Anzahl Chargen: ' + _cd.morgenRuns + ' (Bedarf ' + _cd.morgenCapsTotal + ' Kapseln)\n'
            + 'Einwaage Wirkstoffe (300 Kps): ' + _g(_cd.laufWirkstoffMg) + '\n'
            + 'Bio-Akazienpulver auffüllen (300 Kps): ' + _g(_cd.laufAkazieMg) + '\n'
            + 'Gesamt-Füllmasse: ' + _g(_cd.laufGesamtMg) + '\n';
        } else {
          _capNote = 'Morgen-Routine als KAPSELN: JA (aber keine Morgen-Zutaten vorhanden)\n';
        }
      } else {
        _capNote = 'Morgen-Routine als KAPSELN: NEIN (Pulver)\n';
      }
      // Abend-Routine: bewusst OHNE die Zeichenfolge "KAPSELN: JA" formuliert —
      // die AV App liest dieses Muster als Morgen-Kapselauftrag.
      var _eveNote = '';
      if(eveningIsCapsule()){
        var _ce = getCapsuleDistribution();
        if(_ce.hasEveningCaps){
          var _ge=function(mg){ return mg>=1000 ? (mg/1000).toFixed(2).replace('.',',')+' g'
                                                : Math.round(mg)+' mg'; };
          var _nmE2=function(id){ var it=DB.find(function(x){return x.id===id;}); return it?it.name:id; };
          _eveNote = 'Abend-Routine Darreichung: KAPSELN (eigener Füll-Lauf)\n'
            + 'Kapseln pro Tag (Abend): ' + _ce.eveningCapsulesPerDay + '\n'
            + 'Produktionslauf: ' + _ce.capsulesPerRun + ' Kapseln à ' + KAPSEL_FUELLGEWICHT_MG + ' mg\n'
            + 'Anzahl Chargen: ' + _ce.eveningRuns + ' (Bedarf ' + _ce.eveningCapsTotal + ' Kapseln)\n'
            + 'Einwaage Wirkstoffe (300 Kps): ' + _ge(_ce.eveningLaufWirkstoffMg) + '\n'
            + 'Bio-Akazienpulver auffüllen (300 Kps): ' + _ge(_ce.eveningLaufAkazieMg) + '\n'
            + (_ce.eveningPowder.length
                ? 'Nicht kapselbar, bleibt Pulver: ' + _ce.eveningPowder.map(_nmE2).join(', ') + '\n'
                : '');
        } else {
          _eveNote = 'Abend-Routine Darreichung: Pulver (keine kapselfähigen Zutaten)\n';
        }
      } else {
        _eveNote = 'Abend-Routine Darreichung: Pulver\n';
      }
      _capNote += _eveNote;
      // Booster: eigene Behaelter, werden NICHT in die Routinen gemischt.
      // Je Behaelter ein Abschnitt mit Abfuellmenge, damit die Produktion
      // nichts ableiten muss.
      var _konjNote = boosterNotizBlock(parseInt(properties['_Prod_Laufzeit_Tage']||'90',10));
      var _warn = getActiveWarnings();
      var _warnNote = _warn.length
        ? ('\n--- PFLICHTHINWEISE (auf Etikett und Beipackzettel) ---\n'
           + _warn.map(function(w){return w.name + ': ' + w.text;}).join('\n') + '\n')
        : '';
      var _note = 'REZEPTUR: ' + rname + '\n'
        + 'Kaufart: ' + (properties['Kaufart'] || '-') + '\n'
        + 'Laufzeit: ' + (properties['_Prod_Laufzeit_Tage'] || '90') + ' Tage\n'
        + 'Anzahl Zutaten: ' + activeItems.length + '\n'
        + _capNote
        + (boosterContainers().length ? 'Booster-Beutel: '
             + boosterBeutelAnzahl(parseInt(properties['_Prod_Laufzeit_Tage']||'90',10)) + '\n' : '')
        + '\n'
        + '--- MORGEN-ROUTINE ---\n'
        + (properties['Zutaten_Morgen'] || '-').split('  |  ').join('\n') + '\n'
        + '\n'
        + '--- ABEND-ROUTINE ---\n'
        + (properties['Zutaten_Abend'] || '—').split('  |  ').join('\n')
        + _konjNote
        + _warnNote;
      return fetch('https://'+window.location.hostname+'/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ note: _note })
      });
    })
    .then(function(){
      // Send structured data to Google Apps Script webhook (eine Zeile pro Zutat)
      if(window.GOOGLE_APPS_SCRIPT_URL) {
        var payload = {
          bestelldatum: new Date().toISOString().slice(0,10),
          rezepttitel: rname,
          email: S.ans.email || '',
          zutaten: activeItems.map(function(it){
            var menge = parseFloat(fa(S.amt[it.id], it.unit));
            return {
              name:         names[it.id],
              id:           it.id,
              typ:          it.type === 'bot' ? 'Botanical' : 'Naehrstoff',
              menge_tag:    menge,
              einheit:      it.unit,
              menge_monat:  parseFloat((menge*30).toFixed(3)),
              kosten_monat: parseFloat((pd(it)*30).toFixed(4)),
              pk_eur_kg:    it.pk || 0
            };
          })
        };
        fetch(window.GOOGLE_APPS_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify(payload)
        }).catch(function(){});
      }
      // Direkt zur Kasse. WICHTIG: NICHT auf '/cart' leiten — auf dieser URL
      // läuft der Konfigurator selbst, ein Redirect dorthin würde nur den
      // Quiz-Start neu laden ("Rücksprung"). '/checkout' ist eine Shopify-
      // System-URL und wird nicht vom Konfigurator überdeckt.
      window.location.href = '/checkout';
    })
    .catch(function(err){
      toast('Fehler: ' + err.message);
      console.error('Cart error:', err);
    });
    });
  } else {
  
    sendOrderEmail(rname, activeItems);
    toast('Warenkorb-Integration: Bitte Shopify Variant-ID konfigurieren.');
  }
}

// ── E-Mail an interne Adresse ──────────────────────────────────────────────
function sendOrderEmail(rezepturname, activeItems){
  var rname = rezepturname || S.ans.rezepturname || 'Meine Biotiva Rezeptur';
  var email = S.ans.email || '(keine E-Mail angegeben)';
  var now   = new Date().toLocaleDateString('de-DE', {day:'2-digit',month:'2-digit',year:'numeric'});

  var ingredientLines = activeItems.map(function(it){
    var line = '• ' + names[it.id] + ': ' + fa(S.amt[it.id],it.unit) + ' ' + it.unit + '/Tag';
    if(it.powderDose && it.nrv){
      var cp = it.powderDose * (S.amt[it.id] / it.nrv);
      line += ' (Pulver: ' + cp.toFixed(1) + ' ' + (it.powderUnit||it.unit) + ')';
    }
    return line;
  }).join('\n');

  var totalG  = activeItems.reduce(function(s,it){return s+toMg(S.amt[it.id],it.unit);},0)/1000;
  var totalPr = activeItems.reduce(function(s,it){return s+pd(it);},0);

  var body = [
    'BIOTIVA – NEUE REZEPTUR-BESTELLUNG',
    '=====================================',
    '',
    'Datum: ' + now,
    'Kunden-E-Mail: ' + email,
    'Rezepturname: ' + rname,
    '',
    'ZUTATENLISTE (Tagesdosis):',
    ingredientLines,
    '',
    'Gesamtmenge/Tag: ' + totalG.toFixed(2) + ' g',
    'Rohstoffpreis/Tag: € ' + totalPr.toFixed(2),
    'Rohstoffpreis/Monat (30 Tage): € ' + (totalPr*30).toFixed(2),
    '',
    'Quiz-Angaben:',
    'Alter: ' + (S.ans.age||'') + ' Jahre',
    'Geschlecht: ' + (S.ans.sex||''),
    'Ernährung: ' + (S.ans.diet||''),
    'Sport: ' + (S.ans.sport||'') + 'x/Woche',
    'Stress: ' + (S.ans.stress||'') + '/5',
    'Ziele: ' + (S.ans.goals||[]).join(', '),
  ].join('\n');

  var subject = encodeURIComponent('Biotiva Rezeptur: ' + rname + ' | ' + email);
  var bodyEnc = encodeURIComponent(body);
  var mailtoUrl = 'mailto:' + INTERNAL_EMAIL + '?subject=' + subject + '&body=' + bodyEnc;

  if(EMAILJS_KEY && typeof emailjs !== 'undefined'){
    emailjs.init(EMAILJS_KEY);
    emailjs.send(EMAILJS_SERVICE, EMAILJS_TEMPLATE, {
      to_email:   INTERNAL_EMAIL,
      rezeptur:   rname,
      kunde_email:email,
      zutaten:    body,
      datum:      now
    }).catch(function(e){console.warn('EmailJS error:',e);});
    return;
  }

  try {
    var a = document.createElement('a');
    a.href = mailtoUrl;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch(e) { console.warn('mailto failed:', e); }
}

// ── Alle Seiten-Angaben strukturiert einsammeln (für E-Mail/Webhook) ────────
function collectAllAnswers(){
  return {
    rezepturname:     S.ans.rezepturname || '',
    email:            S.ans.email || '',
    alter:            S.ans.age || '',
    geschlecht:       S.ans.sex || '',
    gewicht_kg:       S.ans.gewicht || '',
    groesse_cm:       S.ans.groesse || '',
    bmi:              S.ans._bmiVal || '',
    bmi_kategorie:    S.ans.bmi || '',
    lebensmittelpunkt:locDisplay(S.ans.plz) || S.ans.plz || '',
    uv_verfuegbarkeit:S.ans._uvTier || '',
    sport_tage_woche: S.ans.sport,
    stress:           S.ans.stress,
    sonne:            S.ans.sun || '',
    schlaf_h:         S.ans.sleep,
    rauchen:          S.ans.smoke || '',
    ernaehrung:       S.ans.diet || '',
    laktose:          S.ans.lacto || '',
    fisch_woche:      S.ans.fish,
    alkohol_woche:    S.ans.alc,
    obst_gemuese_tag: S.ans.veg,
    gesundheit:       (S.ans.gesundheit || []).join(' | '),
    ziele:            (S.ans.goals || []).join(' | ')
  };
}

// ── Rezeptur inkl. ALLER Angaben an die Kunden-E-Mail senden ────────────────
// Läuft unabhängig vom Warenkorb. Der eigentliche Mailversand passiert
// serverseitig im Google-Apps-Script (Webhook empfängt sende_an_kunde+empfaenger).
// ── Rezeptur in Einzelteilen ────────────────────────────────────────────────
// Liefert die Bausteine getrennt, damit der Mailtext außerhalb zusammengesetzt
// werden kann (Zapier). So wird kein fertiger Fließtext mehr übertragen, den
// ein Fremder durch einen eigenen ersetzen könnte.
function rezepturTeile(){
  var ids = billableItems().map(function(it){ return it.id; });
  var zeile = function(id){
    var it = DB.find(function(x){ return x.id===id; });
    if(!it || !(S.amt[it.id]>0)) return null;
    return (names[it.id]||it.name) + ': ' + fa(S.amt[it.id], it.unit) + ' ' + it.unit + ' pro Tag';
  };
  var liste = function(l){
    return (l||[]).filter(function(id){ return ids.indexOf(id)>=0; })
                  .map(zeile).filter(Boolean);
  };
  var r = getAntagonismResults(), d = getCapsuleDistribution();

  var hc = [];
  billableItems().forEach(function(it){
    var c = (claims[it.id]!==undefined ? claims[it.id] : it.claim) || '';
    c = c.trim(); if(!c) return;
    if(!claimErlaubt(it)) return;
    hc.push(c);
  });

  return {
    titel:       S.ans.rezepturname || 'Meine Biotiva Rezeptur',
    kaufart:     (PURCHASE_TYPE==='abo3' ? '3×30 Tage Abo (endet automatisch)' : 'Einmalkauf 90 Tage'),
    morgenForm:  DELIVERY_FORM==='capsule' ? d.capsulesPerDay + ' Kapseln täglich' : 'Pulver mit Dosierlöffel',
    abendForm:   eveningIsCapsule() ? d.eveningCapsulesPerDay + ' Kapseln täglich' : 'Pulver mit Dosierlöffel',
    morgen:      liste(withoutKonjak(r.morning||[])),
    abend:       liste(withoutKonjak(r.evening||[])),
    konjak:      konjakActive() ? liste(['glucomannan']) : [],
    booster:     liste(boosterIds()),
    claims:      hc,
    hinweise:    getDeliveryNotes() || [],
    preisTag:    (S.tPrD||0).toFixed(2).replace('.',',')
  };
}

// ── Rezeptur als lesbarer Text ──────────────────────────────────────────────
// Eine Quelle für die Bestellnotiz UND die Kunden-E-Mail. Rechnet alles selbst,
// damit sie auch außerhalb des Warenkorb-Ablaufs aufgerufen werden kann.
function rezepturText(){
  var Z = [], ids = billableItems().map(function(it){ return it.id; });
  var nm = function(id){
    var it = DB.find(function(x){ return x.id===id; });
    if(!it || !(S.amt[it.id]>0)) return null;
    return (names[it.id]||it.name) + ': ' + fa(S.amt[it.id], it.unit) + ' ' + it.unit + ' pro Tag';
  };
  var block = function(titel, liste, zusatz){
    var zeilen = liste.filter(function(id){ return ids.indexOf(id)>=0; }).map(nm).filter(Boolean);
    if(!zeilen.length) return;
    Z.push(titel + (zusatz ? ' (' + zusatz + ')' : ''));
    zeilen.forEach(function(z){ Z.push('  ' + z); });
    Z.push('');
  };

  Z.push('DEINE REZEPTUR: ' + (S.ans.rezepturname || 'Meine Biotiva Rezeptur'));
  Z.push('');
  Z.push('Lieferung: ' + (PURCHASE_TYPE==='abo3'
         ? '3×30 Tage Abo (endet automatisch)' : 'Einmalkauf 90 Tage'));
  Z.push('Darreichung: Morgens ' + (DELIVERY_FORM==='capsule' ? 'Kapseln' : 'Pulver')
       + ' · Abends ' + (eveningIsCapsule() ? 'Kapseln' : 'Pulver'));
  Z.push('');

  var r = getAntagonismResults(), d = getCapsuleDistribution();
  block('MORGEN-ROUTINE', withoutKonjak(r.morning||[]),
        DELIVERY_FORM==='capsule' ? d.capsulesPerDay + ' Kapseln täglich' : 'Pulver mit Dosierlöffel');
  block('ABEND-ROUTINE', withoutKonjak(r.evening||[]),
        eveningIsCapsule() ? d.eveningCapsulesPerDay + ' Kapseln täglich' : 'Pulver mit Dosierlöffel');
  boosterContainers().forEach(function(c){
    var _t = (c.form==='capsule')
      ? (c.kapselnTag + ' Kapseln täglich, separater Behälter')
      : (c.ids.indexOf('glucomannan')>=0 ? 'separater Beutel, 3×1 g vor den Mahlzeiten'
         : 'separater Beutel mit Dosierlöffel');
    block(c.art==='mix' ? 'BOOSTER-PULVER' : ('BOOSTER: '+(names[c.ids[0]]||c.ids[0]).toUpperCase()), c.ids, _t);
  });

  // Health Claims mit denselben Schranken wie in der Bestellung
  var hc = [];
  billableItems().forEach(function(it){
    var c = (claims[it.id]!==undefined ? claims[it.id] : it.claim) || '';
    c = c.trim(); if(!c) return;
    if(!claimErlaubt(it)) return;
    hc.push(c);
  });
  if(hc.length){
    Z.push('WAS DIE ZUTATEN BEWIRKEN');
    hc.forEach(function(c){ Z.push('  - ' + c); });
    Z.push('');
  }

  var hin = getDeliveryNotes();
  if(hin && hin.length){
    Z.push('HINWEISE ZU LIEFERUNG UND ANWENDUNG');
    hin.forEach(function(h){ Z.push('  - ' + h); });
    Z.push('');
  }

  Z.push('Preis: ' + (S.tPrD||0).toFixed(2).replace('.',',') + ' EUR pro Tag');
  return Z.join('\n');
}

function emailRecipe(){
  // Eigene Checkbox (div mit data-checked) statt nativem input — das Theme
  // macht native Checkboxen unbrauchbar. Der alte .checked-Fall bleibt als
  // Rückfall stehen, falls das Element doch einmal ein input ist.
  var consent=document.getElementById('email-consent');
  var ok = consent && (consent.getAttribute('data-checked')==='1' || consent.checked===true);
  if(!ok){ toast('Bitte stimme zuerst der Datenschutz-Einwilligung zu.'); return; }
  // Erst das Feld auf der Ergebnisseite, dann die Antwort aus dem Quiz.
  var _ef=document.getElementById('b-email-input');
  var email=((_ef && _ef.value) || S.ans.email || '').trim();
  if(!email || email.indexOf('@')<1 || email.indexOf('.', email.indexOf('@'))<0){
    toast('Bitte gib zuerst eine gültige E-Mail-Adresse an.');
    if(_ef) _ef.focus();
    return;
  }
  S.ans.email = email;
  var active=billableItems();
  if(!active.length){ toast('Deine Rezeptur ist noch leer.'); return; }
  var tPrD=active.reduce(function(s,it){return s+pd(it);},0);
  var _teile=rezepturTeile();
  var payload={
    typ:            'rezeptur_an_kunde',
    token:          window.PURAVEDA_MAIL_TOKEN || '',
    sende_an_kunde: true,
    empfaenger:     email,
    // Bewusst KEIN fertiger Mailtext und kein Betreff mehr: Beides wird im
    // Zap aus einer festen Vorlage gebaut. Ein fremder Aufruf kann damit
    // keine frei formulierte Mail über das verbundene Konto verschicken.
    // Die Felder unten sind Bausteine, keine ganzen Nachrichten.
    bestelldatum:   new Date().toISOString().slice(0,10),
    rezepttitel:    S.ans.rezepturname || 'Meine Biotiva Rezeptur',
    angaben:        collectAllAnswers(),
    summe_tag_eur:  parseFloat(tPrD.toFixed(2)),
    summe_monat_eur:parseFloat((tPrD*30).toFixed(2)),
    // Flache Felder fuer Tabellen-Spalten (Zapier kann Arrays nur umstaendlich)
    anzahl_zutaten: active.length,
    kaufart:        (PURCHASE_TYPE==='abo3' ? '3x30 Tage Abo' : 'Einmalkauf 90 Tage'),
    darreichung:    'Morgens ' + (DELIVERY_FORM==='capsule'?'Kapseln':'Pulver')
                  + ' / Abends ' + (eveningIsCapsule()?'Kapseln':'Pulver'),
    zutaten_kurz:   active.map(function(it){
                      return (names[it.id]||it.name)+': '+fa(S.amt[it.id],it.unit)+' '+it.unit;
                    }).join(' | '),
    // Bausteine für die Mailvorlage im Zap — je Zeile eine Zutat
    zutaten_morgen: _teile.morgen.join('\n'),
    zutaten_abend:  _teile.abend.join('\n'),
    zutaten_konjak: _teile.konjak.join('\n'),
    morgen_form:    _teile.morgenForm,
    abend_form:     _teile.abendForm,
    claims_text:    _teile.claims.join('\n'),
    hinweise_text:  _teile.hinweise.join('\n'),
    zutaten: active.map(function(it){
      var m=parseFloat(fa(S.amt[it.id],it.unit));
      return { name:names[it.id], id:it.id, typ:it.type==='bot'?'Botanical':'Naehrstoff',
               menge_tag:m, einheit:it.unit, menge_monat:parseFloat((m*30).toFixed(3)),
               kosten_monat:parseFloat((pd(it)*30).toFixed(4)) };
    })
  };
  var _mailUrl = window.PURAVEDA_MAIL_WEBHOOK_URL || window.GOOGLE_APPS_SCRIPT_URL;
  if(_mailUrl){
    // Zapier-Hooks senden CORS-Header: dort darf der Content-Type stehen
    // bleiben (sonst kaeme der Body als Text statt als JSON an) und die
    // Antwort ist lesbar, der Versand also pruefbar. Apps Script sendet keine
    // CORS-Header — dort weiter no-cors und damit stumm.
    var _istZapier = /zapier\.com/i.test(_mailUrl);
    try{ console.log('[Puraveda] Rezeptur-Versand an', payload.empfaenger, 'ueber', _mailUrl); }catch(e){}
    if(_istZapier){
      fetch(_mailUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
        .then(function(r){ if(!r.ok) toast('Der Versand hat nicht geklappt. Bitte versuche es noch einmal.'); })
        .catch(function(){ toast('Der Versand hat nicht geklappt. Bitte versuche es noch einmal.'); });
    } else {
      fetch(_mailUrl,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).catch(function(){});
    }
    toast('Deine Rezeptur wird an '+email+' gesendet.');
  } else {
    toast('E-Mail-Versand ist noch nicht konfiguriert.');
  }
}

// ── Health Claims der aktiven Zutaten sammeln ─────────────────────────────
// Liefert ALLE zugelassenen EU-Claims (VO 432/2012) je aktivem Nährstoff für
// das Health-Claims-Textfeld. Botanicals (type 'bot') und Pflanzenpulver
// (type 'plant') erhalten KEINE Health Claims (Punkt 1).
function getActiveClaims(){
  var _sorted = [].concat(DB).sort(function(a,b){return (S.sc[b.id]||0)-(S.sc[a.id]||0);});
  // Nur Nährstoffe — explizit OHNE 'plant' und 'bot'
  var active = _sorted.filter(function(x){
    return x.type==='nutrient' && avails[x.id] && !disabled[x.id] && S.amt[x.id]>0;
  }).slice(0,(S.mode==='expert'?DB.length:20));
  var out = [];
  active.forEach(function(it){
    // HCVO: Claims nur bei wirksamer Menge (>=15% NRV). Zutaten ohne NRV
    // (z.B. Cholin, Protein) werden nicht über die 15%-NRV-Regel gefiltert.
    if(it.nrv){
      var pct = (S.amt[it.id]/it.nrv)*100;
      if(pct < 15) return;
    }
    // Zutaten ohne NRV: Claim nur ab der in der Zulassung genannten Mindestmenge
    // (z. B. Guarkernmehl 10 g/Tag, Glucomannan 3 g/Tag).
    if(it.claimMin && S.amt[it.id] < it.claimMin) return;
    // NUR die als relevant erkannten Claims (identisch mit der Anzeige unter
    // der jeweiligen Zutat oben: Ziel-Match + feste Reihenfolge, max. 3).
    var top = getTopClaims(it.id, 3);
    if(top.length){
      top.forEach(function(t){ out.push({name:names[it.id]||it.name, claim:t}); });
    } else {
      // Fallback auf Einzel-Claim, falls für die ID keine Liste existiert
      var c = (claims[it.id]!==undefined ? claims[it.id] : it.claim) || '';
      c = c.trim();
      if(c) out.push({name:names[it.id]||it.name, claim:c});
    }
  });
  return out;
}

// Liefert die zutatenbezogenen Pflicht-/Warnhinweise der aktuellen Rezeptur.
// Quelle: BfR-Höchstmengenempfehlungen (Stand 2021/2023/2024). Ein Hinweis
// greift, sobald die Zutat aktiv ist; bei gesetztem warnungAb erst ab dieser
// Tagesdosis (Calcium ab 250 mg, Niacin über 16 mg).
function getActiveWarnings(){
  var out = [];
  DB.forEach(function(it){
    if(!it.warnung) return;
    if(!avails[it.id] || disabled[it.id]) return;
    var amt = S.amt[it.id] || 0;
    if(amt <= 0) return;
    if(it.warnungAb && amt < it.warnungAb) return;
    out.push({id:it.id, name:names[it.id]||it.name, text:it.warnung});
  });
  return out;
}

// ── Bedingte Hinweise zu Lieferung und Anwendung ──────────────────────────
function getDeliveryNotes(){
  var isActive = function(id){ return avails[id] && !disabled[id] && S.amt[id] > 0; };
  var notes = [];
  // 0) Allergen-Kennzeichnung (LMIV): Spermidin aus Weizenkeim enthält Gluten
  if(isActive('spermidin')){
    notes.push('Deine Rezeptur enthält Bio Spermidin aus Weizenkeimen und damit glutenhaltiges Weizen. Bei Zöliakie oder Weizenallergie nicht geeignet.');
  }
  // 0a) Flohsamenschalen: quellende Ballaststoffe brauchen denselben
  // Fluessigkeitshinweis wie Glucomannan — ohne genug Wasser besteht
  // Erstickungsgefahr. Eigener Beutel, deshalb eigener Hinweis.
  if(avails['flohsamen'] && !disabled['flohsamen'] && (S.amt['flohsamen']||0) > 0){
    notes.push('Deine Rezeptur enthält Bio Flohsamenschalen. Sie liegen als separater Beutel mit 5-g-Dosierlöffel bei und werden nicht in die Routinen gemischt. Einnahme: 5 g in mindestens 250 ml Wasser einrühren, sofort trinken und ein weiteres Glas Wasser nachtrinken. Niemals trocken einnehmen. Bei Schluckbeschwerden nicht geeignet – bei unzureichender Flüssigkeitszufuhr besteht Erstickungsgefahr.');
  }
  // 0a2) Guarkernmehl: VO (EU) 432/2012 verlangt zur Cholesterin-Angabe nicht nur
  //      die 10-g-Tagesdosis, sondern auch die Warnung vor Erstickungsgefahr bei
  //      Schluckbeschwerden oder zu wenig Fluessigkeit und die Empfehlung, mit
  //      reichlich Wasser einzunehmen. Beides fehlte bis 27.10.2026 vollstaendig,
  //      obwohl Glucomannan und Flohsamen es haben.
  if(isActive('guarkernmehl')){
    notes.push('Deine Rezeptur enthält Bio Guarkernmehl. Es liegt Deiner Lieferung als separater Beutel mit Dosierlöffel bei und wird nicht in die Routinen gemischt. Die positive Wirkung stellt sich bei einer täglichen Aufnahme von 10 g Guarkernmehl ein. Einnahme mit reichlich Wasser, damit das Guarkernmehl in den Magen gelangt. Niemals trocken einnehmen. Bei Schluckbeschwerden nicht geeignet – bei Schluckbeschwerden oder unzureichender Flüssigkeitszufuhr besteht Erstickungsgefahr.');
  }
  // 0b) Konjakmehl/Glucomannan: gesetzlich vorgeschriebener Einnahme-Hinweis
  //     (EU-VO 432/2012: reichlich Wasser, Erstickungsgefahr bei Schluckbeschwerden)
  if(isActive('glucomannan')){
    notes.push('Deine Rezeptur enthält Bio Glucomannan (Konjakmehl). Es liegt Deiner Lieferung als separater Beutel mit 1-g-Dosierlöffel bei und wird nicht in die Routinen gemischt. Einnahme: täglich 3 g in 3 Portionen à 1 g – jede Portion mit 1–2 großen Gläsern Wasser (mind. 250 ml) unmittelbar vor einer Mahlzeit. Niemals trocken einnehmen. Bei Schluckbeschwerden nicht geeignet – bei unzureichender Flüssigkeitszufuhr besteht Erstickungsgefahr. Maximal 4 g pro Tag.');
  }
  // 0b) Entfallene Zutaten offenlegen — sie werden auch nicht berechnet.
  var _weg=getDroppedItems();
  if(_weg.length){
    notes.push('Deine Rezeptur enthält mehr Zutaten, als in eine Routine passen. '
      + 'Wir haben sie nach Deinem Bedarf sortiert; ' + _weg.length + ' Zutaten sind '
      + 'herausgefallen und werden nicht berechnet: '
      + _weg.map(function(x){return x.name;}).join(', ')
      + '. Wenn Du eine davon behalten möchtest, nimm dafür eine andere heraus.');
  }
  // 0c) Zutatenbezogene Pflicht-/Warnhinweise (BfR)
  getActiveWarnings().forEach(function(w){
    notes.push(w.name + ': ' + w.text);
  });
  // 1) Bio-Extrakte (B12, D3, Zink) => Gewichtsabweichung
  if(isActive('vit_b12') || isActive('vit_d') || isActive('zink')){
    // Hinweis entfällt seit '2026-09-17-echte-menge': Die Kennzahl nennt jetzt
    // die echte Pulvermenge und erklärt die Differenz direkt darunter.
  }
  // 1b) Standort × Jahreszeit → Vitamin-D-Anpassung (claim-konform formuliert)
  if(isActive('vit_d') && typeof S.ans.uvAvail==='number' && S.ans.uvAvail<0.66){
    var _uw = (S.ans._uvTier==='keine') ? 'praktisch keine' : (S.ans._uvTier==='minimal' ? 'nur sehr geringe' : 'eingeschränkte');
    notes.push('An Deinem Standort ('+plzRegion(S.ans.plz)+') ist in den nächsten drei Monaten '+_uw+' körpereigene Vitamin-D-Bildung durch Sonnenlicht zu erwarten. Deine Vitamin-D-Dosis ist deshalb angepasst, um Deine normale Versorgung in diesem Zeitraum zu unterstützen.');
  }
  // 3) Modul-System: bei Eisen ≥ 5 mg Aufteilung in Morning / Evening Formula
  //    NUR im Pulver-Modus. Im Kapsel-Modus übernimmt die Kapsel-Komponenten-
  //    Übersicht (renderCapsuleBreakdown) die Lieferaufteilung und Einnahme-Hinweise.
  if(DELIVERY_FORM==='capsule') return notes;
  var _ant = getAntagonismResults();
  var _nm = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?it.name:id; };
  if(_ant.split){
    var _mList = _ant.morning.map(_nm).join(', ');
    var _eList = _ant.evening.map(_nm).join(', ');
    notes.push('Deine Rezeptur enthält Eisen. Da Eisen die Aufnahme von Magnesium, Zink und Calcium beeinträchtigt, liefern wir Deine Rezeptur in zwei funktionalen Routinen:');
    notes.push('☀️ Morning Routine (zum Frühstück): '+_mList+'.');
    notes.push('🌙 Abend Routine (nach dem Abendessen): '+_eList+'.');
    notes.push('Optimale Aufnahme, wenn 8–12 Stunden zwischen Morgen- und Abend Routine liegen.');
    // Synergie-Hinweis Eisen + Vitamin C
    if(_ant.morning.indexOf('vit_c')>=0 && _ant.morning.indexOf('eisen')>=0){
      notes.push('Vitamin C ist bewusst in der Morning Routine enthalten – es verbessert die Eisenaufnahme deutlich.');
    }
  }
  // 3b) Paare, die TROTZ Aufteilung zusammen in einer Routine stehen.
  //     Bis zum 27.10.2026 stand dieser Hinweis nur im Bildschirm-Panel
  //     (_antOrtHinweis). In Bestellung, Produktionsnotiz und Kundenunterlagen
  //     fehlte er — die Unterlagen versprachen eine Trennung und schwiegen
  //     ueber das Paar, das zusammen blieb (z.B. Calcium + Zink im Abend).
  //     Der Notentext kommt unveraendert aus ANTAGONISTS, damit hier keine
  //     zweite, abweichende Fassung derselben Aussage entsteht.
  var _ortVon = function(id){
    if((_ant.morning||[]).indexOf(id)>=0) return 'Morning Routine';
    if((_ant.evening||[]).indexOf(id)>=0) return 'Abend Routine';
    return null;
  };
  (_ant.triggered||[]).forEach(function(a){
    var paar = a.pair || a.ids || [];
    if(paar.length !== 2) return;
    var o1 = _ortVon(paar[0]), o2 = _ortVon(paar[1]);
    if(!o1 || o1 !== o2) return;                 // getrennt oder im Booster → nichts zu melden
    notes.push(_nm(paar[0]) + ' und ' + _nm(paar[1]) + ' stehen beide in Deiner '
      + o1 + '. ' + String(a.note||'').replace(/<[^>]+>/g,'').trim());
  });
  return notes;
}

// ── Booster-Bereich ─────────────────────────────────────────────────────────
// Eigener Abschnitt mit eigenem Banner, getrennt von der Darreichungswahl.
// Jeder Booster laesst sich einzeln abwaehlen: adj(id,-1) setzt die Menge auf
// 0, danach taucht die Zutat wieder unter "+ Zutat hinzufuegen" auf.
function renderBoosterBereich(){
  var bc = boosterContainers();
  if(!bc.length) return '';
  var p = [];
  var nm  = function(id){ return names[id]||id; };
  var mg  = function(id){
    var it=DB.find(function(x){return x.id===id;});
    return it ? fa(S.amt[id],it.unit).replace('.',',')+' '+it.unit : '';
  };
  var gTag = function(v){ return (Math.round(v/100)/10).toFixed(1).replace('.',','); };
  var wegBtn = function(id, label){
    return '<button onclick="adj(\''+id+'\',-1)" title="'+label+' aus der Rezeptur nehmen" '
      + 'style="flex-shrink:0;padding:4px 10px;border-radius:6px;cursor:pointer;font-family:inherit;'
      + 'font-size:11px;font-weight:700;border:1px solid #d8c4c4;background:#fff;color:#8a5a5a">'
      + 'Entfernen</button>';
  };

  p.push('<div class="b-result-name-banner" style="background:#5a4a2a;display:block;text-align:left;margin-top:18px">');
  p.push('<div class="b-result-name-value">Deine Booster: '+bc.length+(bc.length===1?' Beutel':' Beutel')+' zus\u00E4tzlich</div>');
  p.push('<div style="font-size:13px;color:#f4eded;margin-top:6px;line-height:1.5">'
    +'Booster sind <b>keine Darreichungsform</b>, sondern eigene Beutel, die Deiner Lieferung beiliegen. '
    +'Sie werden nicht in die Routinen gemischt \u2013 entweder weil sie in Gramm dosiert werden und '
    +'sonst die Kapselzahl sprengen w\u00FCrden, oder weil sie quellen. '
    +'Du kannst jeden einzeln entfernen.</div></div>');
  p.push('<div style="border:2px solid #5a4a2a;border-radius:14px;padding:16px;margin-bottom:16px;background:#f4eded">');

  bc.forEach(function(c){
    p.push('<div style="border:1px solid #e4dcc8;border-radius:10px;padding:12px 14px;margin-bottom:10px;background:#fff">');
    p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
    p.push('<div style="flex-shrink:0;font-size:20px">'+(c.form==='capsule'?'\uD83D\uDC8A':'\uD83E\uDD44')+'</div>');
    p.push('<div style="flex:1">');
    if(c.art==='mix'){
      p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
      p.push('<div style="flex:1;font-size:15px;font-weight:700;color:#26352f">Booster-Pulver \u2013 '
        +gTag(c.rohMgTag)+'\u00A0g/Tag, mit Dosierl\u00F6ffel</div></div>');
      // Je Zutat eine Zeile mit eigenem Entfernen-Knopf
      p.push('<div style="margin-top:7px">');
      c.ids.forEach(function(id){
        p.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-top:1px solid #f0ece0">');
        p.push('<div style="flex:1;font-size:12px;color:#26352f">'+nm(id)+' <span style="color:#87867e">'+mg(id)+'/Tag</span></div>');
        p.push(wegBtn(id, nm(id)));
        p.push('</div>');
      });
      p.push('</div>');
      p.push('<div style="font-size:11px;color:#87867e;margin-top:6px;line-height:1.45">Alles in einem Beutel. '
        +'Die genaue L\u00F6ffelmenge steht auf dem Etikett \u2013 wir wiegen sie bei der Herstellung Deiner Mischung aus.</div>');
    } else {
      var id = c.ids[0];
      p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
      p.push('<div style="flex:1;font-size:15px;font-weight:700;color:#26352f">'+nm(id)+' \u2013 '+mg(id)+'/Tag'
        +(c.form==='capsule' ? ', '+c.kapselnTag+' Kapseln/Tag'
          : (c.loeffelG ? ', mit '+String(c.loeffelG).replace('.',',')+'-g-Dosierl\u00F6ffel'
                        : ', mit Dosierl\u00F6ffel'))+'</div>');
      p.push(wegBtn(id, nm(id)));
      p.push('</div>');
      if(id==='glucomannan')
        p.push('<div style="font-size:11px;color:#87867e;margin-top:5px;line-height:1.45">Nimm 3\u00D7 t\u00E4glich 1\u00A0g jeweils mit 1\u20132 gro\u00DFen Gl\u00E4sern Wasser unmittelbar vor einer Mahlzeit ein. Niemals trocken einnehmen.</div>');
      else if(id==='flohsamen')
        p.push('<div style="font-size:11px;color:#87867e;margin-top:5px;line-height:1.45">In mindestens 250\u00A0ml Wasser einr\u00FChren, sofort trinken und ein weiteres Glas Wasser nachtrinken. Niemals trocken einnehmen.</div>');
      else if(c.grund)
        p.push('<div style="font-size:11px;color:#87867e;margin-top:5px;line-height:1.45">'+c.grund+'</div>');
      if(!c.loeffelG && c.form!=='capsule')
        p.push('<div style="font-size:11px;color:#87867e;margin-top:5px;line-height:1.45">Die genaue L\u00F6ffelmenge steht auf dem Etikett \u2013 wir wiegen sie bei der Herstellung aus.</div>');
    }
    if(c.ids.length===1 && boosterKapselWahl(c.ids[0])){
      var bid=c.ids[0], bf=boosterForm(bid);
      p.push('<div style="margin-top:9px;display:flex;gap:6px;align-items:center">');
      p.push('<span style="font-size:11px;color:#87867e;margin-right:2px">Form:</span>');
      ['powder','capsule'].forEach(function(f){
        var an=(bf===f);
        p.push('<button onclick="setBoosterForm(\''+bid+'\',\''+f+'\')" '
          +'style="padding:5px 12px;border-radius:6px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:700;border:1px solid '
          +(an?'#5a4a2a;background:#5a4a2a;color:#fff':'#e4dcc8;background:#fff;color:#5a4a2a')+'">'
          +(f==='powder'?'Pulver':'Kapseln')+'</button>');
      });
      p.push('</div>');
    }
    p.push('</div></div></div>');
  });
  p.push('</div>');
  return p.join('');
}

// ── Kapselaufschlag pro Tag, über beide Routinen ────────────────────────────
// Gerechnet wird je Kapsel (Default 0,05 €). Morgen und Abend sind zwei
// getrennte Füll-Läufe und werden deshalb einzeln berechnet: 3 Kapseln je
// Routine und Tag ergeben 0,15 € je Routine, bei beiden zusammen 0,30 €.
function getCapsuleSurchargeDay(){
  var d=getCapsuleDistribution();
  var proKapsel=capsuleSurchargePerCapsule();
  var sum=0;
  if(DELIVERY_FORM==='capsule' && d.hasMorning)              sum += proKapsel*d.capsulesPerDay;
  if(eveningIsCapsule() && d.hasEveningCaps)  sum += proKapsel*d.eveningCapsulesPerDay;
  // Ein Booster in Kapselform ist ein eigener Füll-Lauf mit eigenen Hüllen und
  // gehört deshalb in den Aufschlag — sonst wäre die Kapselwahl beim Booster
  // für den Kunden kostenlos und für uns nicht.
  boosterContainers().forEach(function(c){
    if(c.form==='capsule' && c.kapselnTag) sum += proKapsel*c.kapselnTag;
  });
  return sum;
}
function getCapsuleSurchargeMonth(){
  return getCapsuleSurchargeDay()*30;
}

// ── Routinen-Wahl: Kapseln vs. Pulver, für Morgen UND Abend getrennt ────────
// Beide Routinen sind eigene Füll-Läufe und werden einzeln gewählt. Gramm-
// Zutaten des Abend-Stroms bleiben in jedem Fall Pulver. Ist eine Routine leer,
// entfällt ihr Block.
function renderRoutines(){
  var d=getCapsuleDistribution();
  if(!d.hasMorning && !d.hasEvening) return '';   // nichts zu wählen

  var nm=function(id){ return names[id]||id; };
  var capActive=(DELIVERY_FORM==='capsule');
  var capActiveE=(eveningIsCapsule() && d.hasEveningCaps);
  var _fmtS=function(n){return n.toFixed(2).replace('.',',');};
  var _fmtP=function(n){return n.toFixed(2).replace('.',',')+'\u00A0\u20AC';};
  // Kein fester Tagessatz mehr: beide Routinen rechnen über proKapsel, weil
  // ihre Kapselzahl aus der Rohware stammt.

  // Tagespreis inkl. Kapselaufschlag beider Routinen
  var surchargeDay=getCapsuleSurchargeDay();
  var proKapsel=capsuleSurchargePerCapsule();
  var dayPrice=(S.tPrD||0) + surchargeDay;

  // kleines Tüten-Icon: Bild wenn URL gesetzt, sonst Emoji
  var pouch=function(url,emoji){
    if(url) return '<img src="'+url+'" alt="" style="width:34px;height:34px;object-fit:contain;vertical-align:middle">';
    return '<span style="font-size:26px">'+emoji+'</span>';
  };

  var p=[];

  // ══ GESAMT-RAHMEN: "Deine Rezeptur = 2 Routinen" ══════════════════════════
  p.push('<div class="b-result-name-banner" style="background:#26352f;color:#f6f5f1;display:block;text-align:left"><div class="b-result-name-value">Deine Routinen: Darreichungsoptionen</div>');
  p.push('<div style="font-size:13px;color:#e4e2dc;margin-top:6px;line-height:1.5">Du bekommst diese Zutaten in 2 Routinen: eine f\u00FCr den Morgen und eine f\u00FCr den Abend.'+(boosterContainers().length?' Deine Booster stehen weiter unten in einem eigenen Abschnitt \u2013 sie werden nicht eingemischt.':'')+' W\u00E4hle f\u00FCr jede Routine getrennt zwischen Kapseln und Pulver.</div></div>');
  p.push('<div style="border:2px solid #26352f;border-radius:14px;padding:16px 16px 18px;margin-bottom:16px;background:#fff">');

  // ── MORGEN-ROUTINE ───────────────────────────────────────────────────────
  if(d.hasMorning){
  p.push('<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">');
  p.push(pouch(IMG_POUCH_MORNING,'\uD83C\uDF05'));
  p.push('<div style="font-size:13px;font-weight:700;color:#26352f;letter-spacing:.02em">Morgen-Routine <span style="font-weight:400;color:#727c6a">\u2013 w\u00E4hle Deine Form</span></div>');
  p.push('</div>');

  p.push('<div style="border:1px solid #e4e2dc;border-radius:10px;padding:12px;margin-bottom:16px;background:#f6f5f1">');

  // Option Kapseln
  p.push('<div onclick="selectDelivery(\'capsule\')" style="cursor:pointer;border:2px solid '+(capActive?'#26352f':'#e4e2dc')+';border-radius:9px;padding:12px 14px;margin-bottom:9px;background:#fff;position:relative">');
  p.push('<div style="position:absolute;top:11px;right:12px;background:#70191d;color:#f6f5f1;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px">+'+_fmtS(proKapsel*d.capsulesPerDay)+'\u00A0\u20AC/Tag</div>');
  p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
  p.push('<div style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid '+(capActive?'#26352f':'#c9c4ba')+';background:'+(capActive?'#26352f':'#fff')+';display:flex;align-items:center;justify-content:center;margin-top:1px">'+(capActive?'<div style="width:8px;height:8px;border-radius:50%;background:#fff"></div>':'')+'</div>');
  p.push('<div style="flex:1">');
  p.push('<div style="font-size:15px;font-weight:700;color:#26352f">\uD83D\uDC8A Als Kapseln</div>');
  p.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">'+d.capsulesPerDay+' Kapseln t\u00E4glich \u2013 bequem zu schlucken, unterwegs praktisch. Mit Bio-Akazienpulver aufgef\u00FCllt.</div>');
  p.push(feinschliffHinweis('Morgen'));
  p.push('</div></div></div>');

  // Option Pulver
  p.push('<div onclick="selectDelivery(\'powder\')" style="cursor:pointer;border:2px solid '+(!capActive?'#26352f':'#e4e2dc')+';border-radius:9px;padding:12px 14px;background:#fff">');
  p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
  p.push('<div style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid '+(!capActive?'#26352f':'#c9c4ba')+';background:'+(!capActive?'#26352f':'#fff')+';display:flex;align-items:center;justify-content:center;margin-top:1px">'+(!capActive?'<div style="width:8px;height:8px;border-radius:50%;background:#fff"></div>':'')+'</div>');
  p.push('<div style="flex:1">');
  p.push('<div style="font-size:15px;font-weight:700;color:#26352f">\uD83E\uDD44 Als Pulver</div>');
  p.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">Mit Dosierl\u00F6ffel.</div>');
  p.push('</div></div></div>');

  p.push('</div>'); // Ende Morgen-Kasten
  }

  // ── ABEND-ROUTINE ────────────────────────────────────────────────────────
  if(d.hasEvening){
    p.push('<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">');
    p.push(pouch(IMG_POUCH_EVENING,'\uD83C\uDF19'));
    p.push('<div style="font-size:13px;font-weight:700;color:#26352f;letter-spacing:.02em">Abend-Routine <span style="font-weight:400;color:#727c6a">\u2013 '+((EVENING_CAPSULE_ENABLED&&d.hasEveningCaps)?'w\u00E4hle Deine Form':'immer als Pulver')+'</span></div>');
    p.push('</div>');

    if(!EVENING_CAPSULE_ENABLED || !d.hasEveningCaps){
      // Reiner Gramm-Strom (z. B. nur Guarkernmehl, Kreatin, MCT) — nicht kapselbar.
      p.push('<div style="border:1px solid #e4e2dc;border-radius:10px;padding:12px 14px;margin-bottom:14px;background:#f6f5f1">');
      p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
      p.push('<div style="flex-shrink:0;font-size:20px">\uD83E\uDD44</div>');
      p.push('<div style="flex:1">');
      p.push('<div style="font-size:15px;font-weight:700;color:#26352f">Pulver mit Dosierl\u00F6ffel</div>');
      p.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.45">Enth\u00E4lt u.\u00A0a. '+d.evening.map(nm).slice(0,4).join(', ')+(d.evening.length>4?' u.\u00A0a.':'')+'. Zu einer Hauptmahlzeit mit etwas Fett einzunehmen.</div>');
      p.push('</div></div></div>');
    } else {
      p.push('<div style="border:1px solid #e4e2dc;border-radius:10px;padding:12px;margin-bottom:16px;background:#f6f5f1">');

      // Option Kapseln
      p.push('<div onclick="selectDeliveryEvening(\'capsule\')" style="cursor:pointer;border:2px solid '+(capActiveE?'#26352f':'#e4e2dc')+';border-radius:9px;padding:12px 14px;margin-bottom:9px;background:#fff;position:relative">');
      p.push('<div style="position:absolute;top:11px;right:12px;background:#70191d;color:#f6f5f1;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px">+'+_fmtS(proKapsel*d.eveningCapsulesPerDay)+'\u00A0\u20AC/Tag</div>');
      p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
      p.push('<div style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid '+(capActiveE?'#26352f':'#c9c4ba')+';background:'+(capActiveE?'#26352f':'#fff')+';display:flex;align-items:center;justify-content:center;margin-top:1px">'+(capActiveE?'<div style="width:8px;height:8px;border-radius:50%;background:#fff"></div>':'')+'</div>');
      p.push('<div style="flex:1">');
      p.push('<div style="font-size:15px;font-weight:700;color:#26352f">\uD83D\uDC8A Als Kapseln</div>');
      p.push(feinschliffHinweis('Abend'));
      p.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">'+d.eveningCapsulesPerDay+' Kapseln t\u00E4glich. Mit Bio-Akazienpulver aufgef\u00FCllt.'
        +(d.eveningPowder.length?' <b>'+d.eveningPowder.map(nm).join(', ')+'</b> bleibt zus\u00E4tzlich als Pulver dabei \u2013 diese Menge passt nicht in Kapseln.':'')+'</div>');
      p.push('</div></div></div>');

      // Hinweis mit konkretem Vorschlag, falls ein Zusatzbeutel nötig wäre.
      var _tipp = kapselTippAbend(d);
      if(_tipp){
        p.push('<div style="border:1px solid #f4eded;border-radius:9px;padding:10px 12px;margin-bottom:9px;background:#f4eded">');
        p.push('<div style="display:flex;align-items:flex-start;gap:8px">');
        p.push('<div style="flex-shrink:0;font-size:14px;line-height:1.3">\uD83D\uDCA1</div>');
        p.push('<div style="flex:1;font-size:11px;color:#70191d;line-height:1.5">');
        p.push('Deine Abend-Routine ist etwas zu umfangreich f\u00FCr Kapseln allein \u2013 ein kleiner Pulverbeutel l\u00E4ge bei. ');
        if(_tipp.unsicher){
          p.push('Wer lieber reine Kapseln m\u00F6chte, nimmt die gr\u00F6\u00DFeren Mengen etwas zur\u00FCck.');
        } else if(_tipp.raus){
          p.push('Ohne <b>'+_tipp.namen.join('</b>, <b>')+'</b> passt alles in die Kapseln.');
        } else {
          p.push('Mit <b>'+_tipp.name+'</b> auf '+fa(_tipp.ziel,_tipp.unit)+'\u00A0'+_tipp.unit+' passt alles in die Kapseln.');
        }
        p.push('</div></div></div>');
      }

      // Option Pulver
      p.push('<div onclick="selectDeliveryEvening(\'powder\')" style="cursor:pointer;border:2px solid '+(!capActiveE?'#26352f':'#e4e2dc')+';border-radius:9px;padding:12px 14px;background:#fff">');
      p.push('<div style="display:flex;align-items:flex-start;gap:10px">');
      p.push('<div style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid '+(!capActiveE?'#26352f':'#c9c4ba')+';background:'+(!capActiveE?'#26352f':'#fff')+';display:flex;align-items:center;justify-content:center;margin-top:1px">'+(!capActiveE?'<div style="width:8px;height:8px;border-radius:50%;background:#fff"></div>':'')+'</div>');
      p.push('<div style="flex:1">');
      p.push('<div style="font-size:15px;font-weight:700;color:#26352f">\uD83E\uDD44 Als Pulver</div>');
      p.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">Mit Dosierl\u00F6ffel. Zu einer Hauptmahlzeit mit etwas Fett einzunehmen.</div>');
      p.push('</div></div></div>');

      p.push('</div>'); // Ende Abend-Kasten
    }
  }

  // ── TAGESPREIS im Gesamt-Rahmen ──────────────────────────────────────────
  p.push('<div style="border-top:1px solid #e4e2dc;padding-top:14px;margin-top:2px;display:flex;align-items:center;justify-content:space-between">');
  p.push('<div><div style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#727c6a">Dein Preis / Tag</div>');
  p.push('<div style="font-size:10px;color:#727c6a;margin-top:1px">f\u00FCr '+(boosterContainers().length?'Routinen und Booster':'beide Routinen')+' zusammen'+(surchargeDay>0?' inkl. Kapseln':'')+'</div></div>');
  p.push('<div id="b-routine-price" style="font-size:26px;font-weight:300;color:#26352f">'+_fmtP(dayPrice)+'</div>');
  p.push('</div>');

  p.push('</div>'); // Ende Gesamt-Rahmen

  // ── BOOSTER: eigener Abschnitt ───────────────────────────────────────────
  // Bewusst AUSSERHALB des Routinen-Rahmens. Booster sind keine
  // Darreichungswahl: sie werden nicht eingemischt, sondern liegen als eigene
  // Beutel bei. Standen sie im selben Kasten wie Kapseln/Pulver, las sich das
  // wie eine dritte Darreichungsform.
  p.push(renderBoosterBereich());

  return p.join('');
}

// ── Darreichungsform umschalten + neu rendern ───────────────────────────────
// Rendert neu, OHNE dass die Seite springt. Trick: Während render() den
// #b-app-Inhalt austauscht, kollabiert die Seitenhöhe kurz — der Browser
// klemmt dann die Scroll-Position auf die (kleinere) Maximalhöhe, was den
// Sprung verursacht. Wir fixieren die Höhe von #b-app für den Austausch und
// stellen die Scroll-Position danach wieder her — für window UND einen evtl.
// scrollbaren Eltern-Container (Page-Builder betten manchmal so ein).
function findScrollParent(node){
  var el = node ? node.parentElement : null;
  while(el && el !== document.body && el !== document.documentElement){
    var st = window.getComputedStyle(el);
    var oy = st.overflowY;
    if((oy==='auto' || oy==='scroll') && el.scrollHeight > el.clientHeight + 4){
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function renderKeepScroll(){
  var app = document.getElementById('b-app');
  var winY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  var sp = findScrollParent(app);
  var spY = sp ? sp.scrollTop : 0;
  var h = app ? app.offsetHeight : 0;
  if(app && h){ app.style.minHeight = h + 'px'; }   // Höhe halten -> kein Kollaps
  render();
  var restore = function(){
    window.scrollTo(0, winY);
    if(document.documentElement) document.documentElement.scrollTop = winY;
    if(document.body) document.body.scrollTop = winY;
    if(sp) sp.scrollTop = spY;
  };
  restore();                                         // sofort
  requestAnimationFrame(function(){
    restore();                                       // nach Layout
    requestAnimationFrame(function(){
      restore();                                     // Absicherung (Fonts/Bilder)
      if(app){ app.style.minHeight = ''; }           // Höhe wieder freigeben
    });
  });
}

// ── KAPSEL-FEINSCHLIFF ────────────────────────────────────────────────────
// Die Kapselzahl ist eine Aufrundung: ceil(Masse / Fuellgewicht). Eine
// Rezeptur mit 3.650 mg braucht acht Kapseln, die achte ist zu 15 % gefuellt.
// Nimmt man diesen Ueberhang zurueck, faellt eine ganze Kapsel weg.
//
// Regeln, damit daraus keine stille Dosiskuerzung wird:
//   * nur wenn dadurch wirklich eine Kapsel wegfaellt (wird nachgerechnet),
//   * hoechstens FEINSCHLIFF_MAX_ANTEIL der Routinemasse,
//   * nur aus den schwersten Zutaten — 200 mg weniger Kollagen merkt niemand,
//     5 mg Piperin um 3 % zu kuerzen waere sinnlos,
//   * nie unter 40 % der vollen Dosis (so weit skaliert der Fragebogen selbst),
//   * nie unter die Menge, ab der ein Health Claim stehen darf,
//   * nur bei Kapseln. Wer Pulver nimmt, bekommt die volle Dosis.
// Was der Feinschliff geaendert hat, steht in S.feinschliffDelta — daraus
// stellt der Wechsel zurueck auf Pulver die volle Dosis wieder her.
var FEINSCHLIFF_AKTIV      = true;
var FEINSCHLIFF_MAX_ANTEIL = 0.03;   // 3 % der Routinemasse
var FEINSCHLIFF_MIN_FAKTOR = 0.40;   // nie unter 40 % der vollen Dosis

// Zuruecknehmen: NUR was der Feinschliff selbst geaendert hat, und nur
// solange der Wert noch so dasteht, wie er ihn hinterlassen hat. Eine
// vollstaendige Momentaufnahme aller Dosen waere falsch — wer nach dem
// Feinschliff am Regler dreht, bekaeme seine Aenderung beim naechsten
// Formwechsel wieder weggebuegelt. So gewinnt immer die juengere Hand.
function _feinschliffAnwenden(plan){
  plan.forEach(function(x){ S.amt[x.id] = x.auf; });
}
function _feinschliffRuecknehmen(plan){
  plan.forEach(function(x){
    if(Math.abs((S.amt[x.id]||0) - x.auf) < 1e-9) S.amt[x.id] = x.von;
  });
}
function feinschliffZuruecksetzen(){
  if(S.feinschliffDelta) _feinschliffRuecknehmen(S.feinschliffDelta);
  S.feinschliffDelta = null;
  S.feinschliff = null;
}

// Kleinste Dosis, auf die eine Zutat heruntergehen darf.
function feinschliffBoden(it, vollDosis){
  var b = vollDosis * FEINSCHLIFF_MIN_FAKTOR;
  var cg = claimUntergrenze(it);
  // Nur schuetzen, was ohne Kuerzung auch wirklich einen Claim traegt.
  if(cg !== null && vollDosis >= cg) b = Math.max(b, cg);
  if(it.step) b = Math.max(b, it.step);
  return b;
}

// Plant die Kuerzung EINES Stroms. Aendert S.amt noch nicht.
function _feinschliffPlan(ids, bezeichnung){
  if(!ids || !ids.length) return null;
  var F = KAPSEL_FUELLGEWICHT_MG;
  var posten = ids.map(function(id){
    var it = DB.find(function(x){ return x.id===id; });
    return it ? { it:it, id:id, mg:powderMg(it) } : null;
  }).filter(function(x){ return x && x.mg > 0; });
  if(!posten.length) return null;

  var masse = posten.reduce(function(a,x){ return a+x.mg; }, 0);
  var kapsVorher = Math.max(1, Math.ceil(masse/F));
  if(kapsVorher <= 1) return null;
  var ueberhang = masse % F;
  if(ueberhang <= 0) return null;                              // sitzt schon auf der Grenze
  if(ueberhang > masse * FEINSCHLIFF_MAX_ANTEIL) return null;  // zu teuer

  posten.sort(function(a,b){ return b.mg - a.mg; });           // schwerste zuerst
  var rest = ueberhang, plan = [];
  for(var i=0; i<posten.length && rest > 1e-9; i++){
    var pz = posten[i];
    var voll = S.amt[pz.id];
    var boden = feinschliffBoden(pz.it, voll);
    if(voll <= boden) continue;
    var mgProEinheit = pz.mg / voll;                 // Rohware je Dosiseinheit
    var maxWeg = (voll - boden) * mgProEinheit;
    var nimm = Math.min(maxWeg, rest);
    if(nimm <= 0) continue;
    plan.push({ id:pz.id, von:voll, auf:voll - nimm/mgProEinheit,
                name:(names[pz.id]||pz.it.name), unit:pz.it.unit });
    rest -= nimm;
  }
  if(rest > 1e-9) return null;                                 // Boeden lassen es nicht zu
  return { strom:bezeichnung, plan:plan, kapselnVorher:kapsVorher,
           anteil:ueberhang/masse };
}

// Kapselzahl beider Routinen — gezaehlt wird nur, was auch als Kapsel geht.
function _kapselBild(){
  var F = KAPSEL_FUELLGEWICHT_MG;
  var d = getCapsuleDistribution();
  var masse = function(ids){
    return (ids||[]).reduce(function(a,id){
      var it = DB.find(function(x){ return x.id===id; });
      return a + (it ? powderMg(it) : 0);
    }, 0);
  };
  var m = (DELIVERY_FORM==='capsule' && d.hasMorning)
        ? Math.max(1, Math.ceil(masse(d.morning)/F)) : 0;
  var a = (eveningIsCapsule() && d.hasEveningCaps)
        ? Math.max(1, Math.ceil(masse(d.eveningCaps)/F)) : 0;
  return { Morgen:m, Abend:a, summe:m+a };
}

function feinschliffKapseln(){
  if(!FEINSCHLIFF_AKTIV) return;
  feinschliffZuruecksetzen();
  var morgenKaps = (DELIVERY_FORM === 'capsule');
  var abendKaps  = eveningIsCapsule();
  if(!morgenKaps && !abendKaps) return;

  var vorher = _kapselBild();

  // Je Strom zu kuerzen reicht NICHT als Pruefung: Gruppe C wird nach Masse
  // auf beide Routinen verteilt (verteileGruppeC). Wird morgens gekuerzt,
  // kann eine Zutat in die Abendroutine rutschen und dort eine Kapsel MEHR
  // kosten. In 17 von 3.000 Testrezepturen ist genau das passiert. Also:
  // Varianten durchprobieren und erst das Gesamtbild entscheiden lassen.
  var varianten = [];
  if(morgenKaps && abendKaps) varianten.push(['Morgen','Abend']);
  if(morgenKaps)              varianten.push(['Morgen']);
  if(abendKaps)               varianten.push(['Abend']);

  for(var v = 0; v < varianten.length; v++){
    var d = getCapsuleDistribution();
    var entwuerfe = [], delta = [];
    varianten[v].forEach(function(strom){
      var ids = (strom==='Morgen')
              ? (d.hasMorning ? d.morning : null)
              : (d.hasEveningCaps ? d.eveningCaps : null);
      var e = _feinschliffPlan(ids, strom);
      if(e){ entwuerfe.push(e); _feinschliffAnwenden(e.plan);
             delta = delta.concat(e.plan); }
    });
    if(!entwuerfe.length) continue;
    var nachher = _kapselBild();
    // Keine Routine darf schlechter werden, und unterm Strich muss es
    // wenigstens eine Kapsel bringen.
    if(nachher.Morgen <= vorher.Morgen && nachher.Abend <= vorher.Abend
       && nachher.summe < vorher.summe){
      var berichte = entwuerfe.map(function(e){
        return { strom:e.strom, anteil:e.anteil, zutaten:e.plan,
                 kapselnVorher:vorher[e.strom], kapselnNachher:nachher[e.strom] };
      }).filter(function(b){ return b.kapselnNachher < b.kapselnVorher; });
      if(berichte.length){
        S.feinschliff = berichte;
        S.feinschliffDelta = delta;
        return;
      }
    }
    _feinschliffRuecknehmen(delta);
  }
  S.feinschliff = null; S.feinschliffDelta = null;
}

// Einzeiler fuer die Darreichungs-Auswahl.
function feinschliffHinweis(strom){
  if(!S.feinschliff) return '';
  var b = null;
  S.feinschliff.forEach(function(x){ if(x.strom===strom) b = x; });
  if(!b) return '';
  var z = b.zutaten.map(function(x){ return x.name; }).slice(0,2).join(' und ');
  return '<div style="font-size:11px;color:#70191d;margin-top:4px;line-height:1.4">'
    + 'Feinschliff: &minus;' + (b.anteil*100).toFixed(1).replace('.',',') + '\u00A0% bei '
    + z + ' spart eine Kapsel (' + b.kapselnVorher + ' \u2192 ' + b.kapselnNachher + ').</div>';
}

function selectDelivery(form){
  if(DELIVERY_FORM===form) return;                   // kein unnötiges Re-Render
  DELIVERY_FORM = form;
  feinschliffKapseln();   // Pulver bekommt die volle Dosis zurueck
  renderKeepScroll();
}

function selectDeliveryEvening(form){
  if(DELIVERY_FORM_EVENING===form) return;
  DELIVERY_FORM_EVENING = form;
  feinschliffKapseln();
  renderKeepScroll();
}

function renderCartSection(){
  var rname = S.ans.rezepturname || 'Meine Rezeptur';
  var parts = [];

  // ── Ärztlicher Rücksprache-Hinweis (bei Schwangerschaft/Stillen/Medikamenten/Erkrankung) ─
  var _ges = S.ans.gesundheit || [];
  var _needsDoc = _ges.some(function(g){
    return g.indexOf('schwanger')>=0 || g.indexOf('stille')>=0 ||
           g.indexOf('Medikamente')>=0 || g.indexOf('Erkrankung')>=0;
  });
  if(_needsDoc){
    parts.push('<div style="display:flex;gap:10px;align-items:flex-start;border:1px solid #70191d;background:#f4eded;border-radius:8px;padding:12px 14px;margin-bottom:16px">'
      +'<span style="font-size:18px;flex-shrink:0">⚕️</span>'
      +'<div style="font-size:12px;color:#5a4a00;line-height:1.55">Bei Schwangerschaft, dem Stillen von Babys, der Einnahme von Medikamenten oder diagnostizierten Krankheiten empfehlen wir, vor der Einnahme Ihren Arzt zu kontaktieren.</div>'
      +'</div>');
  }

  // ── Health-Claims-Block (gerahmt) ────────────────────────────────────────
  // Ausgeblendet: Die Claims stehen bereits unter jeder einzelnen Zutat (mit
  // 15%-NRV-Prüfung). Der gebündelte Kasten war reine Redundanz. Zum Wieder-
  // aktivieren SHOW_CLAIMS_SUMMARY_BOX auf true setzen.
  var _hc = getActiveClaims();
  if(SHOW_CLAIMS_SUMMARY_BOX && _hc.length){
    var _hesc=function(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');};
    parts.push('<div style="border:1px solid #000;border-radius:4px;padding:12px 14px;margin-bottom:16px">');
    parts.push('<div style="font-size:12pt;font-weight:700;color:#000;margin-bottom:8px">Health Claims</div>');
    parts.push('<div style="font-size:11px;color:#26352f;line-height:1.55">');
    _hc.forEach(function(e){
      parts.push('<div style="margin-bottom:5px">* '+_hesc(e.claim)+'</div>');
    });
    parts.push('</div></div>');
  }

  // ── Morgen- & Abend-Routine (Gesamt-Rahmen mit Tagespreis) ───────────────
  // WICHTIG: Die Darreichungs-Kacheln stehen bewusst ÜBER dem Hinweise-Block.
  // Grund: getDeliveryNotes() liefert im Pulver-Modus mehr Zeilen als im
  // Kapsel-Modus. Stünde der Hinweis-Block oben, würde sich beim Umschalten
  // die Höhe oberhalb der Kacheln ändern und die Klickstelle verschieben
  // ("Sprung"). Mit den Kacheln oben ändert sich nur Inhalt darunter.
  parts.push(renderRoutines());

  // ── Hinweise zu Lieferung und Anwendung (gerahmt, bedingt) ────────────────
  var _dn = getDeliveryNotes();
  if(_dn.length){
    var _desc=function(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');};
    parts.push('<div style="border:1px solid #000;border-radius:4px;padding:12px 14px;margin:16px 0">');
    parts.push('<div style="font-size:12pt;font-weight:700;color:#000;margin-bottom:8px">Hinweise zu Lieferung und Anwendung</div>');
    parts.push('<div style="font-size:11px;color:#26352f;line-height:1.55">');
    _dn.forEach(function(t){
      parts.push('<div style="margin-bottom:5px">* '+_desc(t)+'</div>');
    });
    parts.push('</div></div>');
  }

  // ── Kaufart-Auswahl: 90-Tage-Einmalkauf  vs.  3×30-Abo ───────────────────
  var _capSurcharge = getCapsuleSurchargeMonth();          // 0, wenn Pulver gewählt
  var _monthly = ((S.tPrD||0)*30) + _capSurcharge;         // Monatspreis inkl. Kapselaufschlag
  // Angezeigt wird, was an der Kasse tatsächlich anfällt — nicht der
  // ungerundete Rechenpreis.
  var _kp     = kassenpreise();
  var _p90    = _kp.einmal90 || get90DayPrice();
  var _p90ref = _kp.abo90    || _monthly*3;                 // Streichpreis = drei Abo-Raten
  var _fmt = function(n){return n.toFixed(2).replace('.',',')+'\u00A0\u20AC';};
  var _pct = Math.round(NINETY_DISCOUNT*100);
  var _spar = _kp.ersparnis;

  parts.push('<div style="margin-bottom:16px">');
  parts.push('<div class="b-result-name-banner" style="background:#26352f;color:#f6f5f1;display:block;text-align:left"><div class="b-result-name-value">Deine Lieferung: W\u00E4hle zwischen 2 Optionen</div></div>');

  // ── Kachel 1: 90-Tage-Einmalkauf (empfohlen, Rabatt) ──
  parts.push('<div id="b-opt-onetime" onclick="selectPurchase(\'90\')" style="cursor:pointer;border:2px solid #26352f;border-radius:10px;padding:14px 16px;margin-bottom:10px;background:#fff;position:relative">');
  // Ersparnis in Euro aus den echten Kassenpreisen — ein fester Prozentsatz
  // stimmt nach dem Aufrunden auf die Preisstufen nicht mehr genau.
  parts.push('<div style="position:absolute;top:12px;right:14px;background:#26352f;color:#fff;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;letter-spacing:.04em">'
    +(_spar && _spar>0 ? _spar+'\u00A0\u20AC SPAREN' : _pct+'\u00A0% SPAREN')+'</div>');
  parts.push('<div style="display:flex;align-items:flex-start;gap:11px">');
  parts.push('<div id="b-radio-onetime" style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid #26352f;background:#26352f;display:flex;align-items:center;justify-content:center;margin-top:1px"><div style="width:8px;height:8px;border-radius:50%;background:#fff"></div></div>');
  parts.push('<div style="flex:1">');
  parts.push('<div style="font-size:15px;font-weight:700;color:#26352f">90 Tage Einmalkauf</div>');
  parts.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">Du erh\u00E4ltst Deine individuelle Rezeptur mit Deiner Morgen- und Deiner Abend-Routine inkl. Dosierl\u00F6ffel f\u00FCr 90 Tage in einer Lieferung. Kein Abo.</div>');
  parts.push('<div style="margin-top:8px;font-size:19px;font-weight:700;color:#26352f">'+_fmt(_p90)+' <span style="font-size:13px;font-weight:400;color:#727c6a;text-decoration:line-through">'+_fmt(_p90ref)+'</span></div>');
  parts.push('</div></div></div>');

  // ── Kachel 2: 3×30 Tage Abo ──
  parts.push('<div id="b-opt-sub" onclick="selectPurchase(\'abo3\')" style="cursor:pointer;border:2px solid #e4e2dc;border-radius:10px;padding:14px 16px;background:#fff">');
  parts.push('<div style="display:flex;align-items:flex-start;gap:11px">');
  parts.push('<div id="b-radio-sub" style="flex-shrink:0;width:20px;height:20px;border-radius:50%;border:2px solid #c9c4ba;background:#fff;display:flex;align-items:center;justify-content:center;margin-top:1px"></div>');
  parts.push('<div style="flex:1">');
  parts.push('<div style="font-size:15px;font-weight:700;color:#26352f">3&times;30 Tage Abo</div>');
  parts.push('<div style="font-size:11px;color:#727c6a;margin-top:3px;line-height:1.4">Du erh\u00E4ltst Deine individuelle Rezeptur mit Deiner Morgen- und Deiner Abend-Routine in 3 Lieferungen nach Zahlungseingang f\u00FCr jeweils 30 Tage. Ein Dosierl\u00F6ffel liegt der ersten Lieferung bei. Endet automatisch nach der dritten Lieferung.</div>');
  parts.push('<div style="margin-top:8px;font-size:19px;font-weight:700;color:#26352f">'+_fmt(_kp.aboMonat || _monthly)+' <span style="font-size:12px;font-weight:400;color:#727c6a">pro Monat (3 Lieferungen)</span></div>');
  parts.push('</div></div></div>');

  parts.push('</div>');

  parts.push('<div style="background:#f5efef;border:2px solid #70191d;border-radius:10px;padding:16px;margin-bottom:16px">');

  // Custom checkbox using div — bypasses theme CSS issues
  parts.push('<div style="display:flex;align-items:flex-start;gap:12px;cursor:pointer" onclick="');
  parts.push('var cb=document.getElementById(\'b-agb-state\');');
  parts.push('var checked=cb.getAttribute(\'data-checked\')===\'1\';');
  parts.push('checked=!checked;');
  parts.push('cb.setAttribute(\'data-checked\',checked?\'1\':\'0\');');
  parts.push('cb.innerHTML=checked?\'✓\':\'\';');
  parts.push('cb.style.background=checked?\'#70191d\':\'#fff\';');
  parts.push('cb.style.borderColor=checked?\'#521719\':\'#70191d\';');
  parts.push('var btn=document.getElementById(\'b-cart-btn-main\');');
  parts.push('if(btn){btn.disabled=!checked;btn.style.opacity=checked?\'1\':\'0.4\';btn.style.cursor=checked?\'pointer\':\'not-allowed\';}');
  parts.push('">');

  // Custom checkbox visual
  parts.push('<div id="b-agb-state" data-checked="0" style="');
  parts.push('flex-shrink:0;width:22px;height:22px;border:2px solid #70191d;border-radius:4px;');
  parts.push('background:#fff;display:flex;align-items:center;justify-content:center;');
  parts.push('font-size:14px;font-weight:700;color:#fff;margin-top:1px;transition:all 0.15s"></div>');

  // Text
  parts.push('<span style="font-size:12px;color:#3a1515;line-height:1.7">');
  parts.push('Ich bestätige, dass mein Produkt <strong>\'Puraveda by Biotiva\'</strong> individuell nach meinen persönlichen Angaben hergestellt wird. ');
  parts.push('Ich habe die <a href="https://www.biotiva.de/policies/terms-of-service" target="_blank" style="color:#521719;font-weight:700" onclick="event.stopPropagation()">AGB</a> ');
  parts.push('gelesen und akzeptiere diese. Gemäß § 312g Abs. 2 Nr. 1 BGB besteht <strong>kein gesetzliches Widerrufsrecht</strong>. ');
  parts.push('Ich habe die Bedingungen zum <strong>Widerruf und zur Einschränkung der Rückgabe</strong> zur Kenntnis genommen.');
  parts.push('</span></div></div>');

  // Button — initially disabled
  parts.push('<button id="b-cart-btn-main" onclick="addToShopifyCart()" disabled ');
  parts.push('style="display:block;width:100%;padding:16px;background:#26352f;color:#fff;border:none;border-radius:10px;');
  parts.push('font-size:16px;font-weight:600;cursor:not-allowed;opacity:0.4;letter-spacing:0.3px;margin-bottom:12px">');
  parts.push('\uD83D\uDED2 "' + rname + '" in den Warenkorb</button>');

  // E-Mail-Versand der Rezeptur – funktioniert unabhängig vom Warenkorb.
  // Pflicht-Einwilligung (Datenschutz) VOR dem Button.
  parts.push('<input id="b-email-input" class="b-text-input" type="email" maxlength="80" autocomplete="email" ');
  parts.push('placeholder="Deine E-Mail-Adresse" value="'+(S.ans.email||'')+'" ');
  parts.push('oninput="S.ans.email=this.value.trim()" ');
  parts.push('style="display:block;width:100%;box-sizing:border-box;padding:12px;margin-bottom:12px;');
  parts.push('border:1px solid #c9c4ba;border-radius:8px;font-size:14px">');

  // Gelber Kasten in derselben Optik wie die AGB-Zustimmung darüber.
  parts.push('<div style="background:#f5efef;border:2px solid #70191d;border-radius:10px;padding:16px;margin-bottom:12px">');
  parts.push('<div style="display:flex;align-items:flex-start;gap:12px;cursor:pointer" onclick="');
  parts.push('var cb=document.getElementById(\'email-consent\');');
  parts.push('var checked=cb.getAttribute(\'data-checked\')===\'1\';');
  parts.push('checked=!checked;');
  parts.push('cb.setAttribute(\'data-checked\',checked?\'1\':\'0\');');
  parts.push('cb.innerHTML=checked?\'\u2713\':\'\';');
  parts.push('cb.style.background=checked?\'#70191d\':\'#fff\';');
  parts.push('cb.style.borderColor=checked?\'#521719\':\'#70191d\';');
  parts.push('var mb=document.getElementById(\'b-mail-btn\');');
  parts.push('if(mb){mb.disabled=!checked;mb.style.opacity=checked?\'1\':\'0.4\';mb.style.cursor=checked?\'pointer\':\'not-allowed\';}');
  parts.push('">');
  parts.push('<div id="email-consent" data-checked="0" style="');
  parts.push('flex-shrink:0;width:22px;height:22px;border:2px solid #70191d;border-radius:4px;');
  parts.push('background:#fff;display:flex;align-items:center;justify-content:center;');
  parts.push('font-size:14px;font-weight:700;color:#fff;margin-top:1px;transition:all 0.15s"></div>');
  parts.push('<span style="font-size:12px;color:#3a1515;line-height:1.7">');
  parts.push('Ich stimme den <a href="https://www.biotiva.de/policies/privacy-policy" target="_blank" style="color:#521719;font-weight:700" onclick="event.stopPropagation()">Datenschutzbestimmungen</a> zu und w\u00fcnsche, dass Good Organics mir diese E-Mail sendet.');
  parts.push('</span></div></div>');
  parts.push('<button id="b-mail-btn" onclick="emailRecipe()" disabled style="display:block;width:100%;padding:13px;background:#fff;color:#26352f;border:2px solid #26352f;border-radius:10px;font-size:14px;font-weight:600;cursor:not-allowed;opacity:0.4;margin-bottom:12px">\uD83D\uDCE7 Rezeptur an meine E-Mail senden</button>');

  // Navigation
  parts.push('<div style="display:flex;gap:8px">');
  parts.push('<button onclick="editRecipe()" style="flex:1;padding:12px;background:transparent;color:#521719;border:1px solid #70191d;border-radius:8px;font-size:13px;cursor:pointer">← Eingaben ändern</button>');
  parts.push('<button onclick="restart()" style="flex:1;padding:12px;background:transparent;color:#87867e;border:1px solid #c9c4ba;border-radius:8px;font-size:13px;cursor:pointer">↺ Neu starten</button>');
  parts.push('</div>');

  return parts.join('');
}

// ── Kaufart umschalten (Abo / Einmalkauf) + Optik aktualisieren ────────────
function selectPurchase(type){
  PURCHASE_TYPE = type;                          // '90' | 'abo3'
  var b90 = document.getElementById('b-opt-onetime');  // 90-Tage-Kachel
  var abo = document.getElementById('b-opt-sub');      // Abo-Kachel
  var r90 = document.getElementById('b-radio-onetime');
  var rAbo = document.getElementById('b-radio-sub');
  if(!b90||!abo) return;
  var on  = function(el,r){ el.style.borderColor='#26352f';
    r.style.borderColor='#26352f'; r.style.background='#26352f';
    r.innerHTML='<div style="width:8px;height:8px;border-radius:50%;background:#fff"></div>'; };
  var off = function(el,r){ el.style.borderColor='#e4e2dc';
    r.style.borderColor='#c9c4ba'; r.style.background='#fff'; r.innerHTML=''; };
  if(type==='90'){ on(b90,r90); off(abo,rAbo); }
  else           { on(abo,rAbo); off(b90,r90); }
}

var PRICE_VARIANT_MAP={
  30:53150607638795,
  31:53150607671563,
  32:53150607704331,
  33:53150607737099,
  34:53150607769867,
  35:53150607802635,
  36:53150607835403,
  37:53150607868171,
  38:53150607900939,
  39:53150607933707,
  40:53150607966475,
  41:53150607999243,
  42:53150608032011,
  43:53150608064779,
  44:53150608097547,
  45:53150608130315,
  46:53150608163083,
  47:53150608195851,
  48:53150608228619,
  49:53150608261387,
  50:53150608294155,
  51:53150608326923,
  52:53150608359691,
  53:53150608392459,
  54:53150608425227,
  55:53150608457995,
  56:53150608490763,
  57:53150608523531,
  58:53150608556299,
  59:53150608589067,
  60:53150608621835,
  61:53150608654603,
  62:53150608687371,
  63:53150608720139,
  64:53150608752907,
  65:53150608785675,
  66:53150608818443,
  67:53150608851211,
  68:53150608883979,
  69:53150608916747,
  70:53150608949515,
  71:53150608982283,
  72:53150609015051,
  73:53150609047819,
  74:53150609080587,
  75:53150609113355,
  76:53150609146123,
  77:53150609178891,
  78:53150609211659,
  79:53150609244427,
  80:53150609277195,
  81:53150609309963,
  82:53150609342731,
  83:53150609375499,
  84:53150609408267,
  85:53150609441035,
  86:53150609473803,
  87:53150609506571,
  88:53150609539339,
  89:53150609572107,
  90:53150609604875,
  91:53150609637643,
  92:53150609670411,
  93:53150609703179,
  94:53150609735947,
  95:53150609768715,
  96:53150609801483,
  97:53150609834251,
  98:53150609867019,
  99:53150609899787,
  100:53150609932555,
  // ── 102–156 in 2er-Schritten (ECHTE IDs, aus Shopify-Admin verifiziert) ──
  102:53215745802507,
  104:53215745835275,
  106:53215745868043,
  108:53215745900811,
  110:53215745933579,
  112:53215745966347,
  114:53215745999115,
  116:53215746031883,
  118:53215746064651,
  120:53215746097419,
  122:53215746130187,
  124:53215746162955,
  126:53215746195723,
  128:53215746228491,
  130:53215746261259,
  132:53215746294027,
  134:53215746326795,
  136:53215746359563,
  138:53215746392331,
  140:53215746425099,
  142:53215746457867,
  144:53215746490635,
  146:53215746523403,
  148:53215746556171,
  150:53215746588939,
  152:53215746621707,
  154:53215746654475,
  156:53215746687243,
};

// ── 90-Tage-Varianten (Produkt B, ID 10992788373771). Verifiziert 2026-07-02. ──
var PRICE_VARIANT_MAP_90 = {
  76: 53216587514123, 78: 53216587546891, 80: 53216587579659, 82: 53216587612427,
  84: 53216587645195, 86: 53216587677963, 88: 53216587710731, 90: 53216587743499,
  92: 53216587776267, 94: 53216587809035, 96: 53216587841803, 98: 53216587874571,
  100: 53216587907339, 104: 53216587940107, 108: 53216587972875, 112: 53216588005643,
  116: 53216588038411, 120: 53216588071179, 124: 53216588103947, 128: 53216588136715,
  132: 53216588169483, 136: 53216588202251, 140: 53216588235019, 144: 53216588267787,
  148: 53216588300555, 152: 53216588333323, 156: 53216588366091, 160: 53216588398859,
  164: 53216588431627, 168: 53216588464395, 172: 53216588497163, 176: 53216588529931,
  180: 53216588562699, 184: 53216588595467, 188: 53216588628235, 192: 53216588661003,
  196: 53216588693771, 200: 53216588726539, 205: 53216588759307, 210: 53216588792075,
  215: 53216588824843, 220: 53216588857611, 225: 53216588890379, 230: 53216588923147,
  235: 53216588955915, 240: 53216588988683, 245: 53216589021451, 250: 53216589054219,
  255: 53216589086987, 260: 53216589119755, 265: 53216589152523, 270: 53216589185291,
  275: 53216589218059, 280: 53216589250827, 285: 53216589283595, 290: 53216589316363,
  295: 53216589349131, 300: 53216589381899, 305: 53216589414667, 310: 53216589447435,
  315: 53216589480203, 320: 53216589512971, 325: 53216589545739, 330: 53216589578507,
  335: 53216589611275, 340: 53216589644043, 345: 53216589676811, 350: 53216589709579,
  355: 53216589742347, 360: 53216589775115, 365: 53216589807883, 370: 53216589840651,
  375: 53216589873419, 380: 53216589906187, 385: 53216589938955, 390: 53216589971723,
  395: 53216590004491, 400: 53216590037259,
};
var V90_MIN = 76, V90_MAX = 400;

// 90-Tage-Preis (Monatspreis inkl. Kapselaufschlag × 3 × (1 − Rabatt))
function get90DayPrice(){
  var monthly = (S.tPrD||0)*30 + getCapsuleSurchargeMonth();
  return monthly * 3 * (1 - NINETY_DISCOUNT);
}

// ── Kassenpreise ───────────────────────────────────────────────────────────
// Die Seite zeigte bisher den ungerundeten Rechenpreis, die Kasse berechnet
// aber die Shopify-Variante, auf die aufgerundet wird. Beispiel: Seite 392,72 €,
// Kasse 395 €. Diese Funktion liefert die Beträge, die der Kunde wirklich
// zahlt — die Seite zeigt ab jetzt nur noch diese.
function preisStufeAbo(monat){
  var p = Math.ceil(monat);
  if(p < VARIANT_PRICE_MIN) p = VARIANT_PRICE_MIN;
  if(p > VARIANT_STEP2_FROM && (p % 2 !== 0)) p += 1;
  return (p > VARIANT_PRICE_MAX) ? null : p;
}
function preisStufe90(preis){
  var p = Math.ceil(preis);
  if(p < V90_MIN) p = V90_MIN;
  if(p < 100){ if(p % 2 !== 0) p += 1; }
  else if(p < 200){ while(p % 4 !== 0) p += 1; }
  else { while(p % 5 !== 0) p += 1; }
  return (p > V90_MAX) ? null : p;
}
function kassenpreise(){
  var monat   = (S.tPrD||0)*30 + getCapsuleSurchargeMonth();
  var aboMon  = preisStufeAbo(monat);
  var ein90   = preisStufe90(get90DayPrice());
  var abo90   = aboMon ? aboMon*3 : null;
  return {
    aboMonat:   aboMon,                 // was im Abo je Monat belastet wird
    abo90:      abo90,                  // drei Abo-Raten zusammen
    einmal90:   ein90,                  // was der 90-Tage-Kauf kostet
    ersparnis:  (abo90 && ein90) ? abo90 - ein90 : null
  };
}

// Rundet den 90-Tage-Preis auf die nächste existierende Stufe AUF (nie darunter).
function getVariantId90(price90){
  var p = Math.ceil(price90);
  if(p < V90_MIN) p = V90_MIN;
  if(p < 100){ if(p % 2 !== 0) p += 1; }         // 2er-Raster
  else if(p < 200){ while(p % 4 !== 0) p += 1; } // 4er-Raster
  else { while(p % 5 !== 0) p += 1; }            // 5er-Raster
  if(p > V90_MAX) return null;
  return PRICE_VARIANT_MAP_90[p] || null;
}

// Preisbereich, für den Shopify-Varianten existieren (siehe PRICE_VARIANT_MAP).
// 30–100 in 1er-Schritten, 102–156 in 2er-Schritten (Shopify 100-Varianten-Limit).
// Liegt der Monatspreis darüber, gibt es KEINE Variante → sauber melden statt HTML-Fehler.
// WICHTIG: Immer AUFrunden auf die nächste existierende Variante – der Kunde zahlt
// nie weniger als den kalkulierten Rezepturpreis.
var VARIANT_PRICE_MIN = 30;
var VARIANT_PRICE_MAX = 156;   // 30–100 in 1er-Schritten, 102–156 in 2er-Schritten
var VARIANT_STEP2_FROM = 100;  // ab hier gilt 2er-Schrittung (gerade Preise)

function getVariantId(monthlyPrice){
  var p=Math.ceil(monthlyPrice);          // aufrunden – nie unter den echten Preis
  if(p < VARIANT_PRICE_MIN) p = VARIANT_PRICE_MIN;
  // Im 2er-Bereich (>100) auf die nächste gerade Zahl aufrunden
  if(p > VARIANT_STEP2_FROM && (p % 2 !== 0)) p += 1;
  if(p > VARIANT_PRICE_MAX) return null;   // über dem Maximum → keine Variante
  return PRICE_VARIANT_MAP[p] || null;
}

// ── "Warum fragen wir?" – eine kurze, claim-sichere Antwort je Frage ────────
var WHY_MAP = {
  age:      'Der N\u00e4hrstoffbedarf ver\u00e4ndert sich mit dem Alter. So stimmen wir Dosierungen und Empfehlungen auf Deine Lebensphase ab.',
  sex:      'Das biologische Geschlecht beeinflusst den Bedarf an einzelnen N\u00e4hrstoffen (z.\u00a0B. Eisen). Das hilft uns, Deinen Plan genauer zu personalisieren.',
  gewicht:  'Gewicht und Gr\u00f6\u00dfe ergeben zusammen Deinen BMI, der bei einigen N\u00e4hrstoffen die passende Dosierung mitbestimmt (u.\u00a0a. Vitamin D).',
  groesse:  'Zusammen mit dem Gewicht ermitteln wir daraus Deinen BMI \u2013 relevant u.\u00a0a. f\u00fcr die Vitamin-D-Dosierung.',
  rezepturname: 'So findest Du Deine pers\u00f6nliche Mischung sp\u00e4ter leicht wieder und kannst sie eindeutig zuordnen.',
  sport:    'K\u00f6rperliche Aktivit\u00e4t beeinflusst, wie Dein K\u00f6rper N\u00e4hrstoffe f\u00fcr Energie, Kraft und Regeneration nutzt.',
  stress:   'Anhaltender Stress kann den Bedarf an bestimmten N\u00e4hrstoffen erh\u00f6hen und beeinflusst, was f\u00fcr Dich sinnvoll ist.',
  sun:      'Sonnenlicht steuert die k\u00f6rpereigene Vitamin-D-Bildung. So sch\u00e4tzen wir ein, wie viel Vitamin D f\u00fcr Dich sinnvoll ist.',
  plz:      'Aus Deiner Region sch\u00e4tzen wir \u00fcber Breitengrad und Jahreszeit, wie viel Vitamin D Deine Haut in den n\u00e4chsten Monaten durch Sonnenlicht bilden kann. Wir werten nur die grobe Lage aus, keine genaue Adresse.',
  sleep:    'Schlaf pr\u00e4gt Energie, Stimmung und Regeneration. Das hilft uns einzusch\u00e4tzen, wo Unterst\u00fctzung sinnvoll ist.',
  smoke:    'Rauchen erh\u00f6ht den oxidativen Stress und den Bedarf an bestimmten Antioxidantien wie Vitamin\u00a0C.',
  diet:     'Deine Ern\u00e4hrungsweise beeinflusst, welche N\u00e4hrstoffe Du \u00fcber die Nahrung bereits abdeckst und welche eher fehlen (z.\u00a0B. Vitamin\u00a0B12 bei veganer Ern\u00e4hrung).',
  lacto:    'Bei Laktoseintoleranz achten wir darauf, dass Deine Mischung frei von Laktose bleibt.',
  fish:     'Fisch ist eine Hauptquelle f\u00fcr Omega-3. So sch\u00e4tzen wir ein, ob Deine Versorgung wahrscheinlich ausreicht.',
  alc:      'Regelm\u00e4\u00dfiger Alkohol kann den N\u00e4hrstoffstatus beeinflussen und mitbestimmen, was f\u00fcr Dich sinnvoll ist.',
  veg:      'Obst und Gem\u00fcse liefern Ballaststoffe und Antioxidantien. Das hilft einzusch\u00e4tzen, ob Deine Grundversorgung gedeckt ist.',
  email:    'An diese Adresse senden wir Dir auf Wunsch Deine pers\u00f6nliche Rezeptur und speichern Deinen Fortschritt, falls Du sp\u00e4ter zur\u00fcckkommen m\u00f6chtest.',
  goals:    'Deine Ziele steuern, welche Empfehlungen Priorit\u00e4t bekommen \u2013 so bildet die Mischung ab, was Dir am wichtigsten ist.'
};

var QUIZ=[
  {id:'age',   sec:'Demografie',  type:'range', label:'Wie alt bist Du?',min:18,max:80,val:35,unit:'Jahre'},
  {id:'sex',   sec:'Demografie',  type:'single',label:'Geschlecht',opts:['Männlich','Weiblich','Keine Angabe']},
  {id:'gewicht', sec:'Demografie',  type:'range', label:'Wie viel wiegst Du?',min:45, max:150, val:75, unit:'kg'},
  {id:'groesse', sec:'Demografie',  type:'range', label:'Wie groß bist Du?',min:140,max:210, val:172,unit:'cm'},
  {id:'rezepturname',sec:'Dein Profil',type:'text',label:'Wie soll Deine Rezeptur heißen?',
   placeholder:'z. B. „Oliver Daily Pack"',
   hint:'',
   sub:'Das wird der Name Deiner Rezeptur. Er erscheint auch auf Deiner personalisierten Tüte.'},
  {id:'sport', sec:'Lifestyle',   type:'range', label:'Sport & Bewegung (Tage / Woche)',min:0,max:7,val:2,unit:'Tage'},
  {id:'stress',sec:'Lifestyle',   type:'range', label:'Stresslevel',min:1,max:5,val:2,unit:'/5',lbl:['Ausgeglichen','Sehr hoch']},
  {id:'sun',   sec:'Lifestyle',   type:'single',label:'Wie viel Sonne täglich?',opts:['Täglich mehr als 30 min','Täglich zwischen 10 und 30 min','Täglich kaum Sonne / meist Büro']},
  {id:'plz',   sec:'Lifestyle',  type:'plz',   label:'Wo wirst Du die nächsten Wochen hauptsächlich sein?', sub:'Ort genügt – wir nutzen nur die Region, um abzuschätzen, wie viel Vitamin D Deine Haut in den kommenden 3 Monaten durch Sonnenlicht bilden kann.', placeholder:'z. B. 80331, München oder Thailand', hint:'Optional. Deutsche PLZ oder Land/Region. Es wird nur die grobe Lage ausgewertet, keine genaue Adresse.', optional:true},
  {id:'sleep', sec:'Lifestyle',   type:'range', label:'Schlafdauer pro Nacht',min:4,max:10,val:7,unit:'h'},
  {id:'smoke', sec:'Lifestyle',   type:'single',label:'Rauchst Du?',opts:['Nein','Selten','Ja']},
  {id:'diet',  sec:'Ernährung', type:'single',label:'Ernährungsweise',opts:['Allesesser','Vegetarisch','Vegan']},
  {id:'lacto', sec:'Ernährung', type:'single',label:'Laktoseintoleranz?',opts:['Nein','Ja']},
  {id:'fish',  sec:'Ernährung', type:'range', label:'Fischkonsum (Portion/Woche)',min:0,max:7,val:1,unit:'pro Woche'},
  {id:'alc',   sec:'Ernährung', type:'range', label:'Alkohol (Portion/Woche)',min:0,max:14,val:2,unit:'pro Woche'},
  {id:'veg',   sec:'Ernährung', type:'range', label:'Obst & Gemüse (Portion / Tag)',min:0,max:10,val:3,unit:'pro Tag'},
  {id:'email', sec:'Dein Profil', type:'email', label:'Deine E-Mail-Adresse',
   placeholder:'name@beispiel.de',
   hint:'Für Bestellbestätigung und Rezeptur-Dokumentation.',
   sub:''},
  {id:'gesundheit', sec:'Gesundheit', type:'multi',
   label:'Trifft eine oder mehrere der folgenden Aussagen auf Dich zu?',
   opts:['Ich bin schwanger.',
         'Ich stille aktuell.',
         'Ich nehme regelmäßig Medikamente ein.',
         'Bei mir wurde eine Erkrankung ärztlich diagnostiziert.',
         'Keine der genannten Aussagen trifft auf mich zu.'],
   optional:true},
  {id:'goals', sec:'Meine Ziele', type:'multi', label:'Welche 3 oder mehr Ziele und Themen willst Du adressieren?',
   opts:['Energie & Vitalität','Immunsystem stärken','Schlaf verbessern','Sporterholung',
         'Konzentration & Fokus','Knochen & Gelenke','Haut & Schönheit','Haare & Nägel',
         'Stress & Resilienz','Darm & Verdauung','Gewichtsmanagement','Leber & Entgiftung','Herz & Gefäße','Augen & Sehkraft','Wechseljahre','Longevity']},
];

// ── SCORING ENGINE ────────────────────────────────────────────────────────────

var INTERACTIONS=[

  {ids:['flechten','sea_lettuce','vitK2'], type:'syn', factor:1.3,
   label:'Vit.D3 + Mg + K2',
   note:'D3 fördert Calcium-Aufnahme, K2 leitet Calcium in Knochen, Mg aktiviert D3 – optimale Knochen-Kombination.'},
  {ids:['moringa','acerola'], type:'syn', factor:1.4,
   label:'Eisen + Vit.C',
   note:'Vitamin C erhöht die Eisen-Bioverfügbarkeit erheblich – eine der am besten belegten Nährstoff-Wechselwirkungen.'},
  {ids:['curcumin_ex','schwarzpfeffer'], type:'syn', factor:2.0,
   label:'Curcumin + Piperin',
   note:'Piperin steigert die Curcumin-Aufnahme deutlich – im gemeinsamen Pulver direkt wirksam.'},
  {ids:['ashwagandha','sea_lettuce'], type:'syn', factor:1.2,
   label:'Ashwagandha + Mg',
   note:'Mg unterstützt Schlaf und Entspannung synergistisch mit Ashwagandha.'},
  {ids:['omega3_algen','hericium'], type:'syn', factor:1.2,
   label:'Omega-3 + Hericium',
   note:'Komplementäre Wirkung für kognitive Funktion und Nervenschutz.'},
  {ids:['cordyceps','rote_beete'], type:'syn', factor:1.3,
   label:'Cordyceps + Rote Beete',
   note:'Kombinierte Ausdauer-Unterstützung durch Sauerstoffverwertung und Nitrat.'},
  {ids:['baldrian','passionsblume'], type:'syn', factor:1.3,
   label:'Baldrian + Passionsblume',
   note:'Klassische Kombination für Schlaf und Entspannung.'},
  {ids:['kurkuma','schwarzpfeffer'], type:'syn', factor:1.8,
   label:'Kurkuma + Piperin',
   note:'Piperin steigert Bioverfügbarkeit des Curcumins in Kurkuma.'},
  {ids:['Q10','vit_e'], type:'syn', factor:1.3,
   label:'Q10 + Vitamin E',
   note:'Q10 regeneriert oxidiertes Vitamin E – fettlösliche Antioxidantien wirken zusammen im Zellmembranschutz.'},
  {ids:['resveratol','Q10'], type:'syn', factor:1.2,
   label:'Resveratrol + Q10',
   note:'Beide unterstützen mitochondriale und kardiovaskuläre Funktion – häufige Longevity-Kombination.'},

];

// ── ANTAGONISMEN (Resorptions-Konkurrenz) ──────────────────────────────────────
// Evidenzbasierte Ausschluss-/Trennregeln für gleichzeitige Einnahme.
// Schwellen-Logik je Paar (Stand Wissenschaft Juni 2026):
//   trigger:'dose'  → Schwelle in Basiseinheit der genannten Zutat (mg)
//   trigger:'ratio' → Verhältnis-Schwelle (z.B. Zn:Cu > 15:1) ODER absolute Dosis
//   trigger:'nrv'   → beide Partner ≥ pctNrv % NRV (Default für Paare ohne etablierte mg-Schwelle)
// stage 2 = automatische physische Trennung in 2. Pulver; stage 1 = nur Einnahme-Hinweis.
// grade: A = RCT/Meta-Analyse, B = Kohorte/Mechanistik, C = Expertenkonsens.
var ANTAGONISTS=[
  {ids:['calcium','eisen'], grade:'A', stage:2,
   trigger:'dose', doseId:'calcium', doseMin:300,
   label:'Calcium + Eisen',
   note:'Calcium hemmt die Eisenaufnahme dosisabhängig (max. ~50 % ab 300 mg Calcium). Nimm die eisenhaltige Portion möglichst nüchtern und die calciumhaltige zu einer anderen Mahlzeit.',
   source:'Hallberg et al. 1991 (Am J Clin Nutr); Lönnerdal 2010 (Nutr Rev): max. Hemmung der Nicht-Häm-Eisen-Resorption ~50 % ab 300 mg Ca.'},

  {ids:['zink','kupfer'], grade:'A', stage:2,
   trigger:'ratio', ratioHighId:'zink', ratioLowId:'kupfer', ratioMax:15, absId:'zink', absMin:25,
   label:'Zink + Kupfer',
   // Zink und Kupfer liegen beide in Modulgruppe B, stehen also in derselben
   // Routine. Der Hinweis darf keine Trennung behaupten; wirksam ist hier das
   // Mengenverhältnis, und genau das prüft der Auslöser oben.
   note:'Hohe Zinkdosen blockieren die Kupferaufnahme (Metallothionein). Entscheidend ist hier nicht die Trennung, sondern das Mengenverhältnis: empfohlen sind 8–15 mg Zink je 1 mg Kupfer. Wir prüfen Deine Auswahl und melden uns, wenn sie darüber liegt.',
   source:'Sandström 2001; IOM 2001; EFSA 2015: Zn:Cu-Verhältnis 8–15:1, Kupfermangelrisiko bei chronisch >50 mg Zn/Tag.'},

  {ids:['zink','eisen'], grade:'B', stage:2,
   trigger:'nrv', pctNrv:25,
   label:'Zink + Eisen',
   note:'Zink und Eisen konkurrieren um denselben Transporter (DMT-1). Nimm die beiden Portionen zeitversetzt, die eisenhaltige möglichst nüchtern.',
   source:'Solomons 1986; Olivares et al. 2012: gegenseitige Resorptionshemmung v. a. nüchtern und bei hohen Eisendosen.'},

  {ids:['calcium','magnesium'], grade:'B', stage:2,
   trigger:'nrv', pctNrv:25,
   label:'Calcium + Magnesium',
   // Calcium steht fest auf abends (GRUPPE_C_NUR_ABEND), Magnesium liegt in
   // Gruppe B und damit ebenfalls abends. Eine Trennung findet nicht statt.
   note:'Calcium und Magnesium konkurrieren bei hohen Einzeldosen um die Resorption. Verteilst Du Deine Portion auf zwei Einnahmen – etwa nach dem Abendessen und vor dem Schlafen –, sinkt die gemeinsame Einzeldosis.',
   source:'Hardwick et al. 1991 (J Nutr): wechselseitige Resorptionskonkurrenz bei hohen Einzeldosen.'},

  {ids:['calcium','zink'], grade:'B', stage:2,
   trigger:'nrv', pctNrv:25,
   label:'Calcium + Zink',
   // Calcium und Zink liegen beide abends, siehe Calcium + Magnesium.
   note:'Hohe Calciumdosen können die Zinkaufnahme senken. Verteilst Du Deine Portion auf zwei Einnahmen, sinkt die gemeinsame Einzeldosis.',
   source:'Wood & Zheng 1997 (Am J Clin Nutr): Calcium reduziert Zinkbilanz bei hoher gemeinsamer Zufuhr.'},

  {ids:['eisen','mangan'], grade:'B', stage:2,
   trigger:'nrv', pctNrv:25,
   label:'Eisen + Mangan',
   note:'Eisen und Mangan teilen sich den DMT-1-Transporter und hemmen sich gegenseitig. Nimm die beiden Portionen zeitversetzt.',
   source:'Rossander-Hultén et al. 1991; Thomson et al. 1971: gemeinsamer DMT-1-Transportweg.'},

  {ids:['eisen','magnesium'], grade:'C', stage:2,
   trigger:'nrv', pctNrv:25,
   label:'Eisen + Magnesium',
   note:'Magnesium kann die Eisenresorption bei gleichzeitiger Einnahme leicht reduzieren (schwächer belegt). Nimm die beiden Portionen zeitversetzt.',
   source:'Expertenkonsens / mechanistische Plausibilität; Evidenz schwächer als für Ca/Fe.'}
];

// ── Wächter: kein Hinweistext darf Logistik behaupten ───────────────────────
// Wo eine Zutat liegt, entscheidet die Modulzuordnung und kann sich ändern —
// durch B_MINERALE_FREI_OHNE_EISEN, eine Booster-Auslagerung oder eine neue
// Gruppenzuordnung. Ein statischer Satz wie "wir liefern beide getrennt" wird
// davon still falsch. Deshalb nennen die Notes nur Mechanismus und Empfehlung;
// die tatsächliche Verteilung liefert _antOrtHinweis() zur Laufzeit.
// Drei Notes haben diese Regel verletzt (Calcium+Magnesium, Calcium+Zink,
// Zink+Kupfer — alle drei stehen immer in derselben Routine).
(function _pruefeAntagonistenNotes(){
  var verboten=/getrennte[nm]? Pulver|liefern (wir )?beide getrennt|trennen wir|Trennung in zwei|erfolgt die Trennung|in zwei getrennten/i;
  var treffer=ANTAGONISTS.filter(function(a){ return verboten.test(a.note||''); });
  if(treffer.length && typeof console!=='undefined' && console.warn)
    console.warn('[Puraveda] '+treffer.length+' Antagonismus-Hinweis(e) behaupten eine '
      +'Trennung, die die Modulzuordnung nicht garantiert: '
      +treffer.map(function(a){return a.label;}).join(', ')
      +'. Logistik gehört nicht in den Notentext, sondern in _antOrtHinweis().');
})();

// ── MODUL-SYSTEM: Morning / Evening / Anytime ───────────────────────────────────
// Statt rein paarweiser Trennung wird die Rezeptur bei Eisen ≥ 5 mg in zwei
// funktionale Beutel aufgeteilt (Morning Formula / Evening Formula).
// Wissenschaftliche Grundlage: Eisen konkurriert mit Calcium, Magnesium, Zink um
// dieselben Transporter (DMT-1). Trennung nach Tageszeit löst alle diese Konflikte
// gleichzeitig und ist praktisch kommunizierbar (Morgenformel zum Frühstück,
// Abendformel nach dem Abendessen → 8–12 h Abstand).
//
// Gruppen (feste Zuordnung):
//   A = Energy & Blood  → MORNING (Eisen, Vit C, B-Komplex, Folat, Energy-Botanicals)
//   B = Balance & Recovery → EVENING (Magnesium, Zink, Mangan, Balance/Recovery-Botanicals)
//   C = Longevity & Daily → ANYTIME (D3, A, E, Selen, Ballaststoffe) – wandert bei
//       Trennung zum EVENING-Beutel (weg vom Eisen: enthält Calcium-nahe & fettlösl.
//       Vitamine; D3 wirkt synergistisch mit Magnesium).
var MODULE_GROUPS = {
  // Gruppe A – Energy & Blood (morgens)
  A: { time:'morning', label:'Energy & Blood', ids:[
        'eisen','vit_c','vit_b12','folat','vit_b1','vit_b2','vit_b6','vit_b3','vit_b5','biotin','jod','chrom',
        // Energy-Botanicals
        'matcha','maca','ginseng','rote_beete','cordyceps','ingwer','schwarzpfeffer','guarana',
        // Erweiterung 27.10.2026
        'mate'
      ]},
  // Gruppe B – Balance & Recovery (abends)
  B: { time:'evening', label:'Balance & Recovery', ids:[
        'magnesium','zink','mangan','kupfer',
        // Balance/Recovery-Botanicals
        'ashwagandha','baldrian','reishi','hericium','chaga','tulsi','melisse','haferkraut','glycin',
        // abends, weil es einen Grund dafuer gibt: Gelenkbeschwerden nachts,
        // Knoblauchgeruch, Verdauung ueber Nacht
        'teufelskralle','knoblauch','triphala',
        // Erweiterung 27.10.2026
        'loewenzahn','brahmi','schafgarbe','tulsi','shatavari','artischocke','wermut'
      ]},
  // Gruppe C – Longevity & Daily Essentials (beliebige Tageszeit → bei Trennung Evening)
  C: { time:'anytime', label:'Longevity & Daily Essentials', ids:[
        'vit_d','vit_a','vit_e','vit_k','selen','calcium','kalium','cholin','omega3',
        'glucomannan','guarkernmehl','Q10','Kollagen','resveratol',
        // Daily-Botanicals/Pflanzen
        'acerola','chlorella','spirulina','brokkoli','akazienfaser','kurkuma','moringa_bot','lucuma',
        'brennnessel','gerstengras','weizengras','spermidin','hagebutte','nac',
        // Bis 10/2026 fielen diese nur ueber den Rueckfall in grp() nach C.
        // Jetzt steht es ausdruecklich da: keine Tageszeit-Bindung, also frei
        // verteilbar — die Zuordnung ist eine Entscheidung, kein Zufall.
        'alpha_liponsaeure','opc','msm','mct','irish_moss','kreatin'
      ]}
};
// Schwelle für die automatische Aufteilung
var IRON_SPLIT_THRESHOLD_MG = 5;   // Eisen ≥ 5 mg → 2 Beutel
// Gruppe C wandert bei Trennung in diesen Beutel (max. 2 Beutel gesamt)
var GROUP_C_TARGET = 'evening';   // nur noch Rückfall, siehe verteileGruppeC()

// Gruppe C heißt „beliebige Tageszeit" — bis 09/2026 landete sie trotzdem
// vollständig im Abend. Dadurch wog die Morgen-Routine oft nur ein halbes
// Gramm und musste zu zwei Dritteln mit Akazienpulver aufgefüllt werden,
// während der Abend auf zehn Gramm kam. Seitdem wird Gruppe C nach Masse auf
// beide Routinen verteilt — bis auf diese hier:
//   fettlöslich  → gehört zur Mahlzeit mit Fett (Abend)
//   Calcium      → darf nicht neben Eisen stehen, das morgens liegt
//   Glucomannan  → eigene Beilage, nie in einer Routine
var GRUPPE_C_NUR_ABEND = ['vit_d','vit_a','vit_e','vit_k','omega3','Q10','calcium','glucomannan'];

// Diese vier liegen in Gruppe B, aber nicht aus Wirkungsgründen wie Baldrian
// oder Ashwagandha, sondern weil sie laut ANTAGONISTS mit Eisen (bzw. Zink mit
// Kupfer) um die Aufnahme konkurrieren. Ohne Eisen in der Rezeptur gibt es
// diesen Grund nicht mehr.
var B_MINERALE_WEGEN_EISEN = ['magnesium','zink','mangan','kupfer'];

// Produktentscheidung, bewusst auf false:
// Magnesium ist mit 2,08 g Rohware der schwerste bewegliche Abend-Posten. Ohne
// Eisen dürfte es morgens stehen, und die Morgen-Routine wäre deutlich voller.
// Dagegen spricht die Produktaussage „Balance & Recovery am Abend" — Magnesium
// abends ist bei Kunden eine feste Erwartung (Muskelentspannung, Schlaf).
// Auf true setzen, wenn der Massenausgleich wichtiger ist als diese Erwartung.
var B_MINERALE_FREI_OHNE_EISEN = false;

// Teilmenge von B_MINERALE_WEGEN_EISEN ohne Abend-Erwartung beim Kunden: Zink,
// Mangan und Kupfer stehen abends ausschliesslich wegen des Eisens — anders als
// Magnesium, das zu „Balance & Recovery am Abend" gehoert. Ohne Eisen in der
// Rezeptur duerfen diese drei deshalb wandern, auch wenn Magnesium bleibt.
// Zweck: Calcium liegt fest auf abends (GRUPPE_C_NUR_ABEND, wegen Calcium+Eisen
// Grad A). Zink daneben loest Calcium+Zink aus (Grad B). Darf Zink wandern, ist
// der Konflikt in eisenfreien Rezepturen aufloesbar.
var B_MINERALE_BEWEGLICH_OHNE_EISEN = ['zink','mangan','kupfer'];

// Hat die Zutat einen AKTIV ausgeloesten Gegenspieler in dieser Routine?
function _hatKonfliktIn(id, liste){
  for(var i=0;i<ANTAGONISTS.length;i++){
    var a=ANTAGONISTS[i];
    if(a.ids.indexOf(id)<0) continue;
    if(!antTriggered(a)) continue;
    for(var j=0;j<a.ids.length;j++)
      if(a.ids[j]!==id && liste.indexOf(a.ids[j])>=0) return true;
  }
  return false;
}

// Verteilt die frei zuordenbaren Zutaten der Gruppe C auf die leichtere der
// beiden Routinen — schwerste zuerst. Ergebnis: zwei Beutel ähnlicher Größe
// statt eines winzigen und eines sehr großen.
//
// Der Massenausgleich allein genuegt nicht: er kennt keine Antagonismen und
// legt eine Zutat auch dann neben ihren Gegenspieler, wenn die andere Routine
// frei waere (gemessen: Calcium+Zink wurde so in 44 % der eisenfreien Faelle
// unnoetig zusammengelegt). Deshalb entscheidet zuerst der Konflikt und nur
// bei Gleichstand die Masse.
function verteileGruppeC(anytime, morning, evening){
  var rohVon = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?powderMg(it):0; };
  var summe  = function(l){ return l.reduce(function(s,id){ return s+rohVon(id); }, 0); };
  var frei = [], fest = [];
  anytime.forEach(function(id){
    (GRUPPE_C_NUR_ABEND.indexOf(id)>=0 ? fest : frei).push(id);
  });
  fest.forEach(function(id){ evening.push(id); });
  frei.sort(function(a,b){ return rohVon(b)-rohVon(a); });
  var mMg = summe(morning), aMg = summe(evening);
  frei.forEach(function(id){
    var w  = rohVon(id);
    var kM = _hatKonfliktIn(id, morning);
    var kA = _hatKonfliktIn(id, evening);
    var nachAbend;
    if(kM !== kA) nachAbend = kM;          // genau eine Seite hat den Gegenspieler
    else          nachAbend = (mMg > aMg); // Gleichstand: wie bisher die Masse
    if(nachAbend){ evening.push(id); aMg += w; }
    else         { morning.push(id); mMg += w; }
  });
}

function _antIsActive(id){ return avails[id] && !disabled[id] && (S.amt[id]||0) > 0; }
function _antDoseMg(id){
  var it=DB.find(function(x){return x.id===id;});
  if(!it)return 0;
  return toMg(S.amt[id]||0,it.unit);
}
function antTriggered(a){
  if(!a.ids.every(_antIsActive))return false;
  if(a.trigger==='dose'){ return _antDoseMg(a.doseId) >= a.doseMin; }
  if(a.trigger==='ratio'){
    var hi=_antDoseMg(a.ratioHighId), lo=_antDoseMg(a.ratioLowId);
    var ratioBad = lo>0 ? (hi/lo) > a.ratioMax : hi>0;
    var absBad   = a.absId ? _antDoseMg(a.absId) >= a.absMin : false;
    return ratioBad || absBad;
  }
  var _nrvPct=function(id){var it=DB.find(function(x){return x.id===id;});if(!it||!it.nrv)return null;return (toMg(S.amt[id]||0,it.unit)/toMg(it.nrv,it.unit))*100;};
  return a.ids.every(function(id){ var p=_nrvPct(id); return p===null ? _antIsActive(id) : p >= (a.pctNrv||25); });
}

// Gruppe einer Zutat bestimmen (Default: C/anytime)
function moduleGroupOf(id){
  for(var g in MODULE_GROUPS){
    if(MODULE_GROUPS[g].ids.indexOf(id)>=0) return g;
  }
  return 'C';
}

// ── BOOSTER-KOMPONENTEN (Beilagen) ──────────────────────────────────────────
// Ein Booster wird NICHT in die Routinen gemischt, sondern liegt als eigene
// Beilage bei. Zwei Gründe, beide gemessen:
//   1. Masse. Die Kapselzahl richtet sich nach der Masse, nicht nach der Zahl
//      der Zutaten. Diese acht Zutaten tragen die Gramm-Dosen. Ausgelagert
//      sinkt die Kapselzahl von 14,6 auf 8,3 je Tag (beide Routinen), und der
//      Anteil der Rezepturen unter 6 Kapseln je Routine steigt von 32 % auf 91 %.
//   2. Antagonismen. Eine Beilage ist konstruktiv von jedem Gegenspieler
//      getrennt. Calcium + Magnesium lag bisher in 100 % der Auslösungen im
//      selben Beutel — als Beilage ist es gelöst.
//
// Booster haben eine FESTE Dosis. Der Fragebogen skaliert sie nicht: unter
// claimMin verliert ein Claim seine Grundlage und der Booster seinen Sinn.
//
// mischbar : darf mit den anderen mischbaren zu EINEM Pulver zusammengehen.
//            Weil alle Dosen fest sind, ist eine Mischung zulässig — dadurch
//            braucht die Bestellung im Median nur einen Zusatzbeutel.
// kapsel   : Mono-Kapsel anbieten. Nur wo sie messbar Kapseln spart. Bei
//            Magnesium, MCT und MSM füllt die Mono-Kapsel nicht dichter als die
//            Mischung — die Wahl wäre keine und wird nicht gezeigt.
// fuellMg  : gemessenes Mono-Füllgewicht. null = nicht gemessen → keine Kapsel,
//            egal was 'kapsel' sagt. Siehe Messplan.
// loeffelG : Dosierlöffel in Gramm für einen eigenen Beutel.
// grund    : warum eigener Beutel statt Mischpulver.
var BOOSTER_AKTIV = true;
var BOOSTER = {
  // dosis: feste Tagesmenge in der Einheit der Zutat. Fehlt sie, greift
  // boosterFestDosis() auf base_dose/dose zurueck und hebt auf claimMin an.
  kreatin:      {mischbar:true,  kapsel:true,  fuellMg:728, dosis:3},
  // Magnesium hat weder base_dose noch dose; 250 mg ist die empfohlene
  // Tageshoechstmenge fuer Nahrungsergaenzung und damit die feste Dosis.
  magnesium:    {mischbar:true,  kapsel:false, fuellMg:null, dosis:250},
  glycin:       {mischbar:true,  kapsel:false, fuellMg:null},
  Kollagen:     {mischbar:true,  kapsel:false, fuellMg:null},
  mct:          {mischbar:true,  kapsel:false, fuellMg:null},
  msm:          {mischbar:true,  kapsel:false, fuellMg:null},
  glucomannan:  {mischbar:false, kapsel:false, loeffelG:1,
                 grund:'Quillt und geliert, würde jede Mischung ruinieren. Der EU-Claim verlangt 3×1 g vor den Mahlzeiten — der Kunde muss selbst portionieren.'},
  // 10 g ist die Claim-Dosis (claimMin). Bei 1 g base_dose waere die Beilage
  // da, der Cholesterin-Claim aber nicht — und der 10-g-Loeffel falsch.
  // Fluessigkeits- und Warnhinweis stehen seit 27.10.2026 in getDeliveryNotes()
  // und in der Produktionsnotiz — VO (EU) 432/2012 verlangt beides zum Claim.
  // Kein fester Loeffel in Gramm: ein 10-g-Dosierloeffel ist ungewoehnliche
  // Hardware. Stattdessen laeuft Guarkernmehl wie das Mischpulver ueber die
  // Kalibrierung — ein gestrichener Loeffel wird bei der Herstellung gewogen
  // und der Wert aufs Etikett geschrieben.
  // Die Tuetengrenze steht jetzt global in BOOSTER_BEUTEL_MAX_G (300 g). Hier
  // keine eigene Zahl mehr — zwei Quellen fuer denselben Wert laufen auseinander.
  // beutelMaxG bleibt moeglich, falls ein Booster eine ENGERE Tuete braucht.
  guarkernmehl: {mischbar:false, kapsel:false, loeffelG:null, dosis:10,
                 grund:'10 g Tagesdosis in einem eigenen Beutel; als Kapsel wären es rund 19 Stück.'},
  // Flohsamenschalen quellen wie Glucomannan: eigener Beutel, eigener Loeffel,
  // und der Fluessigkeitshinweis ist Pflicht. 5 g waeren als Kapsel rund 10 Stueck.
  flohsamen:    {mischbar:false, kapsel:false, loeffelG:5, dosis:5,
                 grund:'Quellende Ballaststoffe, 5 g Tagesdosis mit eigenem Löffel; als Kapsel wären es rund 10 Stück.'}
};

function isBooster(id){ return !!(BOOSTER_AKTIV && BOOSTER[id]); }
// Aktive Booster, in der Reihenfolge der Konfiguration (stabil für Etikett und AV).
function boosterIds(){
  if(!BOOSTER_AKTIV) return [];
  return Object.keys(BOOSTER).filter(function(id){
    return avails[id] && !disabled[id] && (S.amt[id]||0) > 0;
  });
}
function withoutBooster(ids){ return ids.filter(function(id){ return !isBooster(id); }); }

// Booster haben FESTE Dosen: der Fragebogen entscheidet ueber das OB, nicht
// ueber das WIEVIEL. Grund: unterhalb von claimMin verliert ein Claim seine
// Grundlage, und eine Beilage mit beliebiger Menge macht den Dosierloeffel
// falsch. Darum wird die Menge beim Anwenden ueberschrieben.
function boosterFestDosis(id){
  var b=BOOSTER[id]; if(!b) return null;
  if(b.dosis != null) return b.dosis;
  var it=DB.find(function(x){return x.id===id;}); if(!it) return null;
  var d = it.base_dose || it.dose || it.step || 0;
  if(it.claimMin)        d = Math.max(d, it.claimMin);
  if(it.maxSafe != null) d = Math.min(d, it.maxSafe);
  return d || null;
}
function boosterDosisAnwenden(){
  if(!BOOSTER_AKTIV) return;
  Object.keys(BOOSTER).forEach(function(id){
    if(!(avails[id] && !disabled[id] && (S.amt[id]||0) > 0)) return;
    var soll = boosterFestDosis(id);
    if(soll !== null) S.amt[id] = soll;
  });
}

// Der Produktions-Abschnitt fuer die Beilagen. Eigene Funktion, damit er
// pruefbar ist — bisher lag der Notiztext als lokale Variable in
// addToShopifyCart() und war von aussen nicht erreichbar.
// Wie viele PHYSISCHE Beutel braucht ein Behaelter, und wie viel kommt in jeden?
// Bis 27.10.2026 schrieb die Notiz die ganze Laufzeitmenge in einen Beutel \u2014
// bei Guarkernmehl 900 g, die in keinen Doypack passen. Die Grenze haengt am
// Feld BOOSTER[id].beutelMaxG, nicht an einem Zutatennamen, damit kuenftige
// Booster mit eigener Beutelgroesse automatisch erfasst sind.
// ── Tuetengroessen fuer Booster-Beutel ─────────────────────────────────────
// Uebernommen aus der AV App (Oliver, 27.10.2026), damit beide Werkzeuge mit
// denselben Zahlen rechnen. Vorher hatte der Konfigurator gar keine Grenze
// (900 g Guarkernmehl in einem Beutel) und ich hatte zwischenzeitlich eine
// eigene Gramm-Leiter erfunden — zwei Vokabulare fuer dieselben Tueten.
// Quelle: arbeitsvorbereitung PACKUNG_TAGE = 30, TUETE_GRENZE_MG = 100000,
//         tuetenVorschlag(): Kapseln -> 1, Pulver < 100 g/Monat -> 2, sonst 3.
var BOOSTER_PACKUNG_TAGE   = 30;    // je Tuete ein Monat, wie die AV App
var BOOSTER_TUETE_GRENZE_G = 100;   // darunter Groesse 2, darueber Groesse 3

// Tuetengroesse nach der Regel der AV App.
function boosterTuetenGroesse(gJeTuete, form){
  if(form === 'capsule') return 1;
  return gJeTuete < BOOSTER_TUETE_GRENZE_G ? 2 : 3;
}
function boosterBeutelPlan(c, tage){
  // Eine Tuete je Monat — dieselbe Regel, mit der die AV App die Routinen
  // abfuellt. Damit loest sich die 900-g-Frage von selbst: Guarkernmehl sind
  // 300 g im Monat, also drei Tueten, ohne eigene Gramm-Grenze.
  var monate = Math.max(1, Math.round(tage / BOOSTER_PACKUNG_TAGE));
  var tageJe = tage / monate;
  var gJe    = c.rohMgTag * tageJe / 1000;
  var gr     = boosterTuetenGroesse(gJe, c.form);
  var out = [];
  for(var i = 0; i < monate; i++){
    out.push({ g: gJe, teil: i+1, teilVon: monate, tage: tageJe, tuete: gr });
  }
  return out;
}
// Zahl der physischen Beutel ueber alle Behaelter \u2014 das ist die Zahl, die auf
// Etiketten, Umkarton und in die Kundenunterlagen gehoert.
function boosterBeutelAnzahl(tage){
  var t = tage || parseInt((typeof PRODUCTION_DAYS!=='undefined'?PRODUCTION_DAYS:90),10) || 90;
  return boosterContainers().reduce(function(s,c){ return s + boosterBeutelPlan(c,t).length; }, 0);
}
function boosterNotizBlock(tage){
  var bc=boosterContainers(); if(!bc.length) return '';
  var kz=function(v){ return (Math.round(v*10)/10).toString().replace('.',','); };
  var t='';
  // Erst die Gesamtzahl der Beutel bestimmen, damit "Beutel 2 von 4" stimmt.
  var plaene = bc.map(function(c){ return boosterBeutelPlan(c, tage); });
  var gesamtBeutel = plaene.reduce(function(s,p){ return s+p.length; }, 0);
  var laufend = 0;
  bc.forEach(function(c,i){
  var plan = plaene[i];
  plan.forEach(function(b, bi){
    laufend++;
    var bez=(c.art==='mix') ? 'BOOSTER-PULVER (Mischung)'
                            : ('BOOSTER: '+(names[c.ids[0]]||c.ids[0]).toUpperCase());
    t += '\n--- '+bez+' (Beutel '+laufend+' von '+gesamtBeutel+') ---\n';
    if(b.teilVon>1)
      t += 'Teilbeutel '+b.teil+' von '+b.teilVon+' dieses Boosters  |  Abf\u00fcllmenge '
         + kz(b.g)+' g  |  reicht '+Math.round(b.tage)+' Tage'
         + '  |  T\u00fctengr\u00f6\u00dfe '+b.tuete
         + '  (Gesamt '+kz(c.rohMgTag*tage/1000)+' g)\n';
    else
      t += 'T\u00fctengr\u00f6\u00dfe '+b.tuete+'  |  Abf\u00fcllmenge '+kz(b.g)+' g f\u00fcr '+Math.round(b.tage)+' Tage\n';
    c.ids.forEach(function(id){
      var it=DB.find(function(x){return x.id===id;});
      var rohTag=it?powderMg(it):0;
      var anteil=(c.rohMgTag>0 ? rohTag/c.rohMgTag : 1) * b.g;
      t += (names[id]||id)+': '+fa(S.amt[id], it?it.unit:'mg')+' '+(it?it.unit:'mg')
         + '/Tag  |  Rohware '+kz(rohTag)+' mg/Tag  |  Abf\u00fcllmenge '+kz(anteil)+' g\n';
    });
    if(c.ids.length>1) t += 'Summe Mischung: '+kz(b.g)+' g in diesem Beutel\n';
    // Loeffel nur EINMAL je Booster, nicht je Teilbeutel \u2014 sonst legt die
    // Produktion bei Guarkernmehl drei Loeffel in drei Beutel.
    var _loeffelZeile = (bi===0);
    t += (c.form==='capsule')
      ? ('Verkapseln: '+c.kapselnTag+' Kapseln/Tag, '+(c.kapselnTag*tage)+' Kapseln gesamt\n')
      : ('Pulver. '+(!_loeffelZeile
          ? 'Kein weiterer Dosierl\u00f6ffel \u2014 er liegt in Teilbeutel 1.\n'
          : (c.loeffelG ? c.loeffelG+'-g-Dosierl\u00f6ffel beilegen.\n'
             : 'Dosierl\u00f6ffel beilegen und KALIBRIEREN: einen gestrichenen L\u00f6ffel der fertigen Mischung wiegen und den Wert aufs Etikett schreiben.\n')));
    if(c.ids.indexOf('glucomannan')>=0)
      t += 'ACHTUNG Glucomannan: nie trocken einnehmen, 3\u00d71 g mit Wasser vor den Mahlzeiten.\n';
    // Pflichtangaben nach VO (EU) 432/2012 muessen auf Etikett und Beipackzettel.
    // Ohne diese Zeile stand die Warnung nur in den Kundenhinweisen, nicht in der
    // Produktionsanweisung \u2014 die Etiketten waeren ohne sie gedruckt worden.
    if(c.ids.indexOf('guarkernmehl')>=0)
      t += 'ACHTUNG Guarkernmehl (Pflichtangabe 432/2012): Tagesdosis 10 g, mit reichlich '
         + 'Wasser einnehmen, nie trocken. Warnhinweis Erstickungsgefahr bei Schluckbeschwerden '
         + 'oder zu wenig Fl\u00fcssigkeit auf Etikett und Beipackzettel.\n';
  });   // plan.forEach \u2014 ein Abschnitt je physischem Beutel
  });   // bc.forEach \u2014 ein Plan je Behaelter
  return t;
}
// Rückwärtskompatibel: Konjak ist jetzt ein Booster wie die anderen, hat aber
// gesetzlich vorgeschriebene Hinweistexte, die nur ihn betreffen.
function konjakActive(){ return boosterIds().indexOf('glucomannan') >= 0; }
function withoutKonjak(ids){ return withoutBooster(ids); }

// Darf der Kunde bei diesem Booster die Kapselform wählen? Nur wenn ein
// Füllgewicht gemessen ist UND die Mono-Kapsel weniger Kapseln braucht als
// derselbe Stoff in der Mischung. Sonst ist es keine Wahl, sondern Kosmetik.
function boosterKapselWahl(id){
  var b=BOOSTER[id]; if(!b||!b.kapsel||!b.fuellMg) return false;
  var it=DB.find(function(x){return x.id===id;}); if(!it) return false;
  var roh=powderMg(it);
  return Math.ceil(roh/b.fuellMg) < Math.ceil(roh/KAPSEL_FUELLGEWICHT_MG);
}
function boosterForm(id){
  if(!boosterKapselWahl(id)) return 'powder';
  return (S.boosterForm && S.boosterForm[id]==='capsule') ? 'capsule' : 'powder';
}
function setBoosterForm(id, form){
  if(!S.boosterForm) S.boosterForm={};
  S.boosterForm[id] = (form==='capsule' && boosterKapselWahl(id)) ? 'capsule' : 'powder';
  // Wie der Routinen-Umschalter: neu rendern, ohne dass die Seite springt.
  renderKeepScroll();
}

// Die Behälter, die der Bestellung beiliegen. Alles Mischbare in Pulverform
// geht in EINEN Beutel; alles andere bekommt seinen eigenen.
function boosterContainers(){
  var ids=boosterIds(); if(!ids.length) return [];
  var rohVon=function(id){ var it=DB.find(function(x){return x.id===id;}); return it?powderMg(it):0; };
  var mix=[], solo=[];
  ids.forEach(function(id){
    var b=BOOSTER[id];
    if(b.mischbar && boosterForm(id)==='powder') mix.push(id); else solo.push(id);
  });
  var out=[];
  if(mix.length){
    var mg=mix.reduce(function(s,id){ return s+rohVon(id); },0);
    out.push({art:'mix', ids:mix, rohMgTag:mg, form:'powder',
              // Der Löffel wird in der Produktion kalibriert: ein gestrichener
              // Löffel des fertigen Pulvers wird gewogen, die Zahl kommt aufs
              // Etikett. Die Schüttdichte der Mischung ist je Bestellung anders,
              // eine Tabelle kann das nicht leisten.
              loeffelKalibrieren:true});
  }
  solo.forEach(function(id){
    var b=BOOSTER[id], mg=rohVon(id), form=boosterForm(id);
    out.push({art:'solo', ids:[id], rohMgTag:mg, form:form,
              kapselnTag: form==='capsule' ? Math.ceil(mg/b.fuellMg) : 0,
              loeffelG: form==='powder' ? (b.loeffelG||null) : null,
              loeffelKalibrieren: form==='powder' && !b.loeffelG,
              grund: b.grund||''});
  });
  return out;
}

function getAntagonismResults(){
  // Alle aktiven Zutaten — OHNE Glucomannan (eigene Beilage-Komponente)
  var activeIds = withoutKonjak(DB.filter(function(it){return avails[it.id]&&!disabled[it.id]&&S.amt[it.id]>0;})
                    .map(function(it){return it.id;}));

  // Trigger: Eisen ≥ Schwelle → Aufteilung
  var ironMg = _antDoseMg('eisen');
  var splitActive = (activeIds.indexOf('eisen')>=0) && (ironMg >= IRON_SPLIT_THRESHOLD_MG);

  // Ausgelöste Antagonismen (für Hinweise/Anzeige – unverändert)
  var triggered=[];
  ANTAGONISTS.forEach(function(a){ if(antTriggered(a)) triggered.push(a); });

  var morning=[], evening=[], anytime=[];
  activeIds.forEach(function(id){
    var g=moduleGroupOf(id);
    var t=MODULE_GROUPS[g].time;
    // Mineralstoffe der Gruppe B stehen abends, weil sie mit Eisen konkurrieren.
    // Ist kein Eisen in der Rezeptur, faellt dieser Grund weg: dann werden sie
    // wie Gruppe C behandelt und koennen in die leichtere Routine wandern.
    // Steuert B_MINERALE_FREI_OHNE_EISEN — eine Produktentscheidung, siehe dort.
    // Ohne Eisen faellt der Grund weg, diese Mineralstoffe abends zu halten.
    // Zink/Mangan/Kupfer wandern dann immer (keine Abend-Erwartung beim Kunden);
    // Magnesium nur, wenn B_MINERALE_FREI_OHNE_EISEN es erlaubt. Soll Zink wie
    // bisher abends bleiben, B_MINERALE_BEWEGLICH_OHNE_EISEN leeren.
    if(!splitActive && (B_MINERALE_BEWEGLICH_OHNE_EISEN.indexOf(id)>=0
        || (B_MINERALE_FREI_OHNE_EISEN && B_MINERALE_WEGEN_EISEN.indexOf(id)>=0))){
      anytime.push(id); return;
    }
    if(t==='morning') morning.push(id);
    else if(t==='evening') evening.push(id);
    else anytime.push(id);
  });
  // Cap je Pulver-Strom (analog Kapsel-Modus): nach Score sortieren, überzählige
  // (niedrigst-gescorte) Zutaten fallen weg.
  var _ss=function(a,b){ return (S.sc[b]||0)-(S.sc[a]||0); };
  morning.sort(_ss); evening.sort(_ss); anytime.sort(_ss);

  // Die Aufteilung nach Modulgruppe gilt IMMER — sie ist die einzige Quelle für
  // Bestellnotiz, Ergebnisseite und Kapselrechnung. 'split' sagt nur noch, ob
  // zusätzlich der Eisen-Antagonismus ausgelöst hat (für die Hinweistexte).
  // Gruppe C → Zielbeutel (max. 2 Beutel)
  var morningFinal=morning.slice();
  var eveningFinal=evening.slice();
  verteileGruppeC(anytime, morningFinal, eveningFinal);

  // Cap je Beutel — ERST hier, nach dem Zusammenlegen von Gruppe C. Vorher wurde
  // jeder der drei Ströme einzeln auf 20 gekappt und anytime danach addiert;
  // eine Routine konnte so bis zu 40 Zutaten enthalten. Nach Score absteigend
  // sortieren, die schwächsten fallen heraus.
  morningFinal.sort(_ss); eveningFinal.sort(_ss);
  var capDropped=[];
  // Rezeptur-Cap VOR dem Routinen-Cap: beide Routinen zusammen duerfen
  // MAX_ZUTATEN_REZEPTUR nicht uebersteigen. Nach Score absteigend, die
  // schwaechsten fallen zuerst. Booster stecken nicht in diesen Listen.
  var _alle = morningFinal.concat(eveningFinal).sort(_ss);
  if(_alle.length > MAX_ZUTATEN_REZEPTUR){
    var _bleibt = _alle.slice(0, MAX_ZUTATEN_REZEPTUR);
    capDropped  = capDropped.concat(_alle.slice(MAX_ZUTATEN_REZEPTUR));
    morningFinal = morningFinal.filter(function(id){ return _bleibt.indexOf(id)>=0; });
    eveningFinal = eveningFinal.filter(function(id){ return _bleibt.indexOf(id)>=0; });
  }
  if(morningFinal.length>MAX_ZUTATEN_PRO_STROM){
    capDropped=capDropped.concat(morningFinal.slice(MAX_ZUTATEN_PRO_STROM));
    morningFinal=morningFinal.slice(0,MAX_ZUTATEN_PRO_STROM);
  }
  if(eveningFinal.length>MAX_ZUTATEN_PRO_STROM){
    capDropped=capDropped.concat(eveningFinal.slice(MAX_ZUTATEN_PRO_STROM));
    eveningFinal=eveningFinal.slice(0,MAX_ZUTATEN_PRO_STROM);
  }

  // ── Gewichtsgrenze je Routine ────────────────────────────────────────────
  // Gleiche Mechanik wie der Zutaten-Cap: nach Score absteigend sortiert, die
  // schwächste Zutat fällt zuerst heraus. Danach wird nachgeladen, was wieder
  // hineinpasst — sonst reisst eine einzelne schwere Zutat beim Herausfallen
  // ein grosses Loch und alles vorher Entfernte liegt ohne Grund draussen.
  var _rohMgOf = function(id){
    var x=DB.find(function(y){return y.id===id;}); return x?powderMg(x):0;
  };
  var _kappeGewicht = function(liste){
    var raus=[];
    var summe=function(){ return liste.reduce(function(s,id){ return s+_rohMgOf(id); }, 0); };
    while(liste.length>0 && summe() > MAX_ROHWARE_PRO_ROUTINE_MG){
      raus.push(liste.pop());
    }
    for(var i=raus.length-1;i>=0;i--){
      if(summe() + _rohMgOf(raus[i]) <= MAX_ROHWARE_PRO_ROUTINE_MG){
        liste.push(raus[i]); raus.splice(i,1);
      }
    }
    liste.sort(_ss);
    return raus;
  };
  var gewichtDropped = [].concat(_kappeGewicht(morningFinal), _kappeGewicht(eveningFinal));
  capDropped = capDropped.concat(gewichtDropped);

  // Abwärtskompatibilität: "powder2" = alles, was NICHT im Morning-Beutel ist
  var powder2 = eveningFinal.slice();

  return {
    split:true,                   // es gibt zwei Beutel
    ironSplit:splitActive,        // zusätzlich durch Eisen ausgelöst
    triggered:triggered,
    morning:morningFinal,
    evening:eveningFinal,
    anytime:anytime,
    capDropped:capDropped,        // wegen MAX_ZUTATEN_PRO_STROM oder Gewichtsgrenze entfallen
    gewichtDropped:gewichtDropped,// nur die wegen MAX_ROHWARE_PRO_ROUTINE_MG entfallenen
    powder2:powder2,
    splitPairs:triggered.filter(function(a){return a.stage>=2;}),
    noteOnlyPairs:[]
  };
}

// ── Was tatsächlich produziert wird ─────────────────────────────────────────
// Einzige Wahrheit darüber, welche Zutaten beim Kunden ankommen. Quelle ist
// dieselbe Aufteilung, aus der auch Zutaten_Morgen/Zutaten_Abend entstehen.
// Fällt eine Zutat über die Zutaten-Obergrenze oder das Kapsel-Budget heraus, steht sie
// hier nicht mehr — und wird damit auch nicht berechnet.
// NICHT aus getAntagonismResults() oder getCapsuleDistribution() heraus
// aufrufen: beide berechnen diese Listen erst.
function deliveredIds(){
  var out={};
  var r=getAntagonismResults();
  (r.morning||[]).forEach(function(id){ out[id]=true; });
  (r.evening||[]).forEach(function(id){ out[id]=true; });
  // Booster sind separate Beilagen und laufen außerhalb der Routinen mit.
  // Sie dürfen deshalb nie durch das Kapsel-Budget oder die Zutaten-Obergrenze
  // fallen — ohne diese Zeile wären sie bestellt, aber nicht berechnet.
  boosterIds().forEach(function(id){ out[id]=true; });
  if(DELIVERY_FORM==='capsule'){
    (getCapsuleDistribution().dropped||[]).forEach(function(id){ delete out[id]; });
  }
  return out;
}

// Zutaten, die in der Rezeptur stehen, aber nicht produziert werden — mit Grund.
function getDroppedItems(){
  var geliefert=deliveredIds();
  var _ant=getAntagonismResults();
  var _gewicht=_ant.gewichtDropped||[];
  var out=[];
  DB.forEach(function(it){
    if(!avails[it.id] || disabled[it.id] || !(S.amt[it.id]>0)) return;
    if(geliefert[it.id]) return;
    out.push({ id:it.id, name:names[it.id]||it.name,
               grund: _gewicht.indexOf(it.id)>=0
                 ? 'Die Routine hätte sonst mehr als '
                   + (MAX_ROHWARE_PRO_ROUTINE_MG/1000) + ' g Pulver am Tag.'
                 : '' });
  });
  return out;
}

// ── KAPSEL-MODELL (Darreichungsform 'Kapseln') ──────────────────────────────────
// Produktionslogik: Pro Abfüllung werden immer 300 Kapseln befüllt = 3 Kapseln/Tag
// über 90 Tage = exakt ein 90-Tage-Vorrat aus einem einzigen Füll-Lauf.
// Kapsel 00 fasst ~450 mg. Das Kapsel-Budget pro Tag ist damit fix 3×450 = 1.350 mg.
// Was nicht in dieses Budget passt (und alle Gramm-Zutaten) wandert in Pulver-Ströme.
// Leichte Kapsel-Mischungen werden mit Bio-Akazienpulver auf 3 volle Kapseln aufgefüllt.
var KAPSEL_FUELLGEWICHT_MG = 520;   // Kapsel Größe 00, Zielfüllung pro Kapsel
// 300 Kapseln × 520 mg = 156 g Füllmasse je Produktionslauf.
var KAPSELN_PRO_TAG        = 3;     // Einnahme: 3 Kapseln täglich
// Produktionslauf: Die Anlage füllt immer 300 Kapseln ab (nicht 270 für 90 Tage).
// Der Überschuss von 30 Kapseln ist Puffer für Ausschuss und Anlagenverluste.
// WICHTIG: Die Einwaage muss für 300 Kapseln reichen, sonst fehlt am Ende Pulver.
var KAPSELN_PRO_LAUF       = 300;
var KAPSEL_BUDGET_MG       = KAPSEL_FUELLGEWICHT_MG * KAPSELN_PRO_TAG; // 1.560 mg/Tag
// Füllmasse je Produktionslauf — Grundlage der 150-g-Chargen.
var KAPSEL_LAUF_MG         = KAPSEL_FUELLGEWICHT_MG * KAPSELN_PRO_LAUF; // 156.000 mg
// Obergrenze fuer die Abend-Routine. Anders als morgens ist die Kapselzahl dort
// nicht fest, sondern ergibt sich aus der Rohware. Ohne Deckel kaemen bei sehr
// vollen Rezepturen 20 und mehr Kapseln am Abend heraus. Was darueber liegt,
// wandert ins Abend-Pulver.
var KAPSEL_MAX_PRO_TAG_ABEND = 12;
// Gilt seit der Verteilung der Gruppe C auch für den Morgen — dort steckt
// jetzt ebenfalls Masse, und eine feste Kapselzahl wäre willkürlich.
var KAPSEL_MAX_PRO_TAG       = KAPSEL_MAX_PRO_TAG_ABEND;
// Kleinster sinnvoller Pulverbeutel: 1 g am Tag, also ein Dosierloeffel.
// Waere der Rest kleiner, bekaeme der Kunde einen Beutel mit einem halben
// Loeffel — dann lieber ein bis zwei Kapseln mehr und gar kein Beutel.
var ABEND_PULVER_MIN_MG = 1000;
var MAX_ZUTATEN_PRO_STROM  = 18;    // harter Cap je Routine (Morgen bzw. Abend inkl. Pulverrest)
// Cap fuer die GANZE Rezeptur, Booster ausgenommen. Oliver am 27.10.2026:
// die Zutatenzahl darf nicht von der Anzahl der Ziele abhaengen. Vorher waren
// nur die Routinen gedeckelt (18 + 18), vier Ziele erzeugten 33 Kandidaten und
// die Rezeptur lief in die Kapazitaetsgrenze statt in den Bedarf — 41 Zutaten
// fuer 28,80 EUR Rohware im Monat, davon 80 % Grundgebuehr.
// Booster zaehlen NICHT mit: sie liegen in eigenen Beuteln ausserhalb der Routinen.
var MAX_ZUTATEN_REZEPTUR   = 14;

// Obergrenze für das Gesamtgewicht einer Routine. Für Kapseln galt schon immer
// das Budget von 12 Kapseln; als Pulver war die Masse dagegen völlig
// unbegrenzt. Im Expertenmodus liessen sich so 161 g Abendpulver am Tag
// konfigurieren — 14,5 kg je 90-Tage-Charge, weder trinkbar noch produzierbar.
// 25 g/Tag sind rund zwei gehäufte Esslöffel und damit das Äusserste, was man
// in einem Glas Wasser noch unterbekommt.
var MAX_ROHWARE_PRO_ROUTINE_MG = 25000;

// Experten-Modus: um welchen Faktor der Schieberegler über den softMax hinaus
// darf, und ab welcher Menge gar nicht mehr.
// Früher stand hier fest das Vierfache. Bei Milligramm-Zutaten ist das
// harmlos, bei Gramm-Zutaten wurde daraus Unsinn: 40 g Kollagen, 20 g MCT,
// 20 g L-Glycin am Tag — jenseits jeder Studienlage und nie entschieden,
// sondern ein Nebenprodukt der Formel. Ab 1 g ist der softMax bereits die
// belegte Obergrenze, dort gibt es keinen Aufschlag mehr.
var EXPERT_FAKTOR                = 2;
var EXPERT_KEIN_AUFSCHLAG_AB_MG  = 1000;

// Kritische Stoffe: hier greift maxSafe (EFSA/BfR-Höchstmenge) AUCH im Experten-
// Modus als HARTER Stopp – nicht überschreibbar. Diese Stoffe haben bei
// Überdosierung echtes Toxizitätsrisiko (Vit A teratogen/Leber, Eisen akut
// toxisch, Selen Selenose, Vit D Hyperkalzämie, Niacin Leber/Flush).
var CRITICAL_HARD_CAP = ['vit_b3','vit_a','eisen','vit_d','selen'];

// Verteilungs-Engine für die Kapsel-Variante.
// Liefert zwei Ströme zurück:
//   caps   – Kapsel-Strom (Score-priorisiert, hart auf 1.350 mg gedeckelt, mit Akazie aufgefüllt)
//   powder – EIN Pulver-Strom (Gramm-Zutaten + bei Eisen Gruppe B & C + alle Budget-Überhänge)
// plus capsulesPerDay (immer 3) und acaciaFillMg (Auffüllmenge auf das Budget).
function getCapsuleDistribution(){
  var activeIds = withoutKonjak(DB.filter(function(it){return avails[it.id]&&!disabled[it.id]&&S.amt[it.id]>0;})
                    .map(function(it){return it.id;}));
  // In die Kapsel geht die ROHWARE, nicht die deklarierte Wirkstoffmenge.
  // 80 mg Vitamin C sind 471 mg Acerola — mit doseMg() wäre das Budget um ein
  // Vielfaches zu optimistisch gerechnet. doseMg bleibt für die Anzeige.
  var doseMg = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?toMg(S.amt[id]||0,it.unit):0; };
  var rohMg  = function(id){ var it=DB.find(function(x){return x.id===id;}); return it?powderMg(it):0; };
  // (isGram entfiel 10/2026 — siehe Kommentar bei der Routenuebernahme unten.)
  var scoreSort = function(a,b){ return (S.sc[b]||0)-(S.sc[a]||0); };

  var eisenAktiv = (activeIds.indexOf('eisen')>=0) && (doseMg('eisen') >= IRON_SPLIT_THRESHOLD_MG);

  // ── Feste Tageszeit-Zuordnung nach Gruppe (unabhängig von Eisen) ──────────
  // Morgen-Routine = Gruppe A (Energy & Blood)              → wählbar Kapsel/Pulver
  // Haupt-Pulver   = Gruppe B + C + alle Gramm-Zutaten       → IMMER Pulver,
  //   zu einer Hauptmahlzeit mit etwas Fett einzunehmen (fettlösliche Vitamine
  //   A/D/E/K brauchen Nahrungsfett; die Tageszeit selbst ist nicht festgelegt).
  // Dieselben Beutel wie in getAntagonismResults — keine zweite, abweichende
  // Aufteilung mehr. Vorher konnten Bestellnotiz und Kapseldaten auseinanderlaufen:
  // ohne Eisen meldete die Notiz eine leere Abend-Routine, waehrend die
  // Kapseldaten daneben einen vollen Abend-Lauf auswiesen.
  var _ant = getAntagonismResults();
  var _inAct = function(id){ return activeIds.indexOf(id)>=0; };
  var morning = (_ant.morning||[]).filter(_inAct);
  var evening = (_ant.evening||[]).filter(_inAct);
  // FRUEHER stand hier: "Gramm-Zutaten koennen nie in eine Kapsel → immer in
  // den Abend-Strom". Das stammt aus der Zeit vor EVENING_CAPSULE_ENABLED, als
  // der Abend grundsaetzlich Pulver war. Heute ist es falsch und schaedlich:
  //   - Eine Gramm-Zutat passt sehr wohl in Kapseln. 3 g Kreatin sind sieben
  //     Kapseln, und das Budget liegt bei zwoelf — abends wie morgens.
  //   - Der Schritt lief NACH verteileGruppeC() und hat dessen Massenausgleich
  //     wieder zerstoert. Gemessen an einer Sport-Rezeptur: Pulver-Sicht
  //     3,89 g morgens / 4,05 g abends, Kapsel-Sicht 0,48 g / 7,46 g — allein
  //     weil Kreatin in Gramm dosiert ist. Damit liefen Bestellnotiz und
  //     Kapseldaten wieder auseinander, genau der Fehler vom September.
  // Die Gramm-Zutaten bleiben jetzt dort, wo die Verteilung sie hingelegt hat.
  // Ist der Morgen dadurch zu schwer, greift weiter unten das Kapselbudget.
  morning.sort(scoreSort);
  evening.sort(scoreSort);

  // ── Cap je Stream (MAX_ZUTATEN_PRO_STROM, niedrigst-gescorte fallen weg) ─
  var dropped=[];
  // Erst der Rezeptur-Cap, identisch zu getAntagonismResults. Fehlte er hier,
  // wuerde die Kapselrechnung mit mehr Zutaten arbeiten als die Bestellnotiz.
  var _alleK = morning.concat(evening).sort(scoreSort);
  if(_alleK.length > MAX_ZUTATEN_REZEPTUR){
    var _bleibtK = _alleK.slice(0, MAX_ZUTATEN_REZEPTUR);
    dropped = dropped.concat(_alleK.slice(MAX_ZUTATEN_REZEPTUR));
    morning = morning.filter(function(id){ return _bleibtK.indexOf(id)>=0; });
    evening = evening.filter(function(id){ return _bleibtK.indexOf(id)>=0; });
  }
  if(morning.length > MAX_ZUTATEN_PRO_STROM){ dropped=dropped.concat(morning.slice(MAX_ZUTATEN_PRO_STROM)); morning=morning.slice(0,MAX_ZUTATEN_PRO_STROM); }
  if(evening.length > MAX_ZUTATEN_PRO_STROM){ dropped=dropped.concat(evening.slice(MAX_ZUTATEN_PRO_STROM)); evening=evening.slice(0,MAX_ZUTATEN_PRO_STROM); }

  // ── Kapsel-Budget hart durchsetzen ───────────────────────────────────────
  // Passt der Morgen-Strom nicht in 3×500 = 1.500 mg Rohware am Tag, würden die
  // 300 Kapseln überfüllt (Einwaage > 150 g). Die niedrigst-gescorten Zutaten
  // fallen dann aus der Morgen-Routine heraus — sie werden aber NICHT verworfen,
  // sondern wandern in die Abend-Routine. morning ist nach Score absteigend
  // sortiert → pop() entfernt jeweils die schwächste Zutat.
  // Seit die Gruppe C verteilt wird, trägt auch der Morgen echte Masse. Eine
  // feste Zahl von 3 Kapseln passt dazu nicht mehr — sie wird wie abends aus
  // der Rohware gerechnet, mit derselben Obergrenze. Was darüber liegt,
  // wandert in die Abend-Routine.
  var _morningMg = function(){ return morning.reduce(function(s,id){ return s+rohMg(id); }, 0); };
  var _morgenMaxMg = KAPSEL_MAX_PRO_TAG * KAPSEL_FUELLGEWICHT_MG;
  var budgetUeber = Math.max(0, _morningMg() - _morgenMaxMg);
  var budgetDropped = [];
  while(morning.length > 0 && _morningMg() > _morgenMaxMg){
    var _mv = morning.pop();
    budgetDropped.push(_mv);
    evening.push(_mv);              // Überhang geht in die Abend-Routine
  }
  // Nachladen — dasselbe Problem wie abends: die Schleife wirft die schwaechste
  // Zutat aus, nicht die schwerste. Erwischt sie zuletzt eine grosse (5 g
  // Kollagen), faellt der Morgen weit unter das Budget, und alles zuvor
  // ausgeworfene Kleinzeug liegt ohne Grund im Abend. Gemessen an einer
  // Longevity-Rezeptur: Morgen 1,83 g statt moeglicher 2,83 g, Balance 11/89
  // statt 17/83. Also rueckwaerts (= staerkste zuerst) alles zurueckholen,
  // was noch in das Budget passt.
  for(var _mi = budgetDropped.length-1; _mi >= 0; _mi--){
    var _cand = budgetDropped[_mi];
    if(_morningMg() + rohMg(_cand) <= _morgenMaxMg){
      morning.push(_cand);
      evening.splice(evening.indexOf(_cand), 1);
      budgetDropped.splice(_mi, 1);
    }
  }
  if(budgetDropped.length) evening.sort(scoreSort);
  morning.sort(scoreSort);
  budgetUeber = budgetDropped.reduce(function(s,id){ return s+rohMg(id); }, 0);

  // Die Gewichtsgrenze aus getAntagonismResults() gilt dort fuer beide Routinen.
  // Hier kommt danach aber noch der Morgen-Ueberhang im Abend an — ohne diesen
  // Schritt stand der Abend im Extremfall wieder bei 34 g statt 25 g.
  // Also erneut deckeln: was nicht mehr hineinpasst, wird nicht geliefert.
  var _abendMg = function(){ return evening.reduce(function(s,id){ return s+rohMg(id); }, 0); };
  while(evening.length > 0 && _abendMg() > MAX_ROHWARE_PRO_ROUTINE_MG){
    dropped.push(evening.pop());
  }
  for(var _gi = dropped.length-1; _gi >= 0; _gi--){
    if(evening.indexOf(dropped[_gi])>=0 || morning.indexOf(dropped[_gi])>=0) continue;
    if(_abendMg() + rohMg(dropped[_gi]) <= MAX_ROHWARE_PRO_ROUTINE_MG){
      evening.push(dropped[_gi]); dropped.splice(_gi,1);
    }
  }
  evening.sort(scoreSort);

  var morgenKapselnProTag = Math.max(1, Math.ceil(_morningMg() / KAPSEL_FUELLGEWICHT_MG));

  // ── Abend-Routine als Kapseln (zweiter, unabhängiger Füll-Lauf) ──────────
  // Hat der Kunde Kapseln gewählt, kommt ALLES in Kapseln — auch Zutaten, die
  // in Gramm dosiert sind. 1 g sind zwei Kapseln, mehr nicht. Einzige Grenze
  // ist KAPSEL_MAX_PRO_TAG_ABEND: Was darüber hinausginge, wandert als Pulver
  // mit. Glucomannan ist davon unberührt, es läuft als separate Konjak-Beilage
  // ohnehin außerhalb der Routinen.
  var eveningCaps   = evening.slice();
  var eveningPowder = [];
  var _eveningMg = function(){ return eveningCaps.reduce(function(s,id){ return s+rohMg(id); }, 0); };
  // Abends gilt nicht das feste 3-Kapsel-Budget, sondern die Obergrenze. Nur
  // was darüber liegt, wird als Pulver beigelegt — nach Score die schwächsten
  // Zutaten zuerst.
  var _eveMaxMg = KAPSEL_MAX_PRO_TAG_ABEND * KAPSEL_FUELLGEWICHT_MG;
  var eveningBudgetUeber = Math.max(0, _eveningMg() - _eveMaxMg);
  var eveningBudgetDropped = [];
  var _restMg = function(){ return eveningPowder.reduce(function(s,id){ return s+rohMg(id); }, 0); };
  while(eveningCaps.length > 0 && _eveningMg() > _eveMaxMg){
    var _ev = eveningCaps.pop();          // nach Score sortiert → schwächste zuerst
    eveningBudgetDropped.push(_ev);
    eveningPowder.push(_ev);
  }
  // Nachladen: Die Schleife oben nimmt die schwaechste Zutat, nicht die
  // schwerste. Faellt zum Schluss eine grosse heraus (3 g Glycin sind sechs
  // Kapseln), schiesst sie weit unter die Grenze — und alle zuvor
  // aussortierten Leichtgewichte liegen unnoetig im Beutel. Bis 10/2026 kamen
  // so bei 12 erlaubten Kapseln nur 7 heraus. Also: von der zuletzt
  // ausgeworfenen (= staerksten) Zutat rueckwaerts alles wieder aufnehmen,
  // was noch in das Budget passt.
  for(var _ri = eveningPowder.length-1; _ri >= 0; _ri--){
    var _cand = eveningPowder[_ri];
    if(_eveningMg() + rohMg(_cand) <= _eveMaxMg){
      eveningCaps.push(_cand);
      eveningPowder.splice(_ri,1);
      var _bi = eveningBudgetDropped.indexOf(_cand);
      if(_bi >= 0) eveningBudgetDropped.splice(_bi,1);
    }
  }
  eveningCaps.sort(scoreSort);
  eveningBudgetUeber = _restMg();
  // Ein Beutel unter 1 g/Tag lohnt nicht. Dann lieber die Kapselzahl leicht
  // ueber die Obergrenze gehen lassen und alles in Kapseln liefern.
  if(eveningPowder.length && _restMg() < ABEND_PULVER_MIN_MG){
    eveningPowder.forEach(function(id){ eveningCaps.push(id); });
    eveningPowder = [];
    eveningBudgetDropped = [];
    eveningCaps.sort(scoreSort);
    eveningBudgetUeber = 0;
  }
  // Kapselzahl je Tag ergibt sich aus der Rohware, nicht aus einer festen Zahl.
  var eveningCapsulesPerDay = Math.max(1, Math.ceil(_eveningMg() / KAPSEL_FUELLGEWICHT_MG));
  // Produktion in ganzen 150-g-Chargen: Gesamtbedarf für PRODUCTION_DAYS auf
  // volle Läufe à 300 Kapseln aufrunden. Der Überschuss ist Vorlauf, kein Abfall.
  var eveningCapsTotal  = eveningCapsulesPerDay * PRODUCTION_DAYS;
  var eveningRuns       = Math.max(1, Math.ceil(eveningCapsTotal / KAPSELN_PRO_LAUF));
  var eveningChargeMg   = eveningRuns * KAPSEL_LAUF_MG;      // Vielfaches von 150 g
  var eveningActiveMg   = _eveningMg();
  var eveningAcaciaMg   = Math.max(0, eveningCapsulesPerDay*KAPSEL_FUELLGEWICHT_MG - eveningActiveMg);
  var eveProKapselMg    = eveningActiveMg / eveningCapsulesPerDay;
  var eveLaufWirkstoffMg= eveProKapselMg * KAPSELN_PRO_LAUF;
  var eveLaufAkazieMg   = Math.max(0, (KAPSEL_FUELLGEWICHT_MG*KAPSELN_PRO_LAUF) - eveLaufWirkstoffMg);

  // ── Kapsel-Kennzahlen (nur relevant, wenn Morgen-Routine als Kapsel gewählt) ─
  // Die Kapselzahl richtet sich nach der Rohware, der Rest wird mit Bio
  // Akazienpulver auf die volle Füllmasse gebracht.
  var morningMg = _morningMg();
  var acaciaFillMg = Math.max(0, morgenKapselnProTag*KAPSEL_FUELLGEWICHT_MG - morningMg);
  // Produktion in ganzen Chargen à 300 Kapseln — wie abends. Mit fester
  // Kapselzahl 3 reichte eine Charge für 100 Tage; seit die Zahl aus der
  // Rohware kommt, können mehrere nötig sein (7 Kapseln × 90 Tage = 630).
  var morgenCapsTotal  = morgenKapselnProTag * PRODUCTION_DAYS;
  var morgenRuns       = Math.max(1, Math.ceil(morgenCapsTotal / KAPSELN_PRO_LAUF));
  var morgenChargeMg   = morgenRuns * KAPSEL_LAUF_MG;
  var proKapselMg      = morningMg / morgenKapselnProTag;             // Wirkstoff je Kapsel
  var laufWirkstoffMg  = proKapselMg * KAPSELN_PRO_LAUF;              // gesamt für 300 Kapseln
  var laufAkazieMg     = Math.max(0, (KAPSEL_FUELLGEWICHT_MG*KAPSELN_PRO_LAUF) - laufWirkstoffMg);

  return {
    eisenAktiv: eisenAktiv,
    hasMorning: morning.length>0,          // steuert Sichtbarkeit des Umschalters
    morning: morning,                       // Gruppe A (Kapsel ODER Morgen-Pulver)
    evening: evening,                       // Gruppe B+C+Gramm (vollständiger Abend-Strom)
    hasEvening: evening.length>0,
    eveningCaps: eveningCaps,               // kapselfähiger Teil des Abend-Stroms
    eveningPowder: eveningPowder,           // Gramm-Zutaten + Budget-Überhang → immer Pulver
    hasEveningCaps: eveningCaps.length>0,
    eveningCapsulesPerDay: eveningCapsulesPerDay,
    eveningCapsTotal: eveningCapsTotal,
    eveningRuns: eveningRuns,                 // Anzahl 150-g-Chargen
    eveningChargeMg: eveningChargeMg,         // Füllmasse gesamt, Vielfaches von 150 g
    eveningActiveMg: eveningActiveMg,
    eveningAcaciaMg: eveningAcaciaMg,
    eveningProKapselMg: eveProKapselMg,
    eveningLaufWirkstoffMg: eveLaufWirkstoffMg,
    eveningLaufAkazieMg: eveLaufAkazieMg,
    eveningBudgetUeber: eveningBudgetUeber,
    eveningBudgetDropped: eveningBudgetDropped,
    capsulesPerDay: morgenKapselnProTag,
    capsulesPerRun: KAPSELN_PRO_LAUF,
    morgenCapsTotal: morgenCapsTotal,       // Bedarf über die Laufzeit
    morgenRuns: morgenRuns,                 // Anzahl Chargen à 300 Kapseln
    morgenChargeMg: morgenChargeMg,
    morningActiveMg: morningMg,
    acaciaFillMg: acaciaFillMg,
    proKapselMg: proKapselMg,
    laufWirkstoffMg: laufWirkstoffMg,
    laufAkazieMg: laufAkazieMg,
    laufGesamtMg: KAPSEL_FUELLGEWICHT_MG*KAPSELN_PRO_LAUF,
    budgetUeber: budgetUeber,
    budgetDropped: budgetDropped,
    dropped: dropped.concat(budgetDropped)
  };
}

// ── EVIDENZ-MODELL ─────────────────────────────────────────────────────────────
// Jede Regel dokumentiert: Quelle, Evidenzgrad, Logik, Pflicht-Flag
// Evidenzgrad: A = RCT/Meta-Analyse, B = Kohortenstudie/EFSA-Opinion, C = Expertenkonsens/Tradition
// mandatory: true = Zutat erscheint unabhängig von Zielen wenn Bedingung erfüllt

// ═══════════════════════════════════════════════════════════════════════════
// BIOTIVA SCORING MODELL v3
// 3 Schichten:
//   1. ROHWAREN-BASIS   — NRV, Einheit, softMax aus Rohwarenliste
//   2. EVIDENZ-REGELN   — EVIDENCE Array: signal→gewicht mit Quellennachweis  
//   3. WISSENSCHAFTLICHES SCORING — SE Funktionen: Ist-Situation + Ziele
// ═══════════════════════════════════════════════════════════════════════════

// ── SCHICHT 1: QUIZ-SIGNAL-MAPPING ─────────────────────────────────────────
// Definiert alle auswertbaren Quiz-Signale und ihre möglichen Werte
// Dies ist die "Ist-Situation" des Nutzers

var SIGNALS = {
  age:    { type:'range', desc:'Alter in Jahren' },
  sex:    { type:'single', opts:['Männlich','Weiblich','Keine Angabe'] },
  bmi:    { type:'single', opts:['Untergewicht','Normal','Übergewicht','Adipositas'] },
  sport:  { type:'range', desc:'Sporttage/Woche', min:0, max:7 },
  stress: { type:'range', desc:'Stresslevel 1-5', min:1, max:5 },
  sun:    { type:'single', opts:['Täglich mehr als 30 min','Täglich zwischen 10 und 30 min','Täglich kaum Sonne / meist Büro'] },
  sleep:  { type:'range', desc:'Schlafdauer in h', min:4, max:10 },
  smoke:  { type:'single', opts:['Nein','Selten','Ja'] },
  diet:   { type:'single', opts:['Allesesser','Vegetarisch','Vegan','Pescetarisch'] },
  lacto:  { type:'single', opts:['Nein','Ja'] },
  fish:   { type:'range', desc:'Fischmahlzeiten/Woche', min:0, max:7 },
  alc:    { type:'range', desc:'Alkohol Einheiten/Woche', min:0, max:14 },
  veg:    { type:'range', desc:'Portionen Obst/Gemüse/Tag', min:0, max:10 },
  goals:  { type:'multi', desc:'Persönliche Ziele' },
};

// ── SCHICHT 2: EVIDENZ-REGELN ───────────────────────────────────────────────
// Jede Regel: welches Signal → welche Zutat bekommt welches Gewicht
// Basis: peer-reviewed Literatur, EFSA-Opinions, DGE/BfR Empfehlungen

var EVIDENCE_RULES = [

  {id:'ev_vd_sun1', ingredient:'vit_d', signal:'sun', condition:'kaum',   weight:3.5, grade:'A', mandatory:false,
   source:'EFSA NDA 2016: Cutaneous synthesis requires UVB >290nm; office workers near zero synthesis.',
   rationale:'Büro/Kaum Sonne: keine endogene D3-Synthese → starker Mangel-Marker.'},
  {id:'ev_vd_sun2', ingredient:'vit_d', signal:'sun', condition:'zwischen', weight:2.0, grade:'A', mandatory:false,
   source:'RKI 2016: 61% der deutschen Bevölkerung Vitamin-D-Mangel im Winter.',
   rationale:'Selten Sonne in DE (47-55°N): erhebliches Defizitrisiko.'},
  {id:'ev_vd_age1', ingredient:'vit_d', signal:'age',  condition:'>50',   weight:2.5, grade:'A', mandatory:false,
   source:'EFSA NDA 2016: Skin synthesis capacity decreases ~50% from age 20 to 70.',
   rationale:'Ab 50: Hautsynthese-Kapazität stark reduziert, Supplementierung empfohlen.'},
  {id:'ev_vd_age2', ingredient:'vit_d', signal:'age',  condition:'>35',   weight:1.0, grade:'B', mandatory:false,
   source:'Holick 2007 (NEJM): Progressive decline in cutaneous synthesis starts around age 35.',
   rationale:'Ab 35: Hautsynthese nimmt graduell ab.'},
  {id:'ev_vd_bmi',  ingredient:'vit_d', signal:'bmi',  condition:'adipositas', weight:2.5, grade:'A', mandatory:false,
   source:'Earthman et al. 2012 (Obesity Reviews): Adipose tissue sequesters Vit D, reduces bioavailability 30-55%.',
   rationale:'Adipositas: Vitamin D im Fettgewebe eingelagert → deutlich erhöhter Bedarf.'},
  {id:'ev_vd_vegan',ingredient:'vit_d', signal:'diet',  condition:'vegan',  weight:1.5, grade:'B', mandatory:true,
   source:'Crowe et al. 2011 (EPIC-Oxford): Vegans show lowest Vitamin D levels of all dietary groups.',
   rationale:'Vegan: keine tierischen D3-Quellen. Pflicht-Supplementierung.'},

  {id:'ev_b12_veg',  ingredient:'vit_b12', signal:'diet', condition:'vegan',       weight:9.0, grade:'A', mandatory:true,
   source:'EFSA NDA 2015: B12 found almost exclusively in animal products. High deficiency risk in vegans.',
   rationale:'Vegan: kein B12 aus Nahrung möglich. Höchste Priorität.'},
  {id:'ev_b12_veg2', ingredient:'vit_b12', signal:'diet', condition:'vegetarisch', weight:6.0, grade:'A', mandatory:true,
   source:'Pawlak et al. 2013 (Nutrition Reviews): 52% of vegetarians are B12 deficient.',
   rationale:'Vegetarisch: hohe B12-Mängelrate belegt.'},
  {id:'ev_b12_age',  ingredient:'vit_b12', signal:'age',  condition:'>50',         weight:1.5, grade:'B', mandatory:false,
   source:'EFSA NDA 2015: Atrophic gastritis reduces B12 absorption in older adults.',
   rationale:'Ab 50: reduzierte Magenproduktion → schlechtere B12-Resorption.'},

  {id:'ev_fol_female', ingredient:'folat', signal:'sex', condition:'weiblich',   weight:2.0, grade:'A', mandatory:false,
   source:'BfR Stellungnahme 013/2014: Frauen im gebärfähigen Alter 400µg/Tag.',
   rationale:'Frauen: erhöhter Bedarf durch menstruelle Verluste.'},
  {id:'ev_fol_preg',   ingredient:'folat', signal:'sex', condition:'schwanger',  weight:5.0, grade:'A', mandatory:true,
   source:'WHO 2006: Perikonzeptionelle Folsäure zur NTD-Prävention. Grade 1++.',
   rationale:'Schwangerschaft: 400-800µg/Tag präkonzeptionell zwingend.'},

  {id:'ev_mg_sport', ingredient:'magnesium', signal:'sport', condition:'>=3', weight:2.0, grade:'A', mandatory:false,
   source:'Zhang et al. 2017 (Nutrients): Athletes lose significantly more Mg through sweat (up to 70mg/h).',
   rationale:'Sport ≥3×/Woche: erhebliche Mg-Verluste über Schweiß.'},
  {id:'ev_mg_stress',ingredient:'magnesium', signal:'stress',condition:'>=4', weight:1.8, grade:'B', mandatory:false,
   source:'Pickering et al. 2020 (Nutrients): Chronic stress increases urinary Mg excretion via cortisol.',
   rationale:'Hoher Stress: erhöhte Cortisol-Ausschüttung → vermehrte Mg-Ausscheidung.'},
  {id:'ev_mg_sleep', ingredient:'magnesium', signal:'sleep', condition:'<6',  weight:1.5, grade:'B', mandatory:false,
   source:'Abbasi et al. 2012 (J Res Med Sci): Mg supplementation improves sleep quality.',
   rationale:'Schlaf <6h: Magnesiummangel als mögliche Ursache.'},

  {id:'ev_fe_vegan', ingredient:'eisen', signal:'diet', condition:'vegan',       weight:3.0, grade:'A', mandatory:true,
   source:'EFSA NDA 2017: Non-heme iron bioavailability 2-20% vs heme iron 15-35%.',
   rationale:'Vegan: nur Non-Häm-Eisen mit schlechterer Bioverfügbarkeit.'},
  {id:'ev_fe_veg',   ingredient:'eisen', signal:'diet', condition:'vegetarisch', weight:2.0, grade:'A', mandatory:false,
   source:'Hunt 2003 (Am J Clin Nutr): Vegetarians have lower iron stores despite adequate intake.',
   rationale:'Vegetarisch: trotz ausreichender Zufuhr oft niedrigere Eisenspeicher.'},
  {id:'ev_fe_female',ingredient:'eisen', signal:'sex',  condition:'weiblich',    weight:1.5, grade:'A', mandatory:false,
   source:'WHO 2001: Women of reproductive age have higher iron requirements due to menstrual losses.',
   rationale:'Frauen: monatliche Eisenverluste erhöhen Bedarf.'},

  {id:'ev_vc_smoke', ingredient:'vit_c', signal:'smoke', condition:'ja',    weight:2.5, grade:'A', mandatory:false,
   source:'EFSA NDA 2013: Smokers require 35mg/day more Vit C due to oxidative stress.',
   rationale:'Rauchen: Vitamin-C-Verbrauch durch oxidativen Stress +35mg/Tag.'},
  {id:'ev_vc_smoke2',ingredient:'vit_c', signal:'smoke', condition:'selten',weight:1.2, grade:'B', mandatory:false,
   source:'Lykkesfeldt & Poulsen 2010: Even occasional smoking increases Vit C turnover.',
   rationale:'Gelegentliches Rauchen erhöht Vit-C-Bedarf messbar.'},
  {id:'ev_vc_veg',   ingredient:'vit_c', signal:'veg',   condition:'<=2',   weight:1.2, grade:'B', mandatory:false,
   source:'DGE 2017: <2 Portionen Obst/Gemüse/Tag unterschreitet Vit-C-Bedarf.',
   rationale:'Wenig Obst/Gemüse: natürliche Vit-C-Zufuhr wahrscheinlich unter 75mg/Tag.'},

  {id:'ev_iod_vegan',ingredient:'jod', signal:'diet', condition:'vegan',       weight:2.0, grade:'A', mandatory:false,
   source:'Leung et al. 2011 (Thyroid): Vegans have significantly lower urinary iodine.',
   rationale:'Vegan: kein Fisch/Milch → Jodversorgung häufig unzureichend.'},
  {id:'ev_iod_fish', ingredient:'jod', signal:'fish', condition:'<=1',          weight:1.5, grade:'B', mandatory:false,
   source:'BfR 2012: Fisch ist wichtigste natürliche Jodquelle in Deutschland.',
   rationale:'Fisch ≤1×/Woche: natürliche Jodzufuhr <150µg/Tag wahrscheinlich.'},

  {id:'ev_zn_vegan', ingredient:'zink', signal:'diet', condition:'vegan',       weight:1.5, grade:'A', mandatory:false,
   source:'Hotz & Brown 2004 (Food Nutr Bull): Phytates in plant foods reduce zinc bioavailability 50%.',
   rationale:'Vegan: Phytate-Gehalt reduziert Zinkbioverfügbarkeit erheblich.'},
  {id:'ev_zn_sport', ingredient:'zink', signal:'sport', condition:'>=4',        weight:1.0, grade:'B', mandatory:false,
   source:'Micheletti et al. 2001 (Sports Med): Athletes show higher zinc losses via sweat and urine.',
   rationale:'Intensiver Sport: erhöhte Zinkverluste über Schweiß.'},

  {id:'ev_se_smoke', ingredient:'selen', signal:'smoke', condition:'ja',   weight:1.5, grade:'B', mandatory:false,
   source:'Combs & Lu 2001 (Cancer): Smoking increases oxidative stress and selenium turnover.',
   rationale:'Rauchen: erhöhter Selenverbrauch als Antioxidans.'},

  {id:'ev_vk_age',  ingredient:'vit_k', signal:'age',   condition:'>45',  weight:2.0, grade:'A', mandatory:false,
   source:'Knapen et al. 2013 (Osteoporosis Int): Vitamin K2 (MK-7) significantly improves bone strength.',
   rationale:'Ab 45: Knochendichteabnahme beginnt, K2 aktiviert Osteocalcin.'},
  {id:'ev_vk_lacto',ingredient:'vit_k', signal:'lacto', condition:'ja',   weight:0.5, grade:'B', mandatory:false,
   source:'Schurgers et al. 2007 (Blood): Dairy is the primary food source of Vitamin K2.',
   rationale:'Laktoseintoleranz: kein Käse/Milch → reduzierte K2-Aufnahme.'},

  {id:'ev_ash_stress',ingredient:'ashwagandha', signal:'stress', condition:'>=3', weight:1.5, grade:'A', mandatory:false,
   source:'Chandrasekhar et al. 2012 (Indian J Psych Med): KSM-66 reduces cortisol by 27.9% vs placebo (RCT).',
   rationale:'Stress ≥3: Ashwagandha zeigt signifikante Cortisol-Reduktion in RCT.'},

  {id:'ev_bal_sleep',ingredient:'baldrian', signal:'sleep', condition:'<6', weight:2.0, grade:'B', mandatory:false,
   source:'Bent et al. 2006 (Am J Medicine): Meta-analysis 16 RCTs: Valerian may improve sleep quality.',
   rationale:'Schlaf <6h: Baldrian zeigt moderate schlaffördernde Wirkung.'},


  {id:'ev_cor_sport',ingredient:'cordyceps', signal:'sport', condition:'>=4', weight:2.0, grade:'B', mandatory:false,
   source:'Chen et al. 2010 (J Alternative Med): Cordyceps improves VO2max and aerobic capacity.',
   rationale:'Sport ≥4×/Woche: Cordyceps steigert Sauerstoffverwertung.'},

  {id:'ev_ca_lacto', ingredient:'calcium', signal:'lacto', condition:'ja',   weight:2.5, grade:'A', mandatory:false,
   source:'EFSA NDA 2015: Dairy is the primary calcium source; lactose intolerance reduces intake significantly.',
   rationale:'Laktoseintoleranz: Hauptquelle Milchprodukte entfällt.'},
  {id:'ev_ca_age',   ingredient:'calcium', signal:'age',   condition:'>50',  weight:1.5, grade:'A', mandatory:false,
   source:'NIH Consensus 1994: Calcium requirements increase after age 50 due to reduced absorption.',
   rationale:'Ab 50: Calciumabsorption nimmt ab, erhöhter Bedarf.'},

  ];

// Lookup-Map für schnellen Zugriff
var EVIDENCE_MAP = {};
EVIDENCE_RULES.forEach(function(ev){
  if(!EVIDENCE_MAP[ev.ingredient]) EVIDENCE_MAP[ev.ingredient]=[];
  EVIDENCE_MAP[ev.ingredient].push(ev);
});

var MANDATORY_INGREDIENTS = EVIDENCE_RULES
  .filter(function(ev){return ev.mandatory;})
  .map(function(ev){return {ingredient:ev.ingredient, signal:ev.signal, condition:ev.condition};});

// ── SCHICHT 3: WISSENSCHAFTLICHES SCORING ───────────────────────────────────
// Berechnet Score für eine Zutat basierend auf:
//   A. Evidenz-Regeln (Ist-Situation → nachgewiesener Bedarf)
//   B. Ziel-Gewichte (persönliche Ziele → Relevanz)
//   C. Basis-Score (universeller Grundbedarf, unabhängig von Situation)

// Ziel-Mapping: Quiz-Option → Score-Schlüssel
var GOAL_MAP = {
  'Energie':        ['Energie & Vitalität','Energie & Vitalitaet'],
  'Immunsystem':    ['Immunsystem stärken','Immunsystem staerken'],
  'Schlaf':         ['Schlaf verbessern'],
  'Sport':          ['Sporterholung'],
  'Konzentration':  ['Konzentration & Fokus'],
  'Knochen':        ['Knochen & Gelenke'],
  'Haut':           ['Haut & Schönheit','Haut & Schoenheit'],
  'Haar':           ['Haare & Nägel','Haare & Naegel'],
  'Stress':         ['Stress & Resilienz'],
  'Darm':           ['Darm & Verdauung'],
  'Leber':          ['Leber & Entgiftung'],
  'Herz':           ['Herz & Gefäße','Herz & Gefaesse'],
  'Augen':          ['Augen & Sehkraft','Augen und Sehkraft','Sehkraft'],
  'Wechseljahre':   ['Wechseljahre','Menopause','Klimakterium'],
  'Gewicht':        ['Gewichtsmanagement','Gewichtskontrolle'],
};

function hasGoal(ans, goalKey){
  var userGoals = ans.goals || [];
  var patterns = GOAL_MAP[goalKey] || [goalKey];
  return userGoals.some(function(g){
    return patterns.some(function(p){
      return g.toLowerCase().indexOf(p.toLowerCase()) >= 0 ||
             p.toLowerCase().indexOf(g.toLowerCase()) >= 0;
    });
  });
}

// Botanicals, die bei einem der vier Gesundheitszustände (Schwangerschaft, Stillzeit,
// regelmäßige Medikamenteneinnahme, diagnostizierte Erkrankung) hart ausgeschlossen
// werden (Score 0). Fachlich belegt: Adaptogene/uterus- bzw. hormonwirksame bzw.
// sedierende Pflanzen mit Interaktions-/Sicherheitsrisiken. Der ärztliche Rücksprache-
// Hinweis auf der Ergebnisseite ergänzt dies für alle übrigen Zutaten.
var PREG_LACT_EXCLUDE = ['ashwagandha','ginseng','maca','cordyceps','reishi','baldrian','teufelskralle','nac'];

function isPregLactExcluded(ingredientId, ans){
  if(PREG_LACT_EXCLUDE.indexOf(ingredientId) < 0) return false;
  var ges = (ans && ans.gesundheit) ? ans.gesundheit : [];
  return ges.some(function(g){
    return g.indexOf('schwanger') >= 0 || g.indexOf('stille') >= 0 ||
           g.indexOf('Medikamente') >= 0 || g.indexOf('Erkrankung') >= 0;
  });
}

function evidenceScore(ingredientId, ans){
  // Harter Ausschluss bei Schwangerschaft/Stillzeit für kontraindizierte Botanicals
  if(isPregLactExcluded(ingredientId, ans)) return 0;
  var rules = EVIDENCE_MAP[ingredientId] || [];
  var score = 0;
  rules.forEach(function(ev){
    var val = ans[ev.signal];
    if(val === undefined || val === null) return;
    var vs = typeof val === 'string' ? val.toLowerCase() : val;
    var match = false;
    switch(ev.condition){
      case 'vegan':        match = typeof vs==='string' && vs.indexOf('vegan')>=0; break;
      case 'vegetarisch':  match = typeof vs==='string' && vs.indexOf('vegetarisch')>=0; break;
      case 'weiblich':     match = vs==='weiblich'; break;
      case 'schwanger':    match = typeof vs==='string' && vs.indexOf('schwanger')>=0; break;
      case 'adipositas':   match = typeof vs==='string' && vs.indexOf('adipositas')>=0; break;
      case 'übergewicht':  match = typeof vs==='string' && (vs.indexOf('übergewicht')>=0||vs.indexOf('bergewicht')>=0); break;
      case 'ja':           match = vs==='ja'; break;
      case 'selten':       match = vs==='selten'; break;
      case 'kaum':         match = typeof vs==='string' && (vs.indexOf('kaum')>=0||vs.indexOf('büro')>=0||vs.indexOf('buro')>=0); break;
      default:
        var n = typeof val === 'number' ? val : parseFloat(val);
        if(!isNaN(n)){
          if(ev.condition==='>=5') match=n>=5;
          else if(ev.condition==='>=4') match=n>=4;
          else if(ev.condition==='>=3') match=n>=3;
          else if(ev.condition==='>=2') match=n>=2;
          else if(ev.condition==='>50')  match=n>50;
          else if(ev.condition==='>45')  match=n>45;
          else if(ev.condition==='>40')  match=n>40;
          else if(ev.condition==='>35')  match=n>35;
          else if(ev.condition==='<=2')  match=n<=2;
          else if(ev.condition==='<=1')  match=n<=1;
          else if(ev.condition==='<6')   match=n<6;
          else if(ev.condition==='<5')   match=n<5;
        }
    }
    if(match) score += ev.weight;
  });
  return score;
}

// Gebaut auf allen 3 Schichten
var SE = {};

function buildScoringModel(){

  SE['vit_a']     = function(a){return evidenceScore('vit_a',a)     +w(a,'sun','kaum',1.2,'zwischen',0.5,0)+(hasGoal(a,'Haut')?1.5:0)+(hasGoal(a,'Immunsystem')?1.0:0)+(hasGoal(a,'Augen')?2.0:0);};
  SE['vit_b1']    = function(a){return evidenceScore('vit_b1',a)    +w(a,'alc',function(v){return v>=7;},1.5,function(v){return v>=4;},0.8,0)+w(a,'stress',function(v){return v>=4;},0.5)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Konzentration')?0.8:0);};
  SE['vit_b2']    = function(a){return evidenceScore('vit_b2',a)    +w(a,'sport',function(v){return v>=3;},0.8)+w(a,'stress',function(v){return v>=3;},0.5)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Haut')?0.8:0)+(hasGoal(a,'Wechseljahre')?0.8:0)+(hasGoal(a,'Augen')?1.5:0);};
  SE['vit_b3']    = function(a){return evidenceScore('vit_b3',a)    +w(a,'alc',function(v){return v>=4;},0.8)+w(a,'stress',function(v){return v>=3;},0.5)+(hasGoal(a,'Energie')?1.0:0)+(hasGoal(a,'Haut')?1.5:0)+(hasGoal(a,'Konzentration')?0.8:0);};
  SE['vit_b5']    = function(a){return evidenceScore('vit_b5',a)    +w(a,'stress',function(v){return v>=3;},1.0)+(hasGoal(a,'Energie')?1.0:0)+(hasGoal(a,'Stress')?1.2:0);};
  SE['vit_b6']    = function(a){return evidenceScore('vit_b6',a)    +w(a,'stress',function(v){return v>=4;},1.0)+w(a,'alc',function(v){return v>=7;},1.2)+(hasGoal(a,'Konzentration')?1.2:0)+(hasGoal(a,'Stress')?1.0:0)+(hasGoal(a,'Energie')?0.8:0)+(hasGoal(a,'Wechseljahre')?1.5:0);};
  SE['vit_b12']   = function(a){return 3.0+evidenceScore('vit_b12',a)+w(a,'age',function(v){return v>50;},1.5)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Konzentration')?0.8:0)+(hasGoal(a,'Wechseljahre')?0.8:0);};
  SE['biotin']    = function(a){return evidenceScore('biotin',a)    +(hasGoal(a,'Haar')?2.5:0)+(hasGoal(a,'Haut')?1.5:0);};
  SE['folat']     = function(a){return evidenceScore('folat',a)     +(hasGoal(a,'Energie')?0.8:0);};
  SE['vit_c']     = function(a){return 2.5+evidenceScore('vit_c',a)+(hasGoal(a,'Immunsystem')?1.5:0)+(hasGoal(a,'Haut')?1.2:0)+(hasGoal(a,'Energie')?0.8:0)+(hasGoal(a,'Longevity')?1.2:0)+(hasGoal(a,'Wechseljahre')?1.0:0);};
  SE['vit_d']     = function(a){return 1.5+evidenceScore('vit_d',a) +w(a,'lacto','ja',0.8)+(hasGoal(a,'Immunsystem')?1.5:0)+(hasGoal(a,'Knochen')?1.2:0)+(hasGoal(a,'Longevity')?1.3:0)+(hasGoal(a,'Wechseljahre')?2.0:0)
      +(typeof a.uvAvail==='number'?(1-a.uvAvail)*3.0:0);};  // Standort×Jahreszeit: je weniger Sonnensynthese, desto höher der Vit-D-Bedarf
  SE['vit_e']     = function(a){return evidenceScore('vit_e',a)     +w(a,'smoke','ja',1.5,'selten',0.7,0)+(hasGoal(a,'Sport')?1.2:0)+(hasGoal(a,'Immunsystem')?0.8:0)+(hasGoal(a,'Longevity')?2.0:0);};
  SE['vit_k']     = function(a){return evidenceScore('vit_k',a)     +(hasGoal(a,'Knochen')?2.5:0)+(hasGoal(a,'Longevity')?1.0:0)+(hasGoal(a,'Wechseljahre')?1.8:0);};
  SE['calcium']   = function(a){return evidenceScore('calcium',a)   +(hasGoal(a,'Knochen')?2.0:0)+(hasGoal(a,'Wechseljahre')?2.5:0);};
  SE['chrom']     = function(a){return evidenceScore('chrom',a)     +w(a,'bmi',function(v){return typeof v==='string'&&(v.indexOf('adipositas')>=0||v.indexOf('bergewicht')>=0);},1.5)+(hasGoal(a,'Energie')?0.8:0);};
  SE['eisen']     = function(a){return evidenceScore('eisen',a)     +(hasGoal(a,'Energie')?1.5:0)+(hasGoal(a,'Wechseljahre')?0.8:0);};
  SE['jod']       = function(a){return evidenceScore('jod',a)       +w(a,'fish',function(v){return v<=2;},0.8)+(hasGoal(a,'Energie')?0.8:0)+(hasGoal(a,'Konzentration')?0.8:0);};
  SE['kalium']    = function(a){return evidenceScore('kalium',a)    +w(a,'sport',function(v){return v>=4;},1.5,function(v){return v>=2;},0.8,0)+(hasGoal(a,'Sport')?1.2:0)+(hasGoal(a,'Herz')?1.5:0);};
  SE['kupfer']    = function(a){return evidenceScore('kupfer',a)    +(hasGoal(a,'Immunsystem')?0.8:0)+(hasGoal(a,'Haar')?1.0:0);};
  SE['magnesium'] = function(a){return evidenceScore('magnesium',a) +w(a,'sport',function(v){return v>=2;},1.0)+w(a,'stress',function(v){return v>=3;},1.0)+(hasGoal(a,'Sport')?1.5:0)+(hasGoal(a,'Schlaf')?2.0:0)+(hasGoal(a,'Stress')?1.5:0)+(hasGoal(a,'Knochen')?0.8:0)+(hasGoal(a,'Wechseljahre')?1.5:0);};
  SE['mangan']    = function(a){return evidenceScore('mangan',a)    +(hasGoal(a,'Knochen')?1.0:0)+(hasGoal(a,'Wechseljahre')?1.0:0);};
      SE['selen']     = function(a){return evidenceScore('selen',a)     +w(a,'diet','vegan',0.5)+(hasGoal(a,'Immunsystem')?1.2:0)+(hasGoal(a,'Haar')?1.8:0)+(hasGoal(a,'Longevity')?1.8:0);};
  SE['zink']      = function(a){return evidenceScore('zink',a)      +w(a,'sport',function(v){return v>=3;},0.8)+(hasGoal(a,'Immunsystem')?1.5:0)+(hasGoal(a,'Haut')?1.5:0)+(hasGoal(a,'Haar')?1.5:0)+(hasGoal(a,'Augen')?1.2:0);};
                SE['omega3']    = function(a){return evidenceScore('omega3',a)+(hasGoal(a,'Herz')?2.0:0)+(hasGoal(a,'Konzentration')?1.5:0)+(hasGoal(a,'Augen')?1.5:0)+(hasGoal(a,'Longevity')?0.6:0);};
                SE['cholin']    = function(a){return evidenceScore('cholin',a)    +w(a,'alc',function(v){return v>=4;},1.5)+(hasGoal(a,'Konzentration')?1.2:0)+(hasGoal(a,'Leber')?1.5:0);};
  SE['glucomannan']= function(a){return evidenceScore('glucomannan',a)+w(a,'bmi',function(v){return typeof v==='string'&&v.indexOf('adipositas')>=0;},2.0)+(hasGoal(a,'Herz')?1.2:0)+(hasGoal(a,'Darm')?1.8:0);};
        SE['guarkernmehl']= function(a){return evidenceScore('guarkernmehl',a)+w(a,'bmi',function(v){return typeof v==='string'&&v.indexOf('adipositas')>=0;},1.5)+(hasGoal(a,'Darm')?1.5:0);};
                    

  SE['chlorella']   = function(a){return evidenceScore('vit_b12',a)  +w(a,'diet','vegan',0.8)+(hasGoal(a,'Darm')?1.5:0)+(hasGoal(a,'Immunsystem')?0.8:0)+w(a,'alc',function(v){return v>=5;},0.5);};
  SE['spirulina']   = function(a){return evidenceScore('eisen',a)    +w(a,'diet','vegan',1.5)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Immunsystem')?1.0:0)+(hasGoal(a,'Sport')?0.5:0);};
  SE['brennnessel'] = function(a){return evidenceScore('eisen',a)+w(a,'diet','vegan',1.0,'vegetarisch',0.5,0)+(hasGoal(a,'Energie')?0.8:0)+(hasGoal(a,'Knochen')?0.5:0);};
  SE['gerstengras'] = function(a){return 0.3+w(a,'diet','vegan',1.0,'vegetarisch',0.5,0)+w(a,'smoke','ja',0.8,'selten',0.4,0)+(hasGoal(a,'Darm')?1.5:0)+(hasGoal(a,'Leber')?1.2:0)+(hasGoal(a,'Energie')?0.8:0);};
  SE['weizengras']  = function(a){return 0.3+w(a,'diet','vegan',1.0,'vegetarisch',0.5,0)+(hasGoal(a,'Darm')?1.5:0)+(hasGoal(a,'Immunsystem')?1.2:0)+(hasGoal(a,'Energie')?0.8:0);};
      

  SE['ashwagandha'] = function(a){

  var gesundheit = a.gesundheit || [];
  var excluded = gesundheit.some(function(g){
    return g.indexOf('schwanger') >= 0 ||
           g.indexOf('stille') >= 0 ||
           g.indexOf('Medikamente') >= 0 ||
           g.indexOf('Erkrankung') >= 0;
  });
  if(excluded) return 0;
  return evidenceScore('ashwagandha',a)
    +w(a,'stress',function(v){return v>=4;},1.0)
    +w(a,'sleep',function(v){return v<6;},1.0)
    +(hasGoal(a,'Stress')?2.0:0)
    +(hasGoal(a,'Schlaf')?1.0:0)
    +(hasGoal(a,'Longevity')?1.2:0)
    +(hasGoal(a,'Sport')?0.5:0);
};
  SE['reishi']      = function(a){return 0.5+w(a,'stress',function(v){return v>=3;},0.5)+(hasGoal(a,'Immunsystem')?1.5:0)+(hasGoal(a,'Stress')?1.2:0)+(hasGoal(a,'Schlaf')?0.5:0)+(hasGoal(a,'Longevity')?1.5:0);};
  SE['hericium']    = function(a){return 0.5+w(a,'age',function(v){return v>40;},0.5)+(hasGoal(a,'Konzentration')?2.0:0)+(hasGoal(a,'Stress')?1.0:0)+(hasGoal(a,'Longevity')?1.0:0);};
  SE['kurkuma']     = function(a){return 0.5+w(a,'sport',function(v){return v>=3;},0.5)+(hasGoal(a,'Knochen')?1.5:0)+(hasGoal(a,'Immunsystem')?0.8:0)+(hasGoal(a,'Darm')?0.8:0)+(hasGoal(a,'Longevity')?1.5:0);};
  SE['ginseng']     = function(a){return 0.5+w(a,'age',function(v){return v>50;},0.8)+(hasGoal(a,'Energie')?1.5:0)+(hasGoal(a,'Konzentration')?1.0:0)+(hasGoal(a,'Immunsystem')?0.8:0);};
  SE['matcha']      = function(a){return 0.5+(hasGoal(a,'Konzentration')?1.5:0)+(hasGoal(a,'Energie')?1.0:0)+(hasGoal(a,'Immunsystem')?0.5:0);};
  SE['moringa_bot'] = function(a){return 0.5+w(a,'diet','vegan',1.0)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Immunsystem')?0.8:0);};
  SE['rote_beete']  = function(a){return 0.5+w(a,'sport',function(v){return v>=3;},1.0)+(hasGoal(a,'Sport')?1.5:0)+(hasGoal(a,'Energie')?0.8:0);};
  SE['maca']        = function(a){return 0.5+w(a,'stress',function(v){return v>=3;},0.8)+(hasGoal(a,'Energie')?1.5:0)+(hasGoal(a,'Sport')?1.2:0);};
  SE['baldrian']    = function(a){return evidenceScore('baldrian',a) +w(a,'sleep',function(v){return v<6;},1.0)+(hasGoal(a,'Schlaf')?2.5:0)+(hasGoal(a,'Stress')?1.0:0);};
      SE['cordyceps']   = function(a){return evidenceScore('cordyceps',a)+w(a,'sport',function(v){return v>=4;},1.0,function(v){return v>=2;},0.5,0)+(hasGoal(a,'Sport')?2.0:0)+(hasGoal(a,'Energie')?1.2:0);};

  SE['schwarzpfeffer']= function(a){var hC=!disabled['curcumin_ex']&&avails['curcumin_ex'];var hK=!disabled['kurkuma']&&avails['kurkuma'];return (hC||hK)?3.0:0.1;};

  SE['lucuma']  = function(a){return 0.3+(hasGoal(a,'Energie')?1.0:0)+(hasGoal(a,'Darm')?0.5:0)+(hasGoal(a,'Longevity')?0.8:0);};
  SE['chaga']   = function(a){return 0.5+w(a,'smoke','ja',0.8,'selten',0.4,0)+(hasGoal(a,'Immunsystem')?1.5:0)+(hasGoal(a,'Energie')?0.8:0)+(hasGoal(a,'Longevity')?1.5:0);};
  SE['ingwer']  = function(a){return 0.5+w(a,'sport',function(v){return v>=3;},0.5)+(hasGoal(a,'Knochen')?1.5:0)+(hasGoal(a,'Darm')?1.2:0)+(hasGoal(a,'Stress')?0.8:0);};
  SE['spermidin']= function(a){return 0.5+w(a,'age',function(v){return v>=50;},1.5,function(v){return v>=40;},1.0,0)+(hasGoal(a,'Longevity')?2.5:0);};

  // ── NEU (Juli 2026): gezielte Bewertung statt Ziel-Fallback ───────────────
  // Kreatin: v.a. bei Kraft-/Schnellkraftsport; Veganer/Vegetarier profitieren
  // staerker, da sie ueber die Ernaehrung kaum Kreatin aufnehmen.
  SE['kreatin'] = function(a){return 0.5
      + w(a,'sport',function(v){return v>=4;},2.5,function(v){return v>=2;},1.2,0)
      + w(a,'diet','vegan',1.0,'vegetarisch',0.5,0)
      + (hasGoal(a,'Sport')?2.5:0)+(hasGoal(a,'Energie')?1.0:0);};

  // Alpha-Liponsaeure: Antioxidans, Nutzen steigt mit Alter und oxidativer Last
  // (Rauchen). Kein zugelassener EU-Health-Claim -> claim bleibt leer.
  SE['alpha_liponsaeure'] = function(a){return 0.5
      + w(a,'age',function(v){return v>=50;},1.5,function(v){return v>=40;},1.0,0)
      + w(a,'smoke','ja',1.0,'selten',0.5,0)
      + (hasGoal(a,'Longevity')?2.0:0)+(hasGoal(a,'Energie')?1.2:0)+(hasGoal(a,'Haut')?1.0:0);};

  DB.forEach(function(it){
    if(!SE[it.id]){
      SE[it.id]=function(itRef){ return function(a){
        var score=evidenceScore(itRef.id,a);
        (itRef.goals||[]).forEach(function(gk){if(hasGoal(a,gk))score+=1.0;});
        return score;
      };}(it);
    }
  });
}
buildScoringModel();

// ── HELPERS ───────────────────────────────────────────────────────────────────
function w(ans,qid,c1,v1,c2,v2,def){
  if(def===undefined)def=0;
  var raw=ans[qid];if(raw===undefined)return 0;
  var val=typeof raw==='string'?raw.toLowerCase():raw;
  if(typeof c1==='function'){if(c1(val))return v1;}
  else if(c1&&val.toString().toLowerCase().indexOf(c1.toLowerCase())>=0)return v1;
  if(typeof c2==='function'){if(c2(val))return v2;}
  else if(c2&&val.toString().toLowerCase().indexOf(c2.toLowerCase())>=0)return v2;
  return def;
}
function g(ans,key,v,def){
  if(def===undefined)def=0;
  var gs=ans.goals||[];
  return gs.some(function(x){return x.toLowerCase().indexOf(key.toLowerCase())>=0;})?v:def;
}
function toMg(a,u){return u==='g'?a*1000:u==='µg'?a/1000:a;}
function fa(v,u){
  // Immer abrunden (floor) — nie aufrunden
  if(u==='g'){
    if(v<10) return (Math.floor(v*100)/100).toFixed(2);
    return (Math.floor(v*10)/10).toFixed(1);
  }
  if(v<1) return (Math.floor(v*1000)/1000).toFixed(3);
  if(v<10) return (Math.floor(v*10)/10).toFixed(1);
  return Math.floor(v).toLocaleString('de-DE');
}

// ── STATE ─────────────────────────────────────────────────────────────────────
// ── BESTAND STRASSLACH (Stand 26.10.2026, aus den JTL-Artikelstammdaten) ────
// rw   = Rohware in kg, einwiegefertig (Lager_SL; Kapseln und Tabletten
//        zaehlen NICHT, die lassen sich nicht einwiegen)
// fw   = Fertigware in kg, muesste zum Einwiegen umgepackt werden
// zu   = Zulauf in kg
// ku   = Reichweite in 90-Tage-Kuren bei Standarddosis (rw+fw)
// art  = fuehrende JTL-Artikelnummer, damit die Zahl nachvollziehbar ist
// NICHT von Hand pflegen: naechsten JTL-Export durch bestand_block.py
// schicken und diesen Block ersetzen.
var BESTAND_STAND = '26.10.2026';
var BESTAND_SL = {
  'vit_a':              {rw:    0.00, fw:    0.00, zu:   0.00, ku:     0, art:''},
  'vit_b1':             {rw:    1.00, fw:    0.00, zu:   0.00, ku:  8990, art:'RW Vitamin B1 konv'},
  'vit_b2':             {rw:    1.00, fw:    0.00, zu:   0.00, ku:  7936, art:'RW Vitamin B2 KONV'},
  'vit_b3':             {rw:    1.00, fw:    0.00, zu:   0.00, ku:   694, art:'RW Vitamin B3 NIiacin KON'},
  'vit_b5':             {rw:    1.00, fw:    0.00, zu:   0.00, ku:  1704, art:'RW VItamin B5 KONV'},
  'vit_b6':             {rw:    1.10, fw:    0.00, zu:   0.00, ku:  6984, art:'RW Vitamin B6'},
  'vit_b12':            {rw:   24.80, fw:    0.00, zu:   0.00, ku:  2204, art:'RW Vitamin B12 NEM'},
  'biotin':             {rw:    0.75, fw:    0.00, zu:   0.00, ku:165000, art:'RW Biotin KONV'},
  'folat':              {rw:    0.50, fw:    0.00, zu:   0.00, ku: 25000, art:'RW Vitamin B9 Folsäure'},
  'vit_c':              {rw:   50.38, fw:    0.00, zu:   0.00, ku:  1190, art:'RW Vitamin C NEM Bio'},
  'vit_d':              {rw:    1.80, fw:    0.00, zu:   0.00, ku:  2000, art:'RW Vitamin D3 NEM'},
  'vit_e':              {rw:    0.10, fw:    0.00, zu:   0.00, ku:    46, art:'RW Vitamin E'},
  'vit_k':              {rw:    0.00, fw:    0.00, zu:   0.00, ku:     0, art:''},
  'calcium':            {rw:    0.50, fw:   17.25, zu:   0.00, ku:   166, art:'RW kalzium'},
  'chrom':              {rw:    0.00, fw:    0.00, zu:   0.00, ku:     0, art:''},
  'eisen':              {rw:    1.00, fw:    0.00, zu:   0.00, ku:   127, art:'RW Eisen KONV'},
  'jod':                {rw:  255.85, fw:   27.30, zu:   0.00, ku:1048704, art:'RW Kelp. kba Pulver'},
  'kalium':             {rw:    0.50, fw:    0.00, zu:   0.00, ku:     7, art:'RW Kalium'},
  'kupfer':             {rw:    0.10, fw:    0.00, zu:   0.00, ku:   156, art:'RW Kupfergluconat'},
  'magnesium':          {rw:   24.40, fw:    0.00, zu:   0.00, ku:    87, art:'RW Magnesium Bio'},
  'mangan':             {rw:    0.00, fw:    0.00, zu:   0.00, ku:     0, art:''},
  'selen':              {rw:    0.00, fw:    0.00, zu:   0.00, ku:     0, art:''},
  'zink':               {rw:   24.20, fw:    0.00, zu:   0.00, ku:  1076, art:'RW Zink NEM Bio'},
  'omega3':             {rw:    5.00, fw:    0.00, zu:   0.00, ku:    38, art:'RW Omega 3 Pulver 17%DHA'},
  'cholin':             {rw:    1.00, fw:    0.00, zu:   0.00, ku:    11, art:'VItamin B4 Cholin KON'},
  'glucomannan':        {rw:    0.00, fw:   23.25, zu:  50.00, ku:    82, art:'9C-D7UM-IZAQ'},
  'guarkernmehl':       {rw:    0.00, fw:  236.00, zu:   0.00, ku:  2622, art:'MEHL-GUA-500G'},
  'Q10':                {rw:    0.05, fw:    0.00, zu:   0.00, ku:    11, art:'RW Q10 Enzym KONV'},
  'Kollagen':           {rw:    2.00, fw:    0.00, zu:   0.00, ku:    11, art:'RW Kollagen'},
  'resveratol':         {rw:    0.05, fw:    0.00, zu:   0.00, ku:     1, art:'RW Resveratrol'},
  'alpha_liponsaeure':  {rw:    0.10, fw:    0.00, zu:   0.00, ku:     4, art:'RW Alpha-Liponsäure'},
  'chlorella':          {rw:  104.30, fw:   56.10, zu:   0.00, ku:  3564, art:'RW Chlorella BIO Pulver'},
  'spirulina':          {rw:   98.10, fw:   37.50, zu:   0.00, ku:  3013, art:'RW Spirulina'},
  'brennnessel':        {rw:   43.62, fw:  183.65, zu:  75.00, ku:  5050, art:'RW Brennnesselblätter BIO gemahlen'},
  'gerstengras':        {rw:   17.80, fw:   35.80, zu: 150.00, ku:  1191, art:'RW Gerstengras kba'},
  'weizengras':         {rw:  200.00, fw:    4.20, zu:   0.00, ku:  4538, art:'RW Weizengras Bio'},
  'ashwagandha':        {rw:   57.30, fw:  128.90, zu:   0.00, ku:  6896, art:'RW Ashwagandha'},
  'reishi':             {rw:    6.40, fw:   24.52, zu:   0.00, ku:  1145, art:'RW Reishi Pulver BIO'},
  'hericium':           {rw:    0.00, fw:    1.47, zu:  90.00, ku:    54, art:'PUL-HERI-70G'},
  'kurkuma':            {rw:  144.90, fw:  220.90, zu:   0.00, ku: 13548, art:'RW Kurkuma'},
  'ginseng':            {rw:    2.50, fw:    0.00, zu:   0.00, ku:   278, art:'RW Ginsengwurzel weiß gem. kbA'},
  'matcha':             {rw:   21.70, fw:   24.60, zu:   0.00, ku:  2572, art:'RW Matcha'},
  'moringa_bot':        {rw:   31.80, fw:    2.10, zu:   0.00, ku:  1256, art:'RW Moringapulver Bio'},
  'rote_beete':         {rw:    0.00, fw:    2.20, zu:   0.00, ku:    82, art:'PU-ROBES-100G'},
  'maca':               {rw:    3.50, fw:   37.20, zu:   0.00, ku:  1507, art:'RW Macawurzel'},
  'baldrian':           {rw:   29.00, fw:   22.55, zu:   0.00, ku:  1432, art:'RW Baldrianwurzel'},
  'cordyceps':          {rw:    0.00, fw:   13.50, zu:   0.00, ku:   500, art:'ZA-6P62-3W6S'},
  'schwarzpfeffer':     {rw:   10.35, fw:    3.70, zu:  25.00, ku:  1561, art:'RW Pfeffer schwarz gemahlen, kbA'},
  'lucuma':             {rw:    1.00, fw:    0.00, zu:  20.00, ku:    37, art:'RW Lucuma Bio'},
  'chaga':              {rw:    0.00, fw:   25.00, zu:  40.00, ku:   926, art:'CF-8O46-6XK6'},
  'ingwer':             {rw:   61.30, fw:  273.00, zu:   0.00, ku: 12382, art:'RW Ingwer geschnitten'},
  'spermidin':          {rw:    0.00, fw:   98.00, zu:   0.00, ku:  1452, art:'GA-WEIZ-250G'},
  'teufelskralle':      {rw:   23.00, fw:    0.00, zu:   0.00, ku:   639, art:'RW Teufelskralle BIO'},
  'knoblauch':          {rw:    0.35, fw:   11.45, zu:   0.00, ku:   218, art:'RW Knoblauch Granulat Bio'},
  'mct':                {rw:    5.00, fw:   62.00, zu:   0.00, ku:   248, art:'RW MCT Pulver Bio'},
  'opc':                {rw:   25.00, fw:   55.50, zu:  25.00, ku:  2385, art:'RW OPC Traubenkernext. KONV'},
  'msm':                {rw:    2.00, fw:    0.00, zu:   0.00, ku:    22, art:'RW MSM KON'},
  'irish_moss':         {rw:    0.00, fw:   23.00, zu:   0.00, ku:  1022, art:'76-K79J-71UP'},
  'triphala':           {rw:    0.00, fw:  176.50, zu: 500.00, ku:  3922, art:'UL-XAQS-N0XQ'},
  'kreatin':            {rw:    2.00, fw:    0.00, zu:   0.00, ku:     6, art:'RW Kreatin'},
  'hagebutte':          {rw:    9.20, fw: 1549.50, zu:   0.00, ku: 34638, art:'RW Hagebuttenpulver'},
  'glycin':             {rw:    5.00, fw:    0.00, zu:   0.00, ku:    18, art:'RW Glycin'},
  'nac':                {rw:    1.00, fw:    0.00, zu:   0.00, ku:    18, art:'RW NAC'},
  // Nachtrag 27.10.2026: die 16 Zutaten der Erweiterung, Bestaende aus
  // demselben JTL-Export vom 26.10.2026.
  'loewenzahn':      {rw: 46.30, fw: 0.00, zu: 0.00, art:'RW Löwenzahnwurzel gemahlen, kbA'},
  'brahmi':          {rw: 33.20, fw: 0.00, zu: 0.00, art:'RW Brahmi, kbA Kontrakt'},
  'bockshornklee':   {rw: 26.81, fw: 0.00, zu: 0.00, art:'RW Bockshornklee Samen gemahlen, kbA'},
  'mate':            {rw: 24.40, fw: 0.00, zu: 0.00, art:'RW Mateblätter gemahlen, kbA'},
  'melisse':         {rw: 24.05, fw: 0.00, zu: 0.00, art:'RW Melissenblätter gemahlen + RW Melisse'},
  'schafgarbe':      {rw: 10.43, fw: 0.00, zu: 0.00, art:'RW Schafgarbe gemahlen, kbA'},
  'baobab':          {rw: 5.00, fw: 0.00, zu: 100.00, art:'RW Baobab Fruchtpulver BIO'},
  'guarana':         {rw: 4.00, fw: 0.00, zu: 25.00, art:'RW Guaranasamen gemahlen, kbA'},
  'flohsamen':       {rw: 101.00, fw: 0.00, zu: 900.00, art:'RW Flohsamenschalen ganz + Pulver'},
  'schachtelhalm':   {rw: 31.90, fw: 0.00, zu: 0.00, art:'RW Schachtelhalmkraut BIO gemahlen'},
  'tulsi':           {rw: 4.60, fw: 0.00, zu: 0.00, art:'RW Tulsikraut gem., kbA'},
  'shatavari':       {rw: 6.00, fw: 0.00, zu: 0.00, art:'RW Shatavari Pulver BIO'},
  'artischocke':     {rw: 10.00, fw: 0.00, zu: 0.00, art:'RW Artischocken Extrakt BIO (2,5 % Cynarin)'},
  'granatapfel':     {rw: 2.00, fw: 0.00, zu: 0.00, art:'RW Granatapfel Extrakt Bio, 25 %'},
  'agaricus':        {rw: 0.00, fw: 0.00, zu: 25.00, art:'RW Agaricus blazei Pilz Pulver BIO'},
  'amla':            {rw: 0.00, fw: 0.00, zu: 250.00, art:'RW Amla, kbA'},
};

// ── AKTUELL NICHT VERFUEGBAR ────────────────────────────────────────────────
// Zwei Gruende, getrennt gehalten:
//   1. kein Bestand in Strasslach — faellt aus BESTAND_SL heraus
//   2. andere Gruende (Recht, Produktentscheidung) — mit Begruendung
// Beide Teile erzeugt bestand_block.py aus dem JTL-Export. Von Hand hier
// nur Teil 2 aendern, dann das Skript erneut laufen lassen.
var UNAVAILABLE_IDS = [
  'nac',             // Acetylcystein ist in DE als Arzneimittel zugelassen (600 mg).
                     // Rohware liegt in Strasslach, die Sperre ist rein regulatorisch.
  'mangan',          // kein Bestand (Mangan)

  // ── Erweiterung 27.10.2026: angelegt, aber nicht freigeschaltet ─────────
  'wermut',          // Thujon. Fuer Lebensmittel gelten Hoechstmengen, und in einem
                     // frei konfigurierbaren Mix laesst sich die Tagesmenge nicht
                     // zuverlaessig begrenzen. Empfehlung: gar nicht freischalten.
  'garcinia',        // Hydroxyzitronensaeure, Schlankheitsmittel-Umfeld. Es gibt
                     // Berichte zu Leberschaedigungen, und die Positionierung
                     // "serioes statt Hype" spricht dagegen.
  'agar',            // Geliermittel. Quillt wie Glucomannan und wuerde jede
                     // Pulvermischung ruinieren — ohne dessen Claim-Nutzen.
  'akazienfaser',    // Ist der Traegerstoff, mit dem Kapseln aufgefuellt werden.
                     // Als waehlbare Zutat waere dieselbe Ware zweimal im Auftrag.
  'zimt',            // Cumarin. Erst freischalten, wenn Sorte (Ceylon vs. Cassia)
                     // und Gehalt je Charge belegt sind.
  'zistrose',        // Novel-Food-Status und zulaessige Aussagen pruefen lassen.
  'silberohr',       // Tremella fuciformis: Novel-Food-Status pruefen lassen.
  'oregano'          // Gewuerz. Als Nahrungsergaenzung duenner Fall, 200 mg
                     // Kuechenkraut traegt keine eigene Zutat.
];

// Beschafft, aber im JTL-Export vom 26.10.2026 noch ohne Bestand. Ohne diese
// Liste wuerde bestand_block.py sie beim naechsten Lauf wieder sperren und die
// Gegenprobe unten jedes Mal warnen. Eintrag loeschen, sobald der Export
// Bestand zeigt — dann traegt BESTAND_SL die Zahl von selbst.
var BESTAND_NACHGEMELDET = {
  'agaricus': 'Agaricus blazei Pilzpulver BIO — kein Lagerbestand, 25 kg im Zulauf (Stand 26.10.2026)',
  'amla':     'Amla kbA — kein Lagerbestand, 250 kg im Zulauf (Stand 26.10.2026)',
  'vit_a': 'Retinylacetat 325.000 IE/g, 150 EUR/kg — freigegeben 26.10.2026',
  'vit_k': 'Vitamin K2 (MK-7) 1,3 %, 300 EUR/kg — freigegeben 26.10.2026',
  'selen': 'Selen-Hefe 0,2 %, 100 EUR/kg — freigegeben 26.10.2026',
  'chrom': 'Chrompicolinat 12 % — freigegeben 26.10.2026'
};

// Knapp: Vorrat da, reicht aber fuer weniger als 8 90-Tage-Kuren.
// Nicht gesperrt — das waere eine Produktentscheidung —, sondern im
// Admin-Panel markiert und beim Laden einmal in der Konsole gemeldet.
var BESTAND_KNAPP_IDS = ['kalium', 'resveratol', 'alpha_liponsaeure', 'kreatin'];

// Nur als Fertigware da: zum Einwiegen muss eine Verkaufspackung
// geoeffnet werden. Fuer die Arbeitsvorbereitung ein Hinweis, kein Stopp.
var NUR_FERTIGWARE_IDS = ['glucomannan', 'guarkernmehl', 'hericium', 'rote_beete', 'cordyceps', 'chaga', 'spermidin', 'irish_moss', 'triphala'];

// Kurztext fuer das Admin-Panel: "23,00 kg Rohware · reicht fuer 639 Kuren".
function bestandText(id){
  var b = BESTAND_SL[id];
  if(!b) return 'kein Bestandsdatensatz';
  if(typeof BESTAND_NACHGEMELDET !== 'undefined' && BESTAND_NACHGEMELDET[id]
     && (b.rw||0) + (b.fw||0) <= 0)
    return BESTAND_NACHGEMELDET[id];
  if((b.rw||0) + (b.fw||0) <= 0)
    return 'kein Bestand' + (b.zu ? ' · Zulauf ' + b.zu.toFixed(0) + ' kg' : '');
  var t = b.rw > 0 ? b.rw.toFixed(2).replace('.', ',') + ' kg Rohware'
                   : 'nur Fertigware ' + b.fw.toFixed(1).replace('.', ',') + ' kg';
  if(b.rw > 0 && b.fw > 0) t += ' + ' + b.fw.toFixed(0) + ' kg Fertigware';
  if(b.ku != null) t += ' · reicht fuer ' + (b.ku > 999 ? '999+ Kuren'
                                           : b.ku + (b.ku === 1 ? ' Kur' : ' Kuren'));
  if(b.zu) t += ' · Zulauf ' + b.zu.toFixed(0) + ' kg';
  return t;
}

// Gegenprobe: Sperrliste und Bestandsdaten muessen dasselbe sagen. Beide
// kommen aus demselben Skript, aber jemand koennte die Liste von Hand
// anfassen und den Bestand vergessen — dann steht es hier in der Konsole
// statt in einer Bestellung, die sich nicht produzieren laesst.
(function pruefeBestand(){
  try{
    var sollGesperrt = [], fehltDatensatz = [];
    for(var id in BESTAND_SL){
      if(!BESTAND_SL.hasOwnProperty(id)) continue;
      var b = BESTAND_SL[id];
      if((b.rw||0) + (b.fw||0) <= 0) sollGesperrt.push(id);
    }
    var zuviel = sollGesperrt.filter(function(id){
      return UNAVAILABLE_IDS.indexOf(id) < 0
          && !(typeof BESTAND_NACHGEMELDET !== 'undefined'
               && BESTAND_NACHGEMELDET.hasOwnProperty(id));
    });
    if(zuviel.length)
      console.warn('[Puraveda] Ohne Bestand, aber im Konfigurator freigegeben: '
        + zuviel.join(', ') + ' — bestand_block.py erneut laufen lassen.');
    if(BESTAND_KNAPP_IDS.length)
      console.warn('[Puraveda] Knappe Bestaende (Stand ' + BESTAND_STAND + '): '
        + BESTAND_KNAPP_IDS.join(', ') + ' — unter 8 Kuren Reichweite.');
  }catch(e){}
})();

var prices={},avails={},disabled={},names={},descs={},claims={};
DB.forEach(function(it){
  prices[it.id]=it.pk;
  avails[it.id]=(UNAVAILABLE_IDS.indexOf(it.id)<0);
  disabled[it.id]=false;
  names[it.id]=it.name;
  descs[it.id]=it.desc||'';
  claims[it.id]=it.claim||'';
});

// ── PERSISTENCE ───────────────────────────────────────────────────────────────
var STORE_KEY='biotiva_admin_v4';
// Stempel der desc-Bereinigung. Gespeicherte Admin-Daten aus der Zeit davor
// enthalten noch die nicht zugelassenen Aussagen ("natürliches Schlafmittel",
// "Adaptogen", "entzündungshemmend" ...). Stimmt der Stempel nicht, werden
// allein die descs aus dem Speicher verworfen; Preise, Verfügbarkeiten und
// Namen bleiben erhalten.
var DESC_VERSION='2026-10-26-claims-bereinigt';
function saveAdmin(){
  var data={prices:prices,avails:avails,names:names,descs:descs,claims:claims,
            descsVersion:DESC_VERSION};
  try{localStorage.setItem(STORE_KEY,JSON.stringify(data));}catch(e){}
}
function loadAdmin(){
  try{
    var raw=localStorage.getItem(STORE_KEY);
    if(!raw)return;
    var data=JSON.parse(raw);
    var _descsOk=(data.descsVersion===DESC_VERSION);
    ['prices','avails','names','descs','claims'].forEach(function(field){
      if(!data[field])return;
      Object.keys(data[field]).forEach(function(k){
        if(field==='prices'&&prices.hasOwnProperty(k))prices[k]=data[field][k];
        else if(field==='avails'&&avails.hasOwnProperty(k))avails[k]=data[field][k];
        else if(field==='names'&&names.hasOwnProperty(k)){
          // Leere/ungültige Namen aus dem Speicher NIE übernehmen — sie würden den
          // echten Zutatennamen zerstören und die Produktion erhielte nur Mengen.
          var _nm = data[field][k];
          if(_nm !== null && _nm !== undefined && String(_nm).trim() !== ''){
            names[k]=String(_nm).trim();
            var it=DB.find(function(x){return x.id===k;});
            if(it)it.name=String(_nm).trim();
          }
        }
        else if(field==='descs'&&_descsOk&&descs.hasOwnProperty(k))descs[k]=data[field][k];
        else if(field==='claims'&&claims.hasOwnProperty(k)){
          // Botanicals/Pflanzenpulver bekommen NIE einen Health Claim,
          // auch nicht aus gespeicherten Admin-Daten (localStorage).
          var _it=DB.find(function(x){return x.id===k;});
          if(_it && (_it.type==='bot'||_it.type==='plant')) claims[k]='';
          else claims[k]=data[field][k];
        }
      });
    });
    // Sicherheit: nach dem Laden alle Botanical/Plant-Claims final leeren
    DB.forEach(function(it){ if(it.type==='bot'||it.type==='plant') claims[it.id]=''; });
  }catch(e){}
}
function clearAdmin(){
  try{localStorage.removeItem(STORE_KEY);}catch(e){} window._activeIds=null;
  DB.forEach(function(it){prices[it.id]=it.pk;avails[it.id]=(UNAVAILABLE_IDS.indexOf(it.id)<0);names[it.id]=it.name;descs[it.id]=it.desc||'';claims[it.id]=it.claim||'';});
  if(adminOpen)renderAdmin();
  showSave();
}
loadAdmin();

// ── HARTE DURCHSETZUNG der Beschaffungs-Sperre ──────────────────────────────
// WICHTIG: loadAdmin() ueberschreibt avails aus dem localStorage. Ein Browser,
// in dem frueher einmal im Admin-Panel gespeichert wurde, wuerde sonst alte
// Verfuegbarkeiten wiederherstellen und gesperrte Zutaten reaktivieren.
// Deshalb gewinnt die Code-Liste IMMER — sie ist die einzige Quelle der
// Wahrheit fuer die Verfuegbarkeit.
UNAVAILABLE_IDS.forEach(function(id){ if(avails.hasOwnProperty(id)) avails[id]=false; });

var S={step:'start',ans:{},sc:{},amt:{},done:false};

var BASE_FEE_PER_ING_MONTH = (function(){
  try{
    var v=localStorage.getItem('pv_base_fee');
    // Standard seit 2026-09-22: 2,80 € je Zutat und Monat. Alte, im Browser
    // gespeicherte Standardwerte (1.6 / 2.4 / 3.0) werden auf den neuen Wert
    // gehoben — sonst sähe ein Admin mit altem Speicherstand andere Preise
    // als die Kunden.
    if(v===null || [1.6, 2.4, 3.0].indexOf(parseFloat(v))>=0) return 2.8;
    return parseFloat(v);
  }catch(e){return 2.8;}
})();
function setBaseFee(v){
  BASE_FEE_PER_ING_MONTH=v;
  try{localStorage.setItem('pv_base_fee',v);}catch(e){}
}

// Kapselaufschlag pro Tag (€) — greift, wenn der Kunde die Morgen-Routine als
// Kapseln wählt. Über die Admin-Funktion einstellbar; Default 0,15 €/Tag.
var CAPSULE_SURCHARGE_PER_DAY = (function(){
  try{ var v=localStorage.getItem('pv_capsule_surcharge'); return v!==null?parseFloat(v):0.15; }catch(e){return 0.15;}
})();
function setCapsuleSurcharge(v){
  CAPSULE_SURCHARGE_PER_DAY=parseFloat(v)||0;
  try{localStorage.setItem('pv_capsule_surcharge',CAPSULE_SURCHARGE_PER_DAY);}catch(e){}
}
// Aufschlag je EINZELNER Kapsel. Der eingestellte Tageswert bezieht sich auf die
// Morgen-Routine mit 3 Kapseln (0,15 € = 3 × 0,05 €). Beide Routinen rechnen mit
// demselben Satz je Kapsel, damit eine Änderung im Admin überall gleich wirkt.
function capsuleSurchargePerCapsule(){
  return CAPSULE_SURCHARGE_PER_DAY / KAPSELN_PRO_TAG;
}

// ── CORE FUNCTIONS ────────────────────────────────────────────────────────────
function pd(it){if(!avails[it.id]||disabled[it.id]||!prices[it.id])return 0;return prices[it.id]*toMg(S.amt[it.id],it.unit)/1e6+(BASE_FEE_PER_ING_MONTH/30);}
function powderMg(it){var nMg=toMg(S.amt[it.id],it.unit);if(!it.std||it.std>=0.999)return nMg;return nMg/it.std;}

// Beispiel für den Erklärsatz auf der Ergebnisseite: die Zutat mit dem größten
// Unterschied zwischen deklarierter Menge und Rohware.
//
// Der Satz beginnt mit „Wir verwenden pflanzliche Rohstoffe" — also darf hier
// NUR stehen, was auch wirklich eine Pflanze ist. Bis 10/2026 gab es einen
// Rückfall auf alle Zutaten mit Gehalt < 100 %, sobald keine der Pflanzen in
// der Rezeptur lag. Dann erschien etwa „1,92 g Kreatin Monohydrat stecken in
// 2,18 g Kreatin-Monohydrat": inhaltlich falsch (ein Mineral- bzw.
// Syntheserohstoff als pflanzlicher Rohstoff ausgegeben) und als Satz sinnlos,
// weil Zutat und Rohstoff denselben Namen tragen.
// Jetzt gilt: nur diese Liste, und wenn keine davon aktiv ist, entfällt der
// Satz ersatzlos.
var QUELLE_BEISPIEL_PFLANZLICH = [
  'vit_c',          // Acerola
  'zink',           // Guavenblatt
  'jod',            // Kelp-Alge
  'vit_b12',        // Chlorella
  'vit_d',          // Flechten-Extrakt
  // 'vit_a' stand hier wegen Beta-Carotin. Seit 26.10.2026 ist die Quelle
  // Retinylacetat — kein Pflanzenauszug, also kein Beispiel fuer pflanzliche
  // Herkunft mehr.
  'glucomannan',    // Konjakwurzel
  'resveratol',     // Riesenknöterich
  'schwarzpfeffer', // Bio Schwarzer Pfefferpulver
  'opc'             // Traubenkernextrakt
];
function quellenBeispiel(items){
  var pool = items.filter(function(it){
    if(QUELLE_BEISPIEL_PFLANZLICH.indexOf(it.id) < 0) return false;
    if(!it.quelle || !it.std || it.std >= 0.999 || !(S.amt[it.id] > 0)) return false;
    // Sicherheitsnetz: ein Satz der Form „X steckt in X" sagt nichts aus.
    var norm = function(s){ return String(s).toLowerCase().replace(/[^a-zäöüß]/g,''); };
    return norm(it.quelle) !== norm(names[it.id] || it.name);
  });
  if(!pool.length) return null;
  pool.sort(function(a,b){ return (powderMg(b)-toMg(S.amt[b.id],b.unit))
                                - (powderMg(a)-toMg(S.amt[a.id],a.unit)); });
  var it = pool[0];
  var dek = toMg(S.amt[it.id], it.unit);
  var roh = powderMg(it);
  var fmt = function(mg){ return mg>=1000 ? fa(mg/1000,'g')+' g' : Math.round(mg)+' mg'; };
  return fmt(dek)+' '+(names[it.id]||it.name)+' stecken in '+fmt(roh)+' '+it.quelle;
}

// Wenn die Abend-Routine nicht vollständig in Kapseln passt, liegt ein kleiner
// Pulverbeutel bei. Statt das nur zu melden, rechnen wir aus, welche einzelne
// Zutat man wie weit zurücknehmen müsste, damit alles in die Kapseln geht.
// Gewählt wird die schwerste Zutat des Abend-Stroms — sie trägt den Überhang
// am ehesten allein, und eine Stellschraube ist verständlicher als fünf.
// Rückgabe: null, wenn kein Beutel nötig ist, sonst {name, ziel, unit, raus}.
// Probe aufs Exempel: Vorschlag einsetzen, neu rechnen, Zustand zuruecksetzen.
// Noetig, weil jede Mengenaenderung die gesamte Verteilung neu aufrollt —
// Gruppe-C-Ausgleich, Zutaten-Cap, Gewichtsgrenze, Morgen-Ueberhang. Ohne
// diese Probe stimmte der Vorschlag bei aufgezogenen Reglern nur in 60 % der
// Faelle, und ein Hinweis, der nicht haelt, ist schlimmer als keiner.
function _tippHaelt(aenderungen){
  var sicher = {}, k;
  for(k in aenderungen){ sicher[k] = S.amt[k]; S.amt[k] = aenderungen[k]; }
  var ok = false;
  try{
    var d2 = getCapsuleDistribution();
    ok = !!(d2.hasEveningCaps && d2.eveningPowder.length === 0);
  }catch(e){ ok = false; }
  for(k in sicher){ S.amt[k] = sicher[k]; }
  return ok;
}

function kapselTippAbend(d){
  if(!d || !d.hasEveningCaps || !d.eveningPowder || !d.eveningPowder.length) return null;
  var budget = KAPSEL_MAX_PRO_TAG_ABEND * KAPSEL_FUELLGEWICHT_MG;
  var roh = function(id){ var x=DB.find(function(y){return y.id===id;}); return x?powderMg(x):0; };
  var gesamt = d.eveningCaps.concat(d.eveningPowder)
                 .reduce(function(a,id){ return a+roh(id); }, 0);
  var ueber = gesamt - budget;

  // Kandidat ist die schwerste Zutat DES BEUTELS, nicht des ganzen Stroms.
  // Der Kunde sieht sie ohnehin als "bleibt zusaetzlich als Pulver dabei";
  // ein Vorschlag zu einer Zutat, die laengst in der Kapsel steckt, waere
  // verwirrend — und bei Magnesium auch fachlich schlecht.
  var kand = d.eveningPowder.slice().sort(function(a,b){ return roh(b)-roh(a); })[0];
  var it = DB.find(function(x){ return x.id===kand; });

  if(it && ueber > 0 && roh(kand) >= ueber){
    var std  = (it.std && it.std < 0.999) ? it.std : 1;
    var step = it.step || 1;
    // Rohware -> Wirkstoff -> deklarierte Einheit. Ohne die letzte Umrechnung
    // stand bei Gramm-Zutaten eine Zahl in Milligramm im Gramm-Feld.
    var zielMg  = (roh(kand) - ueber) * std;
    var zielDek = (it.unit==='g') ? zielMg/1000 : (it.unit==='\u00B5g') ? zielMg*1000 : zielMg;
    var ziel = parseFloat((Math.floor((zielDek + 1e-9) / step) * step).toFixed(6));
    if(ziel >= step && ziel < S.amt[kand]){
      var aend = {}; aend[kand] = ziel;
      if(_tippHaelt(aend))
        return { name: names[kand]||it.name, ziel: ziel, unit: it.unit, raus: false };
    }
  }

  // Zweiter Versuch: den Beutel ganz weglassen.
  var weg = {};
  d.eveningPowder.forEach(function(id){ weg[id] = 0; });
  if(_tippHaelt(weg))
    return { namen: d.eveningPowder.map(function(id){ return names[id]||id; }), raus: true };

  // Beides haelt nicht — dann kein Versprechen, nur der nackte Hinweis.
  return { unsicher: true };
}

// ── PRODUKTIONS-LAUFZEIT (Abo-Modell: 90 Tage / 3 Zahlungen) ────────────────────
var PRODUCTION_DAYS = (function(){
  try{ var v=localStorage.getItem('pv_prod_days'); return v!==null?parseInt(v,10):90; }catch(e){return 90;}
})();
function setProductionDays(v){
  PRODUCTION_DAYS=parseInt(v,10)||90;
  try{localStorage.setItem('pv_prod_days',PRODUCTION_DAYS);}catch(e){}
}

// ── PRODUKTIONS-ENGINE ──────────────────────────────────────────────────────────
// Je aktiver Zutat für die Laufzeit (Default 90 Tage):
//   Wirkstoffmenge = Tagesdosis × Tage          (Kontrollwert, z.B. 0,9 mg B12)
//   Einwaage/Pulver = Wirkstoffmenge ÷ std       (Extrakt-Umrechnung via Spalte M/std)
// Gruppiert nach Morning / Evening (oder 1 Mischung, wenn keine Trennung).
function fmtG(mg){
  if(mg>=1000) return (mg/1000).toFixed(2)+' g';
  return (Math.round(mg*1000)/1000)+' mg';
}
function getProductionData(){
  var days = PRODUCTION_DAYS;
  var res = getAntagonismResults();
  var activeItems = DB.filter(function(it){return avails[it.id]&&!disabled[it.id]&&S.amt[it.id]>0;});
  function lineFor(it){
    var doseMg   = toMg(S.amt[it.id], it.unit);
    var wirkstoffMg = doseMg * days;
    var einwaageMg  = powderMg(it) * days;
    var std = it.std && it.std<0.999 ? it.std : 1;
    return { id:it.id, name:it.name,
      dosePerDay: fa(S.amt[it.id], it.unit)+' '+it.unit+'/Tag',
      wirkstoff: fmtG(wirkstoffMg), einwaage: fmtG(einwaageMg),
      isExtract: std<1, stdPct: Math.round(std*10000)/100 };
  }
  function fmtGroup(ids){
    return ids.map(function(id){
      var it=DB.find(function(x){return x.id===id;});
      if(!it) return null;
      var l=lineFor(it);
      var s = l.name+': '+l.dosePerDay+' → Wirkstoff '+l.wirkstoff+' → Einwaage '+l.einwaage;
      if(l.isExtract) s += ' (Extrakt '+l.stdPct+'%)';
      return s;
    }).filter(Boolean);
  }
  if(res.split){
    return { split:true, days:days, morning:fmtGroup(res.morning), evening:fmtGroup(res.evening) };
  }
  return { split:false, days:days, single:fmtGroup(activeItems.map(function(it){return it.id;})) };
}
function powderG(it){return powderMg(it)/1000;}
function nrvP(it){
  if(!it.nrv) return null;
  var amt = S.amt[it.id];

  if(it.ref_nutrients && it.ref_nutrients.length>0){
    var primaryStd = it.ref_nutrients[0].std || it.std || 1;
    var nutrientAmt = amt * primaryStd;
  
    var refNut = NUTRIENTS.find(function(n){return n.id===it.ref_nutrients[0].id;});
    var refNrv = refNut ? refNut.nrv : it.nrv;
    return refNrv ? (nutrientAmt / refNrv) * 100 : null;
  }
  return (amt / it.nrv) * 100;
}

// Apply interaction factors to computed scores (Punkt 5: Wechselwirkungen im Scoring)
function applyInteractions(sc){
  var activeIds=Object.keys(sc).filter(function(k){return (sc[k]||0)>0&&avails[k]&&!disabled[k];});
  INTERACTIONS.forEach(function(intr){
    var relevant=intr.ids.filter(function(id){return activeIds.indexOf(id)>=0;});
    if(relevant.length<intr.ids.length)return; // not all active
    if(intr.type==='syn'){
      intr.ids.forEach(function(id){
        if(sc[id]!==undefined)sc[id]=Math.min(sc[id]*intr.factor,10);
      });
    } else if(intr.type==='ant'&&intr.affectedId){
      if(sc[intr.affectedId]!==undefined)sc[intr.affectedId]*=intr.factor;
    }
  });
  return sc;
}

// ── Standort × Jahreszeit → Vitamin-D-Verfügbarkeit ─────────────────────────
// Wissenschaftlicher Kern: Die körpereigene Vitamin-D-Bildung hängt an der
// vitamin-D-wirksamen UV-B-Strahlung. Deren Verfügbarkeit ergibt sich aus dem
// Sonnenstand (Breitengrad + Kalendertag) – NICHT aus Sonnenstunden oder Regen.
// Unterhalb ~30° Mittagshöhe findet praktisch keine Synthese statt
// ("Vitamin-D-Winter", in DE Okt–März). Quelle: BfS, MDPI 2016.
//
// PLZ (erste zwei Ziffern = Leitregion) → Breitengrad + Kurzlabel.
// Latituden sind Regions-Näherungen (±~0.4°) – für das UV-B-Modell mehr als
// ausreichend, da das Ergebnis ohnehin in 4 Stufen ausgewiesen wird.
var PLZ_INFO = {
 '01':[51.05,'Dresden'],'02':[51.18,'Oberlausitz'],'03':[51.76,'Cottbus'],'04':[51.34,'Leipzig'],'06':[51.48,'Halle'],'07':[50.88,'Gera/Jena'],'08':[50.50,'Zwickau/Vogtland'],'09':[50.83,'Chemnitz'],
 '10':[52.52,'Berlin'],'11':[52.52,'Berlin'],'12':[52.45,'Berlin'],'13':[52.57,'Berlin'],'14':[52.40,'Potsdam'],'15':[52.34,'Frankfurt (Oder)'],'16':[52.83,'Nordbrandenburg'],'17':[53.56,'Vorpommern'],'18':[54.09,'Rostock'],'19':[53.63,'Schwerin'],
 '20':[53.55,'Hamburg'],'21':[53.46,'Hamburg-Süd/Harburg'],'22':[53.60,'Hamburg'],'23':[53.87,'Lübeck'],'24':[54.32,'Kiel'],'25':[54.30,'Westküste/Sylt'],'26':[53.30,'Ostfriesland/Oldenburg'],'27':[53.40,'Bremerhaven'],'28':[53.08,'Bremen'],'29':[53.00,'Lüneburg/Celle'],
 '30':[52.37,'Hannover'],'31':[52.15,'Hildesheim'],'32':[52.19,'Herford/Minden'],'33':[51.72,'Bielefeld/Paderborn'],'34':[51.31,'Kassel'],'35':[50.80,'Gießen/Marburg'],'36':[50.55,'Fulda'],'37':[51.53,'Göttingen'],'38':[52.27,'Braunschweig'],'39':[52.12,'Magdeburg'],
 '40':[51.23,'Düsseldorf'],'41':[51.19,'Mönchengladbach'],'42':[51.26,'Wuppertal'],'44':[51.51,'Dortmund'],'45':[51.46,'Essen'],'46':[51.50,'Oberhausen/Bocholt'],'47':[51.34,'Duisburg/Krefeld'],'48':[51.96,'Münster'],'49':[52.28,'Osnabrück'],
 '50':[50.94,'Köln'],'51':[50.99,'Köln/Leverkusen'],'52':[50.78,'Aachen'],'53':[50.73,'Bonn'],'54':[49.75,'Trier'],'55':[50.00,'Mainz'],'56':[50.36,'Koblenz'],'57':[50.87,'Siegen'],'58':[51.36,'Hagen'],'59':[51.60,'Hamm/Soest'],
 '60':[50.11,'Frankfurt a.M.'],'61':[50.30,'Bad Homburg'],'63':[50.05,'Offenbach/Aschaffenburg'],'64':[49.87,'Darmstadt'],'65':[50.08,'Wiesbaden'],'66':[49.24,'Saarbrücken'],'67':[49.44,'Kaiserslautern/Ludwigshafen'],'68':[49.48,'Mannheim'],'69':[49.40,'Heidelberg'],
 '70':[48.78,'Stuttgart'],'71':[48.83,'Stuttgart-Umland'],'72':[48.50,'Tübingen/Reutlingen'],'73':[48.70,'Esslingen/Göppingen'],'74':[49.14,'Heilbronn'],'75':[48.89,'Pforzheim'],'76':[49.00,'Karlsruhe'],'77':[48.47,'Offenburg'],'78':[47.90,'Konstanz/Schwarzwald-Baar'],'79':[47.99,'Freiburg'],
 '80':[48.14,'München'],'81':[48.11,'München'],'82':[47.75,'Starnberg/Garmisch'],'83':[47.75,'Rosenheim/Berchtesgaden'],'84':[48.54,'Landshut'],'85':[48.42,'Ingolstadt/Freising'],'86':[48.37,'Augsburg'],'87':[47.73,'Kempten/Allgäu'],'88':[47.78,'Ravensburg/Bodensee'],'89':[48.40,'Ulm'],
 '90':[49.45,'Nürnberg'],'91':[49.45,'Erlangen/Fürth'],'92':[49.45,'Amberg/Weiden'],'93':[49.01,'Regensburg'],'94':[48.57,'Passau/Deggendorf'],'95':[50.00,'Bayreuth/Hof'],'96':[49.90,'Bamberg/Coburg'],'97':[49.79,'Würzburg'],'98':[50.60,'Südthüringen'],'99':[50.98,'Erfurt']
};
// Ausland / typische Reise- & Überwinterungsziele → grober Landes-Breitengrad.
// Für sonnige Südziele bedeutet die niedrige Breite: volle Vitamin-D-Bildung,
// also KEIN erhöhter Bedarf (im Gegensatz zum Standort Deutschland im Winter).
var COUNTRY_LAT = {
 'deutschland':51.2,'österreich':47.6,'osterreich':47.6,'schweiz':46.9,
 'niederlande':52.1,'holland':52.1,'belgien':50.8,'luxemburg':49.8,
 'frankreich':46.6,'südfrankreich':43.6,'suedfrankreich':43.6,'paris':48.9,'nizza':43.7,
 'spanien':40.2,'mallorca':39.6,'barcelona':41.4,'madrid':40.4,'kanaren':28.3,'teneriffa':28.3,'gran canaria':27.9,'grancanaria':27.9,'fuerteventura':28.4,
 'portugal':39.5,'lissabon':38.7,'madeira':32.7,'algarve':37.1,
 'italien':42.5,'rom':41.9,'sizilien':37.5,'sardinien':40.1,'südtirol':46.5,'suedtirol':46.5,'gardasee':45.6,
 'griechenland':38.5,'kreta':35.2,'rhodos':36.4,'zypern':35.0,'malta':35.9,
 'türkei':39.0,'tuerkei':39.0,'antalya':36.9,'istanbul':41.0,
 'kroatien':45.1,'slowenien':46.1,'polen':52.0,'tschechien':49.8,'ungarn':47.2,
 'dänemark':56.0,'daenemark':56.0,'schweden':60.1,'norwegen':60.5,'finnland':62.0,'island':64.1,
 'großbritannien':53.0,'grossbritannien':53.0,'england':52.4,'london':51.5,'irland':53.3,
 'marokko':31.8,'ägypten':26.0,'aegypten':26.0,'tunesien':34.0,'kapverden':16.0,'kap verden':16.0,'kapstadt':-33.9,
 'vae':24.5,'dubai':25.2,'thailand':14.0,'bangkok':13.7,'bali':-8.4,'indonesien':-2.0,'vietnam':16.0,'philippinen':13.0,'sri lanka':7.5,'srilanka':7.5,'indien':21.0,'malediven':3.2,
 'usa':38.0,'florida':27.8,'miami':25.8,'kalifornien':36.5,'new york':40.7,'mexiko':19.4,'kanada':56.0,'brasilien':-10.0,
 'australien':-25.0,'neuseeland':-41.0,'südafrika':-30.0,'suedafrika':-30.0,'dominikanische republik':18.7,'kuba':21.5,
 'münchen':48.14,'muenchen':48.14,'berlin':52.52,'hamburg':53.55,'köln':50.94,'koeln':50.94,'frankfurt':50.11,'stuttgart':48.78,'düsseldorf':51.23,'duesseldorf':51.23,'leipzig':51.34,'dresden':51.05,'hannover':52.37,'nürnberg':49.45,'nuernberg':49.45,'bremen':53.08,'freiburg':47.99,'kiel':54.32,'dortmund':51.51,'essen':51.46,'münster':51.96,'muenster':51.96,'mainz':50.0,'wiesbaden':50.08,'saarbrücken':49.24,'saarbruecken':49.24,'rostock':54.09,'flensburg':54.78,'garmisch':47.49
};
function normLoc(s){ return (s||'').toString().trim().toLowerCase().replace(/\s+/g,' '); }
// Einheitlicher Standort-Resolver: erkennt deutsche PLZ (mit Ziffer beginnend)
// ODER einen Land-/Ortsnamen. Gibt {lat,label,isPlz,plz} oder null zurück.
function resolveLoc(val){
  var raw=(val||'').toString().trim();
  if(!raw) return null;
  if(/^\d/.test(raw)){
    var k=raw.replace(/\D/g,'').slice(0,2);
    if(k.length===2 && PLZ_INFO[k]) return {lat:PLZ_INFO[k][0], label:PLZ_INFO[k][1], isPlz:true, plz:raw.replace(/\D/g,'').slice(0,5)};
    return null;
  }
  var n=normLoc(raw);
  if(COUNTRY_LAT[n]!==undefined){
    var lbl=raw.charAt(0).toUpperCase()+raw.slice(1);
    return {lat:COUNTRY_LAT[n], label:lbl, isPlz:false};
  }
  return null;
}
function plzToLat(v){ var r=resolveLoc(v); return r?r.lat:null; }
function plzRegion(v){ var r=resolveLoc(v); return r?r.label:''; }
// Anzeige-Text: bei PLZ "Region (PLZ 80331)", bei Land nur der Name.
function locDisplay(v){ var r=resolveLoc(v); if(!r) return ''; return r.isPlz?(r.label+' (PLZ '+r.plz+')'):r.label; }

// Mittags-Sonnenhöhe (Grad) für Breite + Datum. α = 90 − |φ − δ|.
function noonElev(lat, date){
  var start=new Date(date.getFullYear(),0,0);
  var N=Math.floor((date-start)/86400000);
  var decl=23.45*Math.sin(2*Math.PI*(284+N)/365);
  return 90-Math.abs(lat-decl);
}
// Sonnenhöhe → relative vitamin-D-wirksame UV-B (0..1). Schwellen aus der
// Literatur (Synthese bricht unter ~30° Mittagshöhe zusammen).
function elevToUv(elev){
  if(elev>=50) return 1.0;
  if(elev>=45) return 0.7;
  if(elev>=40) return 0.4;
  if(elev>=30) return 0.15;
  return 0;
}
// Mittelt die UV-B-Verfügbarkeit über die NÄCHSTEN 90 TAGE ab heute. Nutzt die
// echte Systemzeit → das Fenster rollt automatisch mit dem Datum mit.
function deriveUv(){
  var lat=plzToLat(S.ans.plz);
  if(lat===null){ S.ans.uvAvail=null; S.ans._uvTier=null; S.ans._uvLat=null; return; }
  var today=new Date(), sum=0, n=0;
  for(var d=0; d<90; d+=3){
    sum+=elevToUv(noonElev(lat, new Date(today.getTime()+d*86400000))); n++;
  }
  var f=sum/n;
  S.ans.uvAvail=f; S.ans._uvLat=lat;
  S.ans._uvTier = f>=0.66?'voll' : f>=0.33?'reduziert' : f>=0.10?'minimal' : 'keine';
}

// Leitet die BMI-Kategorie aus Gewicht (kg) und Größe (cm) ab und legt sie
// unter S.ans.bmi ab. Dadurch funktioniert die komplette bestehende
// BMI-Scoring-Logik (Chrom, Glucomannan, Guarkernmehl, Vitamin D,
// Gewichtsmanagement) unverändert weiter, obwohl der Nutzer jetzt konkrete
// Zahlen statt einer Selbsteinschätzung eingibt.
function deriveBmi(){
  var w=parseFloat(S.ans.gewicht), h=parseFloat(S.ans.groesse);
  if(!w||!h) return;
  var bmi=w/((h/100)*(h/100));
  S.ans.bmi = bmi<18.5?'Untergewicht' : bmi<25?'Normal' : bmi<30?'Übergewicht' : 'Adipositas';
  S.ans._bmiVal = Math.round(bmi*10)/10;
}

function calcSc(){
  deriveBmi();
  deriveUv();
  var sc={};
  Object.keys(SE).forEach(function(k){
    try{
      // Harter Ausschluss bei Schwangerschaft/Stillzeit (greift für ALLE Score-
      // Varianten, unabhängig vom Aufbau der einzelnen SE-Funktion).
      if(isPregLactExcluded(k, S.ans)){ sc[k]=0; return; }
      sc[k]=Math.min(SE[k](S.ans)||0,10);
    }catch(e){sc[k]=0;}
  });
  applyWeightGoal(sc);
  return applyInteractions(sc);
}

// ── Ziel "Gewichtsmanagement" × BMI-Frage ────────────────────────────────────
// Untergewicht  → aufbauende, nährstoffdichte Zutaten stärken; sättigende
//                 Ballaststoffe (Glucomannan, Guarkernmehl) ausschließen.
// Übergewicht / Adipositas → gewichtsreduzierende Zutaten stärken
//                 (Glucomannan mit EU-Claim, Guarkernmehl, Matcha, Chrom).
// Normalgewicht → Stabilisierung: nur milde Unterstützung des Stoffwechsels.
function applyWeightGoal(sc){
  if(!hasGoal(S.ans,'Gewicht'))return;
  var b=(S.ans.bmi||'').toString().toLowerCase();
  function add(id,v){ if(sc[id]!==undefined) sc[id]=Math.min(Math.max(sc[id]+v,0),10); }
  if(b.indexOf('untergewicht')>=0){
    // Gewichtsaufbau
    add('maca',2.5); add('lucuma',2.0); add('spirulina',2.0);
    add('chlorella',1.5); add('ashwagandha',1.5); add('gerstengras',1.0);
    // Sättigende / gewichtsreduzierende Ballaststoffe raus
    sc['glucomannan']=0; sc['guarkernmehl']=0;
  } else if(b.indexOf('adipositas')>=0){
    add('glucomannan',3.5); add('guarkernmehl',2.0); add('matcha',1.5); add('chrom',1.5);
  } else if(b.indexOf('bergewicht')>=0){ // Übergewicht
    add('glucomannan',2.5); add('guarkernmehl',1.5); add('matcha',1.2); add('chrom',1.2);
  } else if(b.indexOf('normal')>=0){
    // Stabilisierung: milde Stoffwechsel-Unterstützung, keine Auf-/Abbau-Pusher
    add('chrom',0.8); add('matcha',0.5);
  }
}

function initAmt(sc){

  var mandatoryIds={};

  MANDATORY_INGREDIENTS.forEach(function(ev){
    var val=S.ans[ev.signal];
    if(val===undefined)return;
    var vs=typeof val==='string'?val.toLowerCase():val;
    var match=false;
    if(ev.condition==='vegan'       && vs.indexOf('vegan')>=0)      match=true;
    if(ev.condition==='vegetarisch' && vs.indexOf('vegetarisch')>=0) match=true;
    if(ev.condition==='schwanger'   && vs.indexOf('schwanger')>=0)  match=true;
    if(ev.condition==='adipositas'  && vs.indexOf('adipositas')>=0) match=true;
    if(match) mandatoryIds[ev.ingredient]=true;
  });

  DB.forEach(function(it){
    (it.mandatory_conditions||[]).forEach(function(mc){
      var val=S.ans[mc.signal];
      if(val===undefined)return;
      var vs=typeof val==='string'?val.toLowerCase():val;
      var match=false;
      if(mc.condition==='vegan'       && vs.indexOf('vegan')>=0)       match=true;
      if(mc.condition==='vegetarisch' && vs.indexOf('vegetarisch')>=0) match=true;
      if(mc.condition==='weiblich'    && vs==='weiblich')               match=true;
      if(mc.condition==='schwanger'   && vs.indexOf('schwanger')>=0)   match=true;
      if(match) mandatoryIds[it.id]=true;
    });
  });

  DB.forEach(function(it){
    if(!avails[it.id]||disabled[it.id]){S.amt[it.id]=0;return;}
    var score=sc[it.id]||0;
    var isMandatory=!!mandatoryIds[it.id];
    if(score<=0&&!isMandatory){S.amt[it.id]=0;return;}
    var scoreFactor=0.4+0.6*(Math.min(score,10)/10);
    var raw=parseFloat((it.dose*scoreFactor).toFixed(6));
  
    var effectiveSoftMax=it.softMax;
    if(it.ref_nutrients&&it.ref_nutrients.length>0){
      var pStd=it.ref_nutrients[0].std||it.std||1;
      var refN=NUTRIENTS.find(function(n){return n.id===it.ref_nutrients[0].id;});
      if(refN&&refN.nrv){
      
        effectiveSoftMax=refN.nrv/pStd;
      }
      if(refN&&refN.softMax){
      
        var hardMax=refN.softMax/pStd;
        effectiveSoftMax=effectiveSoftMax?Math.min(effectiveSoftMax,hardMax):hardMax;
      }
    }
    if(effectiveSoftMax!==null&&effectiveSoftMax!==undefined){raw=Math.min(raw,effectiveSoftMax);}
    raw=Math.max(raw,it.step);
    if(isMandatory){raw=Math.max(raw,it.nrv||it.step);}
    S.amt[it.id]=raw;
  });
  // Glucomannan: EU-Claim (Gewichtsverlust) gilt erst ab 3 g/Tag in 3 Portionen —
  // wird die Zutat automatisch aufgenommen, starten wir claim-konform bei 3 g.
  if(S.amt['glucomannan']>0){ S.amt['glucomannan']=Math.max(S.amt['glucomannan'],3); }
  // Neue Rezeptur: ein alter Feinschliff gehoert nicht mehr dazu.
  S.feinschliffDelta = null; S.feinschliff = null;
  feinschliffKapseln();
  // Booster zuletzt: ihre Dosis ist fest und ueberschreibt die Skalierung.
  boosterDosisAnwenden();
}

// Check if amount exceeds BfR/EFSA guidance
function checkLimit(it){
  var amt=S.amt[it.id];

  if(it.maxSafe!==null&&it.maxSafe!==undefined&&amt>it.maxSafe){return{blocked:true,max:it.maxSafe,unit:it.unit};}

  if(it.softMax!==null&&it.softMax!==undefined&&amt>it.softMax*0.9){return{warn:true,max:it.softMax,unit:it.unit};}
  return null;
}

// ── ACTIONS ───────────────────────────────────────────────────────────────────
function adj(id,d){
  if(!avails[id]||disabled[id])return;
  var it=DB.find(function(x){return x.id===id;});
  // Booster kennen keine Zwischenschritte: ihre Dosis ist fest (Claim und
  // Dosierloeffel haengen daran). Der Regler schaltet sie nur ein oder aus.
  if(isBooster(id)){
    var _fd=boosterFestDosis(id);
    S.amt[id] = (d<0) ? 0 : (_fd!==null ? _fd : S.amt[id]);
    render(); return;
  }
  var nv=Math.max(it.step,parseFloat((S.amt[id]+d*it.step).toFixed(6)));

  var hardMax=it.maxSafe;
  if(!hardMax&&it.ref_nutrients&&it.ref_nutrients.length>0){
    var rn=NUTRIENTS.find(function(n){return n.id===it.ref_nutrients[0].id;});
    if(rn&&rn.maxSafe){
      var pStd2=it.ref_nutrients[0].std||it.std||1;
      hardMax=rn.maxSafe/pStd2;
    }
  }
  // Kein EFSA-UL? Dann BfR-Höchstmenge (softMax) als harter Stopper für Nährstoffe
  if((hardMax===null||hardMax===undefined)&&!(it.ref_nutrients&&it.ref_nutrients.length>0)&&it.softMax!==null&&it.softMax!==undefined){
    hardMax=it.softMax;
  }
  if(hardMax!==null&&hardMax!==undefined){nv=Math.min(nv,hardMax);}
  S.amt[id]=nv;
  render();
}
function toggleDisable(id){
  disabled[id]=!disabled[id];
  if(disabled[id]){S.amt[id]=0;}
  else{
    // Booster zuerst: ihre Dosis ist fest und wird nicht ueber den Score
    // skaliert. Sonst kam Kreatin nach aus/an mit 2,19 g zurueck — unter
    // claimMin von 3 g, der Claim waere still verloren gewesen.
    var _fdTog = isBooster(id) ? boosterFestDosis(id) : null;
    if(_fdTog !== null){ S.amt[id]=_fdTog; }
    else{var it=DB.find(function(x){return x.id===id;});var sc=Math.min(S.sc[it.id]||0,10);var raw=Math.max(parseFloat((it.dose*(0.4+0.6*(sc/10))).toFixed(6)),it.step);if(it.softMax)raw=Math.min(raw,it.softMax);S.amt[id]=raw;}
  }
  render();
}
// Eine inaktive Zutat der Rezeptur hinzufügen (aus dem "+ Zutat hinzufügen"-Bereich).
// Setzt die empfohlene Startdosis, begrenzt durch softMax/maxSafe.
function addIngredient(id){
  var it = DB.find(function(x){ return x.id===id; });
  if(!it) return;
  disabled[id] = false;
  // Booster: feste Dosis statt Startdosis-Rechnung — wie in adj(). Ohne das
  // bekam Guarkernmehl hier seine base_dose von 1 g statt der Claim-Dosis von
  // 10 g: der Cholesterin-Claim waere weg und der 10-g-Dosierloeffel falsch,
  // der Beutel haette 30 g statt 300 g enthalten.
  var _fdAdd = isBooster(id) ? boosterFestDosis(id) : null;
  if(_fdAdd !== null){
    S.amt[id] = _fdAdd;
    render();
    toast(((names[id]||it.name)) + ' hinzugefügt');
    return;
  }
  var raw = it.base_dose || it.nrv || it.dose || it.step || 0;
  if(it.softMax!==null && it.softMax!==undefined) raw = Math.min(raw, it.softMax);
  if(it.maxSafe!==null && it.maxSafe!==undefined) raw = Math.min(raw, it.maxSafe);
  raw = Math.max(raw, it.step||0);
  S.amt[id] = parseFloat(raw.toFixed(6));
  render();
  toast(((names[id]||it.name)) + ' hinzugefügt');
}
function pick(qid,val){S.ans[qid]=val;render();}
function commitRangeDefault(){
  // Slider-Frage ohne Interaktion: sichtbaren Default-Wert als Antwort übernehmen
  if(typeof S.step==='number'&&QUIZ[S.step]&&QUIZ[S.step].type==='range'&&S.ans[QUIZ[S.step].id]===undefined){
    S.ans[QUIZ[S.step].id]=QUIZ[S.step].val;
  }
}
function toggle(val,qid){
  var key=qid||'goals';
  if(!S.ans[key])S.ans[key]=[];
  var i=S.ans[key].indexOf(val);
  if(i>-1){S.ans[key].splice(i,1);}
  else{
    if(val.indexOf('Keine')>=0){S.ans[key]=[];}
    else{S.ans[key]=S.ans[key].filter(function(v){return v.indexOf('Keine')<0;});}
    S.ans[key].push(val);
  }
  render();
}
function onPlzInput(el){
  S.ans.plz=el.value;
  var p=document.getElementById('plz-preview'); if(!p) return;
  var r=resolveLoc(el.value);
  if(!r){ p.style.display='none'; S.ans.uvAvail=null; S.ans._uvTier=null; return; }
  deriveUv();
  var t={voll:'volle Vitamin-D-Bildung durch Sonne',reduziert:'reduzierte Vitamin-D-Bildung \u2013 etwas mehr Vitamin D sinnvoll',minimal:'kaum Vitamin-D-Bildung \u2013 erh\u00f6hter Vitamin-D-Bedarf',keine:'Vitamin-D-Winter \u2013 k\u00f6rpereigene Bildung praktisch bei Null'}[S.ans._uvTier]||'';
  p.style.display='block';
  p.innerHTML='\uD83D\uDCCD '+r.label+' \u00b7 in den n\u00e4chsten 3 Monaten: '+t;
}
function rng(qid,v){
  // Nur Wert + Anzeige aktualisieren – KEIN render()!
  // Ein volles Re-Render zerstört das Slider-Element mitten in der
  // Zieh-Geste, wodurch der Slider pro Geste nur einen Schritt weit kommt.
  S.ans[qid]=+v;
  var nb=document.getElementById('b-next-btn');
  if(nb)nb.disabled=false;
  var d=document.getElementById('qsv-'+qid);
  if(d){
    var u=d.getAttribute('data-unit')||'';
    d.innerHTML=v+' <small>'+u+'</small>';
  }
}
function next(){
  commitRangeDefault();
  if(S.step===QUIZ.length-1){
    S.sc=calcSc();initAmt(S.sc);
  
    var app=document.getElementById('b-app');
    if(app) app.innerHTML=renderLoader();
    window.scrollTo({top:0,behavior:'smooth'});
    setTimeout(function(){
      S.step='r';
      saveStateForReturn();
      render();
      window.scrollTo({top:0,behavior:'smooth'});
    },5000);
  } else {
    S.step++;
    render();
    window.scrollTo({top:0,behavior:'smooth'});
  }
}
function back(){if(S.step===0){S.step='start';render();}else if(S.step>0&&S.step!=='r'){S.step--;render();}}
function editRecipe(){
  // "Eingaben ändern" je nach Eingabeweg sinnvoll zurückführen.
  if(S.mode==='bluttest'){ S.step='blood-upload'; render(); bloodLoadLibs(); return; }
  if(S.mode==='expert'){ S.step='start'; render(); return; }
  // Quiz-Modus: zurück zur letzten Quiz-Frage (Ziele), Antworten bleiben erhalten.
  if(QUIZ && QUIZ.length){ S.step=QUIZ.length-1; } else { S.step='start'; }
  render();
}
function restart(){S.step='start';S.ans={};S.sc={};S.amt={};S.mode=null;S.done=false;agbAccepted=false;sgbAccepted=false;render();}

// ── EXPERTEN-MODUS ──────────────────────────────────────────────────────────────
// Direkteinstieg in die Rezepturseite: alle verfügbaren Zutaten an, auf
// Standard-Basisdosis (it.dose). Keine Quiz-Scores, keine Empfehlungslogik.
// Alle Schutzschranken (Slider-Max, Antagonismen/Morning-Evening, maxSafe-Warnung)
// gelten unverändert, da sie auf der Rezepturseite leben.
// Zutaten, die im Experten-Modus NICHT vorausgewählt sind.
// Sie erscheinen im "+ Zutat hinzufügen"-Bereich und sind mit einem Klick zuwählbar.
// Grund: Alle 53 Zutaten gleichzeitig ergeben ~172 €/Monat und überschreiten den
// Höchstpreis der Shopify-Varianten (156 €) — der Kauf wäre von vornherein blockiert.
// Basis = Vitamine/Mineralstoffe; Botanicals, Pflanzenpulver und teure Spezialstoffe
// sind gezielte Ergänzungen, keine Standardausstattung.
var EXPERT_OFF_BY_DEFAULT = ['Q10','Kollagen','resveratol','glucomannan','kreatin','msm','glycin'];

function startExpert(){
  S.ans = S.ans || {};
  S.mode = 'expert';
  S.sc = {};
  S.amt = {};
  DB.forEach(function(it){
    S.sc[it.id] = 0;
    if(!avails[it.id] || disabled[it.id]){ S.amt[it.id]=0; return; }
    // Botanicals, Pflanzenpulver und teure Spezialstoffe starten NICHT in der Rezeptur.
    // Der Kunde fügt sie über "+ Zutat hinzufügen" gezielt hinzu.
    if(it.type==='bot' || it.type==='plant' || EXPERT_OFF_BY_DEFAULT.indexOf(it.id)>=0){
      S.amt[it.id] = 0;
      return;
    }
    // Booster mit eigenem Behaelter (mischbar:false) kosten Beutel, Loeffel und
    // Etikett. Die darf der Expertenmodus nicht ungefragt einschalten. Die Regel
    // steht hier statt in EXPERT_OFF_BY_DEFAULT, damit kuenftige Booster
    // automatisch erfasst sind. Gefunden am 27.10.2026: Guarkernmehl startete
    // so mit 1 g statt 10 g und damit unter seiner Claim-Untergrenze.
    if(BOOSTER_AKTIV && BOOSTER[it.id] && BOOSTER[it.id].mischbar === false){
      S.amt[it.id] = 0;
      return;
    }
    // Voreinstellung = empfohlene Tagesdosis je Zutat:
    // base_dose (Spezial-Nutrients) → nrv (Standard-Vitamine/Mineralien) → dose (Botanicals)
    var raw = it.base_dose || it.nrv || it.dose || it.step || 0;
    if(it.softMax!==null && it.softMax!==undefined) raw = Math.min(raw, it.softMax);
    if(it.maxSafe!==null && it.maxSafe!==undefined) raw = Math.min(raw, it.maxSafe);
    raw = Math.max(raw, it.step||0);
    S.amt[it.id] = parseFloat(raw.toFixed(6));
  });
  // Booster zuletzt: ihre Dosis ist fest und ueberschreibt die Empfehlung.
  if(typeof boosterDosisAnwenden==='function') boosterDosisAnwenden();
  S.step = 'r';
  S.done = false;
  render();
}

// ── BLUTTEST-MODUL ──────────────────────────────────────────────────────────────
// Eingabeweg 3: User lädt Laborergebnis (PDF/Excel/CSV) hoch. Datei wird AUSSCHLIESSLICH
// im Browser geparst (PDF.js / SheetJS), keine Übertragung an einen Server (DSGVO).
var LAB_MAP = [
  // exclude: 1,25-OH (Calcitriol) ist ein ANDERER Marker. Ueber den breiten
  // Schluessel 'vitamin d' traf er bisher diesen Parameter. 29.10.2026.
  {param:'Vitamin D (25-OH)',keys:['25-oh','25(oh)d','vitamin d','vit d','calcidiol','25-hydroxy'],
   exclude:['1,25','1.25','calcitriol','dihydroxy'],
   ingId:'vit_d',unit:'ng/ml',altUnits:{'nmol/l':0.4},low:20,opt:40,optHigh:60},
  {param:'Ferritin',keys:['ferritin'],ingId:'eisen',unit:'ng/ml',altUnits:{'µg/l':1,'ug/l':1,'mcg/l':1},low:30,opt:50,optHigh:150},
  // Holo-TC ist NICHT Gesamt-B12. Bis 29.10.2026 lag es in denselben keys und
  // wurde mit dem Faktor 1,355 (pmol/l -> pg/ml, gilt nur fuer Gesamt-B12)
  // umgerechnet: 58 pmol/l wurden so zu 78,6 'pg/ml' und galten als schwerer
  // Mangel, obwohl >50 pmol/l unauffaellig ist.
  // vorrang: bei mehreren Markern fuer dieselbe Zutat gewinnt der hoechste.
  // Holo-TC schlaegt Gesamt-B12, weil es den aktiven Anteil misst.
  {param:'Vitamin B12 (gesamt)',keys:['b12','cobalamin'],exclude:['holo'],
   ingId:'vit_b12',unit:'pg/ml',altUnits:{'pmol/l':1.355},low:200,opt:400,optHigh:700,vorrang:1},
  // Grenzen nach Labor Dr. Fenner: <35 Mangel, 35-50 Graubereich, >50 unauffaellig.
  {param:'Vitamin B12 aktiv (Holo-TC)',keys:['holo-tc','holotc','holo tc','holotranscobalamin','aktives vitamin b12'],
   ingId:'vit_b12',unit:'pmol/l',altUnits:{},low:35,opt:50,optHigh:70,vorrang:2},
  {param:'Folat',keys:['folat','folsäure','folsaeure','folate','folic'],ingId:'folat',unit:'ng/ml',altUnits:{'nmol/l':0.441},low:4,opt:8,optHigh:20},
  // µg/ml fehlte: 0,74 µg/ml sind 74 µg/dl. Ohne die Umrechnung fiel der Wert
  // still heraus — oder waere als 0,74 µg/dl ein extremer Mangel gewesen.
  {param:'Zink',keys:['zink','zinc'],ingId:'zink',unit:'µg/dl',
   altUnits:{'µmol/l':6.538,'umol/l':6.538,'µg/ml':100,'ug/ml':100,'mcg/ml':100},
   low:70,opt:90,optHigh:120},
  {param:'Magnesium',keys:['magnesium'],ingId:'magnesium',unit:'mg/dl',altUnits:{'mmol/l':2.431},low:1.8,opt:2.0,optHigh:2.4},
  {param:'Selen',keys:['selen','selenium'],ingId:'selen',unit:'µg/l',altUnits:{'µmol/l':78.96,'umol/l':78.96},low:80,opt:100,optHigh:140},
  {param:'Kupfer',keys:['kupfer','copper'],ingId:'kupfer',unit:'µg/dl',altUnits:{'µmol/l':6.356,'umol/l':6.356},low:70,opt:90,optHigh:130},
  {param:'Vitamin C',keys:['vitamin c','vit c','ascorbinsäure','ascorbat','ascorbic'],ingId:'vit_c',unit:'mg/l',altUnits:{'µmol/l':0.176,'umol/l':0.176},low:4,opt:8,optHigh:15},
  {param:'Vitamin A',keys:['vitamin a','retinol'],ingId:'vit_a',unit:'µg/dl',altUnits:{'µmol/l':28.65,'umol/l':28.65},low:30,opt:50,optHigh:80},
  {param:'Vitamin E',keys:['vitamin e','tocopherol'],ingId:'vit_e',unit:'mg/l',altUnits:{'µmol/l':0.431,'umol/l':0.431},low:5,opt:10,optHigh:20},
  {param:'Vitamin B6',keys:['vitamin b6','pyridoxal','pyridoxin'],ingId:'vit_b6',unit:'µg/l',altUnits:{'nmol/l':0.247},low:5,opt:10,optHigh:30}
];
var bloodDetected = [];

function bloodErr(msg){ var e=document.getElementById('blood-err'); if(e)e.innerHTML='<div style="background:#fdecea;color:#c0392b;border-radius:10px;padding:12px 16px;font-size:13px;margin-top:14px">'+msg+'</div>'; }
function bloodHandleFile(file){
  var e=document.getElementById('blood-err'); if(e)e.innerHTML='';
  var ext=(file.name.split('.').pop()||'').toLowerCase();
  if(ext==='pdf') bloodParsePDF(file);
  else if(ext==='csv'){ var r=new FileReader(); r.onload=function(){bloodExtract(r.result);}; r.readAsText(file); }
  else if(ext==='xlsx'||ext==='xls') bloodParseExcel(file);
  else bloodErr('Format nicht unterstützt. Bitte PDF, XLSX, XLS oder CSV.');
}
function bloodParsePDF(file){
  if(typeof pdfjsLib==='undefined'){ bloodErr('PDF-Bibliothek nicht geladen. Bitte Seite neu laden.'); return; }
  pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
  var reader=new FileReader();
  reader.onload=function(){
    pdfjsLib.getDocument({data:new Uint8Array(reader.result)}).promise.then(function(pdf){
      var pages=[];
      for(var i=1;i<=pdf.numPages;i++)pages.push(pdf.getPage(i).then(function(p){return p.getTextContent().then(function(tc){return tc.items.map(function(it){return it.str;}).join(' ');});}));
      Promise.all(pages).then(function(texts){bloodExtract(texts.join('\n'));});
    }).catch(function(){bloodErr('PDF konnte nicht gelesen werden. Eingescannte Bild-PDFs lassen sich nicht auslesen – bitte Werte im nächsten Schritt manuell ergänzen.');});
  };
  reader.readAsArrayBuffer(file);
}
function bloodParseExcel(file){
  if(typeof XLSX==='undefined'){ bloodErr('Excel-Bibliothek nicht geladen. Bitte Seite neu laden.'); return; }
  var r=new FileReader();
  r.onload=function(){
    try{ var wb=XLSX.read(new Uint8Array(r.result),{type:'array'}); var txt=''; wb.SheetNames.forEach(function(sn){txt+='\n'+XLSX.utils.sheet_to_csv(wb.Sheets[sn]);}); bloodExtract(txt); }
    catch(e){ bloodErr('Excel konnte nicht gelesen werden.'); }
  };
  r.readAsArrayBuffer(file);
}
function bloodExtract(text){
  var lc=text.toLowerCase().replace(/,(\d)/g,'.$1');
  bloodDetected=[];
  LAB_MAP.forEach(function(m){
    var hit=null;
    for(var k=0;k<m.keys.length && !hit;k++){
      var key=m.keys[k], von=0, idx;
      // Jeden Treffer pruefen, nicht nur den ersten: steht im Umfeld ein Wort
      // aus exclude, gehoert die Zeile zu einem anderen Marker (1,25-OH statt
      // 25-OH, Holo-TC statt Gesamt-B12) und die Suche laeuft weiter.
      while((idx=lc.indexOf(key, von)) >= 0){
        var umfeld = lc.slice(Math.max(0, idx-40), idx+key.length+40);
        if(m.exclude && m.exclude.some(function(x){ return umfeld.indexOf(x)>=0; })){
          von = idx + key.length; continue;
        }
        var after=lc.slice(idx+key.length, idx+key.length+80);
        after=after.replace(/\([^)]*\)/g,' ').replace(/\[[^\]]*\]/g,' ');
        after=after.replace(/\d+(?:\.\d+)?\s*[-–]\s*\d+(?:\.\d+)?/g,' ');
        var nm=after.match(/(\d+(?:\.\d+)?)\s*(ng\/ml|pg\/ml|µg\/ml|ug\/ml|mcg\/ml|µg\/l|ug\/l|mcg\/l|nmol\/l|pmol\/l|µmol\/l|umol\/l|µg\/dl|mg\/dl|mg\/l|mmol\/l)?/);
        if(nm&&nm[1]){ hit={value:parseFloat(nm[1]), unit:(nm[2]||'').replace('ug/','µg/').replace('mcg/','µg/').replace('umol','µmol'), raw:(key+' '+after.slice(0,24)).trim()}; break; }
        von = idx + key.length;
      }
    }
    if(hit){
      var v=hit.value;
      if(hit.unit && hit.unit!==m.unit && m.altUnits[hit.unit]!=null) v=v*m.altUnits[hit.unit];
      bloodDetected.push({map:m, valueStd:+v.toFixed(2), rawUnit:hit.unit||m.unit, raw:hit.raw});
    }
  });
  S.step='blood-review';
  render();
}
function bloodStatus(d){
  var v=d.valueStd,m=d.map;
  // Gleiche Schwelle wie bloodDeficitFactor: ab opt ist der Wert im Ziel.
  // Vorher galt erst ab optHigh als Optimum, deshalb stand ein Wert mitten im
  // Referenzbereich als "suboptimal" auf dem Bildschirm.
  if(v>m.optHigh)return{bg:'#fef5e7',c:'#e67e22',t:'über dem Zielbereich'};
  if(v>=m.opt)   return{bg:'#e8f4e8',c:'#3a6a3a',t:'im Zielbereich'};
  if(v<=m.low)   return{bg:'#fdecea',c:'#c0392b',t:'Mangel'};
  return{bg:'#fef5e7',c:'#e67e22',t:'suboptimal'};
}
function bloodUpdateVal(i,val){ bloodDetected[i].valueStd=parseFloat(val)||0; }
// Der Faktor misst den Abstand zum ZIELWERT opt, nicht zur Obergrenze optHigh.
// Bis 29.10.2026 wurde optHigh benutzt und opt war im ganzen Code unbenutzt:
// ein Gesamt-B12 von 345 pg/ml (Referenz 197-893) ergab so Faktor 0,71 und
// loeste eine Dosis von 355 µg aus — 14.200 % NRV fuer einen Normalwert.
function bloodDeficitFactor(value,low,opt){ if(value>=opt)return 0; if(value<=low)return 1; return (opt-value)/(opt-low); }
function bloodApply(){
  S.ans = S.ans || {};
  S.mode = 'bluttest';
  S.sc = {}; S.amt = {};
  DB.forEach(function(it){ S.sc[it.id]=0; S.amt[it.id]=0; });
  // Mehrere Marker koennen auf dieselbe Zutat zeigen (Gesamt-B12 und Holo-TC).
  // Ohne Auswahl ueberschrieb der zuletzt gelesene den anderen. Es gewinnt der
  // hoechste 'vorrang'; ohne Angabe gilt 0 und damit die Reihenfolge wie bisher.
  var _best={};
  bloodDetected.forEach(function(d){
    var id=d.map.ingId, v=(d.map.vorrang||0);
    if(!_best[id] || v > (_best[id].map.vorrang||0)) _best[id]=d;
  });
  Object.keys(_best).map(function(id){return _best[id];}).forEach(function(d){
    var it=DB.find(function(x){return x.id===d.map.ingId;});
    if(!it || !avails[it.id] || disabled[it.id]) return;
    var f=bloodDeficitFactor(d.valueStd, d.map.low, d.map.opt);
    if(f<=0){ S.amt[it.id]=0; return; }
    var base=it.dose||it.step||0;
    var cap=(it.maxSafe!=null)?it.maxSafe:(it.softMax!=null?it.softMax:base*3);
    var raw=base + (cap-base)*f;
    if(it.softMax!=null) raw=Math.min(raw, it.softMax);
    raw=Math.max(raw, it.step||0);
    S.amt[it.id]=parseFloat(raw.toFixed(6));
    S.sc[it.id]=f*10;
  });
  // Booster zuletzt: ihre Dosis ist fest. Ohne dies kann der Bluttest-Pfad
  // z.B. Magnesium auf einen Zwischenwert setzen (base + Defizitfaktor).
  if(typeof boosterDosisAnwenden==='function') boosterDosisAnwenden();
  S.step='r'; S.done=false; render();
}
// Lädt PDF.js + SheetJS dynamisch nach (nur wenn der Bluttest-Weg gewählt wird).
function bloodLoadLibs(cb){
  var need=[];
  if(typeof pdfjsLib==='undefined') need.push('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js');
  if(typeof XLSX==='undefined') need.push('https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js');
  if(!need.length){ cb&&cb(); return; }
  var loaded=0;
  need.forEach(function(src){
    var sc=document.createElement('script');
    sc.src=src;
    sc.onload=function(){ loaded++; if(loaded===need.length) cb&&cb(); };
    sc.onerror=function(){ loaded++; if(loaded===need.length) cb&&cb(); };
    document.head.appendChild(sc);
  });
}
function chooseMode(m){
  if(m==='quiz'){ S.step=0; S.mode=null; render(); }
  else if(m==='expert'){
    // Anleitung immer zeigen (bei jedem Aufruf des Experten-Modus).
    S.step='expert-intro'; render();
  }
  else if(m==='blood'){
    if(!BLUTTEST_AKTIV){ S.step=0; S.mode=null; render(); return; }
    S.step='blood-upload'; render(); bloodLoadLibs();
  }
  else if(m==='start'){ S.step='start'; S.mode=null; render(); }
}
// Vom Anleitungs-Screen aus den Experten-Modus starten.
function startExpertConfirmed(){
  startExpert();
}
// ── BLUTTEST-RENDER ─────────────────────────────────────────────────────────────
function renderStart(){
  var h='<div style="padding:30px 0 0">';
  h+='<div class="b-eyebrow" style="text-align:center">Puraveda by Biotiva</div>';
  h+='<h2 style="text-align:center;font-size:23px;margin:6px 0 4px;color:#26352f">Wie möchtest Du starten?</h2>';
  h+='<p style="text-align:center;color:#727c6a;font-size:14px;margin-bottom:24px">Wir erstellen Deine persönliche Rezeptur auf Basis Deines Inputs. Du hast zwei Optionen: Der KI-basierte Konfigurator erstellt in Sekunden Deine persönliche Rezeptur.</p>';
  h+='<div style="display:flex;flex-direction:column;gap:14px">';
  h+='<div class="b-result-name-banner" onclick="chooseMode(\'quiz\')" style="background:#26352f;color:#f6f5f1;display:block;text-align:left;cursor:pointer;margin-bottom:0;transition:.18s" onmouseover="this.style.background=\'#3d5248\'" onmouseout="this.style.background=\'#26352f\'"><div class="b-result-name-value">Fragebogen</div><div style="font-size:13px;color:#e4e2dc;margin-top:6px;line-height:1.5">Beantworte 17 Fragen in 4 Minuten.</div></div>';
  if(BLUTTEST_AKTIV){
    h+='<div onclick="chooseMode(\'blood\')" style="cursor:pointer;background:#fff;border:1.5px solid #e4e2dc;border-radius:14px;padding:22px 20px;transition:.18s" onmouseover="this.style.borderColor=\'#70191d\'" onmouseout="this.style.borderColor=\'#e4e2dc\'"><div style="font-size:26px;margin-bottom:8px">🩸</div><div style="font-weight:700;font-size:16px;color:#26352f">Bluttest hochladen <span style="background:#70191d;color:#f6f5f1;font-size:10px;font-weight:700;border-radius:4px;padding:2px 7px;vertical-align:middle">NEU</span></div><div style="font-size:13px;color:#727c6a;margin-top:3px">Lade Dein Laborergebnis hoch — wir leiten die Rezeptur aus Deinen Ist-Werten ab.</div></div>';
  }
  h+='<div class="b-result-name-banner" onclick="chooseMode(\'expert\')" style="background:#26352f;color:#f6f5f1;display:block;text-align:left;cursor:pointer;margin-bottom:0;transition:.18s" onmouseover="this.style.background=\'#3d5248\'" onmouseout="this.style.background=\'#26352f\'"><div class="b-result-name-value">Experten-Modus</div><div style="font-size:13px;color:#e4e2dc;margin-top:6px;line-height:1.5">Du weißt genau, was Du brauchst? Stelle Deine Rezeptur frei zusammen.</div></div>';
  h+='</div></div>';
  return h;
}
function renderExpertIntro(){
  var step=function(n,title,text){
    return '<div style="display:flex;gap:14px;align-items:flex-start;margin-bottom:16px">'
      +'<div style="flex-shrink:0;width:30px;height:30px;border-radius:50%;background:#26352f;color:#fff;font-weight:700;font-size:14px;display:flex;align-items:center;justify-content:center">'+n+'</div>'
      +'<div style="flex:1"><div style="font-weight:700;font-size:15px;color:#26352f;margin-bottom:2px">'+title+'</div>'
      +'<div style="font-size:13px;color:#818c77;line-height:1.55">'+text+'</div></div>'
      +'</div>';
  };
  var h='<div style="padding:24px 0 0">';
  h+='<span onclick="chooseMode(\'start\')" style="font-size:13px;color:#70191d;cursor:pointer">&#8592; zurück</span>';
  h+='<div style="text-align:center;margin:14px 0 6px"><div style="font-size:38px">&#9881;&#65039;</div></div>';
  h+='<h2 style="text-align:center;font-size:22px;margin:4px 0 4px;color:#26352f">So funktioniert der Experten-Modus</h2>';
  h+='<p style="text-align:center;color:#727c6a;font-size:14px;margin-bottom:22px;line-height:1.5">Hier stellst Du Deine Rezeptur völlig frei zusammen — ganz ohne Fragebogen. Eine kurze Anleitung, damit Du genau weißt, was Dich erwartet.</p>';

  h+='<div style="background:#fff;border:1px solid #e4e2dc;border-radius:14px;padding:22px 20px;margin-bottom:16px">';
  h+=step('1','Alle Zutaten sind freigeschaltet','Du startest mit der vollständigen Auswahl an Vitaminen, Mineralstoffen und Botanicals — jede auf einer sinnvollen Standard-Dosis.');
  h+=step('2','Menge per Schieberegler einstellen','Über den Regler bei jeder Zutat bestimmst Du Deine Tagesdosis. Der Preis pro Tag und Monat aktualisiert sich dabei live.');
  h+=step('3','Zutaten entfernen oder hinzufügen','Was Du nicht brauchst, entfernst Du mit einem Klick. Über „+ Hinzufügen" holst Du eine Zutat zurück in Deine Rezeptur.');
  h+=step('4','Sicherheit bleibt aktiv','Wissenschaftliche Höchstmengen (EFSA/BfR) und Wechselwirkungs-Hinweise gelten weiter. Überschreitest Du einen sicheren Höchstwert, musst Du das aktiv bestätigen.');
  h+=step('5','In den Warenkorb','Wenn Deine Rezeptur steht, gibst Du ihr einen Namen und legst sie in den Warenkorb. Fertig.');
  h+='</div>';

  h+='<div style="background:#f6f5f1;border-left:3px solid #26352f;border-radius:0 8px 8px 0;padding:12px 14px;margin-bottom:18px;font-size:12px;color:#26352f;line-height:1.6">'
    +'<b>Tipp:</b> Unsicher bei der Dosierung? Der Fragebogen erstellt Dir eine wissenschaftlich begründete Empfehlung als Ausgangspunkt — die Du anschließend frei anpassen kannst.</div>';

  h+='<button class="b-btn b-btn-primary" onclick="startExpertConfirmed()" style="width:100%">Los geht\'s &#8594;</button>';
  h+='<div style="text-align:center;margin-top:10px"><button onclick="chooseMode(\'quiz\')" style="background:none;border:none;color:#727c6a;cursor:pointer;font-size:12px;padding:8px">Lieber den Fragebogen nutzen &#8594;</button></div>';
  h+='</div>';
  return h;
}
function renderBloodUpload(){
  var h='<div style="padding:24px 0 0">';
  h+='<span onclick="chooseMode(\'start\')" style="font-size:13px;color:#70191d;cursor:pointer">← zurück</span>';
  h+='<h2 style="font-size:22px;margin:14px 0 4px;color:#26352f">Bluttest hochladen</h2>';
  h+='<p style="color:#727c6a;font-size:14px;margin-bottom:20px">PDF oder Excel mit Deinen Laborwerten. Die Analyse passiert direkt in Deinem Browser.</p>';
  h+='<label style="display:block;border:2px dashed #61181b;border-radius:14px;background:#fff;padding:40px 24px;text-align:center;cursor:pointer" id="blood-drop">';
  h+='<div style="font-size:38px;margin-bottom:10px">📄</div>';
  h+='<div style="font-weight:600;font-size:16px;color:#26352f">Datei auswählen oder hierher ziehen</div>';
  h+='<div style="font-size:13px;color:#727c6a;margin-top:4px">Wir suchen nach bekannten Laborwerten und ordnen sie zu.</div>';
  h+='<div style="font-size:11px;color:#61181b;margin-top:10px">PDF · XLSX · XLS · CSV</div>';
  h+='<input type="file" accept=".pdf,.xlsx,.xls,.csv" style="display:none" id="blood-file" onchange="if(this.files.length)bloodHandleFile(this.files[0])">';
  h+='</label>';
  h+='<div style="margin-top:14px;font-size:12px;color:#727c6a;background:#f6f5f1;border-radius:10px;padding:12px 14px;line-height:1.5">🔒 <b style="color:#3a6a3a">Deine Daten bleiben bei Dir.</b> Die Datei wird ausschließlich lokal in Deinem Browser ausgewertet und <b>nicht</b> an einen Server gesendet oder gespeichert. Du bestätigst jeden erkannten Wert selbst, bevor eine Rezeptur entsteht.</div>';
  h+='<div id="blood-err"></div>';
  h+='</div>';
  return h;
}
function renderBloodReview(){
  var h='<div style="padding:24px 0 0">';
  h+='<span onclick="chooseMode(\'blood\')" style="font-size:13px;color:#70191d;cursor:pointer">← andere Datei</span>';
  h+='<h2 style="font-size:22px;margin:14px 0 4px;color:#26352f">Erkannte Werte prüfen</h2>';
  h+='<p style="color:#727c6a;font-size:14px;margin-bottom:18px">Bitte kontrolliere die Werte und korrigiere sie bei Bedarf. Nur bestätigte Werte fließen in die Rezeptur.</p>';
  if(!bloodDetected.length){
    h+='<div style="background:#fef5e7;color:#8a6a00;border-radius:10px;padding:14px 16px;font-size:13px;line-height:1.5">In Deiner Datei konnten wir keine bekannten Laborwerte automatisch zuordnen. Das passiert z.&nbsp;B. bei eingescannten Bild-PDFs oder ungewöhnlichen Laborformaten. Bitte nutze den Fragebogen – dort erfassen wir Deinen Bedarf über gezielte Fragen – oder lade eine andere Datei hoch.</div>';
    // Kein "Rezeptur berechnen": ohne Werte gäbe es eine leere Rezeptur.
    h+='<button class="b-btn b-btn-primary" onclick="chooseMode(\'quiz\')" style="margin-top:18px;width:100%">Zum Fragebogen &#8594;</button>';
    h+='<button class="b-btn b-btn-ghost" onclick="chooseMode(\'blood\')" style="margin-top:8px;width:100%">Andere Datei hochladen</button>';
    h+='</div>';
    return h;
  }
  bloodDetected.forEach(function(d,i){
    var st=bloodStatus(d);
    h+='<div style="display:flex;align-items:center;gap:10px;background:#fff;border:1px solid #e4e2dc;border-radius:10px;padding:11px 14px;margin-bottom:8px">';
    h+='<div style="flex:1"><div style="font-weight:600;font-size:14px;color:#26352f">'+d.map.param+'</div><div style="font-size:11px;color:#727c6a">erkannt: "'+d.raw+'"</div></div>';
    h+='<input type="number" step="0.1" value="'+d.valueStd+'" oninput="bloodUpdateVal('+i+',this.value)" style="width:78px;text-align:right;border:1px solid #e4e2dc;border-radius:6px;padding:6px 8px;font-size:14px;font-family:inherit">';
    h+='<span style="font-size:12px;color:#727c6a;min-width:42px">'+d.map.unit+'</span>';
    h+='<span style="font-size:11px;font-weight:700;border-radius:4px;padding:2px 8px;background:'+st.bg+';color:'+st.c+';white-space:nowrap">'+st.t+'</span>';
    h+='</div>';
  });
  h+='<button class="b-btn b-btn-primary" onclick="bloodApply()" style="margin-top:18px;width:100%">Rezeptur berechnen &#8594;</button>';
  h+='</div>';
  return h;
}

function bloodBindDrop(){
  var drop=document.getElementById('blood-drop');
  if(!drop) return;
  ['dragenter','dragover'].forEach(function(e){drop.addEventListener(e,function(ev){ev.preventDefault();drop.style.borderColor='#70191d';drop.style.background='#e8f4e8';});});
  ['dragleave','drop'].forEach(function(e){drop.addEventListener(e,function(ev){ev.preventDefault();drop.style.borderColor='#61181b';drop.style.background='#fff';});});
  drop.addEventListener('drop',function(ev){ if(ev.dataTransfer.files.length) bloodHandleFile(ev.dataTransfer.files[0]); });
}

function updateStd(id,val){var it=DB.find(function(x){return x.id===id;});if(!it)return;var n=parseFloat((val||'').replace(',','.').replace('%',''));if(!isNaN(n)&&n>0)it.std=(n>1?n/100:n);saveAdmin();showSave();}
function updatePrice(id,val){prices[id]=parseFloat(val)||0;saveAdmin();showSave();}
function updateName(id,val){var it=DB.find(function(x){return x.id===id;});if(it&&val.trim()){it.name=val.trim();names[id]=val.trim();}saveAdmin();showSave();}
function updateDesc(id,val){descs[id]=val;saveAdmin();showSave();}
function updateClaim(id,val){claims[id]=val;saveAdmin();showSave();}
function toggleAvail(id){
  avails[id]=!avails[id];var av=avails[id];
  var btn=document.getElementById('avbtn-'+id);
  var row=document.getElementById('arow-'+id);
  var inp=document.getElementById('price-'+id);
  var st=document.getElementById('avstat-'+id);
  if(btn)btn.className='b-avail-toggle '+(av?'on':'off');
  if(row)row.className=av?'':'b-unavail-row';
  if(inp)inp.disabled=!av;
  if(st){st.textContent=av?'Verfügbar':'Nicht verfügbar';st.style.color=av?'#3a6a3a':'#c0392b';}
  saveAdmin();showSave();
  if(av && UNAVAILABLE_IDS.indexOf(id)>=0){
    toast('Achtung: "'+(names[id]||id)+'" steht in UNAVAILABLE_IDS im Code und wird beim naechsten Seitenaufruf wieder gesperrt.');
  }
}
function showSave(){var b=document.getElementById('saveBadge');if(!b)return;b.classList.add('show');clearTimeout(window._st);window._st=setTimeout(function(){b.classList.remove('show');},2500);}
function toast(msg){var t=document.getElementById('b-toast');if(!t)return;t.textContent=msg;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},3800);}

function cart(){
  var rname=S.ans.rezepturname||'Meine Biotiva Rezeptur';
  var email=S.ans.email||'';
  var items=DB.filter(function(it){return avails[it.id]&&!disabled[it.id]&&S.amt[it.id]>0;}).map(function(it){
    return{id:it.id,name:names[it.id]+(it.nutrient?' ('+it.nutrient+')':' (Botanical)'),
      daily_dose:fa(S.amt[it.id],it.unit)+' '+it.unit,
      monthly_g:(toMg(S.amt[it.id],it.unit)/1000*30).toFixed(2)+' g',
      price_per_day:'€ '+pd(it).toFixed(2)};
  });
  var payload={store:'https://www.biotiva.de',rezeptur_name:rname,customer_email:email,bag_label:rname,
    note:'Pers. Rezeptur: '+rname+(email?' | '+email:''),items:items,
    bag_print:{line1:rname,line2:'Personalisierte Tagesdosis',line3:'biotiva.de – 100% Organic'}};
  console.log('[Biotiva Shopify]',JSON.stringify(payload,null,2));
  S.done=true;render();
  toast('"'+rname+'" wurde in den Warenkorb gelegt!');
  setTimeout(function(){window.location.href='/checkout';},900);  // /cart würde den Konfigurator neu laden
}

// ── CLAIM SUMMARY TEXT (Punkt 2) ──────────────────────────────────────────────
// Generates a flowing text based on goals + active ingredients with their EU claims
function buildClaimSummary(){
  var goals=S.ans.goals||[];
  var sex=(S.ans.sex||'').toLowerCase();
  var age=S.ans.age||35;
  var diet=(S.ans.diet||'').toLowerCase();
  var stress=S.ans.stress||2;
  var sleep=S.ans.sleep||7;
  var sport=S.ans.sport||0;

  var activeWithClaims=DB.filter(function(it){
    // Nur Nährstoffe — Botanicals/Pflanzenpulver tragen keine Health Claims
    return it.type==='nutrient'&&!disabled[it.id]&&avails[it.id]&&claimErlaubt(it)
           &&(CLAIMS_ALL[it.id]||claims[it.id]);
  });

  if(!activeWithClaims.length)return '';

  var contextParts=[];
  if(goals.length){
    var goalStr=goals.slice(0,3).map(function(g){return g.toLowerCase();}).join(', ');
    contextParts.push('Du hast als Ziele '+goalStr+' angegeben');
  }
  if(diet.indexOf('vegan')>=0)contextParts.push('Du ernährst Dich vegan');
  else if(diet.indexOf('vegetarisch')>=0)contextParts.push('Du ernährst Dich vegetarisch');
  if(stress>=4)contextParts.push('Dein Stresslevel ist erhöht');
  if(sleep<6)contextParts.push('Du schläfst weniger als 6 Stunden');
  if(sport>=4)contextParts.push('Du bist sportlich sehr aktiv');

  var contextSentence=contextParts.length?contextParts.join(', ')+'. ':
    'Auf Basis Deiner persönlichen Angaben ';

  var claimLines=[];
  activeWithClaims.slice(0,(S.mode==='expert'?DB.length:8)).forEach(function(it){
    var top=getTopClaims(it.id,3);
    if(!top.length && claims[it.id]) top=[claims[it.id]];
    top.forEach(function(t){ claimLines.push(names[it.id]+': '+t); });
  });

  var out='<div style="padding:14px 16px;background:#f6f5f1;border-left:3px solid #26352f;border-radius:0 8px 8px 0;font-size:12px;color:#26352f;line-height:1.7;margin-bottom:14px">';
  out+='<div style="font-weight:700;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#818c77;margin-bottom:6px">Wissenschaftliche Grundlage Deiner Rezeptur</div>';
  out+='<p style="margin-bottom:8px">'+contextSentence;
  out+='Deine Rezeptur wurde auf Basis dieser Ausgangslage zusammengestellt. ';
  out+='Die nachfolgenden Aussagen sind gemäß EU-Verordnung Nr. 432/2012 als Health Claims zugelassen und beschreiben die physiologischen Wirkungen der enthaltenen Nährstoffe:</p>';
  out+='<ul style="list-style:none;padding:0;margin:0">';
  claimLines.forEach(function(line){
    out+='<li style="padding:3px 0;border-bottom:1px solid #e4e2dc;display:flex;gap:6px"><span style="color:#3a6a3a;flex-shrink:0">&#10003;</span><span>'+line+'</span></li>';
  });
  out+='</ul>';
  out+='<p style="margin-top:8px;font-size:10px;color:#727c6a">Quelle: Verordnung (EU) Nr. 432/2012 – Liste der zugelassenen gesundheitsbezogenen Angaben über Lebensmittel. Diese Angaben dürfen nur für Zutaten verwendet werden, die den festgelegten Mengenbedingungen entsprechen.</p>';
  out+='</div>';
  return out;
}

// ── ADMIN ─────────────────────────────────────────────────────────────────────

var csvErrors=[];

function parseCSV(text){
  var lines=text.replace(/\r\n/g,'\n').replace(/\r/g,'\n').split('\n');
  if(!lines.length)return[];
  var sep=lines[0].split(';').length>lines[0].split(',').length?';':',';
  var headers=splitCSVLine(lines[0],sep).map(function(h){
    return h.trim().toLowerCase().replace(/[^a-z0-9_]/g,'');
  });
  var rows=[];
  for(var i=1;i<lines.length;i++){
    var line=lines[i].trim();
    if(!line)continue;
    var cols=splitCSVLine(line,sep);
    var obj={};
    headers.forEach(function(h,j){obj[h]=(cols[j]||'').trim().replace(/^["']|["']$/g,'');});
    rows.push(obj);
  }
  return rows;
}

function splitCSVLine(line,sep){
  var result=[],cur='',inQ=false;
  for(var i=0;i<line.length;i++){
    var ch=line[i];
    if(ch==='"'&&!inQ){inQ=true;continue;}
    if(ch==='"'&&inQ){inQ=false;continue;}
    if(ch===sep&&!inQ){result.push(cur);cur='';continue;}
    cur+=ch;
  }
  result.push(cur);
  return result;
}

function parseNum(v){
  var n=parseFloat((v||'').toString().replace(',','.'));
  return isNaN(n)?null:n;
}

function importCSV(csvText){
  csvErrors=[];
  var rows=parseCSV(csvText);
  var added=0,updated=0,skipped=0,removed=0;

  var uploadedIds=[];
  rows.forEach(function(row){
    if(row.id&&row.name) uploadedIds.push(row.id);
  });

  var plantBotIds=uploadedIds.filter(function(id){
    var row=rows.find(function(r){return r.id===id;});
    return row&&(row.type==='plant'||row.type==='bot');
  });
  window._activeIds=plantBotIds;
  removed = DB.filter(function(it){return uploadedIds.indexOf(it.id)<0;}).length;

  var savedPrices={};
  Object.keys(prices).forEach(function(k){savedPrices[k]=prices[k];});
  DB.length=0;
  buildDB().forEach(function(it){DB.push(it);});

  Object.keys(avails).forEach(function(k){ avails[k]=false; });

  DB.forEach(function(it){
    if(savedPrices[it.id]!==undefined)prices[it.id]=savedPrices[it.id];
  
    if(it.type==='nutrient'||uploadedIds.indexOf(it.id)>=0){
      avails[it.id]=true;
    }
    if(disabled[it.id]===undefined)disabled[it.id]=false;
    if(!names[it.id])names[it.id]=it.name;
  });

  rows.forEach(function(row,i){
    var lineNum=i+2;
    if(!row.id||!row.name){
      csvErrors.push('Zeile '+lineNum+': id oder name fehlt.');
      skipped++;return;
    }
    var type=(row.type||'').toLowerCase();
    if(type!=='plant'&&type!=='bot'&&type!=='nutrient'){
      csvErrors.push('Zeile '+lineNum+' ('+row.id+'): type muss plant, bot oder nutrient sein.');
      skipped++;return;
    }
    var dose=parseNum(row.dose);
    if(dose===null){
      csvErrors.push('Zeile '+lineNum+' ('+row.id+'): dose fehlt oder ungültig.');
      skipped++;return;
    }
    var step=parseNum(row.step)||10;
  
    var refDose=dose||nrv||1;
    if(step>refDose*100) step=parseFloat((Math.max(refDose*0.05,0.001)).toFixed(6));
    var pk=parseNum(row.pk)||0;
    var nrv=parseNum(row.nrv);
    var softMax=parseNum(row.softmax);
    var maxSafe=parseNum(row.maxsafe);
    var unit=row.unit||'mg';
    var existing=DB.find(function(x){return x.id===row.id;});
    if(existing){
      existing.name=row.name;
      if(row.nutrient!==undefined)existing.nutrient=row.nutrient||null;
      existing.dose=dose;existing.unit=unit;existing.step=step;existing.pk=pk;
      existing.nrv=nrv;existing.softMax=softMax;existing.maxSafe=maxSafe;
      var sv5=parseFloat((row.std||'').replace('%','').replace(',','.'));if(!isNaN(sv5)&&sv5>0)existing.std=(sv5>1?sv5/100:sv5);
      if(row.scope)existing.scope=row.scope.replace(/\|/g,',').trim();
      names[row.id]=row.name;
      if(row.desc!==undefined&&row.desc!=='')descs[row.id]=row.desc;
      if(row.claim!==undefined&&row.claim!=='')claims[row.id]=row.claim;
      prices[row.id]=pk;
      updated++;
    }else{
      DB.push({
        id:row.id,name:row.name,type:type,nutrient:row.nutrient||null,
        dose:dose,unit:unit,step:step,pk:pk,nrv:nrv,
        softMax:softMax,maxSafe:maxSafe,noUpperLimit:false,
        std:(function(){var sv6=parseFloat((row.std||'').replace('%','').replace(',','.'));return(!isNaN(sv6)&&sv6>0)?(sv6>1?sv6/100:sv6):1;})(),
        scope:(row.scope||'').replace(/\|/g,',').trim(),
        desc:row.desc||'',claim:row.claim||'',goals:[]
      });
      names[row.id]=row.name;
      descs[row.id]=row.desc||'';
      claims[row.id]=row.claim||'';
      prices[row.id]=pk;
      // verfuegbar column: True/False overrides availability
      var verfRow=(row.verfuegbar||'True').trim().toLowerCase();
      avails[row.id]=(verfRow==='false')?false:(UNAVAILABLE_IDS.indexOf(row.id)<0);
      disabled[row.id]=false;
      added++;
    }
  });
  saveAdmin();
  var msg='Importiert: '+added+' neu, '+updated+' aktualisiert, '+removed+' entfernt';
  if(skipped)msg+=', '+skipped+' übersprungen';
  if(csvErrors.length)msg+=' — '+csvErrors.length+' Hinweis(e) unten';

  DB.forEach(function(it){if(!SE[it.id]){SE[it.id]=function(a){var score=calcScoreFromEvidence(it.id,a);var userGoals=a.goals||[];(it.goals||[]).forEach(function(gk){if(userGoals.some(function(g){return g.toLowerCase().indexOf(gk.toLowerCase())>=0;})){score+=1.0;}});return score;};}});
  return msg;
}

function handleCSVFile(input){
  var file=input.files[0];
  if(!file)return;
  var reader=new FileReader();
  reader.onload=function(e){
    var result=importCSV(e.target.result);
    var status=document.getElementById('csv-status');
    var errBox=document.getElementById('csv-errors');
    if(status){
      status.textContent=result;
      status.style.color=csvErrors.length?'#c0392b':'#3a6a3a';
      status.style.display='block';
    }
    if(errBox){
      errBox.innerHTML=csvErrors.length
        ?('<ul style="margin:6px 0 0;padding-left:16px">'
          +csvErrors.map(function(e){return'<li>'+e+'</li>';}).join('')
          +'</ul>')
        :'';
    }
    renderAdmin();
    if(S.step==='r'){S.sc=calcSc();initAmt(S.sc);render();}
  };
  reader.readAsText(file,'UTF-8');
}

function exportCSV(){
  var header='id;name;type;nutrient;dose;unit;step;pk;nrv;softMax;maxSafe;noUpperLimit;std;powderDose;powderUnit;scope;desc;claim';
  var rows=DB.map(function(it){
    function esc(s){return'"'+(s||'').replace(/"/g,'""').replace(/\n/g,' ')+'"';}
    return[
      it.id,
      esc(names[it.id]||it.name),
      it.type,
      it.nutrient||'',
      it.dose,it.unit,it.step,
      prices[it.id]||0,
      it.nrv||'',
      it.softMax!==null&&it.softMax!==undefined?it.softMax:'',
      it.maxSafe!==null&&it.maxSafe!==undefined?it.maxSafe:'',
      it.noUpperLimit?'true':'',
      it.std?Math.round(it.std*10000)/100+'%':'100%',
      (it.std&&it.std<0.999)?+(toMg(it.dose,it.unit)/it.std/1000).toFixed(4):'',
      (it.std&&it.std<0.999)?(it.unit==='g'?'g':'mg'):'',
      esc((it.scope||'').replace(/,/g,'|')),
      esc(descs[it.id]||''),
      esc(claims[it.id]||'')
    ].join(';');
  });
  var csv=header+'\n'+rows.join('\n');
  var blob=new Blob(['﻿'+csv],{type:'text/csv;charset=utf-8'});
  var url=URL.createObjectURL(blob);
  var a=document.createElement('a');
  a.href=url;
  a.download='biotiva_rohwaren.csv';
  a.click();
  URL.revokeObjectURL(url);
}

var adminOpen=false;
var adminTab='plant';
function toggleAdmin(){
  adminOpen=!adminOpen;
  document.getElementById('adminToggle').className='b-admin-toggle'+(adminOpen?' active':'');
  var p=document.getElementById('admin-panel');
  p.style.display=adminOpen?'block':'none';
  if(adminOpen)renderAdmin();
}
function switchAdminTab(tab){adminTab=tab;renderAdmin();}

function renderAdmin(){
  var items=adminTab==='csv'?[]:DB.filter(function(x){
    return adminTab==='plant'?(x.type==='plant'||x.type==='nutrient'):(x.type==='bot');
  });

  var rows='';
  items.forEach(function(it){
    var av=avails[it.id];
    rows+='<tr class="'+(av?'':'b-unavail-row')+'" id="arow-'+it.id+'">';
    rows+='<td style="min-width:120px"><input class="b-admin-input" style="width:140px;text-align:left" type="text"';
    rows+=' value="'+names[it.id].replace(/"/g,'&quot;')+'"';
    rows+=' oninput="updateName(this.dataset.id,this.value)" data-id="'+it.id+'"></td>';
    rows+='<td style="font-size:10px;color:#727c6a;max-width:90px">'+(it.nutrient||it.scope||'')+'</td>';
    rows+='<td><input class="b-admin-input" type="text" style="width:52px;text-align:right"';
    rows+=' value="'+Math.round((it.std||1)*10000)/100+'"';
    rows+=' oninput="updateStd(this.dataset.id,this.value)" data-id="'+it.id+'" title="Std.%"></td>';
    rows+='<td><div style="display:flex;align-items:center;gap:4px">';
    rows+='<input class="b-admin-input" type="number" min="0" step="0.5" id="price-'+it.id+'"';
    rows+=' value="'+(prices[it.id]||0)+'"';
    rows+=' oninput="updatePrice(this.dataset.id,this.value)" data-id="'+it.id+'"'+(av?'':' disabled')+'>';
    rows+='<span style="font-size:10px;color:#727c6a">&euro;/kg</span></div></td>';
    rows+='<td><button class="b-avail-toggle '+(av?'on':'off')+'" id="avbtn-'+it.id+'"';
    rows+=' onclick="toggleAvail(this.dataset.id)" data-id="'+it.id+'"></button>';
    // Bestand direkt neben den Schalter: ohne die Zahl ist nicht zu sehen, ob
    // eine freigegebene Zutat ueberhaupt noch fuer eine Kur reicht.
    var _bs = (typeof BESTAND_SL !== 'undefined') ? BESTAND_SL[it.id] : null;
    if(_bs){
      var _leer  = ((_bs.rw||0)+(_bs.fw||0) <= 0)
                 && !(typeof BESTAND_NACHGEMELDET !== 'undefined'
                      && BESTAND_NACHGEMELDET[it.id]);
      var _knapp = (BESTAND_KNAPP_IDS.indexOf(it.id) >= 0);
      var _umpck = (NUR_FERTIGWARE_IDS.indexOf(it.id) >= 0);
      rows+='<div style="font-size:9px;line-height:1.35;margin-top:4px;max-width:160px;'
        +'color:'+(_leer?'#b03a2a':(_knapp?'#a8761e':'#727c6a'))+'" title="Stand '+BESTAND_STAND+'">'
        +(_leer?'● ':(_knapp?'▲ ':(_umpck?'◆ ':'')))
        +bestandText(it.id).replace(/</g,'&lt;')+'</div>';
    }
    rows+='</td>';
    rows+='</tr>';
    rows+='<tr'+(av?'':' class="b-unavail-row"')+'>';
    rows+='<td colspan="4" style="padding:4px 8px 10px">';
    rows+='<div style="font-size:10px;color:#61181b;font-weight:700;margin-bottom:3px">Rezeptur-Beschreibung:</div>';
    rows+='<textarea class="b-admin-input" style="width:100%;height:50px;resize:vertical;text-align:left;line-height:1.4"';
    rows+=' oninput="updateDesc(this.dataset.id,this.value)" data-id="'+it.id+'">';
    rows+=(descs[it.id]||'').replace(/</g,'&lt;');
    rows+='</textarea>';
    if(it.type==='bot'||it.type==='plant'){
      rows+='<div style="font-size:10px;color:#70191d;font-weight:700;margin:4px 0 3px">EU Health Claims: nicht zulässig (Botanical/Pflanze)</div>';
      rows+='<div style="font-size:10px;color:#87867e;font-style:italic">Für Botanicals und Pflanzenpulver werden keine Health Claims ausgegeben (EU 432/2012 deckt diese nicht ab).</div>';
    } else {
      var _ac=(typeof CLAIMS_ALL!=='undefined'&&CLAIMS_ALL[it.id])?CLAIMS_ALL[it.id].length:0;
      rows+='<div style="font-size:10px;color:#727c6a;font-weight:700;margin:4px 0 3px">EU Health Claims ('+_ac+' verfügbar, automatisch aus EU-Liste):</div>';
      if(_ac){
        rows+='<div style="font-size:10px;color:#26352f;line-height:1.5;max-height:90px;overflow:auto;border:1px solid #c9c4ba;border-radius:4px;padding:4px 6px;background:#f6f5f1">';
        CLAIMS_ALL[it.id].forEach(function(c){ rows+='<div style="margin-bottom:2px">• '+c.t.replace(/</g,'&lt;')+(c.g?' <span style=\'color:#61181b\'>['+c.g+']</span>':'')+'</div>'; });
        rows+='</div>';
      } else {
        rows+='<input class="b-admin-input" type="text" style="width:100%;text-align:left"';
        rows+=' value="'+(claims[it.id]||'').replace(/"/g,'&quot;')+'"';
        rows+=' oninput="updateClaim(this.dataset.id,this.value)" data-id="'+it.id+'">';
      }
    }
    rows+='</td></tr>';
  });

  var pCnt=DB.filter(function(x){return x.type==='nutrient';}).length;
  var bCnt=DB.filter(function(x){return x.type==='bot';}).length;

  function ts(t){
    var on=(adminTab===t);
    return 'padding:8px 20px;border:none;cursor:pointer;font-family:inherit;'
      +'background:'+(on?'#fff':'transparent')+';'
      +'color:'+(on?'#26352f':'#727c6a')+';'
      +'font-weight:'+(on?'700':'400')+';'
      +'border-bottom:2px solid '+(on?'#26352f':'transparent');
  }

  var el=document.getElementById('admin-panel');
  if(!el)return;

  var h='<div class="b-admin" style="margin-top:16px">';

  h+='<div class="b-admin-header">';
  h+='<div>';
  h+='<div class="b-admin-title">&#9881; Rohwaren-Verwaltung</div>';
  h+='<div class="b-admin-subtitle">Namen, Preise, Beschreibungen &ndash; wird automatisch gespeichert</div>';
  h+='</div>';
  h+='<div style="display:flex;align-items:center;gap:10px">';
  h+='<button onclick="clearAdmin()" style="font-size:11px;padding:4px 10px;border-radius:6px;border:1px solid rgba(255,255,255,.3);background:rgba(255,255,255,.1);color:#727c6a;cursor:pointer;font-family:inherit">Zurücksetzen</button>';
  h+='<span class="b-save-badge" id="saveBadge">&#10003; Gespeichert</span>';
  h+='</div>';
  h+='</div>';

  h+='<div style="display:flex;border-bottom:1px solid #f6f5f1;background:#f6f5f1">';
  h+='<button data-tab="plant" onclick="switchAdminTab(this.dataset.tab)" style="'+ts('plant')+'">Vitamine & Nährstoffe ('+pCnt+')</button>';
  h+='<button data-tab="bot" onclick="switchAdminTab(this.dataset.tab)" style="'+ts('bot')+'">Botanicals ('+bCnt+')</button>';
  h+='<button data-tab="csv" onclick="switchAdminTab(this.dataset.tab)" style="'+ts('csv')+'">&#128196; CSV Import / Export</button>'+
    '<button data-tab="evidence" onclick="switchAdminTab(this.dataset.tab)" style="'+ts('evidence')+'">&#128203; Evidenz-Modell</button>';
  h+='</div>';

  h+='<div class="b-admin-body" style="padding:12px 20px">';
  if(adminTab==='csv'){
    h+=renderCSVPanel();
  }else if(adminTab==='evidence'){
    h+=renderEvidencePanel();
  }else{
    h+='<table class="b-admin-table" style="width:100%">';
    h+='<thead><tr>';
    h+='<th style="min-width:150px">Name</th>';
    h+='<th>Nährstoff / Anwendung</th>';
    h+='<th title="Std.">Std.%</th>';
    h+='<th>&euro;/kg</th>';
    h+='<th>Verfügbar</th>';
    h+='</tr></thead>';
    h+='<tbody>'+rows+'</tbody>';
    h+='</table>';
  }
  h+='</div>';
  h+='</div>';

  el.innerHTML=h;
}

function renderCSVPanel(){
  var docs=[
    ['id','ja','Eindeutiger Bezeichner (a-z, 0-9, _)','acerola'],
    ['name','ja','Anzeigename der Zutat','Acerola'],
    ['type','ja','plant = Pflanzliche Quelle, bot = Botanical','plant'],
    ['nutrient','nein','Nährstoff (bei plant)','Vitamin C'],
    ['dose','ja','Empfohlene Tagesdosis (Nährstoff-Menge)','282'],
    ['unit','ja','Einheit: mg, g oder µg','mg'],
    ['step','nein','Schrittgröße für +/− Button','10'],
    ['pk','nein','Preis in €/kg','40'],
    ['nrv','nein','NRV-Referenzwert (gleiche Einheit wie dose)','80'],
    ['softMax','nein','Score-Ausgabe-Höchstmenge (BfR-Empfehlung)','800'],
    ['maxSafe','nein','Harter Sicherheitsstopper (User-Maximum)','2000'],
    ['std','nein','Standardisierungsgrad in % (z.B. 4 = 4 % Wirkstoff im Pulver)','4'],
    ['scope','nein','Anwendungsbereich, mehrere mit | trennen','Immunsystem | Haut'],
    ['desc','nein','Beschreibungstext in der Rezeptur','Natürliche Quelle ...'],
    ['claim','nein','EU Health Claim (Reg. 432/2012)','Vitamin C trägt zur ...'],
  ];
  var docRows=docs.map(function(r){
    return('<tr>'
      +'<td style="padding:4px 8px;border:1px solid #d9d5cc;font-weight:700;color:#26352f;font-family:monospace;font-size:11px">'+r[0]+'</td>'
      +'<td style="padding:4px 8px;border:1px solid #d9d5cc;color:'+(r[1]==='ja'?'#c0392b':'#727c6a')+'">'+r[1]+'</td>'
      +'<td style="padding:4px 8px;border:1px solid #d9d5cc;color:#818c77;font-size:11px">'+r[2]+'</td>'
      +'<td style="padding:4px 8px;border:1px solid #d9d5cc;color:#727c6a;font-family:monospace;font-size:10px">'+r[3]+'</td>'
      +'</tr>');
  }).join('');

  return(''
    +'<div style="padding:18px 0">'
    +'<div style="font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#61181b;border-bottom:1px solid #f6f5f1;padding-bottom:6px;margin-bottom:14px">CSV-Datei hochladen</div>'
    +'<div style="background:#f6f5f1;border:2px dashed #26352f;border-radius:10px;padding:24px;text-align:center;margin-bottom:14px">'
    +'<div style="font-size:15px;font-weight:700;color:#26352f;margin-bottom:6px">&#128196; CSV hochladen</div>'
    +'<div style="font-size:12px;color:#727c6a;margin-bottom:16px">UTF-8, Semikolon oder Komma als Trennzeichen<br>Vorhandene Zutaten werden aktualisiert, neue werden hinzugefügt</div>'
    +'<input type="file" id="csv-file-input" accept=".csv,.txt" style="display:none" onchange="handleCSVFile(this)">'
    +'<button onclick="document.getElementById(\'csv-file-input\').click()" style="padding:11px 28px;background:#26352f;color:#fff;border:none;border-radius:6px;cursor:pointer;font-family:inherit;font-size:14px;font-weight:700">Datei wählen …</button>'
    +'</div>'
    +'<div id="csv-status" style="display:none;padding:10px 14px;border-radius:6px;background:#e4e2dc;font-size:13px;font-weight:700;margin-bottom:8px"></div>'
    +'<div id="csv-errors" style="font-size:11px;color:#c0392b;margin-bottom:16px"></div>'
    +'<div style="font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#61181b;border-bottom:1px solid #f6f5f1;padding-bottom:6px;margin-bottom:12px">Aktuelle Liste exportieren</div>'
    +'<p style="font-size:12px;color:#727c6a;margin-bottom:12px">Alle Zutaten inkl. Admin-Änderungen als CSV herunterladen:</p>'
    +'<button onclick="exportCSV()" style="padding:10px 22px;background:#26352f;color:#fff;border:none;border-radius:6px;cursor:pointer;font-family:inherit;font-size:13px;font-weight:700;margin-bottom:24px">&#11123; biotiva_rohwaren.csv herunterladen</button>'
    +'<div style="font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#61181b;border-bottom:1px solid #f6f5f1;padding-bottom:6px;margin-bottom:12px">Spalten-Referenz</div>'
    +'<table style="width:100%;border-collapse:collapse">'
    +'<thead><tr style="background:#f6f5f1">'
    +'<th style="padding:5px 8px;text-align:left;border:1px solid #e4e2dc;font-size:11px">Spalte</th>'
    +'<th style="padding:5px 8px;text-align:left;border:1px solid #e4e2dc;font-size:11px">Pflicht</th>'
    +'<th style="padding:5px 8px;text-align:left;border:1px solid #e4e2dc;font-size:11px">Beschreibung</th>'
    +'<th style="padding:5px 8px;text-align:left;border:1px solid #e4e2dc;font-size:11px">Beispiel</th>'
    +'</tr></thead>'
    +'<tbody>'+docRows+'</tbody></table>'
    +'</div>'

  );
}

function getInteractions(){
  var activeIds=DB.filter(function(it){
    return !disabled[it.id]&&avails[it.id]&&S.amt[it.id]>0;
  }).map(function(it){return it.id;});
  var syns=[];
  INTERACTIONS.forEach(function(intr){
    var relevant=intr.ids.filter(function(id){return activeIds.indexOf(id)>=0;});
    if(relevant.length>=intr.ids.length){
      if(intr.type==='syn')syns.push(intr);
    }
  });
  // Antagonismen aus der evidenzbasierten Engine (dosis-/verhältnisbasiert)
  var ants=getAntagonismResults().triggered;
  return{syns:syns,ants:ants};
}

// Wo die beiden Partner eines Antagonismus TATSAECHLICH liegen — berechnet aus
// der Modulzuordnung, nicht im Notentext behauptet. Grund: ein statischer Text
// kann eine dynamische Zuordnung nicht beschreiben. Vorher stand in drei Notes
// "wir liefern beide getrennt", obwohl Calcium/Magnesium, Calcium/Zink und
// Zink/Kupfer immer in derselben Routine stehen. Die Notes nennen jetzt nur
// Mechanismus und Empfehlung; die Logistik kommt von hier.
function _antOrtHinweis(a,res){
  var ort=function(id){
    if((res.morning||[]).indexOf(id)>=0) return 'Morgen';
    if((res.evening||[]).indexOf(id)>=0) return 'Abend';
    return null;
  };
  var nm=function(id){var x=DB.find(function(y){return y.id===id;});return x?x.name:id;};
  var i1=a.ids[0], i2=a.ids[1], o1=ort(i1), o2=ort(i2);
  if(!o1||!o2) return '';
  var s='<div style="margin-top:2px;font-size:10px;opacity:.85">';
  if(o1!==o2) return s+'In Deiner Rezeptur getrennt: '+nm(i1)+' '+(o1==='Morgen'?'morgens':'abends')
    +', '+nm(i2)+' '+(o2==='Morgen'?'morgens':'abends')+'.</div>';
  return s+'In Deiner Rezeptur stehen beide in der '+o1+'-Routine.</div>';
}

function renderInteractions(){
  var ia=getInteractions(),out='';
  if(ia.syns.length){
    out+='<div style="padding:10px 12px;background:#e4e2dc;border:1px solid #c9c4ba;border-radius:8px;font-size:11px;color:#26352f;margin-bottom:8px"><strong>&#10003; Aktive Synergien:</strong><br>';
    ia.syns.forEach(function(s){out+='<div style="margin-top:4px">&#128154; <b>'+s.label+'</b> &mdash; '+s.note+'</div>';});
    out+='</div>';
  }
  if(ia.ants.length){
    var _res=getAntagonismResults();
    out+='<div style="padding:10px 12px;background:#fff8e1;border:1px solid #ffe082;border-radius:8px;font-size:11px;color:#8a6a00;margin-bottom:8px"><strong>&#9888; Wechselwirkungs-Hinweise:</strong><br>';
    ia.ants.forEach(function(a){out+='<div style="margin-top:4px">&#128312; <b>'+a.label+'</b> <span style="font-size:9px;background:#8a6a00;color:#fff;border-radius:3px;padding:1px 4px;vertical-align:middle">Evidenz '+(a.grade||'')+'</span> &mdash; '+a.note+_antOrtHinweis(a,_res)+'</div>';});
    if(_res.ironSplit){
      var _nmR=function(id){var it=DB.find(function(x){return x.id===id;});return it?it.name:id;};
      out+='<div style="margin-top:8px;padding-top:6px;border-top:1px dashed #a97577">'
        +'<b>&#128230; Aufteilung in 2 Formeln (wegen Eisen):</b>'
        +'<div style="margin-top:4px">&#9728;&#65039; <b>Morning Formula</b> (Frühstück): '+_res.morning.map(_nmR).join(', ')+'</div>'
        +'<div style="margin-top:2px">&#127769; <b>Evening Formula</b> (nach Abendessen): '+_res.evening.map(_nmR).join(', ')+'</div>'
        +'<div style="margin-top:4px;font-size:10px">8–12 h Abstand – optimal für die Aufnahme.</div>'
        +'</div>';
    }
    out+='</div>';
  }
  return out;
}

// ── Erlaeuterung, wenn der NRV per Slider nicht erreichbar ist ──────────────
// Greift automatisch, sobald der Slider-Maximalwert unter dem NRV liegt
// (Hoechstmenge fuer Nahrungsergaenzung < Kennzeichnungs-Referenzwert).
// Pro Zutat kann ein eigener Text hinterlegt werden; sonst greift der
// generische Fallback weiter unten.
var NRV_CAP_NOTE = {
  magnesium: '<b>Warum nur 250\u00a0mg?</b> F\u00fcr Magnesium aus Nahrungserg\u00e4nzungsmitteln gilt eine empfohlene Tagesh\u00f6chstmenge von 250\u00a0mg \u2013 unabh\u00e4ngig vom NRV von 375\u00a0mg. Zusammen mit Deiner Ern\u00e4hrung liegst Du damit sicher im Zielbereich.'
};

function nrvCapNote(it,maxVal){
  if(!it.nrv || !(it.nrv>maxVal)) return '';
  var txt = NRV_CAP_NOTE[it.id];
  if(!txt){
    txt = '<b>Warum nicht 100\u00a0%?</b> F\u00fcr '+it.name.replace(/^Bio\s+/,'')
        + ' aus Nahrungserg\u00e4nzungsmitteln gilt eine eigene Tagesh\u00f6chstmenge von '
        + fa(maxVal,it.unit)+'\u00a0'+it.unit+' \u2013 unabh\u00e4ngig vom NRV von '
        + it.nrv+'\u00a0'+it.unit+'. Zusammen mit Deiner Ern\u00e4hrung liegst Du damit im Zielbereich.';
  }
  return '<div style="margin-top:5px;padding:6px 9px;background:#f6f5f1;border:1px solid #e4e2dc;'
       + 'border-left:3px solid #727c6a;border-radius:5px;font-size:10px;line-height:1.45;color:#26352f">'
       + txt + '</div>';
}

function nrvBar(it){
  if(disabled[it.id])return '<div style="margin-top:8px;font-size:11px;color:#87867e;font-style:italic">\u2014 Aus Rezeptur entfernt</div>';
  if(!avails[it.id])return '<div style="margin-top:8px;font-size:11px;color:#c0392b;font-weight:700">\u26a0 Derzeit nicht verf\u00fcgbar</div>';
  var lim=checkLimit(it);
  var limWarn='';
  if(lim&&lim.over){limWarn='<div style="margin-top:5px;padding:4px 8px;background:#fdf0ef;border:1px solid #f5c6c6;border-radius:5px;font-size:10px;color:#c0392b;font-weight:700">\u26ab \u00dcBER BfR-H\u00d6CHSTMENGE! Max: '+lim.max+' '+lim.unit+'</div>';}
  else if(lim&&lim.near){limWarn='<div style="margin-top:5px;padding:4px 8px;background:#fff8e1;border:1px solid #ffe082;border-radius:5px;font-size:10px;color:#8a6a00">\u26a0 Nahe BfR-H\u00f6chstmenge: '+lim.max+' '+lim.unit+'</div>';}

  var id=it.id;
  var amt=S.amt[id]||0;
  var stepSize=it.step||1;
  var minVal=stepSize;
  var maxVal=it.maxSafe||(it.softMax||(it.nrv||it.dose||1)*5);
  // Experten-Modus: bei Stoffen ohne festen maxSafe den Slider-Bereich erweitern,
  // damit der Experte höher dosieren kann (Warnung greift in commitSlider).
  // Der Aufschlag gilt nur für kleine Mengen — siehe EXPERT_FAKTOR.
  var _basis = it.softMax||it.dose||it.step||1;
  if(S.mode==='expert' && (it.maxSafe===null||it.maxSafe===undefined)
     && toMg(_basis, it.unit) < EXPERT_KEIN_AUFSCHLAG_AB_MG){
    maxVal=Math.max(maxVal, _basis*EXPERT_FAKTOR);
  }

  maxVal=Math.ceil(maxVal/stepSize)*stepSize;

  // Feine Slider-Granularität: flüssiges Ziehen, unabhängig vom Rezeptur-Step.
  // Beim Loslassen (commitSlider) wird auf ein step-Vielfaches gerundet.
  var sliderStep=parseFloat((stepSize/20).toFixed(6));
  if(!(sliderStep>0)) sliderStep=stepSize;

  var nrvLabel=it.nrv?'<div style="font-size:9px;color:#87867e;margin-bottom:2px;margin-top:6px">Empfohlene Tagesdosis: '+it.nrv+'\u00a0'+it.unit+' gem. EFSA</div>':'';

  var pct=it.nrv?(amt/it.nrv)*100:null;

  var nrvUnreachable=it.nrv&&it.nrv>maxVal;
  var trackColor=pct===null?'#70191d':nrvUnreachable?'#727c6a':pct>=100?'#70191d':pct>=15?'#3a6a3a':'#e67e22';

  var markerHTML='';
  if(it.nrv&&maxVal>0){
    if(it.nrv<=maxVal){
    
      var markerLeft=Math.min((it.nrv/maxVal)*100,98);
      markerLeft=Math.max(markerLeft,2);
      markerHTML='<div style="position:relative;height:14px;margin-top:2px">'
        +'<div style="position:absolute;left:'+markerLeft.toFixed(1)+'%;transform:translateX(-50%);font-size:8px;color:#26352f;font-weight:700;white-space:nowrap">100%</div>'
        +'</div>';
    } else {
    
      var nrvPct=Math.round((maxVal/it.nrv)*100);
      markerHTML='<div style="position:relative;height:14px;margin-top:2px">'
        +'<div style="position:absolute;right:0;font-size:8px;color:#e67e22;font-weight:700;white-space:nowrap">'
        +'Max '+maxVal+' '+it.unit+' = '+nrvPct+'% NRV'
        +'</div></div>';
    }
  }

  var lowWarn='';
  if(pct!==null&&pct>0&&pct<15){
    lowWarn='<div style="margin-top:3px;padding:3px 8px;background:#fff3e0;border:1px solid #ffe0b2;border-radius:5px;font-size:10px;color:#e65100">'
      +'\u26a0 Unter 15\u00a0% der Tagesdosis \u2013 Wirksamkeit nicht gesichert.'
      +'</div>';
  }

  var fillPct=maxVal>0?Math.min((amt/maxVal)*100,100):0;
  var sliderStyle='background:linear-gradient(to right,'+trackColor+' '+fillPct.toFixed(1)+'%,#e4e2dc '+fillPct.toFixed(1)+'%)';

  var tickHTML='';
  if(it.nrv&&maxVal>0&&it.nrv<=maxVal){
    var tickLeft=Math.min(Math.max((it.nrv/maxVal)*100,0),100);
    tickHTML='<div style="position:absolute;top:50%;left:calc(12px + '+tickLeft.toFixed(1)+' * (100% - 24px) / 100);transform:translate(-50%,-50%);width:2px;height:16px;background:#431617;border-radius:1px;pointer-events:none;z-index:2"></div>';
  }

  return nrvLabel
    +'<div class="b-nrv-wrap">'
    +'<div style="position:relative">'
    +markerHTML
    +'<div class="b-slider-row" style="margin-bottom:0;position:relative">'
    +'<input class="b-dose-slider" type="range"'
    +' min="'+minVal+'" max="'+maxVal+'" step="'+sliderStep+'" value="'+amt+'"'
    +' data-id="'+id+'" data-step="'+stepSize+'" style="'+sliderStyle+'"'
    +' oninput="adjSlider(this)" onchange="commitSlider(this)">'
    +tickHTML
    +'</div>'
    +'</div>'
    +lowWarn+limWarn+nrvCapNote(it,maxVal)
    +'</div>';
}

function powderLabel(it){
  if(!it.powderDose||!it.nrv||!S.amt[it.id]||S.amt[it.id]<=0) return '';
  var cp=it.powderDose*(S.amt[it.id]/it.nrv);
  var pu=it.powderUnit||it.unit||'mg';
  var ps=cp>=1000?(cp/1000).toFixed(2)+' g':parseFloat(cp.toFixed(1))+' '+pu;
  var pct=it.std&&it.std<0.999?' ('+Math.round(it.std*100)+'% Wirkstoff)':'';
  return '<div style="margin-top:3px;font-size:10px;color:#70191d;background:#f4eded;padding:2px 7px;border-radius:4px;display:inline-block">Pulver: <b>'+ps+'</b>'+pct+'</div>';
}

// Die tatsächlich berechnete & bestellte Zutatenmenge: nach Score sortiert,
// verfügbar/aktiv, und auf die Anzeigegrenze (10+10, Experten: alle) geschnitten.
// EINE Quelle der Wahrheit für Preis-Anzeige, Live-Slider und Warenkorb.
// Berechnet wird ausschließlich, was auch produziert wird. Früher stand hier
// ein eigenes Limit (20 bzw. 10 je Typ), das mit der Routenaufteilung nichts zu
// tun hatte — dadurch zahlte der Kunde für Zutaten, die über den Cap oder das
// Kapsel-Budget herausgefallen und nie in die Tüte gekommen sind.
function billableItems(){
  var geliefert=deliveredIds();
  return [].concat(DB)
    .sort(function(a,b){return (S.sc[b.id]||0)-(S.sc[a.id]||0);})
    .filter(function(x){ return geliefert[x.id] && avails[x.id] && !disabled[x.id] && S.amt[x.id]>0; });
}

function adjSlider(input){
  var id=input.dataset.id;
  var val=parseFloat(input.value);
  var it=DB.find(function(x){return x.id===id;});
  if(!it) return;
  // Siehe adj(): ein Booster hat eine feste Dosis. Der Schieber rastet darauf
  // ein, statt eine Menge zu erlauben, die den Claim oder den Loeffel bricht.
  if(isBooster(id)){
    var _fd=boosterFestDosis(id);
    S.amt[id] = (val<=0) ? 0 : (_fd!==null ? _fd : S.amt[id]);
    renderKeepScroll(); return;
  }
  // Sicherheits-Stopper: im Standard-Modus hart bei maxSafe (sonst softMax).
  // Im Experten-Modus wird live NICHT gekappt – die Bestätigung erfolgt in commitSlider.
  // AUSNAHME: kritische Stoffe (CRITICAL_HARD_CAP) werden auch im Expertenmodus
  // live hart bei maxSafe gestoppt – der Slider kann gar nicht darüber.
  if(S.mode!=='expert'){
    var hardCap = (it.maxSafe!==null&&it.maxSafe!==undefined) ? it.maxSafe
                : ((it.softMax!==null&&it.softMax!==undefined) ? it.softMax : null);
    if(hardCap!==null&&val>hardCap){ val=hardCap; input.value=hardCap; }
  } else if(CRITICAL_HARD_CAP.indexOf(id)>=0 && it.maxSafe!==null&&it.maxSafe!==undefined && val>it.maxSafe){
    val=it.maxSafe; input.value=it.maxSafe;
  }
  S.amt[id]=val;

  var pct=it.nrv?(val/it.nrv)*100:null;
  var col=pct===null?'#70191d':pct>=100?'#70191d':pct>=15?'#3a6a3a':'#e67e22';
  var maxVal=parseFloat(input.max)||1;
  var fillPct=Math.min((val/maxVal)*100,100);
  input.style.background='linear-gradient(to right,'+col+' '+fillPct.toFixed(1)+'%,#e4e2dc '+fillPct.toFixed(1)+'%)';

  var amtEl=document.querySelector('[data-live-id="'+id+'"]');
  if(amtEl) amtEl.textContent=fa(val,it.unit)+' '+it.unit;

  var priceEl=document.querySelector('[data-live-price="'+id+'"]');
  if(priceEl){var pr=pd(it);var varPr=prices[it.id]?prices[it.id]*toMg(S.amt[it.id],it.unit)/1e6:0;
    priceEl.textContent=pr>0?'€ '+pr.toFixed(4)+'/Tag':'';
    var brEl=priceEl.nextElementSibling;
}

  // Live-Update Gesamtpreis – MUSS über dieselbe Zutatenmenge rechnen wie die
  // Ergebnisanzeige und der Warenkorb (Top-20, nicht ALLE aktiven). Sonst
  // springt die Summe beim Ziehen hoch und fällt beim Loslassen zurück.
  var newTPrD=billableItems().reduce(function(acc,x){return acc+pd(x);},0);
  S.tPrD=newTPrD;
  var pdEl=document.getElementById('b-price-day');
  if(pdEl) pdEl.textContent='€ '+newTPrD.toFixed(2);

  clearTimeout(adjSlider._t);
  adjSlider._t=setTimeout(function(){render();},600);
}

// Beim Loslassen des Sliders: auf step-Vielfaches runden (sauberer Bestellwert).
function commitSlider(input){
  var id=input.dataset.id;
  var it=DB.find(function(x){return x.id===id;});
  if(!it) return;
  var step=parseFloat(input.dataset.step)||it.step||1;
  var val=parseFloat(input.value)||0;
  var minVal=step;
  // auf nächstes step-Vielfaches runden, mind. ein step
  var snapped=Math.round(val/step)*step;
  snapped=parseFloat(snapped.toFixed(6));
  if(snapped<minVal) snapped=minVal;
  // Sicherheits-Höchstwert (EFSA-UL / BfR = maxSafe)
  var maxSafeCap=(it.maxSafe!==null&&it.maxSafe!==undefined)?it.maxSafe:null;
  var softCap=(it.softMax!==null&&it.softMax!==undefined)?it.softMax:null;
  if(S.mode==='expert'){
    // Kritische Stoffe: maxSafe ist auch im Expertenmodus HART, nicht überschreibbar.
    if(maxSafeCap!==null && CRITICAL_HARD_CAP.indexOf(id)>=0 && snapped>maxSafeCap){
      snapped=Math.floor(maxSafeCap/step)*step;
      window.alert(
        names[id]+': Aus Sicherheitsgründen ist dieser Stoff auf den EFSA/BfR-Höchstwert ('+
        fa(maxSafeCap,it.unit)+' '+it.unit+') begrenzt und kann auch im Experten-Modus nicht höher dosiert werden.');
    }
    // Übrige Stoffe: maxSafe ist warnbar + überschreibbar mit Bestätigung.
    else if(maxSafeCap!==null && snapped>maxSafeCap){
      var okExpert=window.confirm(
        names[id]+': '+fa(snapped,it.unit)+' '+it.unit+' überschreitet den sicheren Höchstwert ('+
        fa(maxSafeCap,it.unit)+' '+it.unit+', EFSA/BfR).\n\n'+
        'Hohe Dosen können gesundheitlich bedenklich sein. Möchtest Du diesen Wert wirklich übernehmen?');
      if(!okExpert){ snapped=Math.floor(maxSafeCap/step)*step; }
    }
    // softMax wird im Expertenmodus NICHT hart gekappt (nur visuell gewarnt via limWarn)
  } else {
    // Standard-Modus (Quiz/Bluttest): harte Begrenzung wie bisher.
    var hardCap = maxSafeCap!==null ? maxSafeCap : softCap;
    if(hardCap!==null&&snapped>hardCap) snapped=Math.floor(hardCap/step)*step;
  }
  S.amt[id]=snapped;
  input.value=snapped;
  clearTimeout(adjSlider._t);
  render();
}

function renderLoader(){
  var cx=60,cy=60;
  var petals='';

  var outerN=13, outerRx=6, outerRy=22, outerDist=28;
  for(var i=0;i<outerN;i++){
    var angle=i*(360/outerN);
    petals+='<ellipse cx="'+cx+'" cy="'+(cy-outerDist)+'" rx="'+outerRx+'" ry="'+outerRy+'"'
      +' fill="#70191d" opacity="0.92"'
      +' transform="rotate('+angle+' '+cx+' '+cy+')"'
      +'/>';
  }

  var innerN=8, innerRx=5, innerRy=14, innerDist=18;
  for(var j=0;j<innerN;j++){
    var angle2=j*(360/innerN)+22;
    petals+='<ellipse cx="'+cx+'" cy="'+(cy-innerDist)+'" rx="'+innerRx+'" ry="'+innerRy+'"'
      +' fill="#70191d" opacity="0.80"'
      +' transform="rotate('+angle2+' '+cx+' '+cy+')"'
      +'/>';
  }

  petals+='<circle cx="'+cx+'" cy="'+cy+'" r="14" fill="#3a1515"/>';

  var seeds=[[60,54],[56,57],[64,57],[54,61],[66,61],[57,65],[63,65],[60,68]];
  seeds.forEach(function(p){
    petals+='<circle cx="'+p[0]+'" cy="'+p[1]+'" r="1.5" fill="#431617" opacity="0.7"/>';
  });

  return '<div style="display:flex;flex-direction:column;align-items:center;'
    +'justify-content:center;min-height:80vh;gap:24px;padding:40px 20px">'
    +'<svg viewBox="0 0 120 120" width="280" height="280" style="width:280px;height:280px;min-width:280px;max-width:280px;display:block;margin:0 auto" xmlns="http://www.w3.org/2000/svg">'
    +'<g class="b-sunflower">'+petals+'</g>'
    +'</svg>'
    +'<div style="text-align:center">'
    +'<div style="font-size:17px;font-weight:700;color:#521719;margin-bottom:8px">'
    +'Deine Rezeptur wird berechnet …</div>'
    +'<div style="font-size:13px;color:#727c6a;line-height:1.6">'
    +'Dank KI ermitteln wir aus mehr als<br>'
    +'9 Billionen möglichen Kombinationen<br>'
    +'die passende für Dich.</div>'
    +'</div>'
    +'</div>';
}

function card(it,i){
  var av=avails[it.id],dis=disabled[it.id],p=pd(it),id=it.id;

  if(!av) return '';
  if(!S.amt[id]||S.amt[id]<=0) return '';
  var h='<div class="b-item'+(av?'':' unavailable')+'" style="animation-delay:'+(i*25)+'ms">';
  h+='<div class="b-item-top"><div style="min-width:0">';
  h+='<div class="b-item-name">'+it.name+'</div>';
  h+='<div class="b-item-badges">';
  h+=it.type==='nutrient'?'':it.nutrient?'<span class="b-badge-nut">'+it.nutrient+'</span>':'<span class="b-badge-bot">Botanical</span>';
  if(!av)h+='<span class="b-badge-unavail">&#9888; Nicht verf&#252;gbar</span>';
  h+='</div>'+nrvBar(it)+powderLabel(it)+renderClaims(it)+'</div>';
  h+='<div style="display:flex;flex-direction:column;align-items:flex-end;gap:3px;flex-shrink:0;padding-top:2px">';
  if(av){
    var dAttr=dis?' disabled':'';
    h+='<div class="b-stepper">';
    h+='<button class="b-stp minus"'+dAttr+' onclick="adj(this.dataset.id,-1)" data-id="'+id+'">&#8722;</button>';
    h+='<span class="b-amtval" data-live-id="'+id+'" style="'+(dis?'text-decoration:line-through;color:#c9c4ba':'')+'">'+(dis?'&mdash;':fa(S.amt[id],it.unit)+' '+it.unit)+'</span>';
    h+='<button class="b-stp"'+dAttr+' onclick="adj(this.dataset.id,1)" data-id="'+id+'">+</button>';
    h+='</div>';
    h+='<button onclick="toggleDisable(this.dataset.id)" data-id="'+id+'" style="margin-top:4px;font-size:10px;padding:2px 8px;border-radius:10px;cursor:pointer;font-family:inherit;display:block;text-align:center;border:1px solid '+(dis?'#3a6a3a':'#e0b0b0')+';background:'+(dis?'#e4e2dc':'#fdf0ef')+';color:'+(dis?'#26352f':'#c0392b')+'">'+(dis?'+ Hinzuf\u00fcgen':'&#215; Entfernen')+'</button>';
    if(!dis&&p>0){
      var varP=prices[id]?prices[id]*toMg(S.amt[id],it.unit)/1e6:0;
      h+='<span class="b-price-lbl" data-live-price="'+id+'">&#8364; '+p.toFixed(4)+'/Tag</span>';
    }
  }
  h+='</div></div></div>';
  return h;
}

function exportEvidence(){
  var header='id;ingredient;signal;condition;weight;grade;mandatory;source;rationale;claim';
  var rows=EVIDENCE_RULES.map(function(ev){
    function esc(v){return '"'+(v||'').replace(/"/g,'""').replace(/\n/g,' ')+'"';}
    return[ev.id,ev.ingredient,ev.signal,ev.condition,ev.weight,
      ev.grade,ev.mandatory?'true':'false',
      esc(ev.source),esc(ev.rationale),esc(ev.claim)
    ].join(';');
  });
  var csv=header+'\n'+rows.join('\n');
  var blob=new Blob(['\uFEFF'+csv],{type:'text/csv;charset=utf-8'});
  var url=URL.createObjectURL(blob);
  var a=document.createElement('a');
  a.href=url;a.download='biotiva_evidenz.csv';a.click();
  URL.revokeObjectURL(url);
}

function importEvidence(csvText){
  var errList=[];
  var lines=csvText.replace(/\r\n/g,'\n').replace(/\r/g,'\n').split('\n');
  var sep=lines[0].indexOf(';')>lines[0].indexOf(',')&&lines[0].indexOf(';')>=0?';':',';
  var headers=splitCSVLine(lines[0],sep).map(function(h){
    return h.trim().toLowerCase().replace(/[^a-z]/g,'');
  });
  var updated=0,added=0,skipped=0;
  for(var i=1;i<lines.length;i++){
    var line=lines[i].trim();if(!line)continue;
    var cols=splitCSVLine(line,sep);
    var r={};
    headers.forEach(function(h,j){r[h]=(cols[j]||'').trim().replace(/^["']|["']$/g,'');});
    if(!r.id||!r.ingredient||!r.signal){
      errList.push('Zeile '+(i+1)+': id, ingredient oder signal fehlt.');
      skipped++;continue;
    }
    var w=parseFloat(r.weight);
    if(isNaN(w)){errList.push('Zeile '+(i+1)+': weight ungültig.');skipped++;continue;}
    var ev={id:r.id,ingredient:r.ingredient,signal:r.signal,condition:r.condition,
      weight:w,grade:r.grade||'C',mandatory:r.mandatory==='true',
      source:r.source||'',rationale:r.rationale||'',claim:r.claim||''};
    var idx2=EVIDENCE_RULES.findIndex(function(e){return e.id===r.id;});
    if(idx2>=0){EVIDENCE_RULES[idx2]=ev;updated++;}
    else{EVIDENCE_RULES.push(ev);added++;}
  }
  EVIDENCE_MAP={};
  EVIDENCE_RULES.forEach(function(ev){
    if(!EVIDENCE_MAP[ev.ingredient])EVIDENCE_MAP[ev.ingredient]=[];
    EVIDENCE_MAP[ev.ingredient].push(ev);
  });
  MANDATORY_INGREDIENTS=EVIDENCE_RULES
    .filter(function(ev){return ev.mandatory;})
    .map(function(ev){return{ingredient:ev.ingredient,signal:ev.signal,condition:ev.condition};});
  var msg='Evidenz: '+added+' neu, '+updated+' aktualisiert';
  if(skipped)msg+=', '+skipped+' übersprungen';
  if(errList.length)msg+=' — '+errList.length+' Hinweise';
  return{msg:msg,errors:errList};
}

function handleEvidenceFile(input){
  var file=input.files[0];if(!file)return;
  var reader=new FileReader();
  reader.onload=function(e){
    var res=importEvidence(e.target.result);
    var status=document.getElementById('ev-import-status');
    var errBox=document.getElementById('ev-import-errors');
    if(status){status.textContent=res.msg;status.style.color=res.errors.length?'#c0392b':'#3a6a3a';status.style.display='block';}
    if(errBox){errBox.innerHTML=res.errors.length?'<ul style="margin:6px 0;padding-left:16px">'+res.errors.map(function(e){return'<li>'+e+'</li>';}).join('')+'</ul>':'';}
  };
  reader.readAsText(file,'UTF-8');
}

function renderEvidencePanel(){
  var grades={A:'&#9679; A',B:'&#9679; B',C:'&#9679; C'};
  var gradeColors={A:'#26352f',B:'#8a6a00',C:'#87867e'};
  var rows=EVIDENCE_RULES.map(function(ev,i){
    var gc=gradeColors[ev.grade]||'#87867e';
    return('<tr style="'+(i%2===0?'background:#f6f5f1':'background:#fff')+'">'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;font-family:monospace;font-size:10px;color:#26352f">'+ev.id+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;font-weight:700;color:#26352f">'+ev.ingredient+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;color:#818c77">'+ev.signal+' '+ev.condition+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;text-align:center;font-weight:700">'+ev.weight+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;text-align:center;font-weight:700;color:'+gc+'">'+ev.grade+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;color:'+(ev.mandatory?'#c0392b':'#727c6a')+';font-weight:'+(ev.mandatory?'700':'400')+'">'+(ev.mandatory?'Ja':'—')+'</td>'
      +'<td style="padding:5px 8px;border:1px solid #d9d5cc;font-size:10px;color:#727c6a;max-width:220px;word-break:break-word">'+ev.source.substring(0,80)+(ev.source.length>80?'…':'')+'</td>'
      +'</tr>'
      +'<tr style="'+(i%2===0?'background:#f6f5f1':'background:#fff')+'">'
      +'<td colspan="7" style="padding:3px 8px 8px 8px;border:1px solid #d9d5cc;border-top:none">'
      +'<span style="font-size:10px;color:#818c77;font-style:italic">'+ev.rationale+'</span>'
      +'</td></tr>');
  }).join('');

  return('<div style="padding:18px 0">'
    +'<div style="font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#61181b;border-bottom:1px solid #f6f5f1;padding-bottom:6px;margin-bottom:14px">Evidenz-Modell Export/Import</div>'
    +'<div style="display:flex;gap:12px;margin-bottom:20px;flex-wrap:wrap">'
    +'<button onclick="exportEvidence()" style="padding:10px 22px;background:#26352f;color:#fff;border:none;border-radius:6px;cursor:pointer;font-family:inherit;font-size:13px;font-weight:700">&#11123; biotiva_evidenz.csv herunterladen</button>'
    +'<div>'
    +'<label style="padding:10px 22px;background:#26352f;color:#fff;border-radius:6px;cursor:pointer;font-family:inherit;font-size:13px;font-weight:700;display:inline-block">&#128196; Evidenz-CSV hochladen<input type="file" accept=".csv,.txt" style="display:none" onchange="handleEvidenceFile(this)"></label>'
    +'</div></div>'
    +'<div id="ev-import-status" style="display:none;padding:8px 12px;border-radius:6px;background:#e4e2dc;font-size:12px;font-weight:700;margin-bottom:8px"></div>'
    +'<div id="ev-import-errors" style="font-size:11px;color:#c0392b;margin-bottom:14px"></div>'
    +'<div style="font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#61181b;border-bottom:1px solid #f6f5f1;padding-bottom:6px;margin-bottom:12px">'
    +'Aktive Evidenzregeln ('+EVIDENCE_RULES.length+') — Evidenzgrad: A=RCT/Meta-Analyse, B=Kohortenstudie/EFSA, C=Expertenkonsens</div>'
    +'<div style="overflow-x:auto">'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px;min-width:700px">'
    +'<thead><tr style="background:#26352f;color:#fff">'
    +'<th style="padding:6px 8px;text-align:left">ID</th>'
    +'<th style="padding:6px 8px;text-align:left">Zutat</th>'
    +'<th style="padding:6px 8px;text-align:left">Signal / Bedingung</th>'
    +'<th style="padding:6px 8px;text-align:center">Gewicht</th>'
    +'<th style="padding:6px 8px;text-align:center">Grad</th>'
    +'<th style="padding:6px 8px;text-align:center">Pflicht</th>'
    +'<th style="padding:6px 8px;text-align:left">Quelle (gekürzt)</th>'
    +'</tr></thead>'
    +'<tbody>'+rows+'</tbody></table></div>'
    +'</div>');
}

function renderQuiz(){
  var q=QUIZ[S.step];
  if(!q){ S.step='start'; return renderStart(); }
  var pct=Math.round((S.step/QUIZ.length)*100);
  var body='';

  if(q.type==='single'){
    var singleCol=['sex','sun','smoke','diet','lacto'];
    var cls=singleCol.indexOf(q.id)>=0?'':q.opts.length<=2?'c2':q.opts.length<=3?'c3':'';
    body='<div class="b-grid '+cls+'">';
    q.opts.forEach(function(o){
      var sel=(S.ans[q.id]===o);
      body+='<button class="b-opt'+(sel?' sel':'')+'" onclick="pick(this.dataset.qid,this.dataset.val)" data-qid="'+q.id+'" data-val="'+o+'">';
      if(sel)body+='<span style="color:#26352f;font-size:11px">&#10003; </span>';
      body+=o+'</button>';
    });
    body+='</div>';
  } else if(q.type==='range'){
    var v=S.ans[q.id]!==undefined?S.ans[q.id]:q.val;
    body='<div style="margin-bottom:8px"><div class="b-slider-row">';
    body+='<input class="b-slider" type="range" min="'+q.min+'" max="'+q.max+'" value="'+v+'" step="1" data-qid="'+q.id+'" oninput="rng(this.dataset.qid,this.value)" onpointerdown="rng(this.dataset.qid,this.value)">';
    body+='<div class="b-slider-val" id="qsv-'+q.id+'" data-unit="'+q.unit+'">'+v+' <small>'+q.unit+'</small></div></div>';
    if(q.lbl)body+='<div class="b-slider-labels"><span>'+q.lbl[0]+'</span><span>'+q.lbl[1]+'</span></div>';
    body+='</div>';
  } else if(q.type==='plz'){
    var pv=S.ans[q.id]||'';
    body='<div><input class="b-text-input" type="text" maxlength="30" placeholder="'+q.placeholder+'" value="'+pv+'"';
    body+=' data-qid="'+q.id+'" oninput="onPlzInput(this)" autocomplete="off">';
    body+='<div class="b-input-hint">'+q.hint+'</div>';
    var _pinit=(function(){ var lat=plzToLat(pv); if(lat===null)return ''; deriveUv();
      var t={voll:'volle Vitamin-D-Bildung durch Sonne',reduziert:'reduzierte Vitamin-D-Bildung – etwas mehr Vitamin D sinnvoll',minimal:'kaum Vitamin-D-Bildung – erhöhter Vitamin-D-Bedarf',keine:'Vitamin-D-Winter – körpereigene Bildung praktisch bei Null'}[S.ans._uvTier]||'';
      return '&#128205; '+plzRegion(pv)+' · in den n\u00e4chsten 3 Monaten: '+t; })();
    body+='<div id="plz-preview" class="b-preview-name" style="display:'+(_pinit?'block':'none')+'">'+_pinit+'</div></div>';
  } else if(q.type==='text'){
    var tv=S.ans[q.id]||'';
    body='<div><input class="b-text-input" type="text" maxlength="60" placeholder="'+q.placeholder+'" value="'+tv+'"';
    body+=' data-qid="'+q.id+'" oninput="S.ans[this.dataset.qid]=this.value;var nb=document.getElementById(\'b-next-btn\');if(nb)nb.disabled=!this.value.trim();var p=document.getElementById(\'rname-preview\');if(p){p.style.display=this.value?\'block\':\'none\';p.textContent=\'&#127881; \'+this.value;}" autocomplete="off">';
    body+='<div class="b-input-hint">'+q.hint+'</div>';
    body+='<div id="rname-preview" class="b-preview-name" style="display:'+(tv?'block':'none')+'">'+(tv?'&#127881; '+tv:'')+'</div></div>';
  } else if(q.type==='email'){
    var ev=S.ans[q.id]||'';
    body='<div><input class="b-text-input" type="email" maxlength="80" placeholder="'+q.placeholder+'" value="'+ev+'"';
    body+=' data-qid="'+q.id+'" oninput="S.ans[this.dataset.qid]=this.value;var nb=document.getElementById(\'b-next-btn\');if(nb)nb.disabled=!this.value.trim()" autocomplete="email">';
    body+='<div class="b-input-hint">'+q.hint+'</div></div>';
  } else if(q.type==='multi'){
    var sel=S.ans[q.id]||[];
    body='<div class="b-grid">';
    q.opts.forEach(function(o){
      var isSel=sel.indexOf(o)>=0;
      body+='<button class="b-opt'+(isSel?' sel':'')+'" onclick="toggle(this.dataset.val,\''+q.id+'\')" data-val="'+o+'">';
      if(isSel)body+='<span style="color:#26352f;font-size:11px">&#10003; </span>';
      body+=o+'</button>';
    });
    body+='</div>';
  }

  var isText=(q.type==='text'||q.type==='email');
  var canNext=(q.type==='range')||(q.type==='plz')||(q.type==='multi'&&(q.optional||(S.ans[q.id]||[]).length>0))||(q.type==='single'&&S.ans[q.id])||(isText&&((S.ans[q.id]||'')+'').trim().length>0);

  var h='<div style="padding:16px 0 0">';
  h+='<div class="b-progress-track"><div class="b-progress-fill" style="width:'+pct+'%"></div></div>';
  h+='';
  h+='<div class="b-card"><p class="b-qtitle">'+q.label+'</p>';
  if(q.sub)h+='<p class="b-qsub">'+q.sub+'</p>';
  h+=body;
  var _why=WHY_MAP[q.id];
  if(_why)h+='<details class="b-why"><summary>Warum fragen wir?</summary><div class="b-why-body">'+_why+'</div></details>';
  h+='</div>';
  h+='<div class="b-navbar">';
  if(S.step>0)h+='<button class="b-btn b-btn-ghost" onclick="back()">&#8592; Zur&#252;ck</button>';
  h+='<button id="b-next-btn" class="b-btn b-btn-primary" onclick="next()"'+(canNext?'':' disabled')+'>'+(S.step===QUIZ.length-1?'Meine Rezeptur entwickeln &#8594;':'Weiter &#8594;')+'</button></div>';
  if(isText)h+='<div style="text-align:center;margin-top:10px"><button onclick="next()" style="background:none;border:none;color:#727c6a;cursor:pointer;font-size:12px;padding:8px">&#220;berspringen &#8594;</button></div>';
  // Experten-Modus: Direkteinstieg nur auf dem ersten Schritt anbieten
  h+='</div>';
  return h;
}

function renderResult(){
  var sorted=[].concat(DB).sort(function(a,b){return(S.sc[b.id]||0)-(S.sc[a.id]||0);});

  var _lim=(S.mode==='expert')?20:10;
  var plants=sorted.filter(function(x){
    return (x.type==='plant'||x.type==='nutrient')&&avails[x.id]&&!disabled[x.id]&&S.amt[x.id]>0;
  }).slice(0,_lim);
  var bots=sorted.filter(function(x){
    return x.type==='bot'&&avails[x.id]&&!disabled[x.id]&&S.amt[x.id]>0;
  }).slice(0,_lim);
  // avItems = die Zutaten, die tatsächlich geliefert und berechnet werden.
  // Deckungsgleich mit Warenkorb, Live-Preis und Bestelldaten.
  var avItems=billableItems();

  // Schutz: leere Rezeptur (keine Zutat aktiv) → keine leere Seite, sondern Hinweis + Wege zurück.
  if(!avItems.length){
    return '<div style="padding:30px 0 0;text-align:center">'
      +'<div style="font-size:40px;margin-bottom:12px">🌱</div>'
      +'<h2 style="font-size:21px;color:#26352f;margin-bottom:8px">Noch keine Rezeptur</h2>'
      +'<p style="color:#727c6a;font-size:14px;line-height:1.6;max-width:360px;margin:0 auto 22px">'
      +'Für Deine Angaben konnten wir noch keine Zutaten ableiten. Starte am besten mit dem Fragebogen – '
      +'so erfassen wir Deinen individuellen Bedarf zuverlässig.</p>'
      +'<button class="b-btn b-btn-primary" onclick="chooseMode(\'quiz\')" style="width:100%;max-width:360px">Zum Fragebogen &#8594;</button>'
      +'<div style="margin-top:10px"><button class="b-btn b-btn-ghost" onclick="restart()" style="width:100%;max-width:360px">&#8634; Neu starten</button></div>'
      +'</div>';
  }

  // Zwei Mengen: was in die Tüte kommt (Rohware) und was davon Wirkstoff ist.
  // Die deklarierte Menge allein hat den Kunden bisher überrascht — 8,6 g auf
  // der Seite gegen 14,6 g im Paket.
  var wirkstoffMg=avItems.reduce(function(s,it){return s+toMg(S.amt[it.id]||0,it.unit);},0);
  var totalMg=avItems.reduce(function(s,it){return s+powderMg(it);},0);
  var totalG=totalMg/1000, wirkstoffG=wirkstoffMg/1000;
  var tPrD=avItems.reduce(function(s,it){return s+pd(it);},0);
  S.tPrD=tPrD; // make available globally
  var goals=S.ans.goals||[];
  var rname=S.ans.rezepturname||'Meine Biotiva Rezeptur';
  var email=S.ans.email||'';
  var unavailCount=DB.filter(function(it){return !avails[it.id];}).length;

  var _isExpert=(S.mode==='expert');
  // 1) Rezeptur-Namens-Banner ganz oben
  var h='<div style="padding:18px 0 0"></div>';
  h+='<div class="b-result-name-banner"><div><div class="b-result-name-label" style="color:#fff">Deine Rezeptur</div>';
  h+='<div class="b-result-name-value">'+rname+'</div>';
  if(email)h+='<div class="b-result-email">&#9993; '+email+'</div>';
  h+='</div></div>';
  // 2)+3) Übersichtsbox "Deine persönlichen Ziele und Themen" mit Zielen zeilenweise
  if(!_isExpert && goals.length){
    h+='<div class="b-result-name-banner" style="background:#26352f;color:#f6f5f1;display:block;text-align:left"><div class="b-result-name-value">Deine persönlichen Ziele und Themen</div>';
    h+='<div style="margin-top:8px">';
    goals.forEach(function(g){h+='<div style="margin:4px 0"><span class="b-goal-tag">&#10003; '+g+'</span></div>';});
    var _loc=locDisplay(S.ans.plz);
    if(_loc){ h+='<div style="margin-top:12px;padding-top:10px;border-top:1px solid rgba(255,255,255,0.28);font-size:13px;color:#f6f5f1">\uD83D\uDCCD Mein Lebensmittelpunkt in den n\u00e4chsten 3 Monaten: <strong>'+_loc+'</strong></div>'; }
    h+='</div></div>';
  }
  if(_isExpert){
    h+='<div class="b-eyebrow" style="margin-bottom:8px">Experten-Rezeptur &middot; selbst zusammengestellt</div>';
    h+='<div style="background:#fffbe6;border:1px solid #e8d97a;border-radius:10px;padding:12px 16px;margin-bottom:14px;font-size:12px;color:#70191d;line-height:1.5">'
      +'<b>&#9881;&#65039; Experten-Modus aktiv.</b> Du stellst Deine Rezeptur frei zusammen. '
      +'Sicherheits-Höchstwerte (EFSA/BfR) und Wechselwirkungs-Hinweise bleiben aktiv; '
      +'Überschreitungen musst Du aktiv bestätigen. Diese Rezeptur ist keine personalisierte Empfehlung.'
      +'</div>';
  }

  
  // Überschriftbox "Deine Zutaten" — jetzt ÜBER den Mengen-/Preis-Kacheln
  h+='<div class="b-result-name-banner" style="background:#26352f;color:#f6f5f1;display:block;text-align:left"><div class="b-result-name-value">Deine Zutaten</div><div style="font-size:13px;color:#e4e2dc;margin-top:6px;line-height:1.5">Die nachfolgende Rezeptur ist auf Deine Situation und Ziele abgestimmt. Solltest Du dennoch die Dosierung einzelner Zutaten anpassen oder diese entfernen wollen \u2013 weil Du beispielsweise noch eine der genannten Zutaten zu Hause hast \u2013 ist dies m\u00F6glich. Jede \u00C4nderung kann die Menge und auch den Preis pro Tag und Monat \u00E4ndern. Entscheide anschlie\u00DFend die Darreichungsform und Lieferoption.</div></div>';
  h+='<div class="b-metrics">';
  h+='<div class="b-metric accent"><div class="b-metric-label">Menge / Tag</div><div class="b-metric-num">'+totalG.toFixed(1)+'<span class="b-metric-unit"> g</span></div><div class="b-metric-note">Pulver, davon '+wirkstoffG.toFixed(1)+' g Wirkstoffe</div></div>';
  h+='<div class="b-metric accent"><div class="b-metric-label">Menge / Monat</div><div class="b-metric-num">'+(totalG*30).toFixed(0)+'<span class="b-metric-unit"> g</span></div><div class="b-metric-note">'+(totalG*30/1000).toFixed(2)+' kg</div></div>';
  h+='</div>';
  // Erklärt die Differenz dort, wo die Frage entsteht — statt in einer Fußnote.
  var _qb = quellenBeispiel(avItems);
  if(_qb && totalMg > wirkstoffMg*1.05){
    h+='<div style="font-size:11px;color:#727c6a;line-height:1.5;margin:-2px 0 10px;padding:0 2px">'
      +'Wir verwenden pflanzliche Rohstoffe \u2014 '+_qb+'.</div>';
  }
  // Preis / Tag als zentrale Stellgröße (volle Breite, gleiche Optik wie Menge-Kacheln)
  h+='<div class="b-metric accent" style="grid-column:1/-1;text-align:center;padding:18px;margin:10px 0 4px">';
  h+='<div class="b-metric-label">Dein Preis / Tag</div>';
  h+='<div class="b-metric-num" id="b-price-day" style="font-size:34px;line-height:1.1">€ '+tPrD.toFixed(2)+'</div>';
  h+='</div>';

  plants.forEach(function(it,i){h+=card(it,i);});

  bots.forEach(function(it,i){h+=card(it,i+plants.length);});

  // ── "+ Zutat hinzufügen" — alle Zutaten, die aktuell nicht in der Rezeptur sind ──
  (function(){
    var inactive = DB.filter(function(it){
      return avails[it.id] && !(S.amt[it.id] > 0);
    });
    if(!inactive.length) return;
    var LBL = { nutrient:'Vitamine & Mineralstoffe', plant:'Pflanzenpulver', bot:'Botanicals & Extrakte' };
    h+='<div style="background:#fff;border:1px solid #e4e2dc;border-radius:14px;padding:18px 16px;margin:16px 0">';
    h+='<div style="font-weight:700;font-size:15px;color:#26352f;margin-bottom:4px">+ Zutat hinzufügen</div>';
    h+='<div style="font-size:12px;color:#727c6a;margin-bottom:14px;line-height:1.5">Diese Zutaten sind nicht in Deiner Rezeptur. Mit einem Klick fügst Du sie hinzu — die Menge kannst Du danach frei einstellen.</div>';
    ['nutrient','plant','bot'].forEach(function(t){
      var grp = inactive.filter(function(it){ return it.type===t; });
      if(!grp.length) return;
      h+='<div style="font-size:11px;font-weight:700;color:#727c6a;letter-spacing:.05em;text-transform:uppercase;margin:12px 0 8px">'+LBL[t]+'</div>';
      h+='<div style="display:flex;flex-wrap:wrap;gap:8px">';
      grp.forEach(function(it){
        var nm = (names[it.id] && String(names[it.id]).trim()) || it.name || it.id;
        h+='<button onclick="addIngredient(\''+it.id+'\')" '
          +'style="background:#f6f5f1;border:1px solid #e4e2dc;border-radius:8px;padding:7px 12px;font-size:12px;'
          +'color:#26352f;cursor:pointer;font-family:inherit;transition:all .15s" '
          +'onmouseover="this.style.background=\'#e4e2dc\';this.style.borderColor=\'#26352f\'" '
          +'onmouseout="this.style.background=\'#f6f5f1\';this.style.borderColor=\'#e4e2dc\'">'
          +'+ '+nm+'</button>';
      });
      h+='</div>';
    });
    h+='</div>';
  })();

  h+=renderCartSection(rname);  h+='<div style="text-align:center;margin-top:18px"><img src="'+LOGO+'" alt="Biotiva" style="height:44px;opacity:.18;mix-blend-mode:multiply"></div>';
  h+='<div class="b-footer"><strong>Biotiva&#174;</strong> &mdash; 100% Organic &middot; Plant-Based &middot; Certified Quality<br><a href="https://www.biotiva.de">www.biotiva.de</a> &middot; Bio-Expertise seit 1982 &middot; Made in Germany</div>';
  return h;
}

function render(){
  var el=document.getElementById('b-app');
  if(!el) return;
  try {
    // Bluttest deaktiviert? Dann blood-Schritte nicht rendern, sondern zum Start.
    if(!BLUTTEST_AKTIV && (S.step==='blood-upload' || S.step==='blood-review')){
      S.step='start'; S.mode=null;
    }
    if(S.step==='r'){ el.innerHTML=renderResult(); }
    else if(S.step==='start'){ el.innerHTML=renderStart(); }
    else if(S.step==='expert-intro'){ el.innerHTML=renderExpertIntro(); }
    else if(S.step==='blood-upload'){ el.innerHTML=renderBloodUpload(); bloodBindDrop(); }
    else if(S.step==='blood-review'){ el.innerHTML=renderBloodReview(); }
    else if(typeof S.step==='number' && S.step>=0 && S.step<QUIZ.length){ el.innerHTML=renderQuiz(); }
    else {
      // Unbekannter/ungültiger Zustand → nie leere Seite, zurück zur Startauswahl.
      S.step='start'; S.mode=null; el.innerHTML=renderStart();
    }
  } catch(e){
    // Render-Fehler abfangen → Start-Screen statt weißer Seite.
    try { S.step='start'; S.mode=null; el.innerHTML=renderStart(); }
    catch(e2){ el.innerHTML='<div style="padding:40px 20px;text-align:center;color:#26352f">Einen Moment bitte – lade die Seite neu (Strg+Shift+R).</div>'; }
  }
}

// Edit-Modus: wenn ?edit=1 in URL → letzte Rezeptur laden und direkt zur Ergebnisseite
(function(){
  function safeRender(){
    try { render(); }
    catch(e){
      // Letztes Sicherheitsnetz: Start-Screen direkt einsetzen
      try {
        var el=document.getElementById('b-app');
        if(el && typeof renderStart==='function'){ S.step='start'; el.innerHTML=renderStart(); }
      } catch(e2){}
    }
  }
  try {
    var params = new URLSearchParams(window.location.search);
    if(params.get('edit')==='1'){
      if(!restoreState()){ safeRender(); }
    } else {
      safeRender();
    }
  } catch(e){ safeRender(); }
})();